import React__default, { createElement, Fragment, Component, createRef } from 'react';
import PropTypes from 'prop-types';
import domain$1 from 'domain';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var axios = require('axios').default;
var getConfig = function (stage, apiKey) {
    return axios.get("https://channel-" + stage + ".rational-touch.com/channel/desktop/bot/config", { params: { apiKey: apiKey } });
};
var getBotList = function (stage) {
    var config = {
        url: "https://api-" + stage + ".rational-touch.com/proxy/bot/config/bots",
        method: 'get',
        headers: { 'x-api-key': '4LSsOjlCJK360d5CIyX638H8EjXltT8y9CslBNi2' }
    };
    return axios(config);
};

/*!
 * Font Awesome Free 5.15.1 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 */
var faCommentDots = {
  prefix: 'fas',
  iconName: 'comment-dots',
  icon: [512, 512, [], "f4ad", "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zM128 272c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"]
};
var faThumbsUp = {
  prefix: 'fas',
  iconName: 'thumbs-up',
  icon: [512, 512, [], "f164", "M104 224H24c-13.255 0-24 10.745-24 24v240c0 13.255 10.745 24 24 24h80c13.255 0 24-10.745 24-24V248c0-13.255-10.745-24-24-24zM64 472c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zM384 81.452c0 42.416-25.97 66.208-33.277 94.548h101.723c33.397 0 59.397 27.746 59.553 58.098.084 17.938-7.546 37.249-19.439 49.197l-.11.11c9.836 23.337 8.237 56.037-9.308 79.469 8.681 25.895-.069 57.704-16.382 74.757 4.298 17.598 2.244 32.575-6.148 44.632C440.202 511.587 389.616 512 346.839 512l-2.845-.001c-48.287-.017-87.806-17.598-119.56-31.725-15.957-7.099-36.821-15.887-52.651-16.178-6.54-.12-11.783-5.457-11.783-11.998v-213.77c0-3.2 1.282-6.271 3.558-8.521 39.614-39.144 56.648-80.587 89.117-113.111 14.804-14.832 20.188-37.236 25.393-58.902C282.515 39.293 291.817 0 312 0c24 0 72 8 72 81.452z"]
};
var faTimesCircle = {
  prefix: 'fas',
  iconName: 'times-circle',
  icon: [512, 512, [], "f057", "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"]
};

/*!
 * Font Awesome Free 5.15.1 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 */

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var noop = function noop() {};

var _WINDOW = {};
var _DOCUMENT = {};
var _MUTATION_OBSERVER = null;
var _PERFORMANCE = {
  mark: noop,
  measure: noop
};

try {
  if (typeof window !== 'undefined') _WINDOW = window;
  if (typeof document !== 'undefined') _DOCUMENT = document;
  if (typeof MutationObserver !== 'undefined') _MUTATION_OBSERVER = MutationObserver;
  if (typeof performance !== 'undefined') _PERFORMANCE = performance;
} catch (e) {}

var _ref = _WINDOW.navigator || {},
    _ref$userAgent = _ref.userAgent,
    userAgent = _ref$userAgent === void 0 ? '' : _ref$userAgent;

var WINDOW = _WINDOW;
var DOCUMENT = _DOCUMENT;
var PERFORMANCE = _PERFORMANCE;
var IS_BROWSER = !!WINDOW.document;
var IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener === 'function' && typeof DOCUMENT.createElement === 'function';
var IS_IE = ~userAgent.indexOf('MSIE') || ~userAgent.indexOf('Trident/');

var NAMESPACE_IDENTIFIER = '___FONT_AWESOME___';
var DEFAULT_FAMILY_PREFIX = 'fa';
var DEFAULT_REPLACEMENT_CLASS = 'svg-inline--fa';
var DATA_FA_I2SVG = 'data-fa-i2svg';
var PRODUCTION = function () {
  try {
    return process.env.NODE_ENV === 'production';
  } catch (e) {
    return false;
  }
}();
var DUOTONE_CLASSES = {
  GROUP: 'group',
  SWAP_OPACITY: 'swap-opacity',
  PRIMARY: 'primary',
  SECONDARY: 'secondary'
};

var initial = WINDOW.FontAwesomeConfig || {};

function getAttrConfig(attr) {
  var element = DOCUMENT.querySelector('script[' + attr + ']');

  if (element) {
    return element.getAttribute(attr);
  }
}

function coerce(val) {
  // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
  // We'll assume that this is an indication that it should be toggled to true
  // For example <script data-search-pseudo-elements src="..."></script>
  if (val === '') return true;
  if (val === 'false') return false;
  if (val === 'true') return true;
  return val;
}

if (DOCUMENT && typeof DOCUMENT.querySelector === 'function') {
  var attrs = [['data-family-prefix', 'familyPrefix'], ['data-replacement-class', 'replacementClass'], ['data-auto-replace-svg', 'autoReplaceSvg'], ['data-auto-add-css', 'autoAddCss'], ['data-auto-a11y', 'autoA11y'], ['data-search-pseudo-elements', 'searchPseudoElements'], ['data-observe-mutations', 'observeMutations'], ['data-mutate-approach', 'mutateApproach'], ['data-keep-original-source', 'keepOriginalSource'], ['data-measure-performance', 'measurePerformance'], ['data-show-missing-icons', 'showMissingIcons']];
  attrs.forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        attr = _ref2[0],
        key = _ref2[1];

    var val = coerce(getAttrConfig(attr));

    if (val !== undefined && val !== null) {
      initial[key] = val;
    }
  });
}

var _default = {
  familyPrefix: DEFAULT_FAMILY_PREFIX,
  replacementClass: DEFAULT_REPLACEMENT_CLASS,
  autoReplaceSvg: true,
  autoAddCss: true,
  autoA11y: true,
  searchPseudoElements: false,
  observeMutations: true,
  mutateApproach: 'async',
  keepOriginalSource: true,
  measurePerformance: false,
  showMissingIcons: true
};

var _config = _objectSpread({}, _default, initial);

if (!_config.autoReplaceSvg) _config.observeMutations = false;

var config = _objectSpread({}, _config);

WINDOW.FontAwesomeConfig = config;

var w = WINDOW || {};
if (!w[NAMESPACE_IDENTIFIER]) w[NAMESPACE_IDENTIFIER] = {};
if (!w[NAMESPACE_IDENTIFIER].styles) w[NAMESPACE_IDENTIFIER].styles = {};
if (!w[NAMESPACE_IDENTIFIER].hooks) w[NAMESPACE_IDENTIFIER].hooks = {};
if (!w[NAMESPACE_IDENTIFIER].shims) w[NAMESPACE_IDENTIFIER].shims = [];
var namespace = w[NAMESPACE_IDENTIFIER];

var functions = [];

var listener = function listener() {
  DOCUMENT.removeEventListener('DOMContentLoaded', listener);
  loaded = 1;
  functions.map(function (fn) {
    return fn();
  });
};

var loaded = false;

if (IS_DOM) {
  loaded = (DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(DOCUMENT.readyState);
  if (!loaded) DOCUMENT.addEventListener('DOMContentLoaded', listener);
}

var isNode = typeof global !== 'undefined' && typeof global.process !== 'undefined' && typeof global.process.emit === 'function';
var asyncSetTimer = typeof setImmediate === 'undefined' ? setTimeout : setImmediate;
var meaninglessTransform = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: false,
  flipY: false
};
function insertCss(css) {
  if (!css || !IS_DOM) {
    return;
  }

  var style = DOCUMENT.createElement('style');
  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  var headChildren = DOCUMENT.head.childNodes;
  var beforeChild = null;

  for (var i = headChildren.length - 1; i > -1; i--) {
    var child = headChildren[i];
    var tagName = (child.tagName || '').toUpperCase();

    if (['STYLE', 'LINK'].indexOf(tagName) > -1) {
      beforeChild = child;
    }
  }

  DOCUMENT.head.insertBefore(style, beforeChild);
  return css;
}
var idPool = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
function nextUniqueId() {
  var size = 12;
  var id = '';

  while (size-- > 0) {
    id += idPool[Math.random() * 62 | 0];
  }

  return id;
}
function htmlEscape(str) {
  return "".concat(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
function joinAttributes(attributes) {
  return Object.keys(attributes || {}).reduce(function (acc, attributeName) {
    return acc + "".concat(attributeName, "=\"").concat(htmlEscape(attributes[attributeName]), "\" ");
  }, '').trim();
}
function joinStyles(styles) {
  return Object.keys(styles || {}).reduce(function (acc, styleName) {
    return acc + "".concat(styleName, ": ").concat(styles[styleName], ";");
  }, '');
}
function transformIsMeaningful(transform) {
  return transform.size !== meaninglessTransform.size || transform.x !== meaninglessTransform.x || transform.y !== meaninglessTransform.y || transform.rotate !== meaninglessTransform.rotate || transform.flipX || transform.flipY;
}
function transformForSvg(_ref) {
  var transform = _ref.transform,
      containerWidth = _ref.containerWidth,
      iconWidth = _ref.iconWidth;
  var outer = {
    transform: "translate(".concat(containerWidth / 2, " 256)")
  };
  var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
  var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
  var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
  var inner = {
    transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
  };
  var path = {
    transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
  };
  return {
    outer: outer,
    inner: inner,
    path: path
  };
}

var ALL_SPACE = {
  x: 0,
  y: 0,
  width: '100%',
  height: '100%'
};

function fillBlack(abstract) {
  var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (abstract.attributes && (abstract.attributes.fill || force)) {
    abstract.attributes.fill = 'black';
  }

  return abstract;
}

function deGroup(abstract) {
  if (abstract.tag === 'g') {
    return abstract.children;
  } else {
    return [abstract];
  }
}

function makeIconMasking (_ref) {
  var children = _ref.children,
      attributes = _ref.attributes,
      main = _ref.main,
      mask = _ref.mask,
      explicitMaskId = _ref.maskId,
      transform = _ref.transform;
  var mainWidth = main.width,
      mainPath = main.icon;
  var maskWidth = mask.width,
      maskPath = mask.icon;
  var trans = transformForSvg({
    transform: transform,
    containerWidth: maskWidth,
    iconWidth: mainWidth
  });
  var maskRect = {
    tag: 'rect',
    attributes: _objectSpread({}, ALL_SPACE, {
      fill: 'white'
    })
  };
  var maskInnerGroupChildrenMixin = mainPath.children ? {
    children: mainPath.children.map(fillBlack)
  } : {};
  var maskInnerGroup = {
    tag: 'g',
    attributes: _objectSpread({}, trans.inner),
    children: [fillBlack(_objectSpread({
      tag: mainPath.tag,
      attributes: _objectSpread({}, mainPath.attributes, trans.path)
    }, maskInnerGroupChildrenMixin))]
  };
  var maskOuterGroup = {
    tag: 'g',
    attributes: _objectSpread({}, trans.outer),
    children: [maskInnerGroup]
  };
  var maskId = "mask-".concat(explicitMaskId || nextUniqueId());
  var clipId = "clip-".concat(explicitMaskId || nextUniqueId());
  var maskTag = {
    tag: 'mask',
    attributes: _objectSpread({}, ALL_SPACE, {
      id: maskId,
      maskUnits: 'userSpaceOnUse',
      maskContentUnits: 'userSpaceOnUse'
    }),
    children: [maskRect, maskOuterGroup]
  };
  var defs = {
    tag: 'defs',
    children: [{
      tag: 'clipPath',
      attributes: {
        id: clipId
      },
      children: deGroup(maskPath)
    }, maskTag]
  };
  children.push(defs, {
    tag: 'rect',
    attributes: _objectSpread({
      fill: 'currentColor',
      'clip-path': "url(#".concat(clipId, ")"),
      mask: "url(#".concat(maskId, ")")
    }, ALL_SPACE)
  });
  return {
    children: children,
    attributes: attributes
  };
}

function makeIconStandard (_ref) {
  var children = _ref.children,
      attributes = _ref.attributes,
      main = _ref.main,
      transform = _ref.transform,
      styles = _ref.styles;
  var styleString = joinStyles(styles);

  if (styleString.length > 0) {
    attributes['style'] = styleString;
  }

  if (transformIsMeaningful(transform)) {
    var trans = transformForSvg({
      transform: transform,
      containerWidth: main.width,
      iconWidth: main.width
    });
    children.push({
      tag: 'g',
      attributes: _objectSpread({}, trans.outer),
      children: [{
        tag: 'g',
        attributes: _objectSpread({}, trans.inner),
        children: [{
          tag: main.icon.tag,
          children: main.icon.children,
          attributes: _objectSpread({}, main.icon.attributes, trans.path)
        }]
      }]
    });
  } else {
    children.push(main.icon);
  }

  return {
    children: children,
    attributes: attributes
  };
}

function asIcon (_ref) {
  var children = _ref.children,
      main = _ref.main,
      mask = _ref.mask,
      attributes = _ref.attributes,
      styles = _ref.styles,
      transform = _ref.transform;

  if (transformIsMeaningful(transform) && main.found && !mask.found) {
    var width = main.width,
        height = main.height;
    var offset = {
      x: width / height / 2,
      y: 0.5
    };
    attributes['style'] = joinStyles(_objectSpread({}, styles, {
      'transform-origin': "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
    }));
  }

  return [{
    tag: 'svg',
    attributes: attributes,
    children: children
  }];
}

function asSymbol (_ref) {
  var prefix = _ref.prefix,
      iconName = _ref.iconName,
      children = _ref.children,
      attributes = _ref.attributes,
      symbol = _ref.symbol;
  var id = symbol === true ? "".concat(prefix, "-").concat(config.familyPrefix, "-").concat(iconName) : symbol;
  return [{
    tag: 'svg',
    attributes: {
      style: 'display: none;'
    },
    children: [{
      tag: 'symbol',
      attributes: _objectSpread({}, attributes, {
        id: id
      }),
      children: children
    }]
  }];
}

function makeInlineSvgAbstract(params) {
  var _params$icons = params.icons,
      main = _params$icons.main,
      mask = _params$icons.mask,
      prefix = params.prefix,
      iconName = params.iconName,
      transform = params.transform,
      symbol = params.symbol,
      title = params.title,
      maskId = params.maskId,
      titleId = params.titleId,
      extra = params.extra,
      _params$watchable = params.watchable,
      watchable = _params$watchable === void 0 ? false : _params$watchable;

  var _ref = mask.found ? mask : main,
      width = _ref.width,
      height = _ref.height;

  var isUploadedIcon = prefix === 'fak';
  var widthClass = isUploadedIcon ? '' : "fa-w-".concat(Math.ceil(width / height * 16));
  var attrClass = [config.replacementClass, iconName ? "".concat(config.familyPrefix, "-").concat(iconName) : '', widthClass].filter(function (c) {
    return extra.classes.indexOf(c) === -1;
  }).filter(function (c) {
    return c !== '' || !!c;
  }).concat(extra.classes).join(' ');
  var content = {
    children: [],
    attributes: _objectSpread({}, extra.attributes, {
      'data-prefix': prefix,
      'data-icon': iconName,
      'class': attrClass,
      'role': extra.attributes.role || 'img',
      'xmlns': 'http://www.w3.org/2000/svg',
      'viewBox': "0 0 ".concat(width, " ").concat(height)
    })
  };
  var uploadedIconWidthStyle = isUploadedIcon && !~extra.classes.indexOf('fa-fw') ? {
    width: "".concat(width / height * 16 * 0.0625, "em")
  } : {};

  if (watchable) {
    content.attributes[DATA_FA_I2SVG] = '';
  }

  if (title) content.children.push({
    tag: 'title',
    attributes: {
      id: content.attributes['aria-labelledby'] || "title-".concat(titleId || nextUniqueId())
    },
    children: [title]
  });

  var args = _objectSpread({}, content, {
    prefix: prefix,
    iconName: iconName,
    main: main,
    mask: mask,
    maskId: maskId,
    transform: transform,
    symbol: symbol,
    styles: _objectSpread({}, uploadedIconWidthStyle, extra.styles)
  });

  var _ref2 = mask.found && main.found ? makeIconMasking(args) : makeIconStandard(args),
      children = _ref2.children,
      attributes = _ref2.attributes;

  args.children = children;
  args.attributes = attributes;

  if (symbol) {
    return asSymbol(args);
  } else {
    return asIcon(args);
  }
}

var noop$1 = function noop() {};

var p = config.measurePerformance && PERFORMANCE && PERFORMANCE.mark && PERFORMANCE.measure ? PERFORMANCE : {
  mark: noop$1,
  measure: noop$1
};

/**
 * Internal helper to bind a function known to have 4 arguments
 * to a given context.
 */

var bindInternal4 = function bindInternal4(func, thisContext) {
  return function (a, b, c, d) {
    return func.call(thisContext, a, b, c, d);
  };
};

/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */


var reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
  var keys = Object.keys(subject),
      length = keys.length,
      iterator = thisContext !== undefined ? bindInternal4(fn, thisContext) : fn,
      i,
      key,
      result;

  if (initialValue === undefined) {
    i = 1;
    result = subject[keys[0]];
  } else {
    i = 0;
    result = initialValue;
  }

  for (; i < length; i++) {
    key = keys[i];
    result = iterator(result, subject[key], key, subject);
  }

  return result;
};

function defineIcons(prefix, icons) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _params$skipHooks = params.skipHooks,
      skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
  var normalized = Object.keys(icons).reduce(function (acc, iconName) {
    var icon = icons[iconName];
    var expanded = !!icon.icon;

    if (expanded) {
      acc[icon.iconName] = icon.icon;
    } else {
      acc[iconName] = icon;
    }

    return acc;
  }, {});

  if (typeof namespace.hooks.addPack === 'function' && !skipHooks) {
    namespace.hooks.addPack(prefix, normalized);
  } else {
    namespace.styles[prefix] = _objectSpread({}, namespace.styles[prefix] || {}, normalized);
  }
  /**
   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
   * for `fas` so we'll easy the upgrade process for our users by automatically defining
   * this as well.
   */


  if (prefix === 'fas') {
    defineIcons('fa', icons);
  }
}

var styles = namespace.styles,
    shims = namespace.shims;
var _byUnicode = {};
var _byLigature = {};
var _byOldName = {};
var build = function build() {
  var lookup = function lookup(reducer) {
    return reduce(styles, function (o, style, prefix) {
      o[prefix] = reduce(style, reducer, {});
      return o;
    }, {});
  };

  _byUnicode = lookup(function (acc, icon, iconName) {
    if (icon[3]) {
      acc[icon[3]] = iconName;
    }

    return acc;
  });
  _byLigature = lookup(function (acc, icon, iconName) {
    var ligatures = icon[2];
    acc[iconName] = iconName;
    ligatures.forEach(function (ligature) {
      acc[ligature] = iconName;
    });
    return acc;
  });
  var hasRegular = 'far' in styles;
  _byOldName = reduce(shims, function (acc, shim) {
    var oldName = shim[0];
    var prefix = shim[1];
    var iconName = shim[2];

    if (prefix === 'far' && !hasRegular) {
      prefix = 'fas';
    }

    acc[oldName] = {
      prefix: prefix,
      iconName: iconName
    };
    return acc;
  }, {});
};
build();

var styles$1 = namespace.styles;
function iconFromMapping(mapping, prefix, iconName) {
  if (mapping && mapping[prefix] && mapping[prefix][iconName]) {
    return {
      prefix: prefix,
      iconName: iconName,
      icon: mapping[prefix][iconName]
    };
  }
}

function toHtml(abstractNodes) {
  var tag = abstractNodes.tag,
      _abstractNodes$attrib = abstractNodes.attributes,
      attributes = _abstractNodes$attrib === void 0 ? {} : _abstractNodes$attrib,
      _abstractNodes$childr = abstractNodes.children,
      children = _abstractNodes$childr === void 0 ? [] : _abstractNodes$childr;

  if (typeof abstractNodes === 'string') {
    return htmlEscape(abstractNodes);
  } else {
    return "<".concat(tag, " ").concat(joinAttributes(attributes), ">").concat(children.map(toHtml).join(''), "</").concat(tag, ">");
  }
}

var parseTransformString = function parseTransformString(transformString) {
  var transform = {
    size: 16,
    x: 0,
    y: 0,
    flipX: false,
    flipY: false,
    rotate: 0
  };

  if (!transformString) {
    return transform;
  } else {
    return transformString.toLowerCase().split(' ').reduce(function (acc, n) {
      var parts = n.toLowerCase().split('-');
      var first = parts[0];
      var rest = parts.slice(1).join('-');

      if (first && rest === 'h') {
        acc.flipX = true;
        return acc;
      }

      if (first && rest === 'v') {
        acc.flipY = true;
        return acc;
      }

      rest = parseFloat(rest);

      if (isNaN(rest)) {
        return acc;
      }

      switch (first) {
        case 'grow':
          acc.size = acc.size + rest;
          break;

        case 'shrink':
          acc.size = acc.size - rest;
          break;

        case 'left':
          acc.x = acc.x - rest;
          break;

        case 'right':
          acc.x = acc.x + rest;
          break;

        case 'up':
          acc.y = acc.y - rest;
          break;

        case 'down':
          acc.y = acc.y + rest;
          break;

        case 'rotate':
          acc.rotate = acc.rotate + rest;
          break;
      }

      return acc;
    }, transform);
  }
};

function MissingIcon(error) {
  this.name = 'MissingIcon';
  this.message = error || 'Icon unavailable';
  this.stack = new Error().stack;
}
MissingIcon.prototype = Object.create(Error.prototype);
MissingIcon.prototype.constructor = MissingIcon;

var FILL = {
  fill: 'currentColor'
};
var ANIMATION_BASE = {
  attributeType: 'XML',
  repeatCount: 'indefinite',
  dur: '2s'
};
var RING = {
  tag: 'path',
  attributes: _objectSpread({}, FILL, {
    d: 'M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z'
  })
};

var OPACITY_ANIMATE = _objectSpread({}, ANIMATION_BASE, {
  attributeName: 'opacity'
});

var DOT = {
  tag: 'circle',
  attributes: _objectSpread({}, FILL, {
    cx: '256',
    cy: '364',
    r: '28'
  }),
  children: [{
    tag: 'animate',
    attributes: _objectSpread({}, ANIMATION_BASE, {
      attributeName: 'r',
      values: '28;14;28;28;14;28;'
    })
  }, {
    tag: 'animate',
    attributes: _objectSpread({}, OPACITY_ANIMATE, {
      values: '1;0;1;1;0;1;'
    })
  }]
};
var QUESTION = {
  tag: 'path',
  attributes: _objectSpread({}, FILL, {
    opacity: '1',
    d: 'M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z'
  }),
  children: [{
    tag: 'animate',
    attributes: _objectSpread({}, OPACITY_ANIMATE, {
      values: '1;0;0;0;0;1;'
    })
  }]
};
var EXCLAMATION = {
  tag: 'path',
  attributes: _objectSpread({}, FILL, {
    opacity: '0',
    d: 'M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z'
  }),
  children: [{
    tag: 'animate',
    attributes: _objectSpread({}, OPACITY_ANIMATE, {
      values: '0;0;1;1;0;0;'
    })
  }]
};

var styles$2 = namespace.styles;
function asFoundIcon(icon) {
  var width = icon[0];
  var height = icon[1];

  var _icon$slice = icon.slice(4),
      _icon$slice2 = _slicedToArray(_icon$slice, 1),
      vectorData = _icon$slice2[0];

  var element = null;

  if (Array.isArray(vectorData)) {
    element = {
      tag: 'g',
      attributes: {
        class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.GROUP)
      },
      children: [{
        tag: 'path',
        attributes: {
          class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.SECONDARY),
          fill: 'currentColor',
          d: vectorData[0]
        }
      }, {
        tag: 'path',
        attributes: {
          class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.PRIMARY),
          fill: 'currentColor',
          d: vectorData[1]
        }
      }]
    };
  } else {
    element = {
      tag: 'path',
      attributes: {
        fill: 'currentColor',
        d: vectorData
      }
    };
  }

  return {
    found: true,
    width: width,
    height: height,
    icon: element
  };
}

var styles$3 = namespace.styles;

var baseStyles = "svg:not(:root).svg-inline--fa {\n  overflow: visible;\n}\n\n.svg-inline--fa {\n  display: inline-block;\n  font-size: inherit;\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.225em;\n}\n.svg-inline--fa.fa-w-1 {\n  width: 0.0625em;\n}\n.svg-inline--fa.fa-w-2 {\n  width: 0.125em;\n}\n.svg-inline--fa.fa-w-3 {\n  width: 0.1875em;\n}\n.svg-inline--fa.fa-w-4 {\n  width: 0.25em;\n}\n.svg-inline--fa.fa-w-5 {\n  width: 0.3125em;\n}\n.svg-inline--fa.fa-w-6 {\n  width: 0.375em;\n}\n.svg-inline--fa.fa-w-7 {\n  width: 0.4375em;\n}\n.svg-inline--fa.fa-w-8 {\n  width: 0.5em;\n}\n.svg-inline--fa.fa-w-9 {\n  width: 0.5625em;\n}\n.svg-inline--fa.fa-w-10 {\n  width: 0.625em;\n}\n.svg-inline--fa.fa-w-11 {\n  width: 0.6875em;\n}\n.svg-inline--fa.fa-w-12 {\n  width: 0.75em;\n}\n.svg-inline--fa.fa-w-13 {\n  width: 0.8125em;\n}\n.svg-inline--fa.fa-w-14 {\n  width: 0.875em;\n}\n.svg-inline--fa.fa-w-15 {\n  width: 0.9375em;\n}\n.svg-inline--fa.fa-w-16 {\n  width: 1em;\n}\n.svg-inline--fa.fa-w-17 {\n  width: 1.0625em;\n}\n.svg-inline--fa.fa-w-18 {\n  width: 1.125em;\n}\n.svg-inline--fa.fa-w-19 {\n  width: 1.1875em;\n}\n.svg-inline--fa.fa-w-20 {\n  width: 1.25em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-border {\n  height: 1.5em;\n}\n.svg-inline--fa.fa-li {\n  width: 2em;\n}\n.svg-inline--fa.fa-fw {\n  width: 1.25em;\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: #ff253a;\n  border-radius: 1em;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  color: #fff;\n  height: 1.5em;\n  line-height: 1;\n  max-width: 5em;\n  min-width: 1.5em;\n  overflow: hidden;\n  padding: 0.25em;\n  right: 0;\n  text-overflow: ellipsis;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: 0;\n  right: 0;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: 0;\n  left: 0;\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  right: 0;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: 0;\n  right: auto;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-lg {\n  font-size: 1.3333333333em;\n  line-height: 0.75em;\n  vertical-align: -0.0667em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: 2.5em;\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: -2em;\n  position: absolute;\n  text-align: center;\n  width: 2em;\n  line-height: inherit;\n}\n\n.fa-border {\n  border: solid 0.08em #eee;\n  border-radius: 0.1em;\n  padding: 0.2em 0.25em 0.15em;\n}\n\n.fa-pull-left {\n  float: left;\n}\n\n.fa-pull-right {\n  float: right;\n}\n\n.fa.fa-pull-left,\n.fas.fa-pull-left,\n.far.fa-pull-left,\n.fal.fa-pull-left,\n.fab.fa-pull-left {\n  margin-right: 0.3em;\n}\n.fa.fa-pull-right,\n.fas.fa-pull-right,\n.far.fa-pull-right,\n.fal.fa-pull-right,\n.fab.fa-pull-right {\n  margin-left: 0.3em;\n}\n\n.fa-spin {\n  -webkit-animation: fa-spin 2s infinite linear;\n          animation: fa-spin 2s infinite linear;\n}\n\n.fa-pulse {\n  -webkit-animation: fa-spin 1s infinite steps(8);\n          animation: fa-spin 1s infinite steps(8);\n}\n\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both, .fa-flip-horizontal.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n:root .fa-rotate-90,\n:root .fa-rotate-180,\n:root .fa-rotate-270,\n:root .fa-flip-horizontal,\n:root .fa-flip-vertical,\n:root .fa-flip-both {\n  -webkit-filter: none;\n          filter: none;\n}\n\n.fa-stack {\n  display: inline-block;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: #fff;\n}\n\n.sr-only {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  clip: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  position: static;\n  width: auto;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: 1;\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: 0.4;\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: 0.4;\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: 1;\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse {\n  color: #fff;\n}";

function css () {
  var dfp = DEFAULT_FAMILY_PREFIX;
  var drc = DEFAULT_REPLACEMENT_CLASS;
  var fp = config.familyPrefix;
  var rc = config.replacementClass;
  var s = baseStyles;

  if (fp !== dfp || rc !== drc) {
    var dPatt = new RegExp("\\.".concat(dfp, "\\-"), 'g');
    var customPropPatt = new RegExp("\\--".concat(dfp, "\\-"), 'g');
    var rPatt = new RegExp("\\.".concat(drc), 'g');
    s = s.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
  }

  return s;
}

var Library =
/*#__PURE__*/
function () {
  function Library() {
    _classCallCheck(this, Library);

    this.definitions = {};
  }

  _createClass(Library, [{
    key: "add",
    value: function add() {
      var _this = this;

      for (var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++) {
        definitions[_key] = arguments[_key];
      }

      var additions = definitions.reduce(this._pullDefinitions, {});
      Object.keys(additions).forEach(function (key) {
        _this.definitions[key] = _objectSpread({}, _this.definitions[key] || {}, additions[key]);
        defineIcons(key, additions[key]);
        build();
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      this.definitions = {};
    }
  }, {
    key: "_pullDefinitions",
    value: function _pullDefinitions(additions, definition) {
      var normalized = definition.prefix && definition.iconName && definition.icon ? {
        0: definition
      } : definition;
      Object.keys(normalized).map(function (key) {
        var _normalized$key = normalized[key],
            prefix = _normalized$key.prefix,
            iconName = _normalized$key.iconName,
            icon = _normalized$key.icon;
        if (!additions[prefix]) additions[prefix] = {};
        additions[prefix][iconName] = icon;
      });
      return additions;
    }
  }]);

  return Library;
}();

function ensureCss() {
  if (config.autoAddCss && !_cssInserted) {
    insertCss(css());

    _cssInserted = true;
  }
}

function apiObject(val, abstractCreator) {
  Object.defineProperty(val, 'abstract', {
    get: abstractCreator
  });
  Object.defineProperty(val, 'html', {
    get: function get() {
      return val.abstract.map(function (a) {
        return toHtml(a);
      });
    }
  });
  Object.defineProperty(val, 'node', {
    get: function get() {
      if (!IS_DOM) return;
      var container = DOCUMENT.createElement('div');
      container.innerHTML = val.html;
      return container.children;
    }
  });
  return val;
}

function findIconDefinition(iconLookup) {
  var _iconLookup$prefix = iconLookup.prefix,
      prefix = _iconLookup$prefix === void 0 ? 'fa' : _iconLookup$prefix,
      iconName = iconLookup.iconName;
  if (!iconName) return;
  return iconFromMapping(library.definitions, prefix, iconName) || iconFromMapping(namespace.styles, prefix, iconName);
}

function resolveIcons(next) {
  return function (maybeIconDefinition) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : findIconDefinition(maybeIconDefinition || {});
    var mask = params.mask;

    if (mask) {
      mask = (mask || {}).icon ? mask : findIconDefinition(mask || {});
    }

    return next(iconDefinition, _objectSpread({}, params, {
      mask: mask
    }));
  };
}

var library = new Library();
var _cssInserted = false;
var parse = {
  transform: function transform(transformString) {
    return parseTransformString(transformString);
  }
};
var icon = resolveIcons(function (iconDefinition) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$transform = params.transform,
      transform = _params$transform === void 0 ? meaninglessTransform : _params$transform,
      _params$symbol = params.symbol,
      symbol = _params$symbol === void 0 ? false : _params$symbol,
      _params$mask = params.mask,
      mask = _params$mask === void 0 ? null : _params$mask,
      _params$maskId = params.maskId,
      maskId = _params$maskId === void 0 ? null : _params$maskId,
      _params$title = params.title,
      title = _params$title === void 0 ? null : _params$title,
      _params$titleId = params.titleId,
      titleId = _params$titleId === void 0 ? null : _params$titleId,
      _params$classes = params.classes,
      classes = _params$classes === void 0 ? [] : _params$classes,
      _params$attributes = params.attributes,
      attributes = _params$attributes === void 0 ? {} : _params$attributes,
      _params$styles = params.styles,
      styles = _params$styles === void 0 ? {} : _params$styles;
  if (!iconDefinition) return;
  var prefix = iconDefinition.prefix,
      iconName = iconDefinition.iconName,
      icon = iconDefinition.icon;
  return apiObject(_objectSpread({
    type: 'icon'
  }, iconDefinition), function () {
    ensureCss();

    if (config.autoA11y) {
      if (title) {
        attributes['aria-labelledby'] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
      } else {
        attributes['aria-hidden'] = 'true';
        attributes['focusable'] = 'false';
      }
    }

    return makeInlineSvgAbstract({
      icons: {
        main: asFoundIcon(icon),
        mask: mask ? asFoundIcon(mask.icon) : {
          found: false,
          width: null,
          height: null,
          icon: {}
        }
      },
      prefix: prefix,
      iconName: iconName,
      transform: _objectSpread({}, meaninglessTransform, transform),
      symbol: symbol,
      title: title,
      maskId: maskId,
      titleId: titleId,
      extra: {
        attributes: attributes,
        styles: styles,
        classes: classes
      }
    });
  });
});

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

// Get CSS class list from a props object
function classList(props) {
  var _classes;

  var spin = props.spin,
      pulse = props.pulse,
      fixedWidth = props.fixedWidth,
      inverse = props.inverse,
      border = props.border,
      listItem = props.listItem,
      flip = props.flip,
      size = props.size,
      rotation = props.rotation,
      pull = props.pull; // map of CSS class names to properties

  var classes = (_classes = {
    'fa-spin': spin,
    'fa-pulse': pulse,
    'fa-fw': fixedWidth,
    'fa-inverse': inverse,
    'fa-border': border,
    'fa-li': listItem,
    'fa-flip-horizontal': flip === 'horizontal' || flip === 'both',
    'fa-flip-vertical': flip === 'vertical' || flip === 'both'
  }, _defineProperty$1(_classes, "fa-".concat(size), typeof size !== 'undefined' && size !== null), _defineProperty$1(_classes, "fa-rotate-".concat(rotation), typeof rotation !== 'undefined' && rotation !== null && rotation !== 0), _defineProperty$1(_classes, "fa-pull-".concat(pull), typeof pull !== 'undefined' && pull !== null), _defineProperty$1(_classes, 'fa-swap-opacity', props.swapOpacity), _classes); // map over all the keys in the classes object
  // return an array of the keys where the value for the key is not null

  return Object.keys(classes).map(function (key) {
    return classes[key] ? key : null;
  }).filter(function (key) {
    return key;
  });
}

// Camelize taken from humps
// humps is copyright © 2012+ Dom Christie
// Released under the MIT license.
// Performant way to determine if object coerces to a number
function _isNumerical(obj) {
  obj = obj - 0; // eslint-disable-next-line no-self-compare

  return obj === obj;
}

function camelize(string) {
  if (_isNumerical(string)) {
    return string;
  } // eslint-disable-next-line no-useless-escape


  string = string.replace(/[\-_\s]+(.)?/g, function (match, chr) {
    return chr ? chr.toUpperCase() : '';
  }); // Ensure 1st char is always lowercase

  return string.substr(0, 1).toLowerCase() + string.substr(1);
}

function capitalize(val) {
  return val.charAt(0).toUpperCase() + val.slice(1);
}

function styleToObject(style) {
  return style.split(';').map(function (s) {
    return s.trim();
  }).filter(function (s) {
    return s;
  }).reduce(function (acc, pair) {
    var i = pair.indexOf(':');
    var prop = camelize(pair.slice(0, i));
    var value = pair.slice(i + 1).trim();
    prop.startsWith('webkit') ? acc[capitalize(prop)] = value : acc[prop] = value;
    return acc;
  }, {});
}

function convert(createElement, element) {
  var extraProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (typeof element === 'string') {
    return element;
  }

  var children = (element.children || []).map(function (child) {
    return convert(createElement, child);
  });
  /* eslint-disable dot-notation */

  var mixins = Object.keys(element.attributes || {}).reduce(function (acc, key) {
    var val = element.attributes[key];

    switch (key) {
      case 'class':
        acc.attrs['className'] = val;
        delete element.attributes['class'];
        break;

      case 'style':
        acc.attrs['style'] = styleToObject(val);
        break;

      default:
        if (key.indexOf('aria-') === 0 || key.indexOf('data-') === 0) {
          acc.attrs[key.toLowerCase()] = val;
        } else {
          acc.attrs[camelize(key)] = val;
        }

    }

    return acc;
  }, {
    attrs: {}
  });

  var _extraProps$style = extraProps.style,
      existingStyle = _extraProps$style === void 0 ? {} : _extraProps$style,
      remaining = _objectWithoutProperties(extraProps, ["style"]);

  mixins.attrs['style'] = _objectSpread2({}, mixins.attrs['style'], {}, existingStyle);
  /* eslint-enable */

  return createElement.apply(void 0, [element.tag, _objectSpread2({}, mixins.attrs, {}, remaining)].concat(_toConsumableArray(children)));
}

var PRODUCTION$1 = false;

try {
  PRODUCTION$1 = process.env.NODE_ENV === 'production';
} catch (e) {}

function log () {
  if (!PRODUCTION$1 && console && typeof console.error === 'function') {
    var _console;

    (_console = console).error.apply(_console, arguments);
  }
}

function normalizeIconArgs(icon) {
  if (parse.icon) {
    return parse.icon(icon);
  } // if the icon is null, there's nothing to do


  if (icon === null) {
    return null;
  } // if the icon is an object and has a prefix and an icon name, return it


  if (_typeof(icon) === 'object' && icon.prefix && icon.iconName) {
    return icon;
  } // if it's an array with length of two


  if (Array.isArray(icon) && icon.length === 2) {
    // use the first item as prefix, second as icon name
    return {
      prefix: icon[0],
      iconName: icon[1]
    };
  } // if it's a string, use it as the icon name


  if (typeof icon === 'string') {
    return {
      prefix: 'fas',
      iconName: icon
    };
  }
}

// creates an object with a key of key
// and a value of value
// if certain conditions are met
function objectWithKey(key, value) {
  // if the value is a non-empty array
  // or it's not an array but it is truthy
  // then create the object with the key and the value
  // if not, return an empty array
  return Array.isArray(value) && value.length > 0 || !Array.isArray(value) && value ? _defineProperty$1({}, key, value) : {};
}

function FontAwesomeIcon(_ref) {
  var forwardedRef = _ref.forwardedRef,
      props = _objectWithoutProperties(_ref, ["forwardedRef"]);

  var iconArgs = props.icon,
      maskArgs = props.mask,
      symbol = props.symbol,
      className = props.className,
      title = props.title,
      titleId = props.titleId;
  var iconLookup = normalizeIconArgs(iconArgs);
  var classes = objectWithKey('classes', [].concat(_toConsumableArray(classList(props)), _toConsumableArray(className.split(' '))));
  var transform = objectWithKey('transform', typeof props.transform === 'string' ? parse.transform(props.transform) : props.transform);
  var mask = objectWithKey('mask', normalizeIconArgs(maskArgs));
  var renderedIcon = icon(iconLookup, _objectSpread2({}, classes, {}, transform, {}, mask, {
    symbol: symbol,
    title: title,
    titleId: titleId
  }));

  if (!renderedIcon) {
    log('Could not find icon', iconLookup);
    return null;
  }

  var abstract = renderedIcon.abstract;
  var extraProps = {
    ref: forwardedRef
  };
  Object.keys(props).forEach(function (key) {
    // eslint-disable-next-line no-prototype-builtins
    if (!FontAwesomeIcon.defaultProps.hasOwnProperty(key)) {
      extraProps[key] = props[key];
    }
  });
  return convertCurry(abstract[0], extraProps);
}
FontAwesomeIcon.displayName = 'FontAwesomeIcon';
FontAwesomeIcon.propTypes = {
  border: PropTypes.bool,
  className: PropTypes.string,
  mask: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),
  fixedWidth: PropTypes.bool,
  inverse: PropTypes.bool,
  flip: PropTypes.oneOf(['horizontal', 'vertical', 'both']),
  icon: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),
  listItem: PropTypes.bool,
  pull: PropTypes.oneOf(['right', 'left']),
  pulse: PropTypes.bool,
  rotation: PropTypes.oneOf([0, 90, 180, 270]),
  size: PropTypes.oneOf(['lg', 'xs', 'sm', '1x', '2x', '3x', '4x', '5x', '6x', '7x', '8x', '9x', '10x']),
  spin: PropTypes.bool,
  symbol: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  title: PropTypes.string,
  transform: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  swapOpacity: PropTypes.bool
};
FontAwesomeIcon.defaultProps = {
  border: false,
  className: '',
  mask: null,
  fixedWidth: false,
  inverse: false,
  flip: null,
  icon: null,
  listItem: false,
  pull: null,
  pulse: false,
  rotation: null,
  size: null,
  spin: false,
  symbol: false,
  title: '',
  transform: null,
  swapOpacity: false
};
var convertCurry = convert.bind(null, React__default.createElement);

function hash(str) {
  var hash = 5381,
      i    = str.length;

  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }

  /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
   * integers. Since we want the results to be always positive, convert the
   * signed int to an unsigned by doing an unsigned bitshift. */
  return hash >>> 0;
}

var stringHash = hash;

var domain; // The domain module is executed on demand
var hasSetImmediate = typeof setImmediate === "function";

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including network IO events in Node.js.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
var raw = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Avoids a function call
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory excaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

rawAsap.requestFlush = requestFlush;
function requestFlush() {
    // Ensure flushing is not bound to any domain.
    // It is not sufficient to exit the domain, because domains exist on a stack.
    // To execute code outside of any domain, the following dance is necessary.
    var parentDomain = process.domain;
    if (parentDomain) {
        if (!domain) {
            // Lazy execute the domain module.
            // Only employed if the user elects to use domains.
            domain = domain$1;
        }
        domain.active = process.domain = null;
    }

    // `setImmediate` is slower that `process.nextTick`, but `process.nextTick`
    // cannot handle recursion.
    // `requestFlush` will only be called recursively from `asap.js`, to resume
    // flushing after an error is thrown into a domain.
    // Conveniently, `setImmediate` was introduced in the same version
    // `process.nextTick` started throwing recursion errors.
    if (flushing && hasSetImmediate) {
        setImmediate(flush);
    } else {
        process.nextTick(flush);
    }

    if (parentDomain) {
        domain.active = process.domain = parentDomain;
    }
}

var freeTasks = [];

/**
 * Calls a task as soon as possible after returning, in its own event, with
 * priority over IO events. An exception thrown in a task can be handled by
 * `process.on("uncaughtException") or `domain.on("error")`, but will otherwise
 * crash the process. If the error is handled, all subsequent tasks will
 * resume.
 *
 * @param {{call}} task A callable object, typically a function that takes no
 * arguments.
 */
var asap_1 = asap;
function asap(task) {
    var rawTask;
    if (freeTasks.length) {
        rawTask = freeTasks.pop();
    } else {
        rawTask = new RawTask();
    }
    rawTask.task = task;
    rawTask.domain = process.domain;
    raw(rawTask);
}

function RawTask() {
    this.task = null;
    this.domain = null;
}

RawTask.prototype.call = function () {
    if (this.domain) {
        this.domain.enter();
    }
    var threw = true;
    try {
        this.task.call();
        threw = false;
        // If the task throws an exception (presumably) Node.js restores the
        // domain stack for the next event.
        if (this.domain) {
            this.domain.exit();
        }
    } finally {
        // We use try/finally and a threw flag to avoid messing up stack traces
        // when we catch and release errors.
        if (threw) {
            // In Node.js, uncaught exceptions are considered fatal errors.
            // Re-throw them to interrupt flushing!
            // Ensure that flushing continues if an uncaught exception is
            // suppressed listening process.on("uncaughtException") or
            // domain.on("error").
            raw.requestFlush();
        }
        // If the task threw an error, we do not want to exit the domain here.
        // Exiting the domain would prevent the domain from catching the error.
        this.task = null;
        this.domain = null;
        freeTasks.push(this);
    }
};

function _typeof$1(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$1 = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof$1 = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof$1(obj);
}

function _defineProperty$2(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty$2(target, key, source[key]);
    });
  }

  return target;
}

function _toConsumableArray$1(arr) {
  return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _nonIterableSpread$1();
}

function _arrayWithoutHoles$1(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray$1(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread$1() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

/* @flow */
/* ::
type ObjectMap = { [id:string]: any };
*/

var UPPERCASE_RE = /([A-Z])/g;

var UPPERCASE_RE_TO_KEBAB = function UPPERCASE_RE_TO_KEBAB(match
/* : string */
) {
  return (
    /* : string */
    "-".concat(match.toLowerCase())
  );
};

var kebabifyStyleName = function kebabifyStyleName(string
/* : string */
)
/* : string */
{
  var result = string.replace(UPPERCASE_RE, UPPERCASE_RE_TO_KEBAB);

  if (result[0] === 'm' && result[1] === 's' && result[2] === '-') {
    return "-".concat(result);
  }

  return result;
};
/**
 * CSS properties which accept numbers but are not in units of "px".
 * Taken from React's CSSProperty.js
 */

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridColumn: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,
  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};
/**
 * Taken from React's CSSProperty.js
 *
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */

function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}
/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 * Taken from React's CSSProperty.js
 */


var prefixes = ['Webkit', 'ms', 'Moz', 'O']; // Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
// Taken from React's CSSProperty.js

Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});
var stringifyValue = function stringifyValue(key
/* : string */
, prop
/* : any */
)
/* : string */
{
  if (typeof prop === "number") {
    if (isUnitlessNumber[key]) {
      return "" + prop;
    } else {
      return prop + "px";
    }
  } else {
    return '' + prop;
  }
};
var stringifyAndImportantifyValue = function stringifyAndImportantifyValue(key
/* : string */
, prop
/* : any */
) {
  return (
    /* : string */
    importantify(stringifyValue(key, prop))
  );
}; // Turn a string into a hash string of base-36 values (using letters and numbers)
// eslint-disable-next-line no-unused-vars

var hashString = function hashString(string
/* : string */
, key
/* : ?string */
) {
  return (
    /* string */
    stringHash(string).toString(36)
  );
}; // Hash a javascript object using JSON.stringify. This is very fast, about 3
// microseconds on my computer for a sample object:
// http://jsperf.com/test-hashfnv32a-hash/5
//
// Note that this uses JSON.stringify to stringify the objects so in order for
// this to produce consistent hashes browsers need to have a consistent
// ordering of objects. Ben Alpert says that Facebook depends on this, so we
// can probably depend on this too.

var hashObject = function hashObject(object
/* : ObjectMap */
) {
  return (
    /* : string */
    hashString(JSON.stringify(object))
  );
}; // Given a single style value string like the "b" from "a: b;", adds !important
// to generate "b !important".

var importantify = function importantify(string
/* : string */
) {
  return (
    /* : string */
    // Bracket string character access is very fast, and in the default case we
    // normally don't expect there to be "!important" at the end of the string
    // so we can use this simple check to take an optimized path. If there
    // happens to be a "!" in this position, we follow up with a more thorough
    // check.
    string[string.length - 10] === '!' && string.slice(-11) === ' !important' ? string : "".concat(string, " !important")
  );
};

/* @flow */
var MAP_EXISTS = typeof Map !== 'undefined';

var OrderedElements =
/*#__PURE__*/
function () {
  /* ::
  elements: {[string]: any};
  keyOrder: string[];
  */
  function OrderedElements() {
    this.elements = {};
    this.keyOrder = [];
  }

  var _proto = OrderedElements.prototype;

  _proto.forEach = function forEach(callback
  /* : (string, any) => void */
  ) {
    for (var i = 0; i < this.keyOrder.length; i++) {
      // (value, key) to match Map's API
      callback(this.elements[this.keyOrder[i]], this.keyOrder[i]);
    }
  };

  _proto.set = function set(key
  /* : string */
  , value
  /* : any */
  , shouldReorder
  /* : ?boolean */
  ) {
    if (!this.elements.hasOwnProperty(key)) {
      this.keyOrder.push(key);
    } else if (shouldReorder) {
      var index = this.keyOrder.indexOf(key);
      this.keyOrder.splice(index, 1);
      this.keyOrder.push(key);
    }

    if (value == null) {
      this.elements[key] = value;
      return;
    }

    if (MAP_EXISTS && value instanceof Map || value instanceof OrderedElements) {
      // We have found a nested Map, so we need to recurse so that all
      // of the nested objects and Maps are merged properly.
      var nested = this.elements.hasOwnProperty(key) ? this.elements[key] : new OrderedElements();
      value.forEach(function (value, key) {
        nested.set(key, value, shouldReorder);
      });
      this.elements[key] = nested;
      return;
    }

    if (!Array.isArray(value) && _typeof$1(value) === 'object') {
      // We have found a nested object, so we need to recurse so that all
      // of the nested objects and Maps are merged properly.
      var _nested = this.elements.hasOwnProperty(key) ? this.elements[key] : new OrderedElements();

      var keys = Object.keys(value);

      for (var i = 0; i < keys.length; i += 1) {
        _nested.set(keys[i], value[keys[i]], shouldReorder);
      }

      this.elements[key] = _nested;
      return;
    }

    this.elements[key] = value;
  };

  _proto.get = function get(key
  /* : string */
  )
  /* : any */
  {
    return this.elements[key];
  };

  _proto.has = function has(key
  /* : string */
  )
  /* : boolean */
  {
    return this.elements.hasOwnProperty(key);
  };

  _proto.addStyleType = function addStyleType(styleType
  /* : any */
  )
  /* : void */
  {
    var _this = this;

    if (MAP_EXISTS && styleType instanceof Map || styleType instanceof OrderedElements) {
      styleType.forEach(function (value, key) {
        _this.set(key, value, true);
      });
    } else {
      var keys = Object.keys(styleType);

      for (var i = 0; i < keys.length; i++) {
        this.set(keys[i], styleType[keys[i]], true);
      }
    }
  };

  return OrderedElements;
}();

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x.default : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

function getCjsExportFromNamespace (n) {
	return n && n.default || n;
}

var capitalizeString_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = capitalizeString;
function capitalizeString(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
});

unwrapExports(capitalizeString_1);

var prefixProperty_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixProperty;



var _capitalizeString2 = _interopRequireDefault(capitalizeString_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function prefixProperty(prefixProperties, property, style) {
  if (prefixProperties.hasOwnProperty(property)) {
    var newStyle = {};
    var requiredPrefixes = prefixProperties[property];
    var capitalizedProperty = (0, _capitalizeString2.default)(property);
    var keys = Object.keys(style);
    for (var i = 0; i < keys.length; i++) {
      var styleProperty = keys[i];
      if (styleProperty === property) {
        for (var j = 0; j < requiredPrefixes.length; j++) {
          newStyle[requiredPrefixes[j] + capitalizedProperty] = style[property];
        }
      }
      newStyle[styleProperty] = style[styleProperty];
    }
    return newStyle;
  }
  return style;
}
});

unwrapExports(prefixProperty_1);

var prefixValue_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixValue;
function prefixValue(plugins, property, value, style, metaData) {
  for (var i = 0, len = plugins.length; i < len; ++i) {
    var processedValue = plugins[i](property, value, style, metaData);

    // we can stop processing if a value is returned
    // as all plugin criteria are unique
    if (processedValue) {
      return processedValue;
    }
  }
}
});

unwrapExports(prefixValue_1);

var addNewValuesOnly_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addNewValuesOnly;
function addIfNew(list, value) {
  if (list.indexOf(value) === -1) {
    list.push(value);
  }
}

function addNewValuesOnly(list, values) {
  if (Array.isArray(values)) {
    for (var i = 0, len = values.length; i < len; ++i) {
      addIfNew(list, values[i]);
    }
  } else {
    addIfNew(list, values);
  }
}
});

unwrapExports(addNewValuesOnly_1);

var isObject_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isObject;
function isObject(value) {
  return value instanceof Object && !Array.isArray(value);
}
});

unwrapExports(isObject_1);

var createPrefixer_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createPrefixer;



var _prefixProperty2 = _interopRequireDefault(prefixProperty_1);



var _prefixValue2 = _interopRequireDefault(prefixValue_1);



var _addNewValuesOnly2 = _interopRequireDefault(addNewValuesOnly_1);



var _isObject2 = _interopRequireDefault(isObject_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createPrefixer(_ref) {
  var prefixMap = _ref.prefixMap,
      plugins = _ref.plugins;

  return function prefix(style) {
    for (var property in style) {
      var value = style[property];

      // handle nested objects
      if ((0, _isObject2.default)(value)) {
        style[property] = prefix(value);
        // handle array values
      } else if (Array.isArray(value)) {
        var combinedValue = [];

        for (var i = 0, len = value.length; i < len; ++i) {
          var processedValue = (0, _prefixValue2.default)(plugins, property, value[i], style, prefixMap);
          (0, _addNewValuesOnly2.default)(combinedValue, processedValue || value[i]);
        }

        // only modify the value if it was touched
        // by any plugin to prevent unnecessary mutations
        if (combinedValue.length > 0) {
          style[property] = combinedValue;
        }
      } else {
        var _processedValue = (0, _prefixValue2.default)(plugins, property, value, style, prefixMap);

        // only modify the value if it was touched
        // by any plugin to prevent unnecessary mutations
        if (_processedValue) {
          style[property] = _processedValue;
        }

        style = (0, _prefixProperty2.default)(prefixMap, property, style);
      }
    }

    return style;
  };
}
});

var createPrefixer = unwrapExports(createPrefixer_1);

var backgroundClip_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = backgroundClip;

// https://developer.mozilla.org/en-US/docs/Web/CSS/background-clip#Browser_compatibility
function backgroundClip(property, value) {
  if (typeof value === 'string' && value === 'text') {
    return ['-webkit-text', 'text'];
  }
}
});

var backgroundClip = unwrapExports(backgroundClip_1);

var isPrefixedValue_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isPrefixedValue;
var regex = /-webkit-|-moz-|-ms-/;

function isPrefixedValue(value) {
  return typeof value === 'string' && regex.test(value);
}
module.exports = exports['default'];
});

unwrapExports(isPrefixedValue_1);

var calc_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = calc;



var _isPrefixedValue2 = _interopRequireDefault(isPrefixedValue_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prefixes = ['-webkit-', '-moz-', ''];
function calc(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('calc(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/calc\(/g, prefix + 'calc(');
    });
  }
}
});

var calc = unwrapExports(calc_1);

var crossFade_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = crossFade;



var _isPrefixedValue2 = _interopRequireDefault(isPrefixedValue_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://caniuse.com/#search=cross-fade
var prefixes = ['-webkit-', ''];
function crossFade(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('cross-fade(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/cross-fade\(/g, prefix + 'cross-fade(');
    });
  }
}
});

var crossFade = unwrapExports(crossFade_1);

var cursor_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = cursor;
var prefixes = ['-webkit-', '-moz-', ''];

var values = {
  'zoom-in': true,
  'zoom-out': true,
  grab: true,
  grabbing: true
};

function cursor(property, value) {
  if (property === 'cursor' && values.hasOwnProperty(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
});

var cursor = unwrapExports(cursor_1);

var filter_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = filter;



var _isPrefixedValue2 = _interopRequireDefault(isPrefixedValue_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://caniuse.com/#feat=css-filter-function
var prefixes = ['-webkit-', ''];
function filter(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('filter(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/filter\(/g, prefix + 'filter(');
    });
  }
}
});

var filter = unwrapExports(filter_1);

var flex_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flex;
var values = {
  flex: ['-webkit-box', '-moz-box', '-ms-flexbox', '-webkit-flex', 'flex'],
  'inline-flex': ['-webkit-inline-box', '-moz-inline-box', '-ms-inline-flexbox', '-webkit-inline-flex', 'inline-flex']
};

function flex(property, value) {
  if (property === 'display' && values.hasOwnProperty(value)) {
    return values[value];
  }
}
});

var flex = unwrapExports(flex_1);

var flexboxIE_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxIE;
var alternativeValues = {
  'space-around': 'distribute',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end'
};
var alternativeProps = {
  alignContent: 'msFlexLinePack',
  alignSelf: 'msFlexItemAlign',
  alignItems: 'msFlexAlign',
  justifyContent: 'msFlexPack',
  order: 'msFlexOrder',
  flexGrow: 'msFlexPositive',
  flexShrink: 'msFlexNegative',
  flexBasis: 'msFlexPreferredSize'
  // Full expanded syntax is flex-grow | flex-shrink | flex-basis.
};var flexShorthandMappings = {
  auto: '1 1 auto',
  inherit: 'inherit',
  initial: '0 1 auto',
  none: '0 0 auto',
  unset: 'unset'
};
var isUnitlessNumber = /^\d+(\.\d+)?$/;

function flexboxIE(property, value, style) {
  if (Object.prototype.hasOwnProperty.call(alternativeProps, property)) {
    style[alternativeProps[property]] = alternativeValues[value] || value;
  }
  if (property === 'flex') {
    // For certain values we can do straight mappings based on the spec
    // for the expansions.
    if (Object.prototype.hasOwnProperty.call(flexShorthandMappings, value)) {
      style.msFlex = flexShorthandMappings[value];
      return;
    }
    // Here we have no direct mapping, so we favor looking for a
    // unitless positive number as that will be the most common use-case.
    if (isUnitlessNumber.test(value)) {
      style.msFlex = value + ' 1 0%';
      return;
    }

    // The next thing we can look for is if there are multiple values.
    var flexValues = value.split(/\s/);
    // If we only have a single value that wasn't a positive unitless
    // or a pre-mapped value, then we can assume it is a unit value.
    switch (flexValues.length) {
      case 1:
        style.msFlex = '1 1 ' + value;
        return;
      case 2:
        // If we have 2 units, then we expect that the first will
        // always be a unitless number and represents flex-grow.
        // The second unit will represent flex-shrink for a unitless
        // value, or flex-basis otherwise.
        if (isUnitlessNumber.test(flexValues[1])) {
          style.msFlex = flexValues[0] + ' ' + flexValues[1] + ' 0%';
        } else {
          style.msFlex = flexValues[0] + ' 1 ' + flexValues[1];
        }
        return;
      default:
        style.msFlex = value;
    }
  }
}
});

var flexboxIE = unwrapExports(flexboxIE_1);

var flexboxOld_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxOld;
var alternativeValues = {
  'space-around': 'justify',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  'wrap-reverse': 'multiple',
  wrap: 'multiple'
};

var alternativeProps = {
  alignItems: 'WebkitBoxAlign',
  justifyContent: 'WebkitBoxPack',
  flexWrap: 'WebkitBoxLines',
  flexGrow: 'WebkitBoxFlex'
};

function flexboxOld(property, value, style) {
  if (property === 'flexDirection' && typeof value === 'string') {
    if (value.indexOf('column') > -1) {
      style.WebkitBoxOrient = 'vertical';
    } else {
      style.WebkitBoxOrient = 'horizontal';
    }
    if (value.indexOf('reverse') > -1) {
      style.WebkitBoxDirection = 'reverse';
    } else {
      style.WebkitBoxDirection = 'normal';
    }
  }
  if (alternativeProps.hasOwnProperty(property)) {
    style[alternativeProps[property]] = alternativeValues[value] || value;
  }
}
});

var flexboxOld = unwrapExports(flexboxOld_1);

var gradient_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = gradient;



var _isPrefixedValue2 = _interopRequireDefault(isPrefixedValue_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prefixes = ['-webkit-', '-moz-', ''];

var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/gi;

function gradient(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && values.test(value)) {
    return prefixes.map(function (prefix) {
      return value.replace(values, function (grad) {
        return prefix + grad;
      });
    });
  }
}
});

var gradient = unwrapExports(gradient_1);

var grid_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = grid;
function isSimplePositionValue(value) {
  return typeof value === 'number' && !isNaN(value);
}

var alignmentValues = ['center', 'end', 'start', 'stretch'];

var displayValues = {
  'inline-grid': ['-ms-inline-grid', 'inline-grid'],
  grid: ['-ms-grid', 'grid']
};

var propertyConverters = {
  alignSelf: function alignSelf(value, style) {
    if (alignmentValues.indexOf(value) > -1) {
      style.msGridRowAlign = value;
    }
  },

  gridColumn: function gridColumn(value, style) {
    if (isSimplePositionValue(value)) {
      style.msGridColumn = value;
    } else {
      var _value$split$map = value.split('/').map(function (position) {
        return +position;
      }),
          _value$split$map2 = _slicedToArray(_value$split$map, 2),
          start = _value$split$map2[0],
          end = _value$split$map2[1];

      propertyConverters.gridColumnStart(start, style);
      propertyConverters.gridColumnEnd(end, style);
    }
  },

  gridColumnEnd: function gridColumnEnd(value, style) {
    var msGridColumn = style.msGridColumn;

    if (isSimplePositionValue(value) && isSimplePositionValue(msGridColumn)) {
      style.msGridColumnSpan = value - msGridColumn;
    }
  },

  gridColumnStart: function gridColumnStart(value, style) {
    if (isSimplePositionValue(value)) {
      style.msGridColumn = value;
    }
  },

  gridRow: function gridRow(value, style) {
    if (isSimplePositionValue(value)) {
      style.msGridRow = value;
    } else {
      var _value$split$map3 = value.split('/').map(function (position) {
        return +position;
      }),
          _value$split$map4 = _slicedToArray(_value$split$map3, 2),
          start = _value$split$map4[0],
          end = _value$split$map4[1];

      propertyConverters.gridRowStart(start, style);
      propertyConverters.gridRowEnd(end, style);
    }
  },

  gridRowEnd: function gridRowEnd(value, style) {
    var msGridRow = style.msGridRow;

    if (isSimplePositionValue(value) && isSimplePositionValue(msGridRow)) {
      style.msGridRowSpan = value - msGridRow;
    }
  },

  gridRowStart: function gridRowStart(value, style) {
    if (isSimplePositionValue(value)) {
      style.msGridRow = value;
    }
  },

  gridTemplateColumns: function gridTemplateColumns(value, style) {
    style.msGridColumns = value;
  },

  gridTemplateRows: function gridTemplateRows(value, style) {
    style.msGridRows = value;
  },

  justifySelf: function justifySelf(value, style) {
    if (alignmentValues.indexOf(value) > -1) {
      style.msGridColumnAlign = value;
    }
  }
};

function grid(property, value, style) {
  if (property === 'display' && value in displayValues) {
    return displayValues[value];
  }

  if (property in propertyConverters) {
    var propertyConverter = propertyConverters[property];
    propertyConverter(value, style);
  }
}
});

var grid = unwrapExports(grid_1);

var imageSet_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = imageSet;



var _isPrefixedValue2 = _interopRequireDefault(isPrefixedValue_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://caniuse.com/#feat=css-image-set
var prefixes = ['-webkit-', ''];
function imageSet(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('image-set(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/image-set\(/g, prefix + 'image-set(');
    });
  }
}
});

var imageSet = unwrapExports(imageSet_1);

var logical_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = logical;
var alternativeProps = {
  marginBlockStart: ['WebkitMarginBefore'],
  marginBlockEnd: ['WebkitMarginAfter'],
  marginInlineStart: ['WebkitMarginStart', 'MozMarginStart'],
  marginInlineEnd: ['WebkitMarginEnd', 'MozMarginEnd'],
  paddingBlockStart: ['WebkitPaddingBefore'],
  paddingBlockEnd: ['WebkitPaddingAfter'],
  paddingInlineStart: ['WebkitPaddingStart', 'MozPaddingStart'],
  paddingInlineEnd: ['WebkitPaddingEnd', 'MozPaddingEnd'],
  borderBlockStart: ['WebkitBorderBefore'],
  borderBlockStartColor: ['WebkitBorderBeforeColor'],
  borderBlockStartStyle: ['WebkitBorderBeforeStyle'],
  borderBlockStartWidth: ['WebkitBorderBeforeWidth'],
  borderBlockEnd: ['WebkitBorderAfter'],
  borderBlockEndColor: ['WebkitBorderAfterColor'],
  borderBlockEndStyle: ['WebkitBorderAfterStyle'],
  borderBlockEndWidth: ['WebkitBorderAfterWidth'],
  borderInlineStart: ['WebkitBorderStart', 'MozBorderStart'],
  borderInlineStartColor: ['WebkitBorderStartColor', 'MozBorderStartColor'],
  borderInlineStartStyle: ['WebkitBorderStartStyle', 'MozBorderStartStyle'],
  borderInlineStartWidth: ['WebkitBorderStartWidth', 'MozBorderStartWidth'],
  borderInlineEnd: ['WebkitBorderEnd', 'MozBorderEnd'],
  borderInlineEndColor: ['WebkitBorderEndColor', 'MozBorderEndColor'],
  borderInlineEndStyle: ['WebkitBorderEndStyle', 'MozBorderEndStyle'],
  borderInlineEndWidth: ['WebkitBorderEndWidth', 'MozBorderEndWidth']
};

function logical(property, value, style) {
  if (Object.prototype.hasOwnProperty.call(alternativeProps, property)) {
    var alternativePropList = alternativeProps[property];
    for (var i = 0, len = alternativePropList.length; i < len; ++i) {
      style[alternativePropList[i]] = value;
    }
  }
}
});

var logical = unwrapExports(logical_1);

var position_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = position;
function position(property, value) {
  if (property === 'position' && value === 'sticky') {
    return ['-webkit-sticky', 'sticky'];
  }
}
});

var position = unwrapExports(position_1);

var sizing_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sizing;
var prefixes = ['-webkit-', '-moz-', ''];

var properties = {
  maxHeight: true,
  maxWidth: true,
  width: true,
  height: true,
  columnWidth: true,
  minWidth: true,
  minHeight: true
};
var values = {
  'min-content': true,
  'max-content': true,
  'fill-available': true,
  'fit-content': true,
  'contain-floats': true
};

function sizing(property, value) {
  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
});

var sizing = unwrapExports(sizing_1);

/* eslint-disable no-var, prefer-template */
var uppercasePattern = /[A-Z]/g;
var msPattern = /^ms-/;
var cache = {};

function toHyphenLower(match) {
  return '-' + match.toLowerCase()
}

function hyphenateStyleName(name) {
  if (cache.hasOwnProperty(name)) {
    return cache[name]
  }

  var hName = name.replace(uppercasePattern, toHyphenLower);
  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
}

var hyphenateStyleName$1 = /*#__PURE__*/Object.freeze({
  default: hyphenateStyleName
});

var _hyphenateStyleName = getCjsExportFromNamespace(hyphenateStyleName$1);

var hyphenateProperty_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hyphenateProperty;



var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hyphenateProperty(property) {
  return (0, _hyphenateStyleName2.default)(property);
}
module.exports = exports['default'];
});

unwrapExports(hyphenateProperty_1);

var transition_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = transition;



var _hyphenateProperty2 = _interopRequireDefault(hyphenateProperty_1);



var _isPrefixedValue2 = _interopRequireDefault(isPrefixedValue_1);



var _capitalizeString2 = _interopRequireDefault(capitalizeString_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var properties = {
  transition: true,
  transitionProperty: true,
  WebkitTransition: true,
  WebkitTransitionProperty: true,
  MozTransition: true,
  MozTransitionProperty: true
};


var prefixMapping = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  ms: '-ms-'
};

function prefixValue(value, propertyPrefixMap) {
  if ((0, _isPrefixedValue2.default)(value)) {
    return value;
  }

  // only split multi values, not cubic beziers
  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);

  for (var i = 0, len = multipleValues.length; i < len; ++i) {
    var singleValue = multipleValues[i];
    var values = [singleValue];
    for (var property in propertyPrefixMap) {
      var dashCaseProperty = (0, _hyphenateProperty2.default)(property);

      if (singleValue.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
        var prefixes = propertyPrefixMap[property];
        for (var j = 0, pLen = prefixes.length; j < pLen; ++j) {
          // join all prefixes and create a new value
          values.unshift(singleValue.replace(dashCaseProperty, prefixMapping[prefixes[j]] + dashCaseProperty));
        }
      }
    }

    multipleValues[i] = values.join(',');
  }

  return multipleValues.join(',');
}

function transition(property, value, style, propertyPrefixMap) {
  // also check for already prefixed transitions
  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
    var outputValue = prefixValue(value, propertyPrefixMap);
    // if the property is already prefixed
    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
      return !/-moz-|-ms-/.test(val);
    }).join(',');

    if (property.indexOf('Webkit') > -1) {
      return webkitOutput;
    }

    var mozOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
      return !/-webkit-|-ms-/.test(val);
    }).join(',');

    if (property.indexOf('Moz') > -1) {
      return mozOutput;
    }

    style['Webkit' + (0, _capitalizeString2.default)(property)] = webkitOutput;
    style['Moz' + (0, _capitalizeString2.default)(property)] = mozOutput;
    return outputValue;
  }
}
});

var transition = unwrapExports(transition_1);

var w$1 = ["Webkit"];
var m = ["Moz"];
var ms = ["ms"];
var wm = ["Webkit", "Moz"];
var wms = ["Webkit", "ms"];
var wmms = ["Webkit", "Moz", "ms"];
var staticData = {
  plugins: [backgroundClip, calc, crossFade, cursor, filter, flex, flexboxIE, flexboxOld, gradient, grid, imageSet, logical, position, sizing, transition],
  prefixMap: {
    "transform": wms,
    "transformOrigin": wms,
    "transformOriginX": wms,
    "transformOriginY": wms,
    "backfaceVisibility": w$1,
    "perspective": w$1,
    "perspectiveOrigin": w$1,
    "transformStyle": w$1,
    "transformOriginZ": w$1,
    "animation": w$1,
    "animationDelay": w$1,
    "animationDirection": w$1,
    "animationFillMode": w$1,
    "animationDuration": w$1,
    "animationIterationCount": w$1,
    "animationName": w$1,
    "animationPlayState": w$1,
    "animationTimingFunction": w$1,
    "appearance": wm,
    "userSelect": wmms,
    "fontKerning": w$1,
    "textEmphasisPosition": w$1,
    "textEmphasis": w$1,
    "textEmphasisStyle": w$1,
    "textEmphasisColor": w$1,
    "boxDecorationBreak": w$1,
    "clipPath": w$1,
    "maskImage": w$1,
    "maskMode": w$1,
    "maskRepeat": w$1,
    "maskPosition": w$1,
    "maskClip": w$1,
    "maskOrigin": w$1,
    "maskSize": w$1,
    "maskComposite": w$1,
    "mask": w$1,
    "maskBorderSource": w$1,
    "maskBorderMode": w$1,
    "maskBorderSlice": w$1,
    "maskBorderWidth": w$1,
    "maskBorderOutset": w$1,
    "maskBorderRepeat": w$1,
    "maskBorder": w$1,
    "maskType": w$1,
    "textDecorationStyle": wm,
    "textDecorationSkip": wm,
    "textDecorationLine": wm,
    "textDecorationColor": wm,
    "filter": w$1,
    "fontFeatureSettings": wm,
    "breakAfter": wmms,
    "breakBefore": wmms,
    "breakInside": wmms,
    "columnCount": wm,
    "columnFill": wm,
    "columnGap": wm,
    "columnRule": wm,
    "columnRuleColor": wm,
    "columnRuleStyle": wm,
    "columnRuleWidth": wm,
    "columns": wm,
    "columnSpan": wm,
    "columnWidth": wm,
    "writingMode": wms,
    "flex": wms,
    "flexBasis": w$1,
    "flexDirection": wms,
    "flexGrow": w$1,
    "flexFlow": wms,
    "flexShrink": w$1,
    "flexWrap": wms,
    "alignContent": w$1,
    "alignItems": w$1,
    "alignSelf": w$1,
    "justifyContent": w$1,
    "order": w$1,
    "transitionDelay": w$1,
    "transitionDuration": w$1,
    "transitionProperty": w$1,
    "transitionTimingFunction": w$1,
    "backdropFilter": w$1,
    "scrollSnapType": wms,
    "scrollSnapPointsX": wms,
    "scrollSnapPointsY": wms,
    "scrollSnapDestination": wms,
    "scrollSnapCoordinate": wms,
    "shapeImageThreshold": w$1,
    "shapeImageMargin": w$1,
    "shapeImageOutside": w$1,
    "hyphens": wmms,
    "flowInto": wms,
    "flowFrom": wms,
    "regionFragment": wms,
    "textOrientation": w$1,
    "boxSizing": m,
    "textAlignLast": m,
    "tabSize": m,
    "wrapFlow": ms,
    "wrapThrough": ms,
    "wrapMargin": ms,
    "touchAction": ms,
    "textSizeAdjust": wms,
    "borderImage": w$1,
    "borderImageOutset": w$1,
    "borderImageRepeat": w$1,
    "borderImageSlice": w$1,
    "borderImageSource": w$1,
    "borderImageWidth": w$1
  }
};

var prefixAll = createPrefixer(staticData);
/* ::
import type { SheetDefinition } from './index.js';
type StringHandlers = { [id:string]: Function };
type SelectorCallback = (selector: string) => string[];
export type SelectorHandler = (
    selector: string,
    baseSelector: string,
    callback: SelectorCallback
) => string[] | string | null;
*/

/**
 * `selectorHandlers` are functions which handle special selectors which act
 * differently than normal style definitions. These functions look at the
 * current selector and can generate CSS for the styles in their subtree by
 * calling the callback with a new selector.
 *
 * For example, when generating styles with a base selector of '.foo' and the
 * following styles object:
 *
 *   {
 *     ':nth-child(2n)': {
 *       ':hover': {
 *         color: 'red'
 *       }
 *     }
 *   }
 *
 * when we reach the ':hover' style, we would call our selector handlers like
 *
 *   handler(':hover', '.foo:nth-child(2n)', callback)
 *
 * Since our `pseudoSelectors` handles ':hover' styles, that handler would call
 * the callback like
 *
 *   callback('.foo:nth-child(2n):hover')
 *
 * to generate its subtree `{ color: 'red' }` styles with a
 * '.foo:nth-child(2n):hover' selector. The callback would return an array of CSS
 * rules like
 *
 *   ['.foo:nth-child(2n):hover{color:red !important;}']
 *
 * and the handler would then return that resulting CSS.
 *
 * `defaultSelectorHandlers` is the list of default handlers used in a call to
 * `generateCSS`.
 *
 * @name SelectorHandler
 * @function
 * @param {string} selector: The currently inspected selector. ':hover' in the
 *     example above.
 * @param {string} baseSelector: The selector of the parent styles.
 *     '.foo:nth-child(2n)' in the example above.
 * @param {function} generateSubtreeStyles: A function which can be called to
 *     generate CSS for the subtree of styles corresponding to the selector.
 *     Accepts a new baseSelector to use for generating those styles.
 * @returns {string[] | string | null} The generated CSS for this selector, or
 *     null if we don't handle this selector.
 */

var defaultSelectorHandlers
/* : SelectorHandler[] */
= [// Handle pseudo-selectors, like :hover and :nth-child(3n)
function pseudoSelectors(selector, baseSelector, generateSubtreeStyles) {
  if (selector[0] !== ":") {
    return null;
  }

  return generateSubtreeStyles(baseSelector + selector);
}, // Handle media queries (or font-faces)
function mediaQueries(selector, baseSelector, generateSubtreeStyles) {
  if (selector[0] !== "@") {
    return null;
  } // Generate the styles normally, and then wrap them in the media query.


  var generated = generateSubtreeStyles(baseSelector);
  return ["".concat(selector, "{").concat(generated.join(''), "}")];
}];
/**
 * Generate CSS for a selector and some styles.
 *
 * This function handles the media queries and pseudo selectors that can be used
 * in aphrodite styles.
 *
 * @param {string} selector: A base CSS selector for the styles to be generated
 *     with.
 * @param {Object} styleTypes: A list of properties of the return type of
 *     StyleSheet.create, e.g. [styles.red, styles.blue].
 * @param {Array.<SelectorHandler>} selectorHandlers: A list of selector
 *     handlers to use for handling special selectors. See
 *     `defaultSelectorHandlers`.
 * @param stringHandlers: See `generateCSSRuleset`
 * @param useImportant: See `generateCSSRuleset`
 *
 * To actually generate the CSS special-construct-less styles are passed to
 * `generateCSSRuleset`.
 *
 * For instance, a call to
 *
 *     generateCSS(".foo", [{
 *       color: "red",
 *       "@media screen": {
 *         height: 20,
 *         ":hover": {
 *           backgroundColor: "black"
 *         }
 *       },
 *       ":active": {
 *         fontWeight: "bold"
 *       }
 *     }], defaultSelectorHandlers);
 *
 * with the default `selectorHandlers` will make 5 calls to
 * `generateCSSRuleset`:
 *
 *     generateCSSRuleset(".foo", { color: "red" }, ...)
 *     generateCSSRuleset(".foo:active", { fontWeight: "bold" }, ...)
 *     // These 2 will be wrapped in @media screen {}
 *     generateCSSRuleset(".foo", { height: 20 }, ...)
 *     generateCSSRuleset(".foo:hover", { backgroundColor: "black" }, ...)
 */

var generateCSS = function generateCSS(selector
/* : string */
, styleTypes
/* : SheetDefinition[] */
, selectorHandlers
/* : SelectorHandler[] */
, stringHandlers
/* : StringHandlers */
, useImportant
/* : boolean */
)
/* : string[] */
{
  var merged = new OrderedElements();

  for (var i = 0; i < styleTypes.length; i++) {
    merged.addStyleType(styleTypes[i]);
  }

  var plainDeclarations = new OrderedElements();
  var generatedStyles = []; // TODO(emily): benchmark this to see if a plain for loop would be faster.

  merged.forEach(function (val, key) {
    // For each key, see if one of the selector handlers will handle these
    // styles.
    var foundHandler = selectorHandlers.some(function (handler) {
      var result = handler(key, selector, function (newSelector) {
        return generateCSS(newSelector, [val], selectorHandlers, stringHandlers, useImportant);
      });

      if (result != null) {
        // If the handler returned something, add it to the generated
        // CSS and stop looking for another handler.
        if (Array.isArray(result)) {
          generatedStyles.push.apply(generatedStyles, _toConsumableArray$1(result));
        } else {
          // eslint-disable-next-line
          console.warn('WARNING: Selector handlers should return an array of rules.' + 'Returning a string containing multiple rules is deprecated.', handler);
          generatedStyles.push("@media all {".concat(result, "}"));
        }

        return true;
      }
    }); // If none of the handlers handled it, add it to the list of plain
    // style declarations.

    if (!foundHandler) {
      plainDeclarations.set(key, val, true);
    }
  });
  var generatedRuleset = generateCSSRuleset(selector, plainDeclarations, stringHandlers, useImportant, selectorHandlers);

  if (generatedRuleset) {
    generatedStyles.unshift(generatedRuleset);
  }

  return generatedStyles;
};
/**
 * Helper method of generateCSSRuleset to facilitate custom handling of certain
 * CSS properties. Used for e.g. font families.
 *
 * See generateCSSRuleset for usage and documentation of paramater types.
 */

var runStringHandlers = function runStringHandlers(declarations
/* : OrderedElements */
, stringHandlers
/* : StringHandlers */
, selectorHandlers
/* : SelectorHandler[] */
)
/* : void */
{
  if (!stringHandlers) {
    return;
  }

  var stringHandlerKeys = Object.keys(stringHandlers);

  for (var i = 0; i < stringHandlerKeys.length; i++) {
    var key = stringHandlerKeys[i];

    if (declarations.has(key)) {
      // A declaration exists for this particular string handler, so we
      // need to let the string handler interpret the declaration first
      // before proceeding.
      //
      // TODO(emily): Pass in a callback which generates CSS, similar to
      // how our selector handlers work, instead of passing in
      // `selectorHandlers` and have them make calls to `generateCSS`
      // themselves. Right now, this is impractical because our string
      // handlers are very specialized and do complex things.
      declarations.set(key, stringHandlers[key](declarations.get(key), selectorHandlers), // Preserve order here, since we are really replacing an
      // unprocessed style with a processed style, not overriding an
      // earlier style
      false);
    }
  }
};

var transformRule = function transformRule(key
/* : string */
, value
/* : string */
, transformValue
/* : function */
) {
  return (
    /* : string */
    "".concat(kebabifyStyleName(key), ":").concat(transformValue(key, value), ";")
  );
};

var arrayToObjectKeysReducer = function arrayToObjectKeysReducer(acc, val) {
  acc[val] = true;
  return acc;
};
/**
 * Generate a CSS ruleset with the selector and containing the declarations.
 *
 * This function assumes that the given declarations don't contain any special
 * children (such as media queries, pseudo-selectors, or descendant styles).
 *
 * Note that this method does not deal with nesting used for e.g.
 * psuedo-selectors or media queries. That responsibility is left to  the
 * `generateCSS` function.
 *
 * @param {string} selector: the selector associated with the ruleset
 * @param {Object} declarations: a map from camelCased CSS property name to CSS
 *     property value.
 * @param {Object.<string, function>} stringHandlers: a map from camelCased CSS
 *     property name to a function which will map the given value to the value
 *     that is output.
 * @param {bool} useImportant: A boolean saying whether to append "!important"
 *     to each of the CSS declarations.
 * @returns {string} A string of raw CSS.
 *
 * Examples:
 *
 *    generateCSSRuleset(".blah", { color: "red" })
 *    -> ".blah{color: red !important;}"
 *    generateCSSRuleset(".blah", { color: "red" }, {}, false)
 *    -> ".blah{color: red}"
 *    generateCSSRuleset(".blah", { color: "red" }, {color: c => c.toUpperCase})
 *    -> ".blah{color: RED}"
 *    generateCSSRuleset(".blah:hover", { color: "red" })
 *    -> ".blah:hover{color: red}"
 */


var generateCSSRuleset = function generateCSSRuleset(selector
/* : string */
, declarations
/* : OrderedElements */
, stringHandlers
/* : StringHandlers */
, useImportant
/* : boolean */
, selectorHandlers
/* : SelectorHandler[] */
)
/* : string */
{
  // Mutates declarations
  runStringHandlers(declarations, stringHandlers, selectorHandlers);
  var originalElements = Object.keys(declarations.elements).reduce(arrayToObjectKeysReducer, Object.create(null)); // NOTE(emily): This mutates handledDeclarations.elements.

  var prefixedElements = prefixAll(declarations.elements);
  var elementNames = Object.keys(prefixedElements);

  if (elementNames.length !== declarations.keyOrder.length) {
    // There are some prefixed values, so we need to figure out how to sort
    // them.
    //
    // Loop through prefixedElements, looking for anything that is not in
    // sortOrder, which means it was added by prefixAll. This means that we
    // need to figure out where it should appear in the sortOrder.
    for (var i = 0; i < elementNames.length; i++) {
      if (!originalElements[elementNames[i]]) {
        // This element is not in the sortOrder, which means it is a prefixed
        // value that was added by prefixAll. Let's try to figure out where it
        // goes.
        var originalStyle = void 0;

        if (elementNames[i][0] === 'W') {
          // This is a Webkit-prefixed style, like "WebkitTransition". Let's
          // find its original style's sort order.
          originalStyle = elementNames[i][6].toLowerCase() + elementNames[i].slice(7);
        } else if (elementNames[i][1] === 'o') {
          // This is a Moz-prefixed style, like "MozTransition". We check
          // the second character to avoid colliding with Ms-prefixed
          // styles. Let's find its original style's sort order.
          originalStyle = elementNames[i][3].toLowerCase() + elementNames[i].slice(4);
        } else {
          // if (elementNames[i][1] === 's') {
          // This is a Ms-prefixed style, like "MsTransition".
          originalStyle = elementNames[i][2].toLowerCase() + elementNames[i].slice(3);
        }

        if (originalStyle && originalElements[originalStyle]) {
          var originalIndex = declarations.keyOrder.indexOf(originalStyle);
          declarations.keyOrder.splice(originalIndex, 0, elementNames[i]);
        } else {
          // We don't know what the original style was, so sort it to
          // top. This can happen for styles that are added that don't
          // have the same base name as the original style.
          declarations.keyOrder.unshift(elementNames[i]);
        }
      }
    }
  }

  var transformValue = useImportant === false ? stringifyValue : stringifyAndImportantifyValue;
  var rules = [];

  for (var _i = 0; _i < declarations.keyOrder.length; _i++) {
    var key = declarations.keyOrder[_i];
    var value = prefixedElements[key];

    if (Array.isArray(value)) {
      // inline-style-prefixer returns an array when there should be
      // multiple rules for the same key. Here we flatten to multiple
      // pairs with the same key.
      for (var j = 0; j < value.length; j++) {
        rules.push(transformRule(key, value[j], transformValue));
      }
    } else {
      rules.push(transformRule(key, value, transformValue));
    }
  }

  if (rules.length) {
    return "".concat(selector, "{").concat(rules.join(""), "}");
  } else {
    return "";
  }
};

/* ::
import type { SheetDefinition, SheetDefinitions } from './index.js';
import type { MaybeSheetDefinition } from './exports.js';
import type { SelectorHandler } from './generate.js';
*/
// The current <style> tag we are inserting into, or null if we haven't
// inserted anything yet. We could find this each time using
// `document.querySelector("style[data-aphrodite"])`, but holding onto it is
// faster.

var styleTag
/* : ?HTMLStyleElement */
= null; // Inject a set of rules into a <style> tag in the head of the document. This
// will automatically create a style tag and then continue to use it for
// multiple injections. It will also use a style tag with the `data-aphrodite`
// tag on it if that exists in the DOM. This could be used for e.g. reusing the
// same style tag that server-side rendering inserts.

var injectStyleTag = function injectStyleTag(cssRules
/* : string[] */
) {
  if (styleTag == null) {
    // Try to find a style tag with the `data-aphrodite` attribute first.
    styleTag = document.querySelector("style[data-aphrodite]")
    /* : any */
    ; // If that doesn't work, generate a new style tag.

    if (styleTag == null) {
      // Taken from
      // http://stackoverflow.com/questions/524696/how-to-create-a-style-tag-with-javascript
      var head = document.head || document.getElementsByTagName('head')[0];
      styleTag = document.createElement('style');
      styleTag.type = 'text/css';
      styleTag.setAttribute("data-aphrodite", "");
      head.appendChild(styleTag);
    }
  } // $FlowFixMe


  var sheet = styleTag.styleSheet || styleTag.sheet
  /* : any */
  ;

  if (sheet.insertRule) {
    var numRules = sheet.cssRules.length;
    cssRules.forEach(function (rule) {
      try {
        sheet.insertRule(rule, numRules);
        numRules += 1;
      } catch (e) {// The selector for this rule wasn't compatible with the browser
      }
    });
  } else {
    styleTag.innerText = (styleTag.innerText || '') + cssRules.join('');
  }
}; // Custom handlers for stringifying CSS values that have side effects
// (such as fontFamily, which can cause @font-face rules to be injected)


var stringHandlers = {
  // With fontFamily we look for objects that are passed in and interpret
  // them as @font-face rules that we need to inject. The value of fontFamily
  // can either be a string (as normal), an object (a single font face), or
  // an array of objects and strings.
  fontFamily: function fontFamily(val) {
    if (Array.isArray(val)) {
      var nameMap = {};
      val.forEach(function (v) {
        nameMap[fontFamily(v)] = true;
      });
      return Object.keys(nameMap).join(",");
    } else if (_typeof$1(val) === "object") {
      injectStyleOnce(val.src, "@font-face", [val], false);
      return "\"".concat(val.fontFamily, "\"");
    } else {
      return val;
    }
  },
  // With animationName we look for an object that contains keyframes and
  // inject them as an `@keyframes` block, returning a uniquely generated
  // name. The keyframes object should look like
  //  animationName: {
  //    from: {
  //      left: 0,
  //      top: 0,
  //    },
  //    '50%': {
  //      left: 15,
  //      top: 5,
  //    },
  //    to: {
  //      left: 20,
  //      top: 20,
  //    }
  //  }
  // TODO(emily): `stringHandlers` doesn't let us rename the key, so I have
  // to use `animationName` here. Improve that so we can call this
  // `animation` instead of `animationName`.
  animationName: function animationName(val, selectorHandlers) {
    if (Array.isArray(val)) {
      return val.map(function (v) {
        return animationName(v, selectorHandlers);
      }).join(",");
    } else if (_typeof$1(val) === "object") {
      // Generate a unique name based on the hash of the object. We can't
      // just use the hash because the name can't start with a number.
      // TODO(emily): this probably makes debugging hard, allow a custom
      // name?
      var name = "keyframe_".concat(hashObject(val)); // Since keyframes need 3 layers of nesting, we use `generateCSS` to
      // build the inner layers and wrap it in `@keyframes` ourselves.

      var finalVal = "@keyframes ".concat(name, "{"); // TODO see if we can find a way where checking for OrderedElements
      // here is not necessary. Alternatively, perhaps we should have a
      // utility method that can iterate over either a plain object, an
      // instance of OrderedElements, or a Map, and then use that here and
      // elsewhere.

      if (val instanceof OrderedElements) {
        val.forEach(function (valVal, valKey) {
          finalVal += generateCSS(valKey, [valVal], selectorHandlers, stringHandlers, false).join('');
        });
      } else {
        Object.keys(val).forEach(function (key) {
          finalVal += generateCSS(key, [val[key]], selectorHandlers, stringHandlers, false).join('');
        });
      }

      finalVal += '}';
      injectGeneratedCSSOnce(name, [finalVal]);
      return name;
    } else {
      return val;
    }
  }
}; // This is a map from Aphrodite's generated class names to `true` (acting as a
// set of class names)

var alreadyInjected = {}; // This is the buffer of styles which have not yet been flushed.

var injectionBuffer
/* : string[] */
= []; // A flag to tell if we are already buffering styles. This could happen either
// because we scheduled a flush call already, so newly added styles will
// already be flushed, or because we are statically buffering on the server.

var isBuffering = false;

var injectGeneratedCSSOnce = function injectGeneratedCSSOnce(key, generatedCSS) {
  var _injectionBuffer;

  if (alreadyInjected[key]) {
    return;
  }

  if (!isBuffering) {
    // We should never be automatically buffering on the server (or any
    // place without a document), so guard against that.
    if (typeof document === "undefined") {
      throw new Error("Cannot automatically buffer without a document");
    } // If we're not already buffering, schedule a call to flush the
    // current styles.


    isBuffering = true;
    asap_1(flushToStyleTag);
  }

  (_injectionBuffer = injectionBuffer).push.apply(_injectionBuffer, _toConsumableArray$1(generatedCSS));

  alreadyInjected[key] = true;
};

var injectStyleOnce = function injectStyleOnce(key
/* : string */
, selector
/* : string */
, definitions
/* : SheetDefinition[] */
, useImportant
/* : boolean */
) {
  var selectorHandlers
  /* : SelectorHandler[] */
  = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];

  if (alreadyInjected[key]) {
    return;
  }

  var generated = generateCSS(selector, definitions, selectorHandlers, stringHandlers, useImportant);
  injectGeneratedCSSOnce(key, generated);
};
var reset = function reset() {
  injectionBuffer = [];
  alreadyInjected = {};
  isBuffering = false;
  styleTag = null;
};
var resetInjectedStyle = function resetInjectedStyle(key
/* : string */
) {
  delete alreadyInjected[key];
};
var getBufferedStyles = function getBufferedStyles() {
  return injectionBuffer;
};
var startBuffering = function startBuffering() {
  if (isBuffering) {
    throw new Error("Cannot buffer while already buffering");
  }

  isBuffering = true;
};

var flushToArray = function flushToArray() {
  isBuffering = false;
  var ret = injectionBuffer;
  injectionBuffer = [];
  return ret;
};

var flushToString = function flushToString() {
  return flushToArray().join('');
};
var flushToStyleTag = function flushToStyleTag() {
  var cssRules = flushToArray();

  if (cssRules.length > 0) {
    injectStyleTag(cssRules);
  }
};
var getRenderedClassNames = function getRenderedClassNames()
/* : string[] */
{
  return Object.keys(alreadyInjected);
};
var addRenderedClassNames = function addRenderedClassNames(classNames
/* : string[] */
) {
  classNames.forEach(function (className) {
    alreadyInjected[className] = true;
  });
};

var isValidStyleDefinition = function isValidStyleDefinition(def
/* : Object */
) {
  return "_definition" in def && "_name" in def && "_len" in def;
};

var processStyleDefinitions = function processStyleDefinitions(styleDefinitions
/* : any[] */
, classNameBits
/* : string[] */
, definitionBits
/* : Object[] */
, length
/* : number */
)
/* : number */
{
  for (var i = 0; i < styleDefinitions.length; i += 1) {
    // Filter out falsy values from the input, to allow for
    // `css(a, test && c)`
    if (styleDefinitions[i]) {
      if (Array.isArray(styleDefinitions[i])) {
        // We've encountered an array, so let's recurse
        length += processStyleDefinitions(styleDefinitions[i], classNameBits, definitionBits, length);
      } else if (isValidStyleDefinition(styleDefinitions[i])) {
        classNameBits.push(styleDefinitions[i]._name);
        definitionBits.push(styleDefinitions[i]._definition);
        length += styleDefinitions[i]._len;
      } else {
        throw new Error("Invalid Style Definition: Styles should be defined using the StyleSheet.create method.");
      }
    }
  }

  return length;
};
/**
 * Inject styles associated with the passed style definition objects, and return
 * an associated CSS class name.
 *
 * @param {boolean} useImportant If true, will append !important to generated
 *     CSS output. e.g. {color: red} -> "color: red !important".
 * @param {(Object|Object[])[]} styleDefinitions style definition objects, or
 *     arbitrarily nested arrays of them, as returned as properties of the
 *     return value of StyleSheet.create().
 */


var injectAndGetClassName = function injectAndGetClassName(useImportant
/* : boolean */
, styleDefinitions
/* : MaybeSheetDefinition[] */
, selectorHandlers
/* : SelectorHandler[] */
)
/* : string */
{
  var classNameBits = [];
  var definitionBits = []; // Mutates classNameBits and definitionBits and returns a length which we
  // will append to the hash to decrease the chance of hash collisions.

  var length = processStyleDefinitions(styleDefinitions, classNameBits, definitionBits, 0); // Break if there aren't any valid styles.

  if (classNameBits.length === 0) {
    return "";
  }

  var className;

  if (process.env.NODE_ENV === 'production') {
    className = classNameBits.length === 1 ? "_".concat(classNameBits[0]) : "_".concat(hashString(classNameBits.join())).concat((length % 36).toString(36));
  } else {
    className = classNameBits.join("-o_O-");
  }

  injectStyleOnce(className, ".".concat(className), definitionBits, useImportant, selectorHandlers);
  return className;
};

/* ::
import type { SelectorHandler } from './generate.js';
export type SheetDefinition = { [id:string]: any };
export type SheetDefinitions = SheetDefinition | SheetDefinition[];
type RenderFunction = () => string;
type Extension = {
    selectorHandler: SelectorHandler
};
export type MaybeSheetDefinition = SheetDefinition | false | null | void
*/

var unminifiedHashFn = function unminifiedHashFn(str
/* : string */
, key
/* : string */
) {
  return "".concat(key, "_").concat(hashString(str));
}; // StyleSheet.create is in a hot path so we want to keep as much logic out of it
// as possible. So, we figure out which hash function to use once, and only
// switch it out via minify() as necessary.
//
// This is in an exported function to make it easier to test.


var initialHashFn = function initialHashFn() {
  return process.env.NODE_ENV === 'production' ? hashString : unminifiedHashFn;
};
var hashFn = initialHashFn();
var StyleSheet = {
  create: function create(sheetDefinition
  /* : SheetDefinition */
  )
  /* : Object */
  {
    var mappedSheetDefinition = {};
    var keys = Object.keys(sheetDefinition);

    for (var i = 0; i < keys.length; i += 1) {
      var key = keys[i];
      var val = sheetDefinition[key];
      var stringVal = JSON.stringify(val);
      mappedSheetDefinition[key] = {
        _len: stringVal.length,
        _name: hashFn(stringVal, key),
        _definition: val
      };
    }

    return mappedSheetDefinition;
  },
  rehydrate: function rehydrate() {
    var renderedClassNames
    /* : string[] */
    = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    addRenderedClassNames(renderedClassNames);
  }
};
/**
 * Utilities for using Aphrodite server-side.
 *
 * This can be minified out in client-only bundles by replacing `typeof window`
 * with `"object"`, e.g. via Webpack's DefinePlugin:
 *
 *   new webpack.DefinePlugin({
 *     "typeof window": JSON.stringify("object")
 *   })
 */

var StyleSheetServer = typeof window !== 'undefined' ? null : {
  renderStatic: function renderStatic(renderFunc
  /* : RenderFunction */
  ) {
    reset();
    startBuffering();
    var html = renderFunc();
    var cssContent = flushToString();
    return {
      html: html,
      css: {
        content: cssContent,
        renderedClassNames: getRenderedClassNames()
      }
    };
  }
};
/**
 * Utilities for using Aphrodite in tests.
 *
 * Not meant to be used in production.
 */

var StyleSheetTestUtils = process.env.NODE_ENV === 'production' ? null : {
  /**
  * Prevent styles from being injected into the DOM.
  *
  * This is useful in situations where you'd like to test rendering UI
  * components which use Aphrodite without any of the side-effects of
  * Aphrodite happening. Particularly useful for testing the output of
  * components when you have no DOM, e.g. testing in Node without a fake DOM.
  *
  * Should be paired with a subsequent call to
  * clearBufferAndResumeStyleInjection.
  */
  suppressStyleInjection: function suppressStyleInjection() {
    reset();
    startBuffering();
  },

  /**
  * Opposite method of preventStyleInject.
  */
  clearBufferAndResumeStyleInjection: function clearBufferAndResumeStyleInjection() {
    reset();
  },

  /**
  * Returns a string of buffered styles which have not been flushed
  *
  * @returns {string}  Buffer of styles which have not yet been flushed.
  */
  getBufferedStyles: function getBufferedStyles$1() {
    return getBufferedStyles();
  }
};
/**
 * Generate the Aphrodite API exports, with given `selectorHandlers` and
 * `useImportant` state.
 */

function makeExports(useImportant
/* : boolean */
) {
  var selectorHandlers
  /* : SelectorHandler[] */
  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultSelectorHandlers;
  return {
    StyleSheet: _objectSpread$1({}, StyleSheet, {
      /**
       * Returns a version of the exports of Aphrodite (i.e. an object
       * with `css` and `StyleSheet` properties) which have some
       * extensions included.
       *
       * @param {Array.<Object>} extensions: An array of extensions to
       *     add to this instance of Aphrodite. Each object should have a
       *     single property on it, defining which kind of extension to
       *     add.
       * @param {SelectorHandler} [extensions[].selectorHandler]: A
       *     selector handler extension. See `defaultSelectorHandlers` in
       *     generate.js.
       *
       * @returns {Object} An object containing the exports of the new
       *     instance of Aphrodite.
       */
      extend: function extend(extensions
      /* : Extension[] */
      ) {
        var extensionSelectorHandlers = extensions // Pull out extensions with a selectorHandler property
        .map(function (extension) {
          return extension.selectorHandler;
        }) // Remove nulls (i.e. extensions without a selectorHandler property).
        .filter(function (handler) {
          return handler;
        });
        return makeExports(useImportant, selectorHandlers.concat(extensionSelectorHandlers));
      }
    }),
    StyleSheetServer: StyleSheetServer,
    StyleSheetTestUtils: StyleSheetTestUtils,
    minify: function minify(shouldMinify
    /* : boolean */
    ) {
      hashFn = shouldMinify ? hashString : unminifiedHashFn;
    },
    css: function css()
    /* : MaybeSheetDefinition[] */
    {
      for (var _len = arguments.length, styleDefinitions = new Array(_len), _key = 0; _key < _len; _key++) {
        styleDefinitions[_key] = arguments[_key];
      }

      return injectAndGetClassName(useImportant, styleDefinitions, selectorHandlers);
    },
    flushToStyleTag: flushToStyleTag,
    injectAndGetClassName: injectAndGetClassName,
    defaultSelectorHandlers: defaultSelectorHandlers,
    reset: reset,
    resetInjectedStyle: resetInjectedStyle
  };
}

var useImportant = true; // Add !important to all style definitions

var Aphrodite = makeExports(useImportant);
var StyleSheet$1 = Aphrodite.StyleSheet,
    css$1 = Aphrodite.css;

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by rollup-plugin-commonjs');
}

function unwrapExports$1 (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule$1(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var merge_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = merge;


// The default allowed delta for keyframe distance
var keyframeDistance = 10;

var defaultNormalizedFrames = {
  'from': 'from',
  '0%': 'from',
  'to': 'to',
  '100%': 'to'
};

/**
 * Takes an array of strings representing transform values and
 * merges them. Ignores duplicates and 'none'.
 * @param {Array} transforms Array<string>
 * @returns {String} merged
 * @private
 * @example
 * mergeTransforms([
 *   'translateX(10px)',
 *   'rotateX(120deg)',
 *   'translateX(10px)',
 *   'none',
 * ])
 * // -> 'translateX(10px) rotateX(120deg)'
 *
 */
var mergeTransforms = function mergeTransforms(transforms) {
  var filtered = transforms.filter(function (transform, i) {
    return transform !== 'none' && transforms.indexOf(transform) === i;
  });
  return filtered.join(' ');
};

/**
 * Returns whichever value is actually defined
 * @param {String|Number} primary CSSValue
 * @param {String|Number} secondary CSSValue
 * @returns {String|Number} defined CSSValue
 * @private
 */
var getDefined = function getDefined(primary, secondary) {
  return typeof primary !== 'undefined' ? primary : secondary;
};

/**
 * Takes a source animation and the current cache, populating the
 * cache with the normalized keyframes and returning a copy of the
 * source animation with the normalized keyframes as well.
 *
 * It uses keyframeDistance to determine how much it should normalize
 * frames.
 * @param {Object} source Animation
 * @param {Object} cache FrameMap
 * @returns {Object} Animation
 * @private
 */
var normalizeFrames = function normalizeFrames(source, cache) {
  var normalized = {};
  for (var frame in source) {
    var normalizedFrame = defaultNormalizedFrames[frame] || Math.round(parseFloat(frame) / keyframeDistance) * keyframeDistance + '%';
    normalized[normalizedFrame] = source[frame];
    cache[normalizedFrame] = normalizedFrame;
  }
  return normalized;
};

var mergeFrames = function mergeFrames(primaryFrame, secondaryFrame, target) {
  // Walk through all properties in the primary frame
  for (var propertyName in primaryFrame) {
    // Transform is special cased, as we want to combine both
    // transforms when posssible.
    if (propertyName === 'transform') {
      // But we dont need to do anything if theres no other
      // transform to merge.
      if (secondaryFrame[propertyName]) {
        var newTransform = mergeTransforms([primaryFrame[propertyName], secondaryFrame[propertyName]]);
        // We make the assumption that animations use 'transform: none'
        // to terminate the keyframe. If we're combining two animations
        // that may terminate at separte frames, its safest to just
        // ignore this.
        if (newTransform !== 'none') {
          target[propertyName] = newTransform;
        }
      } else {
        var propertyValue = getDefined(primaryFrame[propertyName], secondaryFrame[propertyName]);
        target[propertyName] = propertyValue;
      }
    } else {
      // Use a typeof check so we don't ignore falsy values like 0.
      var _propertyValue = getDefined(primaryFrame[propertyName], secondaryFrame[propertyName]);
      target[propertyName] = _propertyValue;
    }
  }
  // Walk through all properties in the secondary frame.
  // We should be able to assume that any property that
  // needed to be merged has already been merged when we
  // walked the primary frame.
  for (var _propertyName in secondaryFrame) {
    var _propertyValue2 = secondaryFrame[_propertyName];
    // Again, ignore 'transform: none'
    if (_propertyName === 'transform' && _propertyValue2 === 'none') {
      continue;
    }
    target[_propertyName] = target[_propertyName] || _propertyValue2;
  }
};

var populateDefinedFrame = function populateDefinedFrame(primaryFrame, secondaryFrame) {
  var definedFrame = primaryFrame || secondaryFrame;
  var target = {};
  for (var propertyName in definedFrame) {
    var propertyValue = definedFrame[propertyName];
    // Again, ignore 'transform: none'
    if (propertyName === 'transform' && propertyValue === 'none') {
      continue;
    }
    target[propertyName] = propertyValue;
  }
  // Only define a frame if there are actual styles to apply
  if (Object.keys(target).length) {
    return target;
  }
  return null;
};

/**
 * Merge lets you take two Animations and merge them together. It
 * iterates through each animation and merges each keyframe. It
 * special cases the `transform` property and uses string interop.
 * to merge the two transforms.
 *
 * This is *at your own risk* and will not work with animations
 * that are clearly opposites (fadeIn and fadeOut).
 *
 * @param {Object} primary Animation
 * @param {Object} secondary Animation
 * @returns {Object} merged Animation
 * @example
 * import { merge, tada, flip } from 'react-animations';
 * const tadaFlip = merge(tada, flip);
 */
function merge(primary, secondary) {
  // A map used to track the normalized frame value in cases where
  // two animations contain frames that appear closely, but not exactly
  var normalizedFrames = {};

  // We merge each frame into a new object and return it
  var merged = {};

  var normalizedPrimary = normalizeFrames(primary, normalizedFrames);

  var normalizedSecondary = normalizeFrames(secondary, normalizedFrames);

  // Iterate all normalized frames
  for (var frame in normalizedFrames) {
    var primaryFrame = normalizedPrimary[frame];
    var secondaryFrame = normalizedSecondary[frame];
    // Create a new frame object if it doesn't exist.
    var target = merged[frame] || (merged[frame] = {});

    // If both aniatmions define this frame, merge them carefully
    if (primaryFrame && secondaryFrame) {
      mergeFrames(primaryFrame, secondaryFrame, target);
    } else {
      // Otherwise find the defined frime and populate all properties\
      // except for "transform" when the value is none.
      var keyframe = populateDefinedFrame(primaryFrame, secondaryFrame);
      if (keyframe) {
        merged[frame] = keyframe;
      }
    }
  }
  return merged;
}
});

unwrapExports$1(merge_1);

var utils = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Composes a variable number of CSS helper functions.
 * Returns a function that accepts all the original arguments
 * of the functions it composed. If the original function
 * accepted multiple arguments, they must be passed as
 * an array.
 * @example
 * const translateXandRotateY = compose(translateX, rotateY);
 * const cssValue = translateXandRotateY('-5px', '30deg');
 */
var compose = exports.compose = function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, styleArgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      styleArgs[_key2] = arguments[_key2];
    }

    var result = funcs.reduce(function (acc, func, i) {
      var arg = styleArgs[i];
      return acc + ' ' + (Array.isArray(arg) ? func.apply(undefined, _toConsumableArray(arg)) : func(arg));
    }, '');
    return result.trim();
  };
};
var cubicBezier = exports.cubicBezier = function cubicBezier(a, b, c, d) {
  return 'cubic-bezier(' + a + ', ' + b + ', ' + c + ', ' + d + ')';
};

var translate3d = exports.translate3d = function translate3d(a, b, c) {
  return 'translate3d(' + a + ', ' + b + ', ' + c + ')';
};

var translateX = exports.translateX = function translateX(a) {
  return 'translateX(' + a + ')';
};

var scale3d = exports.scale3d = function scale3d(a, b, c) {
  return 'scale3d(' + a + ', ' + b + ', ' + c + ')';
};

var scale = exports.scale = function scale(a) {
  return 'scale(' + a + ')';
};

var skewX = exports.skewX = function skewX(deg) {
  return 'skewX(' + deg + 'deg)';
};

var skewY = exports.skewY = function skewY(deg) {
  return 'skewY(' + deg + 'deg)';
};

var skewXY = exports.skewXY = function skewXY(x, y) {
  return skewX(x) + ' ' + skewY(y);
};

var rotateY = exports.rotateY = function rotateY(a) {
  return 'rotateY(' + a + ')';
};

var rotate3d = exports.rotate3d = function rotate3d(a, b, c, d) {
  return 'rotate3d(' + a + ', ' + b + ', ' + c + ', ' + d + 'deg)';
};

var perspective = exports.perspective = function perspective(a) {
  return 'perspective(' + a + ')';
};
});

unwrapExports$1(utils);
var utils_1 = utils.compose;
var utils_2 = utils.cubicBezier;
var utils_3 = utils.translate3d;
var utils_4 = utils.translateX;
var utils_5 = utils.scale3d;
var utils_6 = utils.scale;
var utils_7 = utils.skewX;
var utils_8 = utils.skewY;
var utils_9 = utils.skewXY;
var utils_10 = utils.rotateY;
var utils_11 = utils.rotate3d;
var utils_12 = utils.perspective;

var bounce_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var base = {
  animationTimingFunction: (0, utils.cubicBezier)(0.2125, 0.610, 0.355, 1.000),
  transform: (0, utils.translate3d)(0, 0, 0)
};


var bounce = {
  '0%': base,
  '20%': base,
  '40%': {
    animationTimingFunction: (0, utils.cubicBezier)(0.755, 0.050, 0.855, 0.060),
    transform: (0, utils.translate3d)(0, '-30px', 0)
  },
  '43%': {
    animationTimingFunction: (0, utils.cubicBezier)(0.755, 0.050, 0.855, 0.060),
    transform: (0, utils.translate3d)(0, '-30px', 0)
  },
  '53%': base,
  '70%': {
    animationTimingFunction: (0, utils.cubicBezier)(0.755, 0.050, 0.855, 0.060),
    transform: (0, utils.translate3d)(0, '-50px', 0)
  },
  '80%': base,
  '90%': {
    transform: (0, utils.translate3d)(0, '-4px', 0)
  },
  '100%': base
};

exports.default = bounce;
});

unwrapExports$1(bounce_1);

var flash_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});


var visible = {
  opacity: 1
};


var invisible = {
  opacity: 0
};

var flash = {
  from: visible,
  '25%': invisible,
  '50%': visible,
  '75%': invisible,
  to: visible
};

exports.default = flash;
});

unwrapExports$1(flash_1);

var pulse_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var pulse = {
  from: {
    transform: (0, utils.scale3d)(1, 1, 1)
  },
  '50%': {
    transform: (0, utils.scale3d)(1.05, 1.05, 1.05)
  },
  to: {
    transform: (0, utils.scale3d)(1, 1, 1)
  }
};
exports.default = pulse;
});

unwrapExports$1(pulse_1);

var jello_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var noSkew = {
  transform: 'none'
};


var jello = {
  from: noSkew,
  '11.1%': noSkew,
  '22.2%': {
    transform: (0, utils.skewXY)(-12.5, -12.5)
  },
  '33.3': {
    transform: (0, utils.skewXY)(6.25, 6.25)
  },
  '44.4': {
    transform: (0, utils.skewXY)(-3.125, -3.125)
  },
  '55.5': {
    transform: (0, utils.skewXY)(1.5625, 1.5625)
  },
  '66.6': {
    transform: (0, utils.skewXY)(-0.78125, -0.78125)
  },
  '77.7': {
    transform: (0, utils.skewXY)(0.390625, 0.390625)
  },
  '88.8': {
    transform: (0, utils.skewXY)(-0.1953125, -0.1953125)
  },
  to: noSkew
};

exports.default = jello;
});

unwrapExports$1(jello_1);

var wobble_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var translateAndRotate = (0, utils.compose)(utils.translate3d, utils.rotate3d);


var noWobble = {
  transform: 'none'
};

var wobble = {
  from: noWobble,
  '15%': {
    transform: translateAndRotate(['-25%', 0, 0], [0, 0, 1, -5])
  },
  '30%': {
    transform: translateAndRotate(['20%', 0, 0], [0, 0, 1, -5])
  },
  '45%': {
    transform: translateAndRotate(['-15%', 0, 0], [0, 0, 1, -3])
  },
  '60%': {
    transform: translateAndRotate(['10%', 0, 0], [0, 0, 1, 2])
  },
  '75%': {
    transform: translateAndRotate(['-5%', 0, 0], [0, 0, 1, -1])
  },
  to: noWobble
};

exports.default = wobble;
});

unwrapExports$1(wobble_1);

var headShake_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var translateAndRotate = (0, utils.compose)(utils.translateX, utils.rotateY);


var noShake = {
  transform: (0, utils.translateX)(0)
};

var headShake = {
  '0%': noShake,
  '6.5%': {
    transform: translateAndRotate('-6px', '-9deg')
  },
  '18.5%': {
    transform: translateAndRotate('5px', '7deg')
  },
  '31.5%': {
    transform: translateAndRotate('-3px', '-5deg')
  },
  '43.5%': {
    transform: translateAndRotate('2px', '3deg')
  },
  '50%': noShake
};

exports.default = headShake;
});

unwrapExports$1(headShake_1);

var rubberBand_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var noRubberBanding = {
  transform: (0, utils.scale3d)(1, 1, 1)
};


var rubberBand = {
  from: noRubberBanding,
  '30%': {
    transform: (0, utils.scale3d)(1.25, 0.75, 1)
  },
  '40%': {
    transform: (0, utils.scale3d)(0.75, 1.25, 1)
  },
  '50%': {
    transform: (0, utils.scale3d)(1.15, 0.85, 1)
  },
  '65%': {
    transform: (0, utils.scale3d)(0.95, 1.05, 1)
  },
  '75%': {
    transform: (0, utils.scale3d)(1.05, 0.95, 1)
  },
  to: noRubberBanding
};

exports.default = rubberBand;
});

unwrapExports$1(rubberBand_1);

var shake_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var noShake = {
  transform: (0, utils.translate3d)(0, 0, 0)
};


var downShake = {
  transform: (0, utils.translate3d)('-10px', 0, 0)
};

var upShake = {
  transform: (0, utils.translate3d)('10px', 0, 0)
};

var shake = {
  from: noShake,
  '10%': downShake,
  '20%': upShake,
  '30%': downShake,
  '40%': upShake,
  '50%': downShake,
  '60%': upShake,
  '70%': downShake,
  '80%': upShake,
  '90%': downShake,
  to: noShake
};

exports.default = shake;
});

unwrapExports$1(shake_1);

var swing_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;



var swing = {
  '20%': {
    transform: (0, utils.rotate3d)(0, 0, 1, 15)
  },
  '40%': {
    transform: (0, utils.rotate3d)(0, 0, 1, -10)
  },
  '60%': {
    transform: (0, utils.rotate3d)(0, 0, 1, 5)
  },
  '80%': {
    transform: (0, utils.rotate3d)(0, 0, 1, -5)
  },
  to: {
    transform: (0, utils.rotate3d)(0, 0, 1, 15)
  }
};
var styles = exports.styles = {
  transformOrigin: 'top center'
};

exports.default = swing;
});

unwrapExports$1(swing_1);
var swing_2 = swing_1.styles;

var tada_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var scaleAndRotate = (0, utils.compose)(utils.scale3d, utils.rotate3d);


var noScale = {
  transform: (0, utils.scale3d)(1, 1, 1)
};

var scaleDownNegativeAngle = {
  transform: scaleAndRotate([0.9, 0.9, 0.9], [0, 0, 1, -3])
};

var scaleUpPositiveAngle = {
  transform: scaleAndRotate([1.1, 1.1, 1.1], [0, 0, 1, 3])
};

var scaleUpNegativeAngle = {
  transform: scaleAndRotate([1.1, 1.1, 1.1], [0, 0, 1, -3])
};

var tada = {
  from: noScale,
  '10%': scaleDownNegativeAngle,
  '20%': scaleDownNegativeAngle,
  '30%': scaleUpPositiveAngle,
  '40%': scaleUpNegativeAngle,
  '50%': scaleUpPositiveAngle,
  '60%': scaleUpNegativeAngle,
  '70%': scaleUpPositiveAngle,
  '80%': scaleUpNegativeAngle,
  '90%': scaleUpPositiveAngle,
  to: noScale
};

exports.default = tada;
});

unwrapExports$1(tada_1);

var bounceIn_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var timing = {
  animationTimingFunction: (0, utils.cubicBezier)(0.215, 0.610, 0.355, 1.000)
};

var bounceIn = {
  from: timing,
  '0%': {
    opacity: 0,
    transform: (0, utils.scale3d)(0.3, 0.3, 0.3)
  },
  '20%': _extends({}, timing, {
    transform: (0, utils.scale3d)(1.1, 1.1, 1.1)
  }),
  '40%': _extends({}, timing, {
    transform: (0, utils.scale3d)(0.9, 0.9, 0.9)
  }),
  '60%': _extends({}, timing, {
    opacity: 1,
    transform: (0, utils.scale3d)(1.03, 1.03, 1.03)
  }),
  '80%': _extends({}, timing, {
    transform: (0, utils.scale3d)(0.97, 0.97, 0.97)
  }),
  to: _extends({}, timing, {
    opacity: 1,
    transform: (0, utils.scale3d)(1, 1, 1)
  })
};

exports.default = bounceIn;
});

unwrapExports$1(bounceIn_1);

var bounceInDown_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var timing = {
  animationTimingFunction: (0, utils.cubicBezier)(0.215, 0.610, 0.355, 1.000)
};

var bounceInDown = {
  from: timing,
  '0%': {
    opacity: 0,
    transform: (0, utils.translate3d)(0, '-3000px', 0)
  },
  '60%': _extends({}, timing, {
    opacity: 1,
    transform: (0, utils.translate3d)(0, '25px', 0)
  }),
  '75%': _extends({}, timing, {
    transform: (0, utils.translate3d)(0, '-10px', 0)
  }),
  '90%': _extends({}, timing, {
    transform: (0, utils.translate3d)(0, '5px', 0)
  }),
  to: _extends({}, timing, {
    transform: 'none'
  })
};

exports.default = bounceInDown;
});

unwrapExports$1(bounceInDown_1);

var bounceInLeft_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var timing = {
  animationTimingFunction: (0, utils.cubicBezier)(0.215, 0.610, 0.355, 1.000)
};

var bounceInLeft = {
  from: timing,
  '0%': {
    opacity: 0,
    transform: (0, utils.translate3d)('-3000px', 0, 0)
  },
  '60%': _extends({}, timing, {
    opacity: 1,
    transform: (0, utils.translate3d)('25px', 0, 0)
  }),
  '75%': _extends({}, timing, {
    transform: (0, utils.translate3d)('-10px', 0, 0)
  }),
  '90%': _extends({}, timing, {
    transform: (0, utils.translate3d)('5px', 0, 0)
  }),
  to: _extends({}, timing, {
    transform: 'none'
  })
};

exports.default = bounceInLeft;
});

unwrapExports$1(bounceInLeft_1);

var bounceInRight_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var timing = {
  animationTimingFunction: (0, utils.cubicBezier)(0.215, 0.610, 0.355, 1.000)
};

var bounceInRight = {
  from: timing,
  '0%': {
    opacity: 0,
    transform: (0, utils.translate3d)('3000px', 0, 0)
  },
  '60%': _extends({}, timing, {
    opacity: 1,
    transform: (0, utils.translate3d)('-25px', 0, 0)
  }),
  '75%': _extends({}, timing, {
    transform: (0, utils.translate3d)('10px', 0, 0)
  }),
  '90%': _extends({}, timing, {
    transform: (0, utils.translate3d)('-5px', 0, 0)
  }),
  to: _extends({}, timing, {
    transform: 'none'
  })
};

exports.default = bounceInRight;
});

unwrapExports$1(bounceInRight_1);

var bounceInUp_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var timing = {
  animationTimingFunction: (0, utils.cubicBezier)(0.215, 0.610, 0.355, 1.000)
};

var bounceInUp = {
  from: timing,
  '0%': {
    opacity: 0,
    transform: (0, utils.translate3d)(0, '3000px', 0)
  },
  '60%': _extends({}, timing, {
    opacity: 1,
    transform: (0, utils.translate3d)(0, '-20px', 0)
  }),
  '75%': _extends({}, timing, {
    transform: (0, utils.translate3d)(0, '10px', 0)
  }),
  '90%': _extends({}, timing, {
    transform: (0, utils.translate3d)(0, '-5px', 0)
  }),
  to: _extends({}, timing, {
    transform: 'none'
  })
};

exports.default = bounceInUp;
});

unwrapExports$1(bounceInUp_1);

var bounceOut_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var bounceOut = {
  '20%': {
    transform: (0, utils.scale3d)(0.9, 0.9, 0.9)
  },
  '50%': {
    transform: (0, utils.scale3d)(1.1, 1.1, 1.1)
  },
  '55%': {
    transform: (0, utils.scale3d)(1.1, 1.1, 1.1)
  },
  to: {
    opacity: 0,
    transform: (0, utils.scale3d)(0.3, 0.3, 0.3)
  }
};
exports.default = bounceOut;
});

unwrapExports$1(bounceOut_1);

var bounceOutDown_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var bounceOutDown = {
  '20%': {
    transform: (0, utils.translate3d)(0, '10px', 0)
  },
  '40%': {
    transform: (0, utils.translate3d)(0, '-20px', 0)
  },
  '45%': {
    transform: (0, utils.translate3d)(0, '-20px', 0)
  },
  to: {
    opacity: 0,
    transform: (0, utils.translate3d)(0, '2000px', 0)
  }
};
exports.default = bounceOutDown;
});

unwrapExports$1(bounceOutDown_1);

var bounceOutLeft_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var bounceOutLeft = {
  '20%': {
    opacity: 1,
    transform: (0, utils.translate3d)('20px', 0, 0)
  },
  to: {
    opacity: 0,
    transform: (0, utils.translate3d)('-2000px', 0, 0)
  }
};
exports.default = bounceOutLeft;
});

unwrapExports$1(bounceOutLeft_1);

var bounceOutRight_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var bounceOutRight = {
  '20%': {
    opacity: 1,
    transform: (0, utils.translate3d)('-20px', 0, 0)
  },
  to: {
    opacity: 1,
    transform: (0, utils.translate3d)('2000px', 0, 0)
  }
};
exports.default = bounceOutRight;
});

unwrapExports$1(bounceOutRight_1);

var bounceOutUp_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var bounceOutUp = {
  '20%': {
    transform: (0, utils.translate3d)(0, '-10px', 0)
  },
  '40%': {
    opacity: 1,
    transform: (0, utils.translate3d)(0, '20px', 0)
  },
  '45%': {
    opacity: 1,
    transform: (0, utils.translate3d)(0, '20px', 0)
  },
  to: {
    opacity: 0,
    transform: (0, utils.translate3d)(0, '-2000px', 0)
  }
};
exports.default = bounceOutUp;
});

unwrapExports$1(bounceOutUp_1);

var fadeIn_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});


var fadeIn = {
  from: {
    opacity: 0
  },
  to: {
    opacity: 1
  }
};
exports.default = fadeIn;
});

unwrapExports$1(fadeIn_1);

var fadeInDown_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var fadeInDown = {
  from: {
    opacity: 0,
    transform: (0, utils.translate3d)(0, '-100%', 0)
  },
  to: {
    opacity: 1,
    transform: 'none'
  }
};
exports.default = fadeInDown;
});

unwrapExports$1(fadeInDown_1);

var fadeInDownBig_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var fadeInDownBig = {
  from: {
    opacity: 0,
    transform: (0, utils.translate3d)(0, '-2000px', 0)
  },
  to: {
    opacity: 1,
    transform: 'none'
  }
};
exports.default = fadeInDownBig;
});

unwrapExports$1(fadeInDownBig_1);

var fadeInLeft_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var fadeInLeft = {
  from: {
    opacity: 0,
    transform: (0, utils.translate3d)('-100%', 0, 0)
  },
  to: {
    opacity: 1,
    transform: 'none'
  }
};
exports.default = fadeInLeft;
});

unwrapExports$1(fadeInLeft_1);

var fadeInLeftBig_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var fadeInLeftBig = {
  from: {
    opacity: 0,
    transform: (0, utils.translate3d)('-2000px', 0, 0)
  },
  to: {
    opacity: 1,
    transform: 'none'
  }
};
exports.default = fadeInLeftBig;
});

unwrapExports$1(fadeInLeftBig_1);

var fadeInRight_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var fadeInRight = {
  from: {
    opacity: 0,
    transform: (0, utils.translate3d)('100%', 0, 0)
  },
  to: {
    opacity: 1,
    transform: 'none'
  }
};
exports.default = fadeInRight;
});

unwrapExports$1(fadeInRight_1);

var fadeInRightBig_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var fadeInRightBig = {
  from: {
    opacity: 0,
    transform: (0, utils.translate3d)('2000px', 0, 0)
  },
  to: {
    opacity: 1,
    transform: 'none'
  }
};
exports.default = fadeInRightBig;
});

unwrapExports$1(fadeInRightBig_1);

var fadeInUp_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var fadeInUp = {
  from: {
    opacity: 0,
    transform: (0, utils.translate3d)(0, '100%', 0)
  },
  to: {
    opacity: 1,
    transform: 'none'
  }
};
exports.default = fadeInUp;
});

unwrapExports$1(fadeInUp_1);

var fadeInUpBig_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var fadeInUpBig = {
  from: {
    opacity: 0,
    transform: (0, utils.translate3d)(0, '2000px', 0)
  },
  to: {
    opacity: 1,
    transform: 'none'
  }
};
exports.default = fadeInUpBig;
});

unwrapExports$1(fadeInUpBig_1);

var fadeOut_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});


var fadeOut = {
  from: {
    opacity: 1
  },
  to: {
    opacity: 0
  }
};
exports.default = fadeOut;
});

unwrapExports$1(fadeOut_1);

var fadeOutDown_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var fadeOutDown = {
  from: {
    opacity: 1
  },
  to: {
    opacity: 0,
    transform: (0, utils.translate3d)(0, '100%', 0)
  }
};
exports.default = fadeOutDown;
});

unwrapExports$1(fadeOutDown_1);

var fadeOutDownBig_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var fadeOutDownBig = {
  from: {
    opacity: 1
  },
  to: {
    opacity: 0,
    transform: (0, utils.translate3d)(0, '2000px', 0)
  }
};
exports.default = fadeOutDownBig;
});

unwrapExports$1(fadeOutDownBig_1);

var fadeOutLeft_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var fadeOutLeft = {
  from: {
    opacity: 1
  },
  to: {
    opacity: 0,
    transform: (0, utils.translate3d)('-100%', 0, 0)
  }
};
exports.default = fadeOutLeft;
});

unwrapExports$1(fadeOutLeft_1);

var fadeOutLeftBig_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var fadeOutLeftBig = {
  from: {
    opacity: 1
  },
  to: {
    opacity: 0,
    transform: (0, utils.translate3d)('-2000px', 0, 0)
  }
};
exports.default = fadeOutLeftBig;
});

unwrapExports$1(fadeOutLeftBig_1);

var fadeOutRight_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var fadeOutRight = {
  from: {
    opacity: 1
  },
  to: {
    opacity: 0,
    transform: (0, utils.translate3d)('100%', 0, 0)
  }
};
exports.default = fadeOutRight;
});

unwrapExports$1(fadeOutRight_1);

var fadeOutRightBig_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var fadeOutRightBig = {
  from: {
    opacity: 1
  },
  to: {
    opacity: 0,
    transform: (0, utils.translate3d)('2000px', 0, 0)
  }
};
exports.default = fadeOutRightBig;
});

unwrapExports$1(fadeOutRightBig_1);

var fadeOutUp_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var fadeOutUp = {
  from: {
    opacity: 1
  },
  to: {
    opacity: 0,
    transform: (0, utils.translate3d)(0, '-100%', 0)
  }
};
exports.default = fadeOutUp;
});

unwrapExports$1(fadeOutUp_1);

var fadeOutUpBig_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var fadeOutUpBig = {
  from: {
    opacity: 1
  },
  to: {
    opacity: 0,
    transform: (0, utils.translate3d)(0, '-2000px', 0)
  }
};
exports.default = fadeOutUpBig;
});

unwrapExports$1(fadeOutUpBig_1);

var flip_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var perspectiveAndRotate = (0, utils.compose)(utils.perspective, utils.rotate3d);


var perspectiveAndScale = (0, utils.compose)(utils.perspective, utils.scale3d);

var perspectiveTranslateRotate = (0, utils.compose)(utils.perspective, utils.translate3d, utils.rotate3d);

var flip = {
  from: {
    animationTimingFunction: 'ease-out',
    transform: perspectiveAndRotate('400px', [0, 1, 0, -360])
  },
  '40%': {
    animationTimingFunction: 'ease-out',
    transform: perspectiveTranslateRotate('400px', [0, 0, '150px'], [0, 1, 0, -190])
  },
  '50%': {
    animationTimingFunction: 'ease-in',
    transform: perspectiveTranslateRotate('400px', [0, 0, '150px'], [0, 1, 0, -170])
  },
  '80%': {
    animationTimingFunction: 'ease-in',
    transform: perspectiveAndScale('400px', [0.95, 0.95, 0.95])
  },
  to: {
    animationTimingFunction: 'ease-in',
    transform: (0, utils.perspective)('400px')
  }
};

exports.default = flip;
});

unwrapExports$1(flip_1);

var flipInX_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var perspectiveAndRotate = (0, utils.compose)(utils.perspective, utils.rotate3d);


var flipInX = {
  from: {
    animationTimingFunction: 'ease-out',
    transform: perspectiveAndRotate('400px', [1, 0, 0, 90]),
    opacity: 0
  },
  '40%': {
    animationTimingFunction: 'ease-in',
    transform: perspectiveAndRotate('400px', [1, 0, 0, -20])
  },
  '60%': {
    transform: perspectiveAndRotate('400px', [1, 0, 0, 10])
  },
  '80%': {
    transform: perspectiveAndRotate('400px', [1, 0, 0, -5])
  },
  to: {
    transform: (0, utils.perspective)('400px')
  }
};

exports.default = flipInX;
});

unwrapExports$1(flipInX_1);

var flipInY_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var perspectiveAndRotate = (0, utils.compose)(utils.perspective, utils.rotate3d);


var flipInY = {
  from: {
    animationTimingFunction: 'ease-out',
    transform: perspectiveAndRotate('400px', [0, 1, 0, 90]),
    opacity: 0
  },
  '40%': {
    animationTimingFunction: 'ease-in',
    transform: perspectiveAndRotate('400px', [0, 1, 0, -20])
  },
  '60%': {
    transform: perspectiveAndRotate('400px', [0, 1, 0, 10])
  },
  '80%': {
    transform: perspectiveAndRotate('400px', [0, 1, 0, -5])
  },
  to: {
    transform: (0, utils.perspective)('400px')
  }
};

exports.default = flipInY;
});

unwrapExports$1(flipInY_1);

var flipOutX_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var perspectiveAndRotate = (0, utils.compose)(utils.perspective, utils.rotate3d);


var flipOutX = {
  from: {
    transform: (0, utils.perspective)('400px')
  },
  '30%': {
    transform: perspectiveAndRotate('400px', [1, 0, 0, -20]),
    opacity: 1
  },
  to: {
    transform: perspectiveAndRotate('400px', [1, 0, 0, 90]),
    opacity: 0
  }
};

exports.default = flipOutX;
});

unwrapExports$1(flipOutX_1);

var flipOutY_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var perspectiveAndRotate = (0, utils.compose)(utils.perspective, utils.rotate3d);


var flipOutY = {
  from: {
    transform: (0, utils.perspective)('400px')
  },
  '30%': {
    transform: perspectiveAndRotate('400px', [0, 1, 0, -15]),
    opacity: 1
  },
  to: {
    transform: perspectiveAndRotate('400px', [0, 1, 0, 90]),
    opacity: 0
  }
};

exports.default = flipOutY;
});

unwrapExports$1(flipOutY_1);

var lightSpeedIn_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var translateAndSkew = (0, utils.compose)(utils.translate3d, utils.skewX);

var easeIn = {
  animationTimingFunction: 'ease-out'
};

var lightSpeedIn = {
  from: _extends({}, easeIn, {
    opacity: 0,
    transform: translateAndSkew(['100%', 0, 0], -30)
  }),
  '60%': _extends({}, easeIn, {
    opacity: 1,
    transform: (0, utils.skewX)(20)
  }),
  '80%': _extends({}, easeIn, {
    opacity: 1,
    transform: (0, utils.skewX)(-5)
  }),
  to: _extends({}, easeIn, {
    transform: 'none',
    opacity: 1
  })
};

exports.default = lightSpeedIn;
});

unwrapExports$1(lightSpeedIn_1);

var lightSpeedOut_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var translateAndSkew = (0, utils.compose)(utils.translate3d, utils.skewX);

var easeIn = {
  animationTimingFunction: 'ease-out'
};

var lightSpeedOut = {
  from: _extends({}, easeIn, {
    opacity: 1
  }),
  to: _extends({}, easeIn, {
    transform: translateAndSkew(['100%', 0, 0], 30),
    opacity: 0
  })
};

exports.default = lightSpeedOut;
});

unwrapExports$1(lightSpeedOut_1);

var rotateIn_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var rotateIn = {
  from: {
    transformOrigin: 'center',
    transform: (0, utils.rotate3d)(0, 0, 1, -200),
    opacity: 0
  },
  to: {
    transformOrigin: 'center',
    transform: 'none',
    opacity: 1
  }
};
exports.default = rotateIn;
});

unwrapExports$1(rotateIn_1);

var rotateInDownLeft_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var rotateInDownLeft = {
  from: {
    transformOrigin: 'left bottom',
    transform: (0, utils.rotate3d)(0, 0, 1, -45),
    opacity: 0
  },
  to: {
    transformOrigin: 'left bottom',
    transform: 'none',
    opacity: 1
  }
};
exports.default = rotateInDownLeft;
});

unwrapExports$1(rotateInDownLeft_1);

var rotateInDownRight_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var rotateInDownRight = {
  from: {
    transformOrigin: 'right bottom',
    transform: (0, utils.rotate3d)(0, 0, 1, 45),
    opacity: 0
  },
  to: {
    transformOrigin: 'right bottom',
    transform: 'none',
    opacity: 1
  }
};
exports.default = rotateInDownRight;
});

unwrapExports$1(rotateInDownRight_1);

var rotateInUpLeft_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var rotateInUpLeft = {
  from: {
    transformOrigin: 'left bottom',
    transform: (0, utils.rotate3d)(0, 0, 1, 45),
    opacity: 0
  },
  to: {
    transformOrigin: 'left bottom',
    transform: 'none',
    opacity: 1
  }
};
exports.default = rotateInUpLeft;
});

unwrapExports$1(rotateInUpLeft_1);

var rotateInUpRight_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var rotateInUpRight = {
  from: {
    transformOrigin: 'right bottom',
    transform: (0, utils.rotate3d)(0, 0, 1, -90),
    opacity: 0
  },
  to: {
    transformOrigin: 'right bottom',
    transform: 'none',
    opacity: 1
  }
};
exports.default = rotateInUpRight;
});

unwrapExports$1(rotateInUpRight_1);

var rotateOut_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var rotateOut = {
  from: {
    transformOrigin: 'center',
    opacity: 1
  },
  to: {
    transformOrigin: 'center',
    transform: (0, utils.rotate3d)(0, 0, 1, 200),
    opacity: 0
  }
};
exports.default = rotateOut;
});

unwrapExports$1(rotateOut_1);

var rotateOutDownLeft_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var rotateOutDownLeft = {
  from: {
    transformOrigin: 'left bottom',
    opacity: 1
  },
  to: {
    transformOrigin: 'left bottom',
    transform: (0, utils.rotate3d)(0, 0, 1, 45),
    opacity: 0
  }
};
exports.default = rotateOutDownLeft;
});

unwrapExports$1(rotateOutDownLeft_1);

var rotateOutDownRight_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var rotateOutDownRight = {
  from: {
    transformOrigin: 'right bottom',
    opacity: 1
  },
  to: {
    transformOrigin: 'right bottom',
    transform: (0, utils.rotate3d)(0, 0, 1, -45),
    opacity: 0
  }
};
exports.default = rotateOutDownRight;
});

unwrapExports$1(rotateOutDownRight_1);

var rotateOutUpLeft_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var rotateOutUpLeft = {
  from: {
    transformOrigin: 'left bottom',
    opacity: 1
  },
  to: {
    transformOrigin: 'left bottom',
    transform: (0, utils.rotate3d)(0, 0, 1, -45),
    opacity: 0
  }
};
exports.default = rotateOutUpLeft;
});

unwrapExports$1(rotateOutUpLeft_1);

var rotateOutUpRight_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var rotateOutUpRight = {
  from: {
    transformOrigin: 'right bottom',
    opacity: 1
  },
  to: {
    transformOrigin: 'right bottom',
    transform: (0, utils.rotate3d)(0, 0, 1, 90),
    opacity: 0
  }
};
exports.default = rotateOutUpRight;
});

unwrapExports$1(rotateOutUpRight_1);

var slideInDown_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var slideInDown = {
  from: {
    transform: (0, utils.translate3d)(0, '-100%', 0),
    visibility: 'visible'
  },
  to: {
    transform: (0, utils.translate3d)(0, 0, 0)
  }
};
exports.default = slideInDown;
});

unwrapExports$1(slideInDown_1);

var slideInLeft_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var slideInLeft = {
  from: {
    transform: (0, utils.translate3d)('-100%', 0, 0),
    visibility: 'visible'
  },
  to: {
    transform: (0, utils.translate3d)(0, 0, 0)
  }
};
exports.default = slideInLeft;
});

unwrapExports$1(slideInLeft_1);

var slideInRight_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var slideInRight = {
  from: {
    transform: (0, utils.translate3d)('100%', 0, 0),
    visibility: 'visible'
  },
  to: {
    transform: (0, utils.translate3d)(0, 0, 0)
  }
};
exports.default = slideInRight;
});

unwrapExports$1(slideInRight_1);

var slideInUp_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var slideInUp = {
  from: {
    transform: (0, utils.translate3d)(0, '100%', 0),
    visibility: 'visible'
  },
  to: {
    transform: (0, utils.translate3d)(0, 0, 0)
  }
};
exports.default = slideInUp;
});

unwrapExports$1(slideInUp_1);

var slideOutDown_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var slideOutDown = {
  from: {
    transform: (0, utils.translate3d)(0, 0, 0)
  },
  to: {
    visibility: 'hidden',
    transform: (0, utils.translate3d)(0, '100%', 0)
  }
};
exports.default = slideOutDown;
});

unwrapExports$1(slideOutDown_1);

var slideOutLeft_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var slideOutLeft = {
  from: {
    transform: (0, utils.translate3d)(0, 0, 0)
  },
  to: {
    visibility: 'hidden',
    transform: (0, utils.translate3d)('-100%', 0, 0)
  }
};
exports.default = slideOutLeft;
});

unwrapExports$1(slideOutLeft_1);

var slideOutRight_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var slideOutRight = {
  from: {
    transform: (0, utils.translate3d)(0, 0, 0)
  },
  to: {
    visibility: 'hidden',
    transform: (0, utils.translate3d)('100%', 0, 0)
  }
};
exports.default = slideOutRight;
});

unwrapExports$1(slideOutRight_1);

var slideOutUp_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var slideOutUp = {
  from: {
    transform: (0, utils.translate3d)(0, 0, 0)
  },
  to: {
    visibility: 'hidden',
    transform: (0, utils.translate3d)(0, '-100%', 0)
  }
};
exports.default = slideOutUp;
});

unwrapExports$1(slideOutUp_1);

var hinge_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var hingeUp = {
  transform: (0, utils.rotate3d)(0, 0, 1, 80),
  transformOrigin: 'top left',
  animationTimingFunction: 'ease-in-out'
};


var hingeDown = {
  transform: (0, utils.rotate3d)(0, 0, 1, 60),
  transformOrigin: 'top left',
  animationTimingFunction: 'ease-in-out',
  opacity: 1
};

var hinge = {
  '0%': {
    transformOrigin: 'top left',
    animationTimingFunction: 'ease-in-out'
  },
  '20%': hingeUp,
  '40%': hingeDown,
  '60%': hingeUp,
  '80%': hingeDown,
  to: {
    transform: (0, utils.translate3d)(0, '700px', 0),
    opacity: 0
  }
};

exports.default = hinge;
});

unwrapExports$1(hinge_1);

var rollIn_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var translateAndRotate = (0, utils.compose)(utils.translate3d, utils.rotate3d);


var rollIn = {
  from: {
    opacity: 0,
    transform: translateAndRotate(['-100%', 0, 0], [0, 0, 1, -120])
  },
  to: {
    opacity: 1,
    transform: 'none'
  }
};

exports.default = rollIn;
});

unwrapExports$1(rollIn_1);

var rollOut_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var translateAndRotate = (0, utils.compose)(utils.translate3d, utils.rotate3d);


var rollOut = {
  from: {
    opacity: 1
  },
  to: {
    opacity: 0,
    transform: translateAndRotate(['100%', 0, 0], [0, 0, 1, 120])
  }
};

exports.default = rollOut;
});

unwrapExports$1(rollOut_1);

var zoomIn_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var zoomIn = {
  from: {
    opacity: 0,
    transform: (0, utils.scale3d)(0.3, 0.3, 0.3)
  },
  '50%': {
    opacity: 1
  }
};
exports.default = zoomIn;
});

unwrapExports$1(zoomIn_1);

var zoomInDown_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var scaleAndTranslate = (0, utils.compose)(utils.scale3d, utils.translate3d);


var zoomInDown = {
  from: {
    opacity: 0,
    transform: scaleAndTranslate([0.1, 0.1, 0.1], [0, '-1000px', 0]),
    animationTimingFunction: (0, utils.cubicBezier)(0.550, 0.055, 0.675, 0.190)
  },
  '60%': {
    opacity: 1,
    transform: scaleAndTranslate([0.475, 0.475, 0.475], [0, '60px', 0]),
    animationTimingFunction: (0, utils.cubicBezier)(0.175, 0.885, 0.320, 1)
  }
};

exports.default = zoomInDown;
});

unwrapExports$1(zoomInDown_1);

var zoomInLeft_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var scaleAndTranslate = (0, utils.compose)(utils.scale3d, utils.translate3d);


var zoomInLeft = {
  from: {
    opacity: 0,
    transform: scaleAndTranslate([0.1, 0.1, 0.1], ['-1000px', 0, 0]),
    animationTimingFunction: (0, utils.cubicBezier)(0.550, 0.055, 0.675, 0.190)
  },
  '60%': {
    opacity: 1,
    transform: scaleAndTranslate([0.475, 0.475, 0.475], ['10px', 0, 0]),
    animationTimingFunction: (0, utils.cubicBezier)(0.175, 0.885, 0.320, 1)
  }
};

exports.default = zoomInLeft;
});

unwrapExports$1(zoomInLeft_1);

var zoomInRight_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var scaleAndTranslate = (0, utils.compose)(utils.scale3d, utils.translate3d);


var zoomInRight = {
  from: {
    opacity: 0,
    transform: scaleAndTranslate([0.1, 0.1, 0.1], ['1000px', 0, 0]),
    animationTimingFunction: (0, utils.cubicBezier)(0.550, 0.055, 0.675, 0.190)
  },
  '60%': {
    opacity: 1,
    transform: scaleAndTranslate([0.475, 0.475, 0.475], ['-10px', 0, 0]),
    animationTimingFunction: (0, utils.cubicBezier)(0.175, 0.885, 0.320, 1)
  }
};

exports.default = zoomInRight;
});

unwrapExports$1(zoomInRight_1);

var zoomInUp_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var scaleAndTranslate = (0, utils.compose)(utils.scale3d, utils.translate3d);


var zoomInUp = {
  from: {
    opacity: 0,
    transform: scaleAndTranslate([0.1, 0.1, 0.1], [0, '1000px', 0]),
    animationTimingFunction: (0, utils.cubicBezier)(0.550, 0.055, 0.675, 0.190)
  },
  '60%': {
    opacity: 1,
    transform: scaleAndTranslate([0.475, 0.475, 0.475], [0, '-60px', 0]),
    animationTimingFunction: (0, utils.cubicBezier)(0.175, 0.885, 0.320, 1)
  }
};

exports.default = zoomInUp;
});

unwrapExports$1(zoomInUp_1);

var zoomOut_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var zoomOut = {
  from: {
    opacity: 1
  },
  '50%': {
    opacity: 0,
    transform: (0, utils.scale3d)(0.3, 0.3, 0.3)
  },
  to: {
    opacity: 0
  }
};
exports.default = zoomOut;
});

unwrapExports$1(zoomOut_1);

var zoomOutDown_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var scaleAndTranslate = (0, utils.compose)(utils.scale3d, utils.translate3d);


var zoomOutDown = {
  '40%': {
    opacity: 1,
    transform: scaleAndTranslate([0.475, 0.475, 0.475], [0, '-60px', 0]),
    animationTimingFunction: (0, utils.cubicBezier)(0.550, 0.055, 0.675, 0.190)
  },
  to: {
    opacity: 0,
    transform: scaleAndTranslate([0.1, 0.1, 0.1], [0, '2000px', 0]),
    transformOrigin: 'center bottom',
    animationTimingFunction: (0, utils.cubicBezier)(0.175, 0.885, 0.320, 1)
  }
};

exports.default = zoomOutDown;
});

unwrapExports$1(zoomOutDown_1);

var zoomOutLeft_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var scale3dAndTranslate = (0, utils.compose)(utils.scale3d, utils.translate3d);

var scaleAndTranslate = (0, utils.compose)(utils.scale, utils.translate3d);

var zoomOutLeft = {
  '40%': {
    opacity: 1,
    transform: scale3dAndTranslate([0.475, 0.475, 0.475], ['42px', 0, 0])
  },
  to: {
    opacity: 0,
    transform: scaleAndTranslate(0.1, ['-2000px', 0, 0]),
    transformOrigin: 'left center'
  }
};

exports.default = zoomOutLeft;
});

unwrapExports$1(zoomOutLeft_1);

var zoomOutRight_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var scale3dAndTranslate = (0, utils.compose)(utils.scale3d, utils.translate3d);

var scaleAndTranslate = (0, utils.compose)(utils.scale, utils.translate3d);

var zoomOutRight = {
  '40%': {
    opacity: 1,
    transform: scale3dAndTranslate([0.475, 0.475, 0.475], ['-42px', 0, 0])
  },
  to: {
    opacity: 0,
    transform: scaleAndTranslate(0.1, ['2000px', 0, 0]),
    transformOrigin: 'right center'
  }
};

exports.default = zoomOutRight;
});

unwrapExports$1(zoomOutRight_1);

var zoomOutUp_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var scaleAndTranslate = (0, utils.compose)(utils.scale3d, utils.translate3d);


var zoomOutUp = {
  '40%': {
    opacity: 1,
    transform: scaleAndTranslate([0.475, 0.475, 0.475], [0, '60px', 0]),
    animationTimingFunction: (0, utils.cubicBezier)(0.550, 0.055, 0.675, 0.190)
  },
  to: {
    opacity: 0,
    transform: scaleAndTranslate([0.1, 0.1, 0.1], [0, '-2000px', 0]),
    transformOrigin: 'center bottom',
    animationTimingFunction: (0, utils.cubicBezier)(0.175, 0.885, 0.320, 1)
  }
};

exports.default = zoomOutUp;
});

unwrapExports$1(zoomOutUp_1);

var lib = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.zoomOutUp = exports.zoomOutRight = exports.zoomOutLeft = exports.zoomOutDown = exports.zoomOut = exports.zoomInUp = exports.zoomInRight = exports.zoomInLeft = exports.zoomInDown = exports.zoomIn = exports.rollOut = exports.rollIn = exports.hinge = exports.slideOutUp = exports.slideOutRight = exports.slideOutLeft = exports.slideOutDown = exports.slideInUp = exports.slideInRight = exports.slideInLeft = exports.slideInDown = exports.rotateOutUpRight = exports.rotateOutUpLeft = exports.rotateOutDownRight = exports.rotateOutDownLeft = exports.rotateOut = exports.rotateInUpRight = exports.rotateInUpLeft = exports.rotateInDownRight = exports.rotateInDownLeft = exports.rotateIn = exports.lightSpeedOut = exports.lightSpeedIn = exports.flipOutY = exports.flipOutX = exports.flipInY = exports.flipInX = exports.flip = exports.fadeOutUpBig = exports.fadeOutUp = exports.fadeOutRightBig = exports.fadeOutRight = exports.fadeOutLeftBig = exports.fadeOutLeft = exports.fadeOutDownBig = exports.fadeOutDown = exports.fadeOut = exports.fadeInUpBig = exports.fadeInUp = exports.fadeInRightBig = exports.fadeInRight = exports.fadeInLeftBig = exports.fadeInLeft = exports.fadeInDownBig = exports.fadeInDown = exports.fadeIn = exports.bounceOutUp = exports.bounceOutRight = exports.bounceOutLeft = exports.bounceOutDown = exports.bounceOut = exports.bounceInUp = exports.bounceInRight = exports.bounceInLeft = exports.bounceInDown = exports.bounceIn = exports.tada = exports.swing = exports.shake = exports.rubberBand = exports.headShake = exports.wobble = exports.jello = exports.pulse = exports.flash = exports.bounce = exports.merge = undefined;



var _merge3 = _interopRequireDefault(merge_1);



var _bounce3 = _interopRequireDefault(bounce_1);



var _flash3 = _interopRequireDefault(flash_1);



var _pulse3 = _interopRequireDefault(pulse_1);



var _jello3 = _interopRequireDefault(jello_1);



var _wobble3 = _interopRequireDefault(wobble_1);



var _headShake3 = _interopRequireDefault(headShake_1);



var _rubberBand3 = _interopRequireDefault(rubberBand_1);



var _shake3 = _interopRequireDefault(shake_1);



var _swing3 = _interopRequireDefault(swing_1);



var _tada3 = _interopRequireDefault(tada_1);



var _bounceIn3 = _interopRequireDefault(bounceIn_1);



var _bounceInDown3 = _interopRequireDefault(bounceInDown_1);



var _bounceInLeft3 = _interopRequireDefault(bounceInLeft_1);



var _bounceInRight3 = _interopRequireDefault(bounceInRight_1);



var _bounceInUp3 = _interopRequireDefault(bounceInUp_1);



var _bounceOut3 = _interopRequireDefault(bounceOut_1);



var _bounceOutDown3 = _interopRequireDefault(bounceOutDown_1);



var _bounceOutLeft3 = _interopRequireDefault(bounceOutLeft_1);



var _bounceOutRight3 = _interopRequireDefault(bounceOutRight_1);



var _bounceOutUp3 = _interopRequireDefault(bounceOutUp_1);



var _fadeIn3 = _interopRequireDefault(fadeIn_1);



var _fadeInDown3 = _interopRequireDefault(fadeInDown_1);



var _fadeInDownBig3 = _interopRequireDefault(fadeInDownBig_1);



var _fadeInLeft3 = _interopRequireDefault(fadeInLeft_1);



var _fadeInLeftBig3 = _interopRequireDefault(fadeInLeftBig_1);



var _fadeInRight3 = _interopRequireDefault(fadeInRight_1);



var _fadeInRightBig3 = _interopRequireDefault(fadeInRightBig_1);



var _fadeInUp3 = _interopRequireDefault(fadeInUp_1);



var _fadeInUpBig3 = _interopRequireDefault(fadeInUpBig_1);



var _fadeOut3 = _interopRequireDefault(fadeOut_1);



var _fadeOutDown3 = _interopRequireDefault(fadeOutDown_1);



var _fadeOutDownBig3 = _interopRequireDefault(fadeOutDownBig_1);



var _fadeOutLeft3 = _interopRequireDefault(fadeOutLeft_1);



var _fadeOutLeftBig3 = _interopRequireDefault(fadeOutLeftBig_1);



var _fadeOutRight3 = _interopRequireDefault(fadeOutRight_1);



var _fadeOutRightBig3 = _interopRequireDefault(fadeOutRightBig_1);



var _fadeOutUp3 = _interopRequireDefault(fadeOutUp_1);



var _fadeOutUpBig3 = _interopRequireDefault(fadeOutUpBig_1);



var _flip3 = _interopRequireDefault(flip_1);



var _flipInX3 = _interopRequireDefault(flipInX_1);



var _flipInY3 = _interopRequireDefault(flipInY_1);



var _flipOutX3 = _interopRequireDefault(flipOutX_1);



var _flipOutY3 = _interopRequireDefault(flipOutY_1);



var _lightSpeedIn3 = _interopRequireDefault(lightSpeedIn_1);



var _lightSpeedOut3 = _interopRequireDefault(lightSpeedOut_1);



var _rotateIn3 = _interopRequireDefault(rotateIn_1);



var _rotateInDownLeft3 = _interopRequireDefault(rotateInDownLeft_1);



var _rotateInDownRight3 = _interopRequireDefault(rotateInDownRight_1);



var _rotateInUpLeft3 = _interopRequireDefault(rotateInUpLeft_1);



var _rotateInUpRight3 = _interopRequireDefault(rotateInUpRight_1);



var _rotateOut3 = _interopRequireDefault(rotateOut_1);



var _rotateOutDownLeft3 = _interopRequireDefault(rotateOutDownLeft_1);



var _rotateOutDownRight3 = _interopRequireDefault(rotateOutDownRight_1);



var _rotateOutUpLeft3 = _interopRequireDefault(rotateOutUpLeft_1);



var _rotateOutUpRight3 = _interopRequireDefault(rotateOutUpRight_1);



var _slideInDown3 = _interopRequireDefault(slideInDown_1);



var _slideInLeft3 = _interopRequireDefault(slideInLeft_1);



var _slideInRight3 = _interopRequireDefault(slideInRight_1);



var _slideInUp3 = _interopRequireDefault(slideInUp_1);



var _slideOutDown3 = _interopRequireDefault(slideOutDown_1);



var _slideOutLeft3 = _interopRequireDefault(slideOutLeft_1);



var _slideOutRight3 = _interopRequireDefault(slideOutRight_1);



var _slideOutUp3 = _interopRequireDefault(slideOutUp_1);



var _hinge3 = _interopRequireDefault(hinge_1);



var _rollIn3 = _interopRequireDefault(rollIn_1);



var _rollOut3 = _interopRequireDefault(rollOut_1);



var _zoomIn3 = _interopRequireDefault(zoomIn_1);



var _zoomInDown3 = _interopRequireDefault(zoomInDown_1);



var _zoomInLeft3 = _interopRequireDefault(zoomInLeft_1);



var _zoomInRight3 = _interopRequireDefault(zoomInRight_1);



var _zoomInUp3 = _interopRequireDefault(zoomInUp_1);



var _zoomOut3 = _interopRequireDefault(zoomOut_1);



var _zoomOutDown3 = _interopRequireDefault(zoomOutDown_1);



var _zoomOutLeft3 = _interopRequireDefault(zoomOutLeft_1);



var _zoomOutRight3 = _interopRequireDefault(zoomOutRight_1);



var _zoomOutUp3 = _interopRequireDefault(zoomOutUp_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.merge = _merge3.default;

/* Attention seekers */
/* Fun stuff */

exports.bounce = _bounce3.default;
exports.flash = _flash3.default;
exports.pulse = _pulse3.default;
exports.jello = _jello3.default;
exports.wobble = _wobble3.default;
exports.headShake = _headShake3.default;
exports.rubberBand = _rubberBand3.default;
exports.shake = _shake3.default;
exports.swing = _swing3.default;
exports.tada = _tada3.default;

/* Bouncing entrances */

exports.bounceIn = _bounceIn3.default;
exports.bounceInDown = _bounceInDown3.default;
exports.bounceInLeft = _bounceInLeft3.default;
exports.bounceInRight = _bounceInRight3.default;
exports.bounceInUp = _bounceInUp3.default;

/* Bouncing  exits */

exports.bounceOut = _bounceOut3.default;
exports.bounceOutDown = _bounceOutDown3.default;
exports.bounceOutLeft = _bounceOutLeft3.default;
exports.bounceOutRight = _bounceOutRight3.default;
exports.bounceOutUp = _bounceOutUp3.default;

/* Fading entrances */

exports.fadeIn = _fadeIn3.default;
exports.fadeInDown = _fadeInDown3.default;
exports.fadeInDownBig = _fadeInDownBig3.default;
exports.fadeInLeft = _fadeInLeft3.default;
exports.fadeInLeftBig = _fadeInLeftBig3.default;
exports.fadeInRight = _fadeInRight3.default;
exports.fadeInRightBig = _fadeInRightBig3.default;
exports.fadeInUp = _fadeInUp3.default;
exports.fadeInUpBig = _fadeInUpBig3.default;

/* Fading exits */

exports.fadeOut = _fadeOut3.default;
exports.fadeOutDown = _fadeOutDown3.default;
exports.fadeOutDownBig = _fadeOutDownBig3.default;
exports.fadeOutLeft = _fadeOutLeft3.default;
exports.fadeOutLeftBig = _fadeOutLeftBig3.default;
exports.fadeOutRight = _fadeOutRight3.default;
exports.fadeOutRightBig = _fadeOutRightBig3.default;
exports.fadeOutUp = _fadeOutUp3.default;
exports.fadeOutUpBig = _fadeOutUpBig3.default;

/* Flippers */

exports.flip = _flip3.default;
exports.flipInX = _flipInX3.default;
exports.flipInY = _flipInY3.default;
exports.flipOutX = _flipOutX3.default;
exports.flipOutY = _flipOutY3.default;

/* Lightspeed */

exports.lightSpeedIn = _lightSpeedIn3.default;
exports.lightSpeedOut = _lightSpeedOut3.default;

/* Rotating entrances */

exports.rotateIn = _rotateIn3.default;
exports.rotateInDownLeft = _rotateInDownLeft3.default;
exports.rotateInDownRight = _rotateInDownRight3.default;
exports.rotateInUpLeft = _rotateInUpLeft3.default;
exports.rotateInUpRight = _rotateInUpRight3.default;

/* Rotation exits */

exports.rotateOut = _rotateOut3.default;
exports.rotateOutDownLeft = _rotateOutDownLeft3.default;
exports.rotateOutDownRight = _rotateOutDownRight3.default;
exports.rotateOutUpLeft = _rotateOutUpLeft3.default;
exports.rotateOutUpRight = _rotateOutUpRight3.default;

/* Sliding entrances */

exports.slideInDown = _slideInDown3.default;
exports.slideInLeft = _slideInLeft3.default;
exports.slideInRight = _slideInRight3.default;
exports.slideInUp = _slideInUp3.default;

/* Sliding exits */

exports.slideOutDown = _slideOutDown3.default;
exports.slideOutLeft = _slideOutLeft3.default;
exports.slideOutRight = _slideOutRight3.default;
exports.slideOutUp = _slideOutUp3.default;

/* Specials */

exports.hinge = _hinge3.default;
exports.rollIn = _rollIn3.default;
exports.rollOut = _rollOut3.default;

/* Zooming entrances */

exports.zoomIn = _zoomIn3.default;
exports.zoomInDown = _zoomInDown3.default;
exports.zoomInLeft = _zoomInLeft3.default;
exports.zoomInRight = _zoomInRight3.default;
exports.zoomInUp = _zoomInUp3.default;

/* Zooming exits */

exports.zoomOut = _zoomOut3.default;
exports.zoomOutDown = _zoomOutDown3.default;
exports.zoomOutLeft = _zoomOutLeft3.default;
exports.zoomOutRight = _zoomOutRight3.default;
exports.zoomOutUp = _zoomOutUp3.default;
});

unwrapExports$1(lib);
var lib_1 = lib.zoomOutUp;
var lib_2 = lib.zoomOutRight;
var lib_3 = lib.zoomOutLeft;
var lib_4 = lib.zoomOutDown;
var lib_5 = lib.zoomOut;
var lib_6 = lib.zoomInUp;
var lib_7 = lib.zoomInRight;
var lib_8 = lib.zoomInLeft;
var lib_9 = lib.zoomInDown;
var lib_10 = lib.zoomIn;
var lib_11 = lib.rollOut;
var lib_12 = lib.rollIn;
var lib_13 = lib.hinge;
var lib_14 = lib.slideOutUp;
var lib_15 = lib.slideOutRight;
var lib_16 = lib.slideOutLeft;
var lib_17 = lib.slideOutDown;
var lib_18 = lib.slideInUp;
var lib_19 = lib.slideInRight;
var lib_20 = lib.slideInLeft;
var lib_21 = lib.slideInDown;
var lib_22 = lib.rotateOutUpRight;
var lib_23 = lib.rotateOutUpLeft;
var lib_24 = lib.rotateOutDownRight;
var lib_25 = lib.rotateOutDownLeft;
var lib_26 = lib.rotateOut;
var lib_27 = lib.rotateInUpRight;
var lib_28 = lib.rotateInUpLeft;
var lib_29 = lib.rotateInDownRight;
var lib_30 = lib.rotateInDownLeft;
var lib_31 = lib.rotateIn;
var lib_32 = lib.lightSpeedOut;
var lib_33 = lib.lightSpeedIn;
var lib_34 = lib.flipOutY;
var lib_35 = lib.flipOutX;
var lib_36 = lib.flipInY;
var lib_37 = lib.flipInX;
var lib_38 = lib.flip;
var lib_39 = lib.fadeOutUpBig;
var lib_40 = lib.fadeOutUp;
var lib_41 = lib.fadeOutRightBig;
var lib_42 = lib.fadeOutRight;
var lib_43 = lib.fadeOutLeftBig;
var lib_44 = lib.fadeOutLeft;
var lib_45 = lib.fadeOutDownBig;
var lib_46 = lib.fadeOutDown;
var lib_47 = lib.fadeOut;
var lib_48 = lib.fadeInUpBig;
var lib_49 = lib.fadeInUp;
var lib_50 = lib.fadeInRightBig;
var lib_51 = lib.fadeInRight;
var lib_52 = lib.fadeInLeftBig;
var lib_53 = lib.fadeInLeft;
var lib_54 = lib.fadeInDownBig;
var lib_55 = lib.fadeInDown;
var lib_56 = lib.fadeIn;
var lib_57 = lib.bounceOutUp;
var lib_58 = lib.bounceOutRight;
var lib_59 = lib.bounceOutLeft;
var lib_60 = lib.bounceOutDown;
var lib_61 = lib.bounceOut;
var lib_62 = lib.bounceInUp;
var lib_63 = lib.bounceInRight;
var lib_64 = lib.bounceInLeft;
var lib_65 = lib.bounceInDown;
var lib_66 = lib.bounceIn;
var lib_67 = lib.tada;
var lib_68 = lib.swing;
var lib_69 = lib.shake;
var lib_70 = lib.rubberBand;
var lib_71 = lib.headShake;
var lib_72 = lib.wobble;
var lib_73 = lib.jello;
var lib_74 = lib.pulse;
var lib_75 = lib.flash;
var lib_76 = lib.bounce;
var lib_77 = lib.merge;

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css$2 = ".styles_tooltip__1z_Ax {\n\tposition: fixed;\n  bottom: 8em;\n  right: 7em;\n  z-index: 99999;\n  background-color: white;\n  width: 300px;\n  height: auto;\n  border: 1px solid lightgray;\n  border-radius: 20px 20px 0px 20px;\n  box-shadow: 0px 3px 16px 0px rgba(0,0,0,0.1);\n  display: block;\n  font-size: 14px;\n  color: #333;\n  padding: 1em;\n  text-align: center;\n  line-height: initial;\n  font-family: 'Montserrat Light', arial;\n}\n\n.styles_chatCircle__3yoPm {\n  position: absolute;\n  background-color: white;\n  border: 1px solid lightgray;\n  width: 0.5em !important;\n  height: 0.5em !important;\n  border-radius: 50%;\n  padding: 0.8em;\n  cursor: pointer;\n  box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.1), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\n  text-align: center;\n  font-size: 1.2em;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.styles_chatCirclePosition__n8oIR {\n  position: fixed;\n  bottom: 4em;\n  right: 4em;\n}\n\n.styles_chatCircleSmall__G17Jm {\n  position: fixed;\n  bottom: 90px;\n  right: 40px;\n  background-color: white;\n  border: 1px solid lightgray;\n  border-radius: 50%;\n  padding: 0.4em;\n  cursor: pointer;\n  box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.1), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\n  text-align: center;\n  font-size: 1em;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.styles_speechBubble__GrPCz {\n  position: fixed;\n  background: #999999 none repeat scroll 0% 0%;\n  border-radius: .4em;\n  display: block;\n  padding: 10px;\n  height: auto;\n  text-align: center;\n  max-width: 200px;\n  font-size: 14px;\n  bottom: 110px;\n  right: 10px;\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 3px 16px 0px, rgba(0, 0, 0, 0.2) 0px 3px 1px -2px, rgba(0, 0, 0, 0.12) 0px 1px 5px 0px !important;\n  border: 1px solid lightgray;\n}\n\n.styles_speechBubbleOff__3nI9q {\n  position: fixed;\n  background: ivory none repeat scroll 0% 0%;\n  border-radius: .4em;\n  display: block;\n  padding: 10px;\n  height: auto;\n  text-align: center;\n  max-width: 200px;\n  font-size: 14px;\n  bottom: 110px;\n  right: 10px;\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 3px 16px 0px, rgba(0, 0, 0, 0.2) 0px 3px 1px -2px, rgba(0, 0, 0, 0.12) 0px 1px 5px 0px !important;\n  border: 1px solid lightgray,\n}\n\n.styles_speechBubbleArrow__3mB7B {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 80%;\n  width: 0;\n  height: 0;\n  border: 20px solid transparent;\n  border-top-color: #999999;\n  border-bottom: 0;\n  border-left: 0;\n  margin-left: -10px;\n  margin-bottom: -20px;\n}\n";
var styles$4 = {"tooltip":"styles_tooltip__1z_Ax","chatCircle":"styles_chatCircle__3yoPm","chatCirclePosition":"styles_chatCirclePosition__n8oIR","chatCircleSmall":"styles_chatCircleSmall__G17Jm","speechBubble":"styles_speechBubble__GrPCz","speechBubbleOff":"styles_speechBubbleOff__3nI9q","speechBubbleArrow":"styles_speechBubbleArrow__3mB7B"};
styleInject(css$2);

var animStyles = StyleSheet$1.create({
    fadeIn: {
        animationName: lib_56,
        animationDuration: '1s',
    },
    fadeOut: {
        animationName: lib_47,
        animationDuration: '1s',
    },
    fadeInLarge: {
        animationName: lib_56,
        animationDuration: '3s',
    },
    wobble: {
        animationName: lib_72,
        animationDuration: '1s'
    },
    bounce: {
        animationName: lib_76,
        animationDuration: '3s'
    },
    pulse: {
        animationName: lib_74,
        animationDuration: '2s'
    }
});
var CircleBtn = /** @class */ (function (_super) {
    __extends(CircleBtn, _super);
    function CircleBtn(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isShown: false,
            colorClass: '',
        };
        return _this;
    }
    CircleBtn.prototype.componentDidMount = function () {
        this.setState({ colorClass: this.props.theme.mainColor });
    };
    CircleBtn.prototype.shouldRenderCircleAnimation = function () {
        var _this = this;
        var _a = this.props, popoverActive = _a.popoverActive, popoverText = _a.popoverText, currentEvent = _a.currentEvent, currentEventType = _a.currentEventType, lang = _a.lang;
        var switchChat = this.props.switchChat;
        // (currentEventType === 'visual_claim') ? (css(animStyles.bounce)) : (css(animStyles.fadeInLarge))
        return (createElement("div", { className: this.state.colorClass },
            createElement("div", { className: styles$4.chatCirclePosition },
                createElement("div", { className: (currentEventType === 'visual_claim') ? (css$1(animStyles.bounce)) : '' },
                    createElement("div", { className: styles$4.chatCircle, onClick: switchChat, onMouseEnter: function () { return _this.setState({ isShown: true }); }, onMouseLeave: function () { return _this.setState({ isShown: false }); } },
                        (this.state.isShown && popoverActive) ? (createElement("div", { className: css$1(animStyles.fadeIn) },
                            createElement("div", { className: styles$4.tooltip }, popoverText))) : (createElement(Fragment, null)),
                        (currentEventType === 'popup_claim' || currentEventType === 'popup_claim_off') ? (createElement("div", { className: (currentEventType === 'popup_claim') ? css$1(animStyles.fadeIn) : (css$1(animStyles.fadeOut)) },
                            createElement("div", { className: styles$4.tooltip }, currentEvent.message[lang]))) : (createElement(Fragment, null)),
                        createElement(FontAwesomeIcon, { icon: faCommentDots, size: "1x" }),
                        createElement("div", { id: "chat-overlay" }))))));
    };
    CircleBtn.prototype.render = function () {
        var _a = this.props, switchChat = _a.switchChat, openedChat = _a.openedChat;
        if (openedChat) {
            return (createElement("div", { className: this.state.colorClass },
                createElement("div", { className: css$1(animStyles.fadeInLarge) },
                    createElement("div", { className: styles$4.chatCircleSmall, onClick: switchChat },
                        createElement(FontAwesomeIcon, { icon: faTimesCircle, size: "1x" }),
                        createElement("div", { id: "chat-overlay" })))));
        }
        else {
            return (createElement("div", null, this.shouldRenderCircleAnimation()));
        }
    };
    return CircleBtn;
}(Component));

var Base64 = (function () {
    function Base64() {
    }
    Base64.prototype.encode = function (s) {
        return (typeof $ !== 'undefined' && $.base64) ? $.base64.encode(s) : this.stringToBase64(JSON.stringify(s));
    };
    Base64.prototype.decode = function (s) {
        return (typeof $ !== 'undefined' && $.base64) ? $.base64.decode(s) : this.base64ToString(s);
    };
    Base64.prototype.stringToBase64 = function (str) {
        return window.btoa(unescape(encodeURIComponent(str)));
    };
    Base64.prototype.base64ToString = function (str) {
        return decodeURIComponent(escape(window.atob(str)));
    };
    return Base64;
}());

var CookiesManager = (function () {
    function CookiesManager() {
    }
    CookiesManager.getActions = function () {
        var cookiesList = document.cookie.split(';');
        var result = [];
        for (var index = 0; index < cookiesList.length; index++) {
            var cookie = cookiesList[index];
            if (cookie !== '' && cookie.indexOf('$RT_') !== -1) {
                var actionCodeStr = cookie.substring(cookie.indexOf('$RT_') + 5, cookie.length);
                try {
                    var actionCode = JSON.parse(unescape(actionCodeStr));
                    result.push(actionCode);
                }
                catch (error) {
                    
                }
            }
        }
        return result;
    };
    CookiesManager.getWinCtrlCookie = function () {
        var cookieList = document.cookie.split(';');
        var winCtrlCookie = false;
        for (var _i = 0, cookieList_1 = cookieList; _i < cookieList_1.length; _i++) {
            var cookie = cookieList_1[_i];
            if (cookie.indexOf('__WIN_CTRL') !== -1) {
                winCtrlCookie = cookie.substring(cookie.indexOf('__WIN_CTRL') + 11, cookie.length);
            }
        }
        if (winCtrlCookie) {
            return JSON.parse(unescape(winCtrlCookie));
        }
        else {
            return {
                winStack: []
            };
        }
    };
    CookiesManager.setWinControlCookie = function (winStack) {
        var date = new Date();
        var threeMonths = 7890000 * 1000;
        date.setTime(date.getTime() + threeMonths);
        var winStackToCookie = JSON.stringify(winStack);
        var cookieCreated = "__WIN_CTRL=" + escape(winStackToCookie) + ";path=/;domain=" + window.location.hostname + ";secure:'';expires=" + date.toUTCString();
        window.document.cookie = cookieCreated;
    };
    CookiesManager.delWinControlCookie = function () {
        window.document.cookie = "__WIN_CTRL=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;domain=" + window.location.hostname;
    };
    CookiesManager.getRuntimeCookie = function () {
        var cookieList = document.cookie.split(';');
        var runtimeCookie = false;
        for (var _i = 0, cookieList_2 = cookieList; _i < cookieList_2.length; _i++) {
            var cookie = cookieList_2[_i];
            if (cookie.indexOf('__runtime_rt') !== -1) {
                runtimeCookie = cookie.substring(cookie.indexOf('__runtime_rt') + 13, cookie.length);
            }
        }
        if (runtimeCookie) {
            return JSON.parse(unescape(runtimeCookie));
        }
    };
    CookiesManager.setRuntimeCookie = function (restartOnClose) {
        var date = new Date();
        date.setTime(date.getTime() + 5 * 1000);
        var value = JSON.stringify({
            restart_on_close: restartOnClose,
            voice_actived: true
        });
        var runtimeCookie = "__runtime_rt=" + escape(value) + ";path=/;domain=" + window.location.hostname + ";secure:'';expires=" + date.toUTCString();
        window.document.cookie = runtimeCookie;
    };
    CookiesManager.delRuntimeCookie = function () {
        var d = new Date();
        d.setTime(d.getTime() - 1000 * 60 * 60 * 24);
        var expires = 'expires=' + d.toUTCString();
        window.document.cookie = "__runtime_rt=;" + expires;
    };
    CookiesManager.getConfigCookie = function () {
        var cookieList = document.cookie.split(';');
        var configCookie = false;
        for (var _i = 0, cookieList_3 = cookieList; _i < cookieList_3.length; _i++) {
            var cookie = cookieList_3[_i];
            if (cookie.indexOf('__config_rt') !== -1) {
                configCookie = cookie.substring(cookie.indexOf('__config_rt') + 12, cookie.length);
            }
        }
        if (configCookie) {
            var unescapedConfig = unescape(configCookie);
            var parsedConfig = void 0;
            try {
                parsedConfig = JSON.parse(unescapedConfig);
                return parsedConfig;
            }
            catch (error) {
                
            }
        }
    };
    CookiesManager.setConfigCookie = function (config) {
        var date = new Date();
        date.setTime(date.getTime() + 7890000 * 1000);
        var cookieCreated = "__config_rt=" + escape(JSON.stringify(config)) + ";path=/;domain=" + window.location.hostname + ";secure:'';expires=" + date.toUTCString();
        window.document.cookie = cookieCreated;
    };
    CookiesManager.delConfigCookie = function () {
        var d = new Date();
        d.setTime(d.getTime() - 1000 * 60 * 60 * 24);
        var expires = 'expires=' + d.toUTCString();
        window.document.cookie = "__config_rt=;" + expires;
    };
    CookiesManager.set = function (cookie) {
        var cookieName = this.getNameEncoded(cookie.value);
        var cookieCreated = cookieName +
            '=' +
            escape(JSON.stringify(cookie.value)) +
            (cookie.expires ? '; expires=' + cookie.expires : '') +
            (cookie.path ? '; path=' + cookie.path : '') +
            (cookie.domain ? '; domain=' + cookie.domain : '') +
            (cookie.secure ? '; secure' : '');
        window.document.cookie = cookieCreated;
    };
    CookiesManager.del = function (input) {
        var d = new Date();
        d.setTime(d.getTime() - 1000 * 60 * 60 * 24);
        var expires = 'expires=' + d.toUTCString();
        window.document.cookie = this.getNameEncoded(input) + '=' + '; ' + expires;
    };
    CookiesManager.createActionCookie = function (input) {
        var date = new Date();
        date.setTime(date.getTime() + 10 * 1000);
        var cookie = {
            expires: date.toUTCString(),
            value: input
        };
        if (typeof window !== 'undefined') {
            this.set(cookie);
        }
    };
    CookiesManager.getNameEncoded = function (event) {
        var base64Name = this.base64.encode(event);
        var cookieName = base64Name.substring(0, 150) + '$RT_';
        cookieName = cookieName.replace('=', '');
        return cookieName;
    };
    CookiesManager.base64 = new Base64();
    return CookiesManager;
}());

function createRtSdkError(errorScope, errorMessage) {
    var error = new Error(errorMessage);
    error.name = "RtSdk." + errorScope + " Error";
    return error;
}

var GenericEventDispatcher = (function () {
    function GenericEventDispatcher(options) {
        this.actionMappers = options.actionMappers;
        this.handlerAdapters = options.handlerAdapters;
        this.errorMapper = options.errorMapper;
        this.actionExecution = false;
    }
    GenericEventDispatcher.prototype.dispatchAction = function (input, cb) {
        var _this = this;
        this.actionExecution = false;
        for (var i = 0; i <= this.actionMappers.length - 1; i++) {
            var actionMapper = this.actionMappers[i];
            actionMapper.getActionHandlerChain(input, function (error, handlerChain) {
                if (error) {
                    throw new Error(error);
                }
                if (handlerChain) {
                    var handler = handlerChain.getActionHandler();
                    var adapter = void 0;
                    for (var _i = 0, _a = _this.handlerAdapters; _i < _a.length; _i++) {
                        var handlerAdapter = _a[_i];
                        if (handlerAdapter.supports(handler)) {
                            adapter = handlerAdapter;
                            break;
                        }
                    }
                    if (!adapter) {
                        throw createRtSdkError('GenericEventDispatcher', "Unable to find a suitable handler adapter.");
                    }
                    adapter.execute(input, handler, cb);
                    _this.actionExecution = true;
                }
            });
        }
        if (!this.actionExecution && input.type === 'application') {
            this.saveEventToStorage(input);
        }
        else {
            this.removeEventFromStorage(input);
        }
    };
    GenericEventDispatcher.prototype.dispatchError = function (input, error) {
        if (this.errorMapper) {
            this.errorMapper.getErrorHandler(input, error, function (e, handler) {
                if (handler) {
                    return handler.handle(input, error);
                }
            });
        }
        throw error;
    };
    GenericEventDispatcher.prototype.saveEventToStorage = function (input) {
        if (input) {
            CookiesManager.createActionCookie(input);
        }
    };
    GenericEventDispatcher.prototype.removeEventFromStorage = function (input) {
        if (typeof window !== 'undefined') {
            CookiesManager.del(input);
        }
    };
    return GenericEventDispatcher;
}());

var GenericActionHandlerChain = (function () {
    function GenericActionHandlerChain(options) {
        this.actionHandler = options.actionHandler;
    }
    GenericActionHandlerChain.prototype.getActionHandler = function () {
        return this.actionHandler;
    };
    return GenericActionHandlerChain;
}());

var GenericHandlerAdapter = (function () {
    function GenericHandlerAdapter() {
    }
    GenericHandlerAdapter.prototype.supports = function (handler) {
        return ((typeof handler.canHandle === 'function' && typeof handler.handle === 'function') ||
            (typeof handler.handle === 'object' && typeof handler.canHandle === 'function'));
    };
    GenericHandlerAdapter.prototype.execute = function (input, handler, cb) {
        var currentStep = input._step || 0;
        input.next = this.nextAction.bind(this, cb, currentStep, input, handler);
        input.redirect = this.redirect.bind(this, currentStep, input);
        input.context = {};
        if (Array.isArray(handler.handle)) {
            input._num_steps = handler.handle.length - 1;
            delete input._step;
            delete input._num_steps;
            handler.handle[currentStep].call(this, input);
        }
        else {
            return handler.handle(input);
        }
    };
    GenericHandlerAdapter.prototype.redirect = function (currentStep, input, path, passingData) {
        var isPath = path.match(/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/);
        if (isPath && path !== window.location.href) {
            if (input._step) {
                input.context = passingData;
                input._step = currentStep + 1;
                if (input._step !== input._num_steps) {
                    CookiesManager.createActionCookie(input);
                }
            }
            window.location.href = path;
        }
        throw new Error('rt-sdk-js: not valid url or path to redirect');
    };
    GenericHandlerAdapter.prototype.objectValues = function (obj) {
        var res = [];
        for (var i in obj) {
            if (obj.hasOwnProperty(i)) {
                res.push(obj[i]);
            }
        }
        return res;
    };
    GenericHandlerAdapter.prototype.nextAction = function (originalCb, currentStep, input, handler, actionError, passingData) {
        input.context = passingData;
        input._step = currentStep + 1;
        var steps = this.objectValues(handler.handle);
        if (steps[input._step]) {
            this.execute(input, handler, originalCb);
        }
        else {
            return originalCb(actionError, input.context);
        }
    };
    return GenericHandlerAdapter;
}());

var GenericActionMapper = (function () {
    function GenericActionMapper(options) {
        this.actionHandlerChains = options.actionHandlerChains;
    }
    GenericActionMapper.prototype.getActionHandlerChain = function (input, cb) {
        for (var _i = 0, _a = this.actionHandlerChains; _i < _a.length; _i++) {
            var actionHandlerChain = _a[_i];
            var requestHandler = actionHandlerChain.getActionHandler();
            this.callback = cb;
            input.redirect = this.redirect.bind(this, input);
            input.isCurrentUrlIn = this.isCurrentUrlIn;
            input.allow = this.allowHandle.bind(this, actionHandlerChain);
            input.deny = this.denyHandle.bind(this);
            requestHandler.canHandle(input);
        }
    };
    GenericActionMapper.prototype.allowHandle = function (actionHandlerChain) {
        return this.callback(null, actionHandlerChain);
    };
    GenericActionMapper.prototype.denyHandle = function () {
    };
    GenericActionMapper.prototype.redirect = function (input, url) {
        if (window.location.href !== url) {
            CookiesManager.createActionCookie(input);
            window.location.href = url;
        }
    };
    GenericActionMapper.prototype.isCurrentUrlIn = function (domains) {
        if (domains[0] === '*') {
            return true;
        }
        var isDomainMatch = false;
        for (var _i = 0, domains_1 = domains; _i < domains_1.length; _i++) {
            var domain = domains_1[_i];
            var urlToCompare = domain.split('*')[0];
            isDomainMatch = isDomainMatch || window.location.href.indexOf(urlToCompare) !== -1;
        }
        return isDomainMatch;
    };
    return GenericActionMapper;
}());

var GenericErrorMapper = (function () {
    function GenericErrorMapper(options) {
        this.errorHandlers = options.errorHandlers;
    }
    GenericErrorMapper.prototype.getErrorHandler = function (handlerInput, error, cb) {
        return null;
    };
    return GenericErrorMapper;
}());

var RuntimeConfigurationBuilder = (function () {
    function RuntimeConfigurationBuilder() {
        this.actionHandlerChains = [];
        this.errorHandlers = [];
    }
    RuntimeConfigurationBuilder.prototype.addActionHandlers = function () {
        var actionHandlers = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            actionHandlers[_i] = arguments[_i];
        }
        for (var _a = 0, actionHandlers_1 = actionHandlers; _a < actionHandlers_1.length; _a++) {
            var actionHandler = actionHandlers_1[_a];
            this.actionHandlerChains.push(new GenericActionHandlerChain({
                actionHandler: actionHandler
            }));
        }
        return this;
    };
    RuntimeConfigurationBuilder.prototype.addErrorHandlers = function () {
        var _a;
        var errorHandlers = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            errorHandlers[_i] = arguments[_i];
        }
        (_a = this.errorHandlers).push.apply(_a, errorHandlers);
        return this;
    };
    RuntimeConfigurationBuilder.prototype.getRuntimeConfiguration = function () {
        var actionMapper = new GenericActionMapper({
            actionHandlerChains: this.actionHandlerChains
        });
        var errorMapper = this.errorHandlers.length
            ? new GenericErrorMapper({
                errorHandlers: this.errorHandlers
            })
            : undefined;
        return {
            actionMappers: [actionMapper],
            errorMapper: errorMapper,
            handlerAdapters: [new GenericHandlerAdapter()]
        };
    };
    return RuntimeConfigurationBuilder;
}());

function extractVersion(uastring, expr, pos) {
    var match = uastring.match(expr);
    return match && match.length >= pos && parseInt(match[pos], 10);
}
function detectBrowser(window) {
    var navigator = window.navigator;
    var result = { browser: null, version: null };
    if (typeof window === 'undefined' || !window.navigator) {
        result.browser = 'Not a browser.';
        return result;
    }
    if (navigator.mozGetUserMedia) {
        result.browser = 'firefox';
        result.version = extractVersion(navigator.userAgent, /Firefox\/(\d+)\./, 1);
    }
    else if (navigator.webkitGetUserMedia) {
        result.browser = 'chrome';
        result.version = extractVersion(navigator.userAgent, /Chrom(e|ium)\/(\d+)\./, 2);
    }
    else if (navigator.mediaDevices &&
        navigator.userAgent.match(/Edge\/(\d+).(\d+)$/)) {
        result.browser = 'edge';
        result.version = extractVersion(navigator.userAgent, /Edge\/(\d+).(\d+)$/, 2);
    }
    else if (window.RTCPeerConnection &&
        navigator.userAgent.match(/AppleWebKit\/(\d+)\./)) {
        result.browser = 'safari';
        result.version = extractVersion(navigator.userAgent, /AppleWebKit\/(\d+)\./, 1);
    }
    else {
        result.browser = 'Not a supported browser.';
        return result;
    }
    return result;
}

function shimGetUserMedia(window) {
    var _this = this;
    var browserDetails = detectBrowser(window);
    var navigator = window && window.navigator;
    var MediaStreamTrack = window && window.MediaStreamTrack;
    navigator.getUserMedia = function (constraints, onSuccess, onError) {
        navigator.mediaDevices.getUserMedia(constraints).then(onSuccess, onError);
    };
    if (!(browserDetails.version > 55 && 'autoGainControl' in navigator.mediaDevices.getSupportedConstraints())) {
        var remap_1 = function (obj, a, b) {
            if (a in obj && !(b in obj)) {
                obj[b] = obj[a];
                delete obj[a];
            }
        };
        var nativeGetUserMedia_1 = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);
        navigator.mediaDevices.getUserMedia = function (c) {
            if (typeof c === 'object' && typeof c.audio === 'object') {
                c = JSON.parse(JSON.stringify(c));
                remap_1(c.audio, 'autoGainControl', 'mozAutoGainControl');
                remap_1(c.audio, 'noiseSuppression', 'mozNoiseSuppression');
            }
            return nativeGetUserMedia_1(c);
        };
        if (MediaStreamTrack && MediaStreamTrack.prototype.getSettings) {
            var nativeGetSettings_1 = MediaStreamTrack.prototype.getSettings;
            MediaStreamTrack.prototype.getSettings = function () {
                var obj = nativeGetSettings_1.apply(this, arguments);
                remap_1(obj, 'mozAutoGainControl', 'autoGainControl');
                remap_1(obj, 'mozNoiseSuppression', 'noiseSuppression');
                return obj;
            };
        }
        if (MediaStreamTrack && MediaStreamTrack.prototype.applyConstraints) {
            var nativeApplyConstraints_1 = MediaStreamTrack.prototype.applyConstraints;
            MediaStreamTrack.prototype.applyConstraints = function (c) {
                if (_this.kind === 'audio' && typeof c === 'object') {
                    c = JSON.parse(JSON.stringify(c));
                    remap_1(c, 'autoGainControl', 'mozAutoGainControl');
                    remap_1(c, 'noiseSuppression', 'mozNoiseSuppression');
                }
                return nativeApplyConstraints_1.apply(_this, [c]);
            };
        }
    }
}

var Events = (function () {
    function Events(seatId, channel, apiKey, entryPoint, url, device) {
        this.seatId = seatId;
        this.channel = channel;
        this.apiKey = apiKey;
        this.entryPoint = entryPoint;
        this.url = url;
        this.device = device;
    }
    Events.prototype.startIntent = function (intent) {
        var startIntent = {
            content: {
                actions: {
                    main: {
                        entities: [],
                        intent: intent
                    }
                },
                targetUser: {
                    channel: this.channel,
                    sourceValue: this.seatId
                },
                type: 'run'
            },
            type: 'application'
        };
        return startIntent;
    };
    Events.prototype.restartUserContext = function () {
        var restartUsrContxt = {
            content: {
                actions: {
                    main: {
                        action: 'RestartUserContext',
                        entities: [],
                        intent: ''
                    }
                },
                targetUser: {
                    channel: 'desktop',
                    sourceValue: this.seatId
                },
                type: 'dialogControl'
            },
            type: 'application'
        };
        return restartUsrContxt;
    };
    Events.prototype.desktopTalk = function (text) {
        var desktopTalkMsg = {
            content: {
                actions: {
                    main: {
                        domainName: 'rt/system-actions',
                        entities: [
                            {
                                entity: 'text',
                                value: text
                            },
                        ],
                        intent: 'system_desktop_talk'
                    }
                },
                targetUser: {
                    botName: '',
                    channel: 'desktop',
                    sourceValue: this.seatId
                },
                type: 'run'
            },
            type: 'application'
        };
        return desktopTalkMsg;
    };
    Events.prototype.sendUtterance = function (text, lang) {
        var sendUtteranceMsg = {
            content: {
                language: this.standarizationLang(lang),
                text: text
            },
            source: {
                apiKey: this.apiKey
            },
            type: 'user'
        };
        return sendUtteranceMsg;
    };
    Events.prototype.noUnderstood = function (lang) {
        var noUnderstoodMsg = {
            content: {
                language: this.standarizationLang(lang),
                text: 'not_understood'
            },
            source: {
                apiKey: this.apiKey
            },
            type: 'user'
        };
        return noUnderstoodMsg;
    };
    Events.prototype.initializeWs = function () {
        var msg = {
            apiKey: this.apiKey,
            channel: this.channel,
            entryPoint: this.entryPoint || '',
            events: 'all',
            seatId: this.seatId,
            url: this.url,
            device: this.device
        };
        return msg;
    };
    Events.prototype.initializeTranscriptWs = function (lang, sampleRate) {
        var msg = {
            apiKey: this.apiKey,
            language: this.standarizationLang(lang),
            sampleRate: sampleRate,
            seatId: this.seatId
        };
        return msg;
    };
    Events.prototype.speechRecognition = function (text, event) {
        var msg = {
            content: {
                event: event,
                text: text
            },
            type: 'SpeechRecognition'
        };
        return msg;
    };
    Events.prototype.notSupportedCriticalFeature = function (error, event) {
        var msg = {
            content: {
                event: event,
                error: error
            },
            type: 'notSupportedCriticalFeature'
        };
        return msg;
    };
    Events.prototype.streamingTranscription = function (text, event) {
        var msg = {
            content: {
                event: event,
                text: text
            },
            type: 'StreamingTranscription'
        };
        return msg;
    };
    Events.prototype.connectedToTalkServer = function () {
        var msg = {
            content: {
                event: 'connected',
                text: 'ok'
            },
            type: 'Websockets'
        };
        return msg;
    };
    Events.prototype.keyboard = function () {
        var msg = {
            content: {
                event: {},
                text: {}
            },
            type: 'TargetKeyDown'
        };
        return msg;
    };
    Events.prototype.error = function (error) {
        var msg = {
            content: {
                event: {},
                text: {},
                error: error
            },
            type: 'Error'
        };
        return msg;
    };
    Events.prototype.remoteConfig = function (remoteData) {
        var msg = {
            content: {
                event: remoteData,
                text: {}
            },
            type: 'RemoteConfig'
        };
        return msg;
    };
    Events.prototype.standarizationLang = function (lang) {
        return lang.split('-')[0];
    };
    return Events;
}());

var AudioStreaming = (function () {
    function AudioStreaming(dispatch, options) {
        if (options === void 0) { options = { bufferSize: 0, audio: true }; }
        this.checkSupport();
        shimGetUserMedia(window);
        this.isNotSending = true;
        this._AudioContext = window.AudioContext || window.webkitAudioContext;
        this.emptyChunk = new Int16Array(512);
        this.dispatch = dispatch;
        this.libEvents = new Events('.', '.', '', '.', '', '');
        this.bufferSize = options.bufferSize;
        this.audioSettings = options.audio;
        this.status = 'not_running';
        
        
        
    }
    AudioStreaming.prototype.start = function (connectionManager, callback) {
        var _this = this;
        if (this.status === 'not_running') {
            this.status = 'running';
            this.connectionManager = connectionManager;
            this.connectionManager.openTscWebSocket(function () {
                _this.isNotSending = false;
                navigator.mediaDevices
                    .getUserMedia({ audio: _this.audioSettings })
                    .then(function (stream) {
                    _this.handleSuccess(stream);
                    if (callback && typeof callback === 'function')
                        callback(true);
                })["catch"](function (error) {
                    _this.handleError(error);
                    if (callback && typeof callback === 'function')
                        callback(true);
                });
            });
        }
        else if (this.status === 'iddle') {
            this.status = 'running';
            this.connectionManager.openTscWebSocket(function () {
                _this.audioTrack[0].enabled = true;
                _this.isNotSending = false;
            });
        }
    };
    AudioStreaming.prototype.closeStreaming = function () {
        this.audioTrack[0].enabled = false;
        this.status = 'iddle';
        this.isNotSending = true;
    };
    AudioStreaming.prototype.checkSupport = function () {
        var getUserMedia = navigator.getUserMedia ||
            navigator.webkitGetUserMedia ||
            navigator.mozGetUserMedia ||
            navigator.mediaDevices.getUserMedia;
        if (!getUserMedia) {
            throw new Error("getUserMedia is not implemented or you are in an insecure environment, make sure you are on https SSL");
        }
        else
            this.isSupported = true;
    };
    AudioStreaming.prototype.handleSuccess = function (stream) {
        this.stream = stream;
        this.audioTrack = this.stream.getAudioTracks();
        
        this.initializeRecorder(this.stream);
    };
    AudioStreaming.prototype.handleError = function (error) {
        
        this.isNotSending = true;
    };
    AudioStreaming.prototype.initializeRecorder = function (stream) {
        this.context = new this._AudioContext();
        var audioInput = this.context.createMediaStreamSource(stream);
        this.recorder = this.context.createScriptProcessor(this.bufferSize, 1, 1);
        this.recorder.onaudioprocess = this.micAudioHandler.bind(this);
        audioInput.connect(this.recorder).connect(this.context.destination);
    };
    AudioStreaming.prototype.micAudioHandler = function (e) {
        if (this.status === 'running') {
            if (this.connectionManager.transport.tscWS.client.readyState === 1) {
                var unprocessedData = e.inputBuffer.getChannelData(0);
                var processedData = this.convertFloat32ToInt16(unprocessedData);
                var i = void 0;
                var j = void 0;
                var chunk = 512;
                for (i = 0, j = processedData.length; i < j; i += chunk) {
                    var chunkedData = Object.assign(this.emptyChunk, processedData.slice(i, i + chunk));
                    this.connectionManager.transport.tscWS.send(chunkedData.buffer);
                }
            }
        }
    };
    AudioStreaming.prototype.convertFloat32ToInt16 = function (buffer) {
        var l = buffer.length;
        var buf = new Int16Array(l);
        while (l--) {
            buf[l] = Math.min(1, buffer[l]) * 0x7fff;
        }
        return buf;
    };
    return AudioStreaming;
}());

var runtimeConfig = {
    api: {
        pro: {
            jsonpSend: 'https://channel-pro.woice.live/channel/desktop/jpae',
            longPollingJP: 'https://channel-pro.woice.live/channel/desktop/jplp',
            tscWs: 'wss://channel-pro.rational-touch.com/channel/voice/transcript',
            wsUrl: 'wss://channel-pro.rational-touch.com/channel/desktop/desktop'
        },
        proShopify: {
            jsonpSend: 'https://channel-pro.woice.live/channel/desktop/jpae',
            longPollingJP: 'https://channel-pro.woice.live/channel/desktop/jplp',
            tscWs: 'wss://channel-pro.rational-touch.com/channel/voice/transcript',
            wsUrl: 'wss://channel-pro.rational-touch.com/channel/desktop/woice/v010/desktop'
        },
        qa: {
            jsonpSend: 'https://channel-qa.woice.live/channel/desktop/jpae',
            longPollingJP: 'https://channel-qa.woice.live/channel/desktop/jplp',
            tscWs: 'wss://channel-qa.rational-touch.com/channel/voice/transcript',
            wsUrl: 'wss://channel-qa.rational-touch.com/channel/desktop/desktop'
        },
        qaShopify: {
            jsonpSend: 'https://channel-qa.woice.live/channel/desktop/jpae',
            longPollingJP: 'https://channel-qa.woice.live/channel/desktop/jplp',
            tscWs: 'wss://channel-qa.rational-touch.com/channel/voice/transcript',
            wsUrl: 'wss://channel-qa.rational-touch.com/channel/desktop/woice/v010/desktop'
        },
        dev: {
            jsonpSend: 'https://channel-dev.woice.live/channel/desktop/jpae',
            longPollingJP: 'https://channel-dev.woice.live/channel/desktop/jplp',
            tscWs: 'wss://channel-dev.rational-touch.com/channel/voice/transcript',
            wsUrl: 'wss://channel-dev.rational-touch.com/channel/desktop/desktop'
        },
        cmadridCita: {
            jsonpSend: 'https://botcita.comunidad.madrid/channel/desktop/jpae',
            longPollingJP: 'https://botcita.comunidad.madrid/channel/desktop/jplp',
            tscWs: 'wss://botcita.comunidad.madrid/channel/voice/transcript',
            wsUrl: 'wss://botcita.comunidad.madrid/channel/desktop/desktop'
        }
    },
    connection: {
        maxRetries: 3,
        timeAfterMaxRetries: 3000000,
        timeBtwRetries: 10000
    }
};

function makeid() {
    var text = '';
    var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (var i = 0; i < 12; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
}

var WebSocketHandler = (function () {
    function WebSocketHandler(_a) {
        var seatId = _a.seatId, apikey = _a.apikey, wsUrl = _a.wsUrl, channel = _a.channel, entryPoint = _a.entryPoint, url = _a.url, device = _a.device;
        this.client = new WebSocket(wsUrl);
        this.serverMsgs = new Events(seatId, channel, apikey, entryPoint, url, device);
    }
    WebSocketHandler.prototype.createTransport = function () {
        return { send: this.send.bind(this) };
    };
    WebSocketHandler.prototype.send = function (event) {
        this.client.send(event);
    };
    WebSocketHandler.prototype.close = function () {
        if (this.client.readyState === 1 && this.client.close) {
            this.client.close();
            clearInterval(this.timerKeepAlive);
        }
    };
    WebSocketHandler.prototype.onopen = function (callback) {
        this.client.onopen = callback;
    };
    WebSocketHandler.prototype.onmessage = function (callback) {
        this.client.onmessage = callback;
    };
    WebSocketHandler.prototype.onclose = function (callback) {
        this.client.onclose = callback;
    };
    WebSocketHandler.prototype.onerror = function (callback) {
        this.client.onerror = callback;
    };
    WebSocketHandler.prototype.sendInitial = function () {
        var msg = this.serverMsgs.initializeWs();
        this.client.send(JSON.stringify(msg));
        this.keepAlive();
    };
    WebSocketHandler.prototype.sendInitialTsc = function (language, sampleRate) {
        var msg = this.serverMsgs.initializeTranscriptWs(language, sampleRate);
        this.client.send(JSON.stringify(msg));
    };
    WebSocketHandler.prototype.keepAlive = function () {
        var _this = this;
        var keepAliveMsg = JSON.stringify({
            type: 'keepAlive'
        });
        this.timerKeepAlive = setInterval(function () {
            _this.client.send(keepAliveMsg);
        }, 45000);
    };
    return WebSocketHandler;
}());

var ConnectionManager = (function () {
    function ConnectionManager(dispatch, language, environment, href, device) {
        this.events = 'application';
        this.dispatch = dispatch;
        this.seatId = null;
        this.channel = false;
        this.TIMEOUT = 59;
        this.currentLocation = href;
        this.currentDevice = device;
        this.syncConfig = CookiesManager.getConfigCookie() || {};
        this.supportsWebSockets = 'WebSocket' in window || 'MozWebSocket' in window;
        this.STAGE = environment;
        this.urlLP = runtimeConfig.api[this.STAGE].longPollingJP;
        this.urlSE = runtimeConfig.api[this.STAGE].jsonpSend;
        this.wsUrl = runtimeConfig.api[this.STAGE].wsUrl;
        this.tscWs = runtimeConfig.api[this.STAGE].tscWs;
        this.wsHandler = null;
        this.retriesCounter = 0;
        this.timeBtwRetries = runtimeConfig.connection.timeBtwRetries;
        this.timeAfterMaxRetries = runtimeConfig.connection.timeAfterMaxRetries;
        this.maxRetries = runtimeConfig.connection.maxRetries;
        this.reconnecting = false;
        this.language = language;
        this.autoReconnect = true;
    }
    ConnectionManager.prototype.connect = function (apikey, channel, entryPoint, seatId, callback) {
        if (apikey === void 0) { apikey = this.apiKey; }
        this.apiKey = apikey;
        this.seatId = seatId;
        this.channel = channel;
        this.entryPoint = entryPoint;
        if (callback) {
            this.connectionCallback = callback;
        }
        if (this.supportsWebSockets) {
            this.createConnection();
        }
        else {
            this.dispatch(this.serverMessages.error(new Error('No websockets support')));
        }
    };
    ConnectionManager.prototype.disconnect = function () {
        this.autoReconnect = false;
        clearInterval(this.reconnectTimer);
        return this.wsHandler.close();
    };
    ConnectionManager.prototype.receivedEventFromLongPolling = function (event) {
        if (event.messages && typeof event.messages === 'object') {
            for (var _i = 0, _a = event.messages; _i < _a.length; _i++) {
                var singleEvent = _a[_i];
                var input = singleEvent;
                input.seatId = this.seatId;
                this.dispatch(input, null);
            }
        }
        this.transport.lp(this.urlLP, {
            onSuccess: this.receivedEventFromLongPolling.bind(this),
            onTimeout: this.onTimeOutLongPolling.bind(this),
            timeout: this.TIMEOUT
        });
    };
    ConnectionManager.prototype.onTimeOutLongPolling = function () {
        this.transport.lp(this.urlLP, {
            onSuccess: this.receivedEventFromLongPolling.bind(this),
            onTimeout: this.onTimeOutLongPolling.bind(this),
            timeout: this.TIMEOUT
        });
    };
    ConnectionManager.prototype.returnFromSE = function () {
        return void 0;
    };
    ConnectionManager.prototype.sendStartIntent = function (event) {
        var _event = this.serverMessages.startIntent(event);
        if (this.supportsWebSockets) {
            this.transport.send(JSON.stringify(_event));
        }
        else {
            try {
                this.transport.send(this.urlSE, _event, this.callbackFromSendEventToServer);
            }
            catch (e) {
                
            }
        }
    };
    ConnectionManager.prototype.sendRestartUserContext = function () {
        var _event = this.serverMessages.restartUserContext();
        if (this.supportsWebSockets) {
            this.transport.send(JSON.stringify(_event));
        }
        else {
            try {
                this.transport.send(this.urlSE, _event, this.callbackFromSendEventToServer);
            }
            catch (e) {
                
            }
        }
    };
    ConnectionManager.prototype.sendDesktopTalk = function (text) {
        var _event = this.serverMessages.desktopTalk(text);
        if (this.supportsWebSockets) {
            this.transport.send(JSON.stringify(_event));
        }
        else {
            try {
                this.transport.send(this.urlSE, _event, this.callbackFromSendEventToServer);
            }
            catch (e) {
                
            }
        }
    };
    ConnectionManager.prototype.sendUtterance = function (text, language) {
        var _event = this.serverMessages.sendUtterance(text, language);
        this.transport.send(JSON.stringify(_event));
    };
    ConnectionManager.prototype.noUnderstood = function () {
        var _event = this.serverMessages.noUnderstood(this.language);
        this.transport.send(JSON.stringify(_event));
    };
    ConnectionManager.prototype.openTscWebSocket = function (callback) {
        var _this = this;
        this.transport.tscWS = new WebSocketHandler({
            seatId: this.seatId,
            apikey: this.apiKey,
            wsUrl: this.tscWs,
            channel: this.channel,
            entryPoint: this.entryPoint,
            url: this.currentLocation,
            device: this.currentDevice
        });
        this.transport.tscWS.onopen(function () {
            _this.transport.tscWS.sendInitialTsc(_this.language, 44000);
            return callback(true);
        });
        this.transport.tscWS.onmessage(function (ws) {
            var msg;
            var text;
            try {
                msg = JSON.parse(ws.data);
                text = msg.userEntry.text;
                _this.sendUtterance(text, _this.language);
                _this.dispatch(_this.serverMessages.streamingTranscription('', 'onEnd'));
            }
            catch (error) {
                
            }
            _this.transport.tscWS = undefined;
        });
        this.transport.tscWS.onerror(function (error) {
            _this.dispatch(_this.serverMessages.streamingTranscription(error, 'onError'));
        });
        this.transport.tscWS.onclose(function (event) {
            _this.dispatch(_this.serverMessages.streamingTranscription(event, 'onClose'));
        });
    };
    ConnectionManager.prototype.callbackFromSendEventToServer = function () {
        return void 0;
    };
    ConnectionManager.prototype.syncWithDesktop = function () {
        try {
            this.transport.send('http://127.0.0.1:3333/config', null, this.syncDataReceived.bind(this));
        }
        catch (error) {
            
        }
    };
    ConnectionManager.prototype.syncDataReceived = function (data) {
        this.syncConfig = data;
        CookiesManager.setConfigCookie(data);
        this.whenDOMisReady();
    };
    ConnectionManager.prototype.whenDOMisReady = function () {
        if (this.syncConfig) {
            this.seatId = this.seatId || this.syncConfig.seatId;
            this.urlLP = this.urlLP + "?seatId=" + this.seatId + "&events=" + this.events;
            this.serverMessages = new Events(this.seatId, this.channel, this.apiKey, this.entryPoint, this.currentLocation, this.currentDevice);
            this.transport.lp(this.urlLP, {
                onSuccess: this.receivedEventFromLongPolling.bind(this),
                onTimeout: this.onTimeOutLongPolling.bind(this),
                timeout: this.TIMEOUT
            });
        }
        else {
            this.syncWithDesktop();
        }
    };
    ConnectionManager.prototype.createConnection = function () {
        if (!this.seatId)
            this.seatId = this.syncConfig.seatId ? this.syncConfig.seatId : makeid();
        if (!this.channel)
            this.channel = 'desktop';
        this.wsHandler = new WebSocketHandler({
            seatId: this.seatId,
            apikey: this.apiKey,
            wsUrl: this.wsUrl,
            channel: this.channel,
            entryPoint: this.entryPoint,
            url: this.currentLocation,
            device: this.currentDevice
        });
        var newTransport = this.wsHandler;
        this.connectWithWebSockets();
        if (!this.reconnectorAcive) {
            this.reconnector();
        }
        this.serverMessages = new Events(this.seatId, this.channel, this.apiKey, this.entryPoint, this.currentLocation, this.currentDevice);
        if (!this.syncConfig.seatId) {
            CookiesManager.setConfigCookie({ seatId: this.seatId });
        }
        this.transport = newTransport.createTransport();
    };
    ConnectionManager.prototype.connectWithWebSockets = function () {
        this.wsHandler.onmessage(this.msgFromWS.bind(this));
        this.wsHandler.onerror(this.onErrorWS.bind(this));
        this.wsHandler.onclose(this.onCloseWS.bind(this));
        this.wsHandler.onopen(this.onOpen.bind(this));
    };
    ConnectionManager.prototype.onOpen = function (event) {
        this.wsIsAlive = true;
        this.wsHandler.sendInitial();
        if (this.connectionCallback) {
            this.connectionCallback();
        }
        this.dispatch(this.serverMessages.connectedToTalkServer());
    };
    ConnectionManager.prototype.msgFromWS = function (event) {
        var _this = this;
        var parsedData;
        try {
            parsedData = JSON.parse(event.data);
            if (parsedData.messages) {
                parsedData.messages.map(function (msg) { return _this.dispatch(msg); });
            }
            else {
                this.dispatch(this.serverMessages.remoteConfig(parsedData));
            }
        }
        catch (error) {
            
        }
    };
    ConnectionManager.prototype.onCloseWS = function (event) {
        if (!this.autoReconnect) {
            return;
        }
        
        this.wsIsAlive = false;
        if (event.code !== 1014) {
            this.retriesCounter = 0;
            this.reconnecting = false;
        }
        throw new Error('Woice | connection fail code: ' + JSON.stringify(event.code));
    };
    ConnectionManager.prototype.onErrorWS = function (event) {
        this.wsIsAlive = false;
        
        
        throw new Error(JSON.stringify(event.error));
    };
    ConnectionManager.prototype.reconnector = function () {
        var _this = this;
        if (!this.autoReconnect) {
            return;
        }
        var self = this;
        this.reconnectorAcive = true;
        this.reconnectTimer = setInterval(function () {
            if (!_this.wsIsAlive && !_this.reconnecting) {
                if (_this.retriesCounter === _this.maxRetries) {
                    _this.reconnecting = true;
                    setTimeout(_this.createConnection, _this.timeAfterMaxRetries);
                }
                else {
                    _this.reconnecting = true;
                    var currentTimeRetry = _this.retriesCounter === 0 ? 1 : _this.timeBtwRetries;
                    if (_this.retriesCounter === 0) {
                        _this.createConnection();
                    }
                    else {
                        setTimeout(_this.createConnection.bind(self), currentTimeRetry);
                    }
                    _this.retriesCounter += 1;
                }
            }
        }, 10000);
    };
    return ConnectionManager;
}());

function keyBoardController(keys, runtime) {
    var event = new Events('.', '.', '.', ',', '', '');
    document.addEventListener('keydown', function (zEvent) {
        keys.map(function (k) {
            var capitalize = k.charAt(0).toUpperCase() + k.slice(1);
            var completeKey = 'Key' + capitalize;
            if (zEvent.ctrlKey && zEvent.code === completeKey) {
                runtime.dispatch(event.keyboard());
            }
        });
    });
}

var SpeechRecognition = (function () {
    function SpeechRecognition(dispatch, language) {
        if (!language) {
            throw new Error('Language is mandatory to initialize SpeechRecognition');
        }
        this.recognition = false;
        this.dispatch = dispatch;
        this.libEvents = new Events('.', '.', '', '.', '', '');
        this.state = {
            active: false,
            lang: language,
            recognizing: false,
            started: false,
            currentTranscription: ''
        };
    }
    SpeechRecognition.isSupported = function () {
        return 'webkitSpeechRecognition' in window;
    };
    SpeechRecognition.prototype.start = function () {
        var _this = this;
        var recognizing = this.state.recognizing;
        if (!recognizing) {
            this.recognition = false;
            this.initialize(this.state, function () {
                _this.recognition.start();
            });
        }
    };
    SpeechRecognition.prototype.stop = function () {
        var recognizing = this.state.recognizing;
        if (recognizing) {
            this.recognition.stop();
        }
    };
    SpeechRecognition.prototype.initialize = function (options, callback) {
        if (options === void 0) { options = { interimResults: true }; }
        if (options.lang) {
            this.state.lang = options.lang;
        }
        this.sr = window.SpeechRecognition || window.webkitSpeechRecognition;
        this.recognition = new this.sr();
        this.recognition.continuous = options.continuous || false;
        this.recognition.interimResults = options.interimResults || true;
        this.recognition.onstart = this.onStart.bind(this);
        this.recognition.onerror = this.onError.bind(this);
        this.recognition.onend = this.onEnd.bind(this);
        this.recognition.onresult = this.onResult.bind(this);
        this.recognition.lang = this.state.lang;
        if (callback) {
            return callback();
        }
    };
    SpeechRecognition.prototype.onStart = function () {
        var msg = this.libEvents.speechRecognition('', 'onStart');
        this.dispatch(msg);
        this.state.recognizing = true;
        this.state.currentTranscription = '';
    };
    SpeechRecognition.prototype.onError = function (event) {
        var msg = this.libEvents.speechRecognition(event.error, 'onError');
        this.dispatch(msg);
    };
    SpeechRecognition.prototype.onEnd = function () {
        this.state.recognizing = false;
        this.recognition.stop();
        var msg = this.libEvents.speechRecognition(this.state.currentTranscription, 'onEnd');
        this.dispatch(msg);
    };
    SpeechRecognition.prototype.onResult = function () {
        var finalTranscript = '';
        var interimTranscript = '';
        for (var i = event.resultIndex; i < event.results.length; ++i) {
            if (event.results[i].isFinal) {
                finalTranscript += event.results[i][0].transcript;
            }
            else {
                interimTranscript += event.results[i][0].transcript;
            }
        }
        if (finalTranscript) {
            finalTranscript = this.capitalize(finalTranscript);
            var msg = this.libEvents.speechRecognition(finalTranscript, 'onResult_finalTranscript');
            this.state.currentTranscription = finalTranscript;
            this.dispatch(msg);
            this.recognition.stop();
        }
        if (interimTranscript) {
            var msg = this.libEvents.speechRecognition(interimTranscript, 'onResult_interimTranscript');
            this.dispatch(msg);
        }
    };
    SpeechRecognition.prototype.capitalize = function (s) {
        var firstChar = /\S/;
        return s.replace(firstChar, function (m) { return m.toUpperCase(); });
    };
    return SpeechRecognition;
}());

var SpeechSynthesis = (function () {
    function SpeechSynthesis(lang) {
        var _this = this;
        this.lang = lang || navigator.language || navigator.userLanguage;
        this.Speech = window.speechSynthesis;
        this.voices = [];
        window.speechSynthesis.onvoiceschanged = function (e) {
            _this.allVoices = window.speechSynthesis.getVoices();
            _this.changeLangVoices();
        };
        window.speechSynthesis.getVoices();
    }
    SpeechSynthesis.isSupported = function () {
        return !!window.speechSynthesis;
    };
    SpeechSynthesis.prototype.speak = function (text) {
        var utterThis = new SpeechSynthesisUtterance(text);
        utterThis.voice = this.voices[0];
        if (this.voices.length === 0) {
            utterThis.lang = this.lang;
        }
        this.Speech.speak(utterThis);
        utterThis.onend = function () { return void 0; };
        utterThis.onpause = function (_event) {
        };
    };
    SpeechSynthesis.prototype.changeLangVoices = function () {
        for (var i = 0; i < this.allVoices.length; i += 1) {
            if (this.allVoices[i].lang === this.lang) {
                this.voices.push(this.allVoices[i]);
            }
        }
    };
    return SpeechSynthesis;
}());

var MicImage = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJDYXBhXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IiB3aWR0aD0iNzkycHgiIGhlaWdodD0iNzkycHgiIHZpZXdCb3g9IjAgMCA3OTIgNzkyIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA3OTIgNzkyOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PGc+PGc+PHBhdGggZD0iTTM5Ni4wMzYsNTE0Ljg4MWM2Mi4xNzksMCwxMTIuNzA0LTUwLjU1LDExMi43MDQtMTEyLjY4VjExMi43MDRDNTA4Ljc0LDUwLjU1LDQ1OC4yMTUsMCwzOTYuMDM2LDBDMzMzLjkwNiwwLDI4My4zOCw1MC41NSwyODMuMzgsMTEyLjcwNHYyODkuNTIxQzI4My4zNTYsNDY0LjMzMSwzMzMuODgyLDUxNC44ODEsMzk2LjAzNiw1MTQuODgxeiIvPjxwYXRoIGQ9Ik02MTMuOTc1LDQwMi42ODVjMC0xNi4zMTgtMTMuMjI0LTI5LjU0Mi0yOS41NjYtMjkuNTQyYy0xNi4zNDIsMC0yOS41NjUsMTMuMjI0LTI5LjU2NSwyOS41NDJjMCw4Ny41ODYtNzEuMjQ0LDE1OC44NTQtMTU4LjgzMSwxNTguODU0Yy04Ny41MzgsMC0xNTguODMxLTcxLjI2OS0xNTguODMxLTE1OC44NTRjMC0xNi4zMTgtMTMuMjcyLTI5LjU0Mi0yOS42MTQtMjkuNTQycy0yOS41NDIsMTMuMjI0LTI5LjU0MiwyOS41NDJjMCwxMTAuMDY5LDgyLjI5MiwyMDAuNDExLDE4OC40NDUsMjE0Ljk4OXYxNDQuNzZjMCwxNi4zNDMsMTMuMjI0LDI5LjU2NiwyOS41NjYsMjkuNTY2YzE2LjM0MywwLDI5LjYxNC0xMy4yMjQsMjkuNjE0LTI5LjU2NnYtMTQ0Ljc2QzUzMS43MzEsNjAzLjA5Niw2MTMuOTc1LDUxMi43NTQsNjEzLjk3NSw0MDIuNjg1eiIvPjwvZz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PC9zdmc+";

var WindowState = (function () {
    function WindowState() {
        this.micButtonIdConstant = 'woice_mic_bttn_0';
        this.windowVisibility = 'visible';
        this.mainWin = true;
        this.allowVisibilityHandlers = true;
        this.startCtrlWindow();
        this.execBeforeLeaving();
    }
    WindowState.prototype.watch = function () {
        this.activeNoActiveWatcher();
    };
    WindowState.prototype.stop = function () {
    };
    WindowState.prototype.insertTranscription = function (input, cb) {
        var el = this.selectedElementToTranscript;
        if (el) {
            var text = input.content.properties.value;
            if (el.nodeName === 'INPUT' &&
                (el.type === 'text' || el.type === 'search')) {
                this.selectedElementToTranscript.value = text;
            }
            else if (el.nodeName === 'TEXTAREA') {
                this.selectedElementToTranscript.value += ' ' + text;
            }
            return cb(true);
        }
        else {
            return cb(false);
        }
    };
    WindowState.prototype.analyzeDOMForInputs = function (cb) {
        var inputsListCol;
        var textsAreaListCol;
        if (window.$) {
            inputsListCol = $('input');
            textsAreaListCol = $('textarea');
        }
        else {
            inputsListCol = document.getElementsByTagName('input');
            textsAreaListCol = document.querySelectorAll('textarea');
        }
        this.processInputsAndTxtsAreas(inputsListCol, textsAreaListCol, cb);
        return { inputsListCol: inputsListCol, textsAreaListCol: textsAreaListCol };
    };
    WindowState.prototype.setOnCloseRestartInNextWindow = function () {
        return CookiesManager.setRuntimeCookie(true);
    };
    WindowState.prototype.noRestartContext = function () {
        CookiesManager.delRuntimeCookie();
        CookiesManager.setRuntimeCookie(false);
    };
    WindowState.prototype.checkRuntimeCookie = function (next) {
        var runtimeData = CookiesManager.getRuntimeCookie();
        if (runtimeData) {
            return next(null, runtimeData.restart_on_close);
        }
        else {
            return next(null, false);
        }
    };
    WindowState.prototype.execBeforeLeaving = function (connectionManager) {
        var _this = this;
        var beforeClose = function (event) {
            _this.allowVisibilityHandlers = false;
            if (connectionManager) {
                connectionManager.sendRestartUserContext();
            }
            _this.removeWinFromStack();
            return undefined;
        };
        window.onbeforeunload = beforeClose;
    };
    WindowState.prototype.isMain = function () {
        this.updateCurrentWinStack();
        if (this.currentWinStack.winStack[this.currentWinStack.winStack.length - 1] === this.windowName) {
            this.mainWin = true;
            return true;
        }
        return false;
    };
    WindowState.prototype.clearAnimation = function () {
        var el = document.getElementById(this.micButtonIdConstant);
        if (el) {
            var styles = el.getAttribute('style');
            var noAnim = "-webkit-animation: none !important;\n    -moz-animation: none !important;\n    animation: none !important";
            el.setAttribute('style', styles + noAnim);
        }
    };
    WindowState.prototype.processInputsAndTxtsAreas = function (inputsListCol, textsAreaListCol, cb) {
        this.addMicIconStyleToHeader();
        for (var _i = 0, inputsListCol_1 = inputsListCol; _i < inputsListCol_1.length; _i++) {
            var input = inputsListCol_1[_i];
            if (window.$) {
                $(input).click(this.ElementOnClick.bind(this, cb));
            }
            else {
                input.addEventListener('click', this.ElementOnClick.bind(this, cb));
            }
        }
        for (var _a = 0, textsAreaListCol_1 = textsAreaListCol; _a < textsAreaListCol_1.length; _a++) {
            var txtarea = textsAreaListCol_1[_a];
            if (window.$) {
                $(txtarea).click(this.ElementOnClick.bind(this, cb));
            }
            else {
                txtarea.addEventListener('click', this.ElementOnClick.bind(this, cb));
            }
        }
    };
    WindowState.prototype.ElementOnClick = function (cb, event) {
        this.selectedElementToTranscript = event.target;
        this.removeLastMicButton();
        var _a = this.getElementCoordinates(event), positionX = _a.positionX, positionY = _a.positionY;
        this.createMicImage("" + positionX, "" + positionY, cb);
    };
    WindowState.prototype.removeLastMicButton = function () {
        var elem = document.getElementById(this.micButtonIdConstant);
        if (elem) {
            elem.parentNode.removeChild(elem);
        }
    };
    WindowState.prototype.getElementCoordinates = function (event) {
        var rect = event.target.getBoundingClientRect();
        var positionY = rect.y + rect.height - 32;
        var positionX = rect.x + rect.width - 32;
        return { positionY: positionY, positionX: positionX };
    };
    WindowState.prototype.createMicImage = function (positionX, positionY, cb) {
        var img =  document.createElement('img');
        img.src = MicImage;
        var alt = 'Woice Voice Search';
        var title = 'Click and start talk to transcript';
        img.id = this.micButtonIdConstant;
        {
            img.alt = alt;
        }
        {
            img.title = title;
        }
        img.setAttribute('style', "position:absolute; top:" + positionY + "px;left:" + positionX + "px;width:24px;height:24px;cursor:pointer;");
        img.onclick = function () {
            var styles = img.getAttribute('style');
            var animations = "-webkit-animation:flickerAnimation 2s infinite;\n      -moz-animation:flickerAnimation 2s infinite;\n      animation:flickerAnimation 2s infinite;\n      ";
            img.setAttribute('style', styles + animations);
            return cb();
        };
        document.body.appendChild(img);
    };
    WindowState.prototype.addMicIconStyleToHeader = function () {
        var cssAnimation = document.createElement('style');
        cssAnimation.type = 'text/css';
        var rules = document.createTextNode("\n      @-moz-keyframes flickerAnimation {\n        0%   { opacity:1; }\n        50%  { opacity:0; }\n        100% { opacity:1; }\n      }\n      @-webkit-keyframes flickerAnimation {\n        0%   { opacity:1; }\n        50%  { opacity:0; }\n        100% { opacity:1; }\n      }\n      @keyframes flickerAnimation {\n        0%   { opacity:1; }\n        50%  { opacity:0; }\n        100% { opacity:1; }\n      };\n    ");
        cssAnimation.appendChild(rules);
        document.getElementsByTagName('head')[0].appendChild(cssAnimation);
    };
    WindowState.prototype.activeNoActiveWatcher = function () {
        var _this = this;
        if (window.addEventListener) {
            window.addEventListener('focus', function () {
                if (_this.allowVisibilityHandlers) {
                    _this.changeVisibility('visible');
                }
            }, false);
            window.addEventListener('blur', function () {
                if (_this.allowVisibilityHandlers) {
                    _this.changeVisibility('hidden');
                }
            }, false);
        }
        else {
            window.attachEvent('focus', function (event) {
                _this.changeVisibility('visible');
            });
            window.attachEvent('focusin', function (event) {
                _this.changeVisibility('visible');
            });
            window.attachEvent('blur', function (event) {
                _this.changeVisibility('hidden');
            });
            document.onfocusin = function () {
                _this.changeVisibility('visible');
            };
            document.onfocusout = function () {
                _this.changeVisibility('hidden');
            };
        }
    };
    WindowState.prototype.changeVisibility = function (state) {
        this.windowVisibility = state;
        this.mainWin = state === 'visible' ? true : false;
        if (state === 'visible') {
            this.updateCurrentWinStack();
            this.claimMainWin();
        }
        if (typeof this.onChangeVisibility === 'function') {
            return this.onChangeVisibility(this.windowVisibility);
        }
    };
    WindowState.prototype.startCtrlWindow = function () {
        this.updateCurrentWinStack();
        this.windowName = makeid();
        this.claimMainWin();
    };
    WindowState.prototype.updateCurrentWinStack = function () {
        this.currentWinStack = CookiesManager.getWinCtrlCookie();
    };
    WindowState.prototype.removeWinFromStack = function () {
        var _this = this;
        this.updateCurrentWinStack();
        var newWinStack = this.currentWinStack.winStack.filter(function (winName) { return winName !== _this.windowName; });
        CookiesManager.delWinControlCookie();
        CookiesManager.setWinControlCookie({ winStack: newWinStack });
    };
    WindowState.prototype.claimMainWin = function () {
        var _this = this;
        var newWinStack = this.currentWinStack.winStack.filter(function (winName) { return winName !== _this.windowName; });
        newWinStack.push(this.windowName);
        this.mainWin = true;
        CookiesManager.delWinControlCookie();
        CookiesManager.setWinControlCookie({ winStack: newWinStack });
        this.currentWinStack = { winStack: newWinStack };
    };
    return WindowState;
}());

function Pipeline(input, runtime, callback) {
    if (typeof input !== 'object') {
        return;
    }
    var visibility = runtime.windowState.windowVisibility;
    var isMain = runtime.windowState.isMain();
    var speechSynthesisActivated = runtime.speechSynthesisActivated, speechSynthSupport = runtime.speechSynthSupport;
    if (input.type === 'StreamingTranscription' && input.content.event === 'onEnd') {
        runtime.audioStreaming.closeStreaming();
    }
    if (input.type === 'SpeechRecognition' && input.content.event === 'onEnd') {
        if (input.content.text) {
            runtime.connectionManager.sendUtterance(input.content.text, runtime.language);
            runtime.windowState.clearAnimation();
        }
    }
    if (input.type === 'TargetKeyDown') {
        runtime.startSpeechRecognition();
        return;
    }
    if (input.type === 'user' && speechSynthSupport && isMain && speechSynthesisActivated) {
        runtime.speechSynthesizer.speak(input.text);
        return;
    }
    if (visibility === 'visible') {
        if (input.type === 'application') {
            if (input.content.properties.entity === 'CURRENT') {
                runtime.windowState.insertTranscription(input, function (success) {
                    if (!success) {
                        runtime.connectionManager.noUnderstood();
                    }
                });
            }
        }
        return callback(input);
    }
}

var WoiceRuntime = (function () {
    function WoiceRuntime(dispatcherReference) {
        this.dispatcher = dispatcherReference;
        this.windowState = new WindowState();
        this.windowState.watch();
        this.onChangeToVisibleWindow();
        this.speechSynthSupport = SpeechSynthesis.isSupported();
        this.speechRecognitionSupport = SpeechRecognition.isSupported();
        this.language = navigator.language;
        this.speechSynthesisActivated = true;
        this.speechRecognitionActive = false;
        this.currentLocation = document.location.pathname;
        this.currentDevice = this.detectDevice();
    }
    WoiceRuntime.prototype.start = function () {
        this.checkStorage();
    };
    WoiceRuntime.prototype.setLanguage = function (lang) {
        if (typeof lang === 'string') {
            this.language = lang;
            if (this.speechSynthSupport && this.speechSynthesisActivated) {
                this.speechSynthesizer = new SpeechSynthesis(this.language);
            }
            else if (this.speechRecognitionSupport) {
                this.speechRecognition = new SpeechRecognition(this.dispatch.bind(this), this.language);
            }
        }
    };
    WoiceRuntime.prototype.closeStreaming = function () {
        this.audioStreaming.closeStreaming();
    };
    WoiceRuntime.prototype.dispatch = function (input, cb) {
        this.currentInput = input;
        this.executionPipeline(input, cb);
    };
    WoiceRuntime.prototype.createConnectionManager = function (apikey, channel, entryPoint, seatId) {
        if (channel === void 0) { channel = false; }
        if (entryPoint === void 0) { entryPoint = false; }
        if (seatId === void 0) { seatId = false; }
        this.connectionManager = new ConnectionManager(this.dispatch.bind(this), this.language, this.stageEnv, this.currentLocation, this.currentDevice);
        this.connectionManager.connect(apikey, channel, entryPoint, seatId);
    };
    WoiceRuntime.prototype.runAutoTranscription = function (elementSelector) {
        var _this = this;
        this.windowState.analyzeDOMForInputs(function () {
            _this.startSpeechRecognition();
        });
    };
    WoiceRuntime.prototype.activeSpeechRecognition = function (options) {
        if (!this.language) {
            throw new Error('Language is mandatory to initialize driver');
        }
        this.speechRecognitionActive = true;
        if (this.speechRecognitionSupport) {
            var opts = options || {};
            this.speechRecognition = new SpeechRecognition(this.dispatch.bind(this), this.language);
            this.speechRecognition.initialize(opts);
        }
        else {
            this.audioStreaming = new AudioStreaming(this.dispatch.bind(this), options);
        }
    };
    WoiceRuntime.prototype.startSpeechRecognition = function (callback) {
        var _this = this;
        if (!this.connectionManager.wsIsAlive) {
            this.connectionManager.connect(null, null, null, null, function () {
                setTimeout(function () {
                    if (_this.connectionManager.wsIsAlive) {
                        _this.startAudioInput(callback);
                    }
                }, 300);
            });
        }
        else {
            this.startAudioInput(callback);
        }
    };
    WoiceRuntime.prototype.disableSpeechSynth = function () {
        this.speechSynthesisActivated = false;
    };
    WoiceRuntime.prototype.sendUserUtterance = function (text) {
        this.connectionManager.sendUtterance(text, this.language);
    };
    WoiceRuntime.prototype.sendRestartUserContext = function () {
        this.connectionManager.sendRestartUserContext();
    };
    WoiceRuntime.prototype.getSeatId = function () {
        return this.connectionManager.seatId;
    };
    WoiceRuntime.prototype.setTriggerToKeys = function (keys) {
        keyBoardController(keys, this);
    };
    WoiceRuntime.prototype.closeWebSocket = function () {
        return this.connectionManager.disconnect();
    };
    WoiceRuntime.prototype.setStage = function (env) {
        this.stageEnv = env || 'dev';
    };
    WoiceRuntime.prototype.stopRecognition = function () {
        this.speechRecognition.stop();
    };
    WoiceRuntime.prototype.isNativeSpeechRecognition = function () {
        return this.speechRecognitionSupport;
    };
    WoiceRuntime.prototype.isConnected = function () {
        return this.connectionManager.wsIsAlive;
    };
    WoiceRuntime.prototype.startAudioInput = function (callback) {
        if (this.speechRecognitionSupport && this.speechRecognitionActive) {
            this.speechRecognition.start();
        }
        else if (this.audioStreaming.isSupported && this.speechRecognitionActive) {
            this.audioStreaming.start(this.connectionManager, callback);
        }
    };
    WoiceRuntime.prototype.checkStorage = function () {
        var _this = this;
        if (typeof window !== 'undefined') {
            this.windowState.checkRuntimeCookie(function (error, runtimeData) {
                if (runtimeData) {
                    _this.windowState.execBeforeLeaving(_this.connectionManager);
                }
            });
            var actionsFromStorage = CookiesManager.getActions();
            if (actionsFromStorage.length > 0) {
                for (var _i = 0, actionsFromStorage_1 = actionsFromStorage; _i < actionsFromStorage_1.length; _i++) {
                    var event_1 = actionsFromStorage_1[_i];
                    this.dispatch(event_1);
                }
            }
        }
    };
    WoiceRuntime.prototype.onChangeToVisibleWindow = function () {
        var _this = this;
        this.windowState.onChangeVisibility = function (error, windowVisibility) {
            if (windowVisibility === 'visible') {
                _this.checkStorage();
            }
        };
    };
    WoiceRuntime.prototype.executionPipeline = function (input, cb) {
        var _this = this;
        Pipeline(input, this, function (_input) {
            _this.setMethodsAndExec(_input, cb);
        });
    };
    WoiceRuntime.prototype.isIntent = function (intentName) {
        return this.isStart(intentName);
    };
    WoiceRuntime.prototype.isStart = function (intentName) {
        if (this.currentInput.type === 'application') {
            var ev = this.currentInput.content;
            if (ev.event === 'startUserIntent' && ev.properties.userIntent === intentName) {
                this.windowState.setOnCloseRestartInNextWindow();
                return true;
            }
            else {
                return false;
            }
        }
    };
    WoiceRuntime.prototype.isFinish = function (intentName) {
        if (this.currentInput.type === 'application') {
            var ev = this.currentInput.content;
            if (ev.event === 'finishUserIntent' && ev.properties.userIntent === intentName) {
                this.windowState.setOnCloseRestartInNextWindow();
                return true;
            }
            else {
                return false;
            }
        }
    };
    WoiceRuntime.prototype.isEntity = function (entityName, intentName) {
        if (this.currentInput.type === 'application') {
            var ev = this.currentInput.content;
            if (ev.event === 'entity' &&
                ev.properties.entity === entityName &&
                ev.properties.userIntent === intentName) {
                return true;
            }
            else {
                return false;
            }
        }
    };
    WoiceRuntime.prototype.isAction = function (actionName, intentName) {
        if (this.currentInput.type === 'application') {
            var ev = this.currentInput.content.properties;
            if (ev.action === actionName) {
                return true;
            }
            else {
                return false;
            }
        }
    };
    WoiceRuntime.prototype.noRestartContext = function () {
        this.windowState.noRestartContext();
    };
    WoiceRuntime.prototype.setMethodsAndExec = function (input, cb) {
        var _this = this;
        input.startIntent = this.connectionManager.sendStartIntent.bind(this.connectionManager);
        input.restartUserContext = this.connectionManager.sendRestartUserContext.bind(this.connectionManager);
        input.talk = this.connectionManager.sendDesktopTalk.bind(this.connectionManager);
        this.injectToHandlerInput(input);
        this.dispatcher.dispatchAction(input, function (error, result) {
            if (error) {
                return _this.dispatcher.dispatchError(input, error);
            }
            if (cb) {
                return cb(null, result);
            }
        });
    };
    WoiceRuntime.prototype.injectToHandlerInput = function (input) {
        input.isIntent = this.isIntent.bind(this);
        input.isEntity = this.isEntity.bind(this);
        input.isAction = this.isAction.bind(this);
        input.isStart = this.isStart.bind(this);
        input.isFinish = this.isFinish.bind(this);
        input.noRestartContext = this.noRestartContext.bind(this);
        if (this.speechRecognitionSupport && this.speechRecognitionActive) {
            input.startSpeechRecognition = this.speechRecognition.start;
        }
        input.sendUserUtterance = this.connectionManager.sendUtterance;
    };
    WoiceRuntime.prototype.detectDevice = function () {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            return 'mobile';
        }
        else {
            return 'desktop';
        }
    };
    return WoiceRuntime;
}());

var ConfigDriverFactory = (function () {
    function ConfigDriverFactory() {
    }
    ConfigDriverFactory.init = function () {
        var runtimeConfigurationBuilder = new RuntimeConfigurationBuilder();
        var genericEventDispatcher = new GenericEventDispatcher(runtimeConfigurationBuilder.getRuntimeConfiguration());
        var woiceRuntime = new WoiceRuntime(genericEventDispatcher);
        return {
            addActionHandlers: function () {
                var actionHandlers = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    actionHandlers[_i] = arguments[_i];
                }
                runtimeConfigurationBuilder.addActionHandlers.apply(runtimeConfigurationBuilder, actionHandlers);
                return this;
            },
            addErrorHandlers: function () {
                var errorHandlers = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    errorHandlers[_i] = arguments[_i];
                }
                runtimeConfigurationBuilder.addErrorHandlers.apply(runtimeConfigurationBuilder, errorHandlers);
                return this;
            },
            withSpeechRecognition: function (options) {
                woiceRuntime.activeSpeechRecognition(options);
                return this;
            },
            noSpeechSynthesis: function () {
                woiceRuntime.disableSpeechSynth();
                return this;
            },
            start: function () {
                woiceRuntime.start();
                return this;
            },
            dispatch: function (response) {
                woiceRuntime.dispatch(response);
                return this;
            },
            connect: function (apikey, channel, entryPoint, seatId) {
                woiceRuntime.createConnectionManager(apikey, channel, entryPoint, seatId);
                return this;
            },
            disconnect: function () {
                woiceRuntime.closeWebSocket();
                return this;
            },
            withAutoTranscription: function (elementSelector) {
                woiceRuntime.runAutoTranscription();
                return this;
            },
            startSpeechRecognition: function (callback) {
                woiceRuntime.startSpeechRecognition(callback);
                return this;
            },
            lang: function (lang) {
                woiceRuntime.setLanguage(lang);
                return this;
            },
            sendUserUtterance: function (text) {
                woiceRuntime.sendUserUtterance(text);
                return this;
            },
            restartUserContext: function () {
                woiceRuntime.sendRestartUserContext();
                return this;
            },
            _getSeatId: function () {
                return woiceRuntime.getSeatId();
            },
            withKeys: function () {
                var keys = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    keys[_i] = arguments[_i];
                }
                woiceRuntime.setTriggerToKeys(keys);
                return this;
            },
            setStage: function (env) {
                woiceRuntime.setStage(env);
                return this;
            },
            closeAudioStreaming: function () {
                woiceRuntime.closeStreaming();
                return this;
            },
            stopSpeechRecognition: function () {
                woiceRuntime.stopRecognition();
                return this;
            },
            isNativeRecognition: function () {
                return woiceRuntime.isNativeSpeechRecognition();
            },
            isConnected: function () {
                return woiceRuntime.isConnected();
            }
        };
    };
    return ConfigDriverFactory;
}());

var Polyfills = function () {
    Function.prototype.bind = function (context) {
        var fn = this;
        var args = Array.prototype.slice.call(arguments, 1);
        if (typeof (fn) !== 'function') {
            throw new TypeError('Function.prototype.bind - context must be a valid function');
        }
        return function () {
            return fn.apply(context, args.concat(Array.prototype.slice.call(arguments)));
        };
    };
    if (!document.querySelectorAll) {
        document.querySelectorAll = function (selector) {
            var doc = document;
            var head = doc.documentElement.firstChild;
            var styleTag = doc.createElement('STYLE');
            head.appendChild(styleTag);
            doc.__qsaels = [];
            styleTag.styleSheet.cssText = selector + '{x:expression(document.__qsaels.push(this))}';
            window.scrollBy(0, 0);
            return doc.__qsaels;
        };
    }
    Array.isArray = function (obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    };
};

var DriverBuilders = {
    config: function () {
        Polyfills();
        return ConfigDriverFactory.init();
    }
};

var SettingsPanel = /** @class */ (function (_super) {
    __extends(SettingsPanel, _super);
    function SettingsPanel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SettingsPanel.prototype.render = function () {
        var _a = this.props, theme = _a.theme, handleBotSelection = _a.handleBotSelection, handleChannelSelection = _a.handleChannelSelection, handleLangSelection = _a.handleLangSelection, botList = _a.botList, handleSourceValue = _a.handleSourceValue, handleConnect = _a.handleConnect, apiKey = _a.apiKey;
        return (createElement("div", { className: theme.settingsContainer },
            createElement("span", null, "Bots"),
            createElement("select", { onChange: handleBotSelection, defaultValue: apiKey || 'de42918b-3573-45e8-85b7-f187f47f42d7' },
                createElement("option", { value: "" }, "--- Select one ---"),
                botList.map(function (bot, i) {
                    return (createElement("option", { value: bot.apiKey, key: i }, bot.name));
                })),
            createElement("span", null, "Channel"),
            createElement("select", { onChange: handleChannelSelection, defaultValue: '' },
                createElement("option", { value: "" }, "--- Select one ---"),
                createElement("option", { value: "voice" }, "voice"),
                createElement("option", { value: "google" }, "google"),
                createElement("option", { value: "alexa" }, "alexa"),
                createElement("option", { value: "slack" }, "slack"),
                createElement("option", { value: "desktop" }, "desktop"),
                createElement("option", { value: "whatsapp" }, "whatsapp"),
                createElement("option", { value: "webchat" }, "webchat")),
            createElement("span", null, "SourceValue"),
            createElement("input", { placeholder: "Enter your custom seatId", onChange: handleSourceValue }),
            createElement("span", null, "Language"),
            createElement("select", { onChange: handleLangSelection, defaultValue: 'es', disabled: true },
                createElement("option", null, "--- Select one ---"),
                createElement("option", { value: "es" }, "ES"),
                createElement("option", { value: "en" }, "EN")),
            createElement("a", { href: "#", className: theme.button, onClick: handleConnect }, "Connect")));
    };
    return SettingsPanel;
}(Component));

var moment = createCommonjsModule$1(function (module, exports) {
(function (global, factory) {
     module.exports = factory() ;
}(commonjsGlobal, (function () {
    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key;
                for (i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i;
            for (i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (
                    matched,
                    p1,
                    p2,
                    p3,
                    p4
                ) {
                    return p1 || p2 || p3 || p4;
                })
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split(
            '_'
        ),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            'object' !== 'undefined' &&
            module &&
            module.exports
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = commonjsRequire;
                aliasedRequire('./locale/' + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^)]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (
        input,
        array,
        config,
        token
    ) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) {
            getParsingFlags(config).era = era;
        } else {
            getParsingFlags(config).invalidEra = input;
        }
    });

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.29.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));
});

var dist = createCommonjsModule$1(function (module, exports) {
!function(e,t){module.exports=t(moment,React__default);}(commonjsGlobal,function(e,t){return function(e){var t={};function n(r){if(t[r])return t[r].exports;var o=t[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r});},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0});},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)n.d(r,o,function(t){return e[t]}.bind(null,o));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=6)}([function(e,t,n){e.exports=n(3)();},function(t,n){t.exports=e;},function(e,n){e.exports=t;},function(e,t,n){var r=n(4);function o(){}function i(){}i.resetWarningCache=o,e.exports=function(){function e(e,t,n,o,i,a){if(a!==r){var l=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw l.name="Invariant Violation",l}}function t(){return e}e.isRequired=e;var n={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,elementType:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t,checkPropTypes:i,resetWarningCache:o};return n.PropTypes=n,n};},function(e,t,n){e.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";},function(e,t,n){var r,o,i,a,l;
/*! Moment Duration Format v2.2.2
 *  https://github.com/jsmreese/moment-duration-format
 *  Date: 2018-02-16
 *
 *  Duration format plugin function for the Moment.js library
 *  http://momentjs.com/
 *
 *  Copyright 2018 John Madhavan-Reese
 *  Released under the MIT license
 */
/*! Moment Duration Format v2.2.2
 *  https://github.com/jsmreese/moment-duration-format
 *  Date: 2018-02-16
 *
 *  Duration format plugin function for the Moment.js library
 *  http://momentjs.com/
 *
 *  Copyright 2018 John Madhavan-Reese
 *  Released under the MIT license
 */
a=this,l=function(e){var t=!1,n=!1,r="escape years months weeks days hours minutes seconds milliseconds general".split(" "),o=[{type:"seconds",targets:[{type:"minutes",value:60},{type:"hours",value:3600},{type:"days",value:86400},{type:"weeks",value:604800},{type:"months",value:2678400},{type:"years",value:31536e3}]},{type:"minutes",targets:[{type:"hours",value:60},{type:"days",value:1440},{type:"weeks",value:10080},{type:"months",value:44640},{type:"years",value:525600}]},{type:"hours",targets:[{type:"days",value:24},{type:"weeks",value:168},{type:"months",value:744},{type:"years",value:8760}]},{type:"days",targets:[{type:"weeks",value:7},{type:"months",value:31},{type:"years",value:365}]},{type:"months",targets:[{type:"years",value:12}]}];function i(e,t){return !(t.length>e.length)&&-1!==e.indexOf(t)}function a(e){for(var t="";e;)t+="0",e-=1;return t}function l(e,t,r){var o,i,u,s=t.useToLocaleString,c=t.useGrouping,m=c&&t.grouping.slice(),f=t.maximumSignificantDigits,p=t.minimumIntegerDigits||1,g=t.fractionDigits||0,y=t.groupingSeparator,h=t.decimalSeparator;if(s&&r){var d={minimumIntegerDigits:p,useGrouping:c};if(g&&(d.maximumFractionDigits=g,d.minimumFractionDigits=g),f&&e>0&&(d.maximumSignificantDigits=f),!n){var v=w({},t);v.useGrouping=!1,v.decimalSeparator=".",e=parseFloat(l(e,v),10);}return e.toLocaleString(r,d)}var b=(f?e.toPrecision(f+1):e.toFixed(g+1)).split("e");u=b[1]||"",i=(b=b[0].split("."))[1]||"";var S=(o=b[0]||"").length,T=i.length,_=S+T,x=o+i;(f&&_===f+1||!f&&T===g+1)&&((x=function(e){for(var t=e.split("").reverse(),n=0,r=!0;r&&n<t.length;)n?"9"===t[n]?t[n]="0":(t[n]=(parseInt(t[n],10)+1).toString(),r=!1):(parseInt(t[n],10)<5&&(r=!1),t[n]="0"),n+=1;return r&&t.push("1"),t.reverse().join("")}(x)).length===_+1&&(S+=1),T&&(x=x.slice(0,-1)),o=x.slice(0,S),i=x.slice(S)),f&&(i=i.replace(/0*$/,""));var O=parseInt(u,10);O>0?i.length<=O?(o+=i+=a(O-i.length),i=""):(o+=i.slice(0,O),i=i.slice(O)):O<0&&(i=a(Math.abs(O)-o.length)+o+i,o="0"),f||((i=i.slice(0,g)).length<g&&(i+=a(g-i.length)),o.length<p&&(o=a(p-o.length)+o));var V,D="";if(c)for(b=o;b.length;)m.length&&(V=m.shift()),D&&(D=y+D),D=b.slice(-V)+D,b=b.slice(0,-V);else D=o;return i&&(D=D+h+i),D}function u(e,t){return e.label.length>t.label.length?-1:e.label.length<t.label.length?1:0}var s,c={durationLabelsStandard:{S:"millisecond",SS:"milliseconds",s:"second",ss:"seconds",m:"minute",mm:"minutes",h:"hour",hh:"hours",d:"day",dd:"days",w:"week",ww:"weeks",M:"month",MM:"months",y:"year",yy:"years"},durationLabelsShort:{S:"msec",SS:"msecs",s:"sec",ss:"secs",m:"min",mm:"mins",h:"hr",hh:"hrs",d:"dy",dd:"dys",w:"wk",ww:"wks",M:"mo",MM:"mos",y:"yr",yy:"yrs"},durationTimeTemplates:{HMS:"h:mm:ss",HM:"h:mm",MS:"m:ss"},durationLabelTypes:[{type:"standard",string:"__"},{type:"short",string:"_"}],durationPluralKey:function(e,t,n){return 1===t&&null===n?e:e+e}};function m(e){return "[object Array]"===Object.prototype.toString.call(e)}function f(e){return "[object Object]"===Object.prototype.toString.call(e)}function p(e,t){var n,r=0,o=e&&e.length||0;for("function"!=typeof t&&(n=t,t=function(e){return e===n});r<o;){if(t(e[r]))return e[r];r+=1;}}function g(e,t){var n=0,r=e.length;if(e&&r)for(;n<r;){if(!1===t(e[n],n))return;n+=1;}}function y(e,t){var n=0,r=e.length,o=[];if(!e||!r)return o;for(;n<r;)o[n]=t(e[n],n),n+=1;return o}function h(e,t){return y(e,function(e){return e[t]})}function d(e){var t=[];return g(e,function(e){e&&t.push(e);}),t}function v(e){var t=[];return g(e,function(e){p(t,e)||t.push(e);}),t}function b(e,t){var n=[];return g(e,function(e){g(t,function(t){e===t&&n.push(e);});}),v(n)}function S(e,t){var n=[];return g(e,function(r,o){if(!t(r))return n=e.slice(o),!1}),n}function w(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n]);return e}function T(e){var t=[];for(var n in e)e.hasOwnProperty(n)&&t.push(n);return t}function _(e,t){var n=0,r=e.length;if(!e||!r)return !1;for(;n<r;){if(!0===t(e[n],n))return !0;n+=1;}return !1}function x(){var e,t=[].slice.call(arguments),n={};if(g(t,function(t,r){if(!r){if(!m(t))throw "Expected array as the first argument to durationsFormat.";e=t;}"string"!=typeof t&&"function"!=typeof t?"number"!=typeof t?f(t)&&w(n,t):n.precision=t:n.template=t;}),!e||!e.length)return [];n.returnMomentTypes=!0;var o,i=y(e,function(e){return e.format(n)}),a=b(r,v(h((o=[],g(i,function(e){o=o.concat(e);}),o),"type"))),l=n.largest;return l&&(a=a.slice(0,l)),n.returnMomentTypes=!1,n.outputTypes=a,y(e,function(e){return e.format(n)})}function O(){var n=[].slice.call(arguments),a=w({},this.format.defaults),s=this.asMilliseconds(),x=this.asMonths();"function"==typeof this.isValid&&!1===this.isValid()&&(s=0,x=0);var O=s<0,V=e.duration(Math.abs(s),"milliseconds"),D=e.duration(Math.abs(x),"months");g(n,function(e){"string"!=typeof e&&"function"!=typeof e?"number"!=typeof e?f(e)&&w(a,e):a.precision=e:a.template=e;});var L={years:"y",months:"M",weeks:"w",days:"d",hours:"h",minutes:"m",seconds:"s",milliseconds:"S"},j={escape:/\[(.+?)\]/,years:/\*?[Yy]+/,months:/\*?M+/,weeks:/\*?[Ww]+/,days:/\*?[Dd]+/,hours:/\*?[Hh]+/,minutes:/\*?m+/,seconds:/\*?s+/,milliseconds:/\*?S+/,general:/.+?/};a.types=r;var M=function(e){return p(r,function(t){return j[t].test(e)})},k=new RegExp(y(r,function(e){return j[e].source}).join("|"),"g");a.duration=this;var P="function"==typeof a.template?a.template.apply(a):a.template,E=a.outputTypes,F=a.returnMomentTypes,I=a.largest,C=[];E||(m(a.stopTrim)&&(a.stopTrim=a.stopTrim.join("")),a.stopTrim&&g(a.stopTrim.match(k),function(e){var t=M(e);"escape"!==t&&"general"!==t&&C.push(t);}));var N=e.localeData();N||(N={}),g(T(c),function(e){"function"!=typeof c[e]?N["_"+e]||(N["_"+e]=c[e]):N[e]||(N[e]=c[e]);}),g(T(N._durationTimeTemplates),function(e){P=P.replace("_"+e+"_",N._durationTimeTemplates[e]);});var G=a.userLocale||e.locale(),R=a.useLeftUnits,U=a.usePlural,q=a.precision,z=a.forceLength,H=a.useGrouping,W=a.trunc,$=a.useSignificantDigits&&q>0,A=$?a.precision:0,B=A,K=a.minValue,Y=!1,J=a.maxValue,Q=!1,X=a.useToLocaleString,Z=a.groupingSeparator,ee=a.decimalSeparator,te=a.grouping;X=X&&t;var ne=a.trim;m(ne)&&(ne=ne.join(" ")),null===ne&&(I||J||$)&&(ne="all"),null!==ne&&!0!==ne&&"left"!==ne&&"right"!==ne||(ne="large"),!1===ne&&(ne="");var re=function(e){return e.test(ne)},oe=/both/,ie=/^all|[^sm]all/,ae=I>0||_([/large/,oe,ie],re),le=_([/small/,oe,ie],re),ue=_([/mid/,ie],re),se=_([/final/,ie],re),ce=y(P.match(k),function(e,t){var n=M(e);return "*"===e.slice(0,1)&&(e=e.slice(1),"escape"!==n&&"general"!==n&&C.push(n)),{index:t,length:e.length,text:"",token:"escape"===n?e.replace(j.escape,"$1"):e,type:"escape"===n||"general"===n?null:n}}),me={index:0,length:0,token:"",text:"",type:null},fe=[];R&&ce.reverse(),g(ce,function(e){if(e.type)return (me.type||me.text)&&fe.push(me),void(me=e);R?me.text=e.token+me.text:me.text+=e.token;}),(me.type||me.text)&&fe.push(me),R&&fe.reverse();var pe=b(r,v(d(h(fe,"type"))));if(!pe.length)return h(fe,"text").join("");pe=y(pe,function(e,t){var n,r=t+1===pe.length,o=!t;n="years"===e||"months"===e?D.as(e):V.as(e);var i=Math.floor(n),l=n-i,u=p(fe,function(t){return e===t.type});return o&&J&&n>J&&(Q=!0),r&&K&&Math.abs(a.duration.as(e))<K&&(Y=!0),o&&null===z&&u.length>1&&(z=!0),V.subtract(i,e),D.subtract(i,e),{rawValue:n,wholeValue:i,decimalValue:r?l:0,isSmallest:r,isLargest:o,type:e,tokenLength:u.length}});var ge,ye=W?Math.floor:Math.round,he=function(e,t){var n=Math.pow(10,t);return ye(e*n)/n},de=!1,ve=!1,be=function(e,t){var n={useGrouping:H,groupingSeparator:Z,decimalSeparator:ee,grouping:te,useToLocaleString:X};return $&&(A<=0?(e.rawValue=0,e.wholeValue=0,e.decimalValue=0):(n.maximumSignificantDigits=A,e.significantDigits=A)),Q&&!ve&&(e.isLargest?(e.wholeValue=J,e.decimalValue=0):(e.wholeValue=0,e.decimalValue=0)),Y&&!ve&&(e.isSmallest?(e.wholeValue=K,e.decimalValue=0):(e.wholeValue=0,e.decimalValue=0)),e.isSmallest||e.significantDigits&&e.significantDigits-e.wholeValue.toString().length<=0?q<0?e.value=he(e.wholeValue,q):0===q?e.value=ye(e.wholeValue+e.decimalValue):$?(e.value=W?he(e.rawValue,A-e.wholeValue.toString().length):e.rawValue,e.wholeValue&&(A-=e.wholeValue.toString().length)):(n.fractionDigits=q,e.value=W?e.wholeValue+he(e.decimalValue,q):e.wholeValue+e.decimalValue):$&&e.wholeValue?(e.value=Math.round(he(e.wholeValue,e.significantDigits-e.wholeValue.toString().length)),A-=e.wholeValue.toString().length):e.value=e.wholeValue,e.tokenLength>1&&(z||de)&&(n.minimumIntegerDigits=e.tokenLength,ve&&n.maximumSignificantDigits<e.tokenLength&&delete n.maximumSignificantDigits),!de&&(e.value>0||""===ne||p(C,e.type)||p(E,e.type))&&(de=!0),e.formattedValue=l(e.value,n,G),n.useGrouping=!1,n.decimalSeparator=".",e.formattedValueEn=l(e.value,n,"en"),2===e.tokenLength&&"milliseconds"===e.type&&(e.formattedValueMS=l(e.value,{minimumIntegerDigits:3,useGrouping:!1},"en").slice(0,2)),e};if((pe=d(pe=y(pe,be))).length>1){var Se=function(e){return p(pe,function(t){return t.type===e})};g(o,function(e){var t=Se(e.type);t&&g(e.targets,function(e){var n=Se(e.type);n&&parseInt(t.formattedValueEn,10)===e.value&&(t.rawValue=0,t.wholeValue=0,t.decimalValue=0,n.rawValue+=1,n.wholeValue+=1,n.decimalValue=0,n.formattedValueEn=n.wholeValue.toString(),ve=!0);});});}return ve&&(de=!1,A=B,pe=d(pe=y(pe,be))),!E||Q&&!a.trim?(ae&&(pe=S(pe,function(e){return !e.isSmallest&&!e.wholeValue&&!p(C,e.type)})),I&&pe.length&&(pe=pe.slice(0,I)),le&&pe.length>1&&(ge=function(e){return !e.wholeValue&&!p(C,e.type)&&!e.isLargest},pe=S(pe.slice().reverse(),ge).reverse()),ue&&(pe=d(pe=y(pe,function(e,t){return t>0&&t<pe.length-1&&!e.wholeValue?null:e}))),!se||1!==pe.length||pe[0].wholeValue||!W&&pe[0].isSmallest&&pe[0].rawValue<K||(pe=[])):pe=d(pe=y(pe,function(e){return p(E,function(t){return e.type===t})?e:null})),F?pe:(g(fe,function(e){var t=L[e.type],n=p(pe,function(t){return t.type===e.type});if(t&&n){var r=n.formattedValueEn.split(".");r[0]=parseInt(r[0],10),r[1]?r[1]=parseFloat("0."+r[1],10):r[1]=null;var o=N.durationPluralKey(t,r[0],r[1]),a=function(e,t){var n=[];return g(T(t),function(r){if("_durationLabels"===r.slice(0,15)){var o=r.slice(15).toLowerCase();g(T(t[r]),function(i){i.slice(0,1)===e&&n.push({type:o,key:i,label:t[r][i]});});}}),n}(t,N),l=!1,s={};g(N._durationLabelTypes,function(t){var n=p(a,function(e){return e.type===t.type&&e.key===o});n&&(s[n.type]=n.label,i(e.text,t.string)&&(e.text=e.text.replace(t.string,n.label),l=!0));}),U&&!l&&(a.sort(u),g(a,function(t){return s[t.type]===t.label?!i(e.text,t.label)&&void 0:i(e.text,t.label)?(e.text=e.text.replace(t.label,s[t.type]),!1):void 0}));}}),(fe=y(fe,function(e){if(!e.type)return e.text;var t=p(pe,function(t){return t.type===e.type});if(!t)return "";var n="";return R&&(n+=e.text),(O&&Q||!O&&Y)&&(n+="< ",Q=!1,Y=!1),(O&&Y||!O&&Q)&&(n+="> ",Q=!1,Y=!1),O&&(t.value>0||""===ne||p(C,t.type)||p(E,t.type))&&(n+="-",O=!1),"milliseconds"===e.type&&t.formattedValueMS?n+=t.formattedValueMS:n+=t.formattedValue,R||(n+=e.text),n})).join("").replace(/(,| |:|\.)*$/,"").replace(/^(,| |:|\.)*/,""))}function V(){var e=this.duration,t=function(t){return e._data[t]},n=p(this.types,t),r=function(e,t){for(var n=e.length;n-=1;)if(t(e[n]))return e[n]}(this.types,t);switch(n){case"milliseconds":return "S __";case"seconds":case"minutes":return "*_MS_";case"hours":return "_HMS_";case"days":if(n===r)return "d __";case"weeks":return n===r?"w __":(null===this.trim&&(this.trim="both"),"w __, d __, h __");case"months":if(n===r)return "M __";case"years":return n===r?"y __":(null===this.trim&&(this.trim="both"),"y __, M __, d __");default:return null===this.trim&&(this.trim="both"),"y __, d __, h __, m __, s __"}}function D(e){if(!e)throw "Moment Duration Format init cannot find moment instance.";e.duration.format=x,e.duration.fn.format=O,e.duration.fn.format.defaults={trim:null,stopTrim:null,largest:null,maxValue:null,minValue:null,precision:0,trunc:!1,forceLength:null,userLocale:null,usePlural:!0,useLeftUnits:!1,useGrouping:!0,useSignificantDigits:!1,template:V,useToLocaleString:!0,groupingSeparator:",",decimalSeparator:".",grouping:[3]},e.updateLocale("en",c);}return t=!!((s=(s=!0)&&function(){try{(0).toLocaleString("i");}catch(e){return "RangeError"===e.name}return !1}())&&(s=(s=(s=s&&"1"===1..toLocaleString("en",{minimumIntegerDigits:1}))&&"01"===1..toLocaleString("en",{minimumIntegerDigits:2}))&&"001"===1..toLocaleString("en",{minimumIntegerDigits:3}))&&(s=(s=(s=(s=s&&"100"===99.99.toLocaleString("en",{maximumFractionDigits:0,minimumFractionDigits:0}))&&"100.0"===99.99.toLocaleString("en",{maximumFractionDigits:1,minimumFractionDigits:1}))&&"99.99"===99.99.toLocaleString("en",{maximumFractionDigits:2,minimumFractionDigits:2}))&&"99.990"===99.99.toLocaleString("en",{maximumFractionDigits:3,minimumFractionDigits:3}))&&(s=(s=(s=(s=(s=s&&"100"===99.99.toLocaleString("en",{maximumSignificantDigits:1}))&&"100"===99.99.toLocaleString("en",{maximumSignificantDigits:2}))&&"100"===99.99.toLocaleString("en",{maximumSignificantDigits:3}))&&"99.99"===99.99.toLocaleString("en",{maximumSignificantDigits:4}))&&"99.99"===99.99.toLocaleString("en",{maximumSignificantDigits:5}))&&(s=(s=s&&"1,000"===1e3.toLocaleString("en",{useGrouping:!0}))&&"1000"===1e3.toLocaleString("en",{useGrouping:!1}))),n=t&&"3.6"===3.55.toLocaleString("en",{useGrouping:!1,minimumIntegerDigits:1,minimumFractionDigits:1,maximumFractionDigits:1}),D(e),D},o=[n(1)],void 0===(i="function"==typeof(r=l)?r.apply(t,o):r)||(e.exports=i),a&&(a.momentDurationFormatSetup=a.moment?l(a.moment):l);},function(e,t,n){n.r(t);var r=n(2),o=n.n(r),i=n(0),a=n.n(i),l=n(1),u=n.n(l);n(5);function s(e){return (s="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function c(e,t){if(null==e)return {};var n,r,o=function(e,t){if(null==e)return {};var n,r,o={},i=Object.keys(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(e,n)&&(o[n]=e[n]);}return o}function m(e){return (m=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function f(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function p(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r);}}function g(e,t,n){return t&&p(e.prototype,t),n&&p(e,n),e}function y(e,t){return (y=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function h(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}n.d(t,"default",function(){return S});var d=[a.a.string,a.a.number,a.a.array,a.a.object],v=[a.a.string,a.a.array],b=[a.a.object,a.a.bool],S=function(e){function t(e){var n,r,o;return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t),r=this,o=m(t).call(this,e),n=!o||"object"!==s(o)&&"function"!=typeof o?f(r):o,h(f(n),"setTimer",function(){var e=n.props.interval;n.clearTimer(),t.pooledTimer||0===e||(n.timer=setInterval(function(){n.update(n.props);},e));}),h(f(n),"getTitle",function(){var e=n.props.titleFormat,r=t.getDatetime(n.props),o=e||t.globalFormat;return r.format(o)}),h(f(n),"clearTimer",function(){!t.pooledTimer&&n.timer&&(clearInterval(n.timer),n.timer=null),t.pooledTimer&&!n.timer&&t.removePooledElement(f(n));}),t.globalMoment||(t.globalMoment=u.a),n.state={content:""},n.timer=null,n}return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&y(e,t);}(t,o.a.Component),g(t,null,[{key:"startPooledTimer",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:6e4;t.clearPooledTimer(),t.pooledTimer=setInterval(function(){t.pooledElements.forEach(function(e){0!==e.props.interval&&e.update();});},e);}},{key:"clearPooledTimer",value:function(){t.pooledTimer&&(clearInterval(t.pooledTimer),t.pooledTimer=null,t.pooledElements=[]);}},{key:"pushPooledElement",value:function(e){e instanceof t?-1===t.pooledElements.indexOf(e)&&t.pooledElements.push(e):console.error("Element not an instance of Moment.");}},{key:"removePooledElement",value:function(e){var n=t.pooledElements.indexOf(e);-1!==n&&t.pooledElements.splice(n,1);}},{key:"getDatetime",value:function(e){var n=e.utc,r=e.unix,o=e.date,i=e.locale,a=e.parse,l=e.tz,u=e.local;o=o||e.children,a=a||t.globalParse,u=u||t.globalLocal,l=l||t.globalTimezone,i=t.globalLocale?t.globalLocale:i||t.globalMoment.locale();var s=null;return s=n?t.globalMoment.utc(o,a,i):r?t.globalMoment(1e3*o,a,i):t.globalMoment(o,a,i),l?s=s.tz(l):u&&(s=s.local()),s}},{key:"getContent",value:function(e){var n=e.fromNow,r=e.fromNowDuring,o=e.from,i=e.add,a=e.subtract,l=e.toNow,s=e.to,c=e.ago,m=e.calendar,f=e.diff,p=e.duration,g=e.durationFromNow,y=e.unit,h=e.decimal,d=e.format;d=d||t.globalFormat;var v=t.getDatetime(e);i&&v.add(i),a&&v.subtract(a);var b=Boolean(r)&&-v.diff(u()())<r,S="";return S=d&&!b?v.format(d):o?v.from(o,c):n||b?v.fromNow(c):s?v.to(s,c):l?v.toNow(c):m?v.calendar(null,m):f?v.diff(f,y,h):p?v.diff(p):g?u()().diff(v):v.toString(),(p||g)&&(S=(S=u.a.duration(S)).format(d)),S=(t.globalFilter||e.filter)(S)}}]),g(t,[{key:"componentDidMount",value:function(){this.setTimer(),t.pooledTimer&&t.pushPooledElement(this);}},{key:"componentDidUpdate",value:function(e){var t=this.props.interval;e.interval!==t&&this.setTimer();}},{key:"componentWillUnmount",value:function(){this.clearTimer();}},{key:"update",value:function(e){var n=e||this.props,r=n.onChange,o=t.getContent(n);this.setState({content:o},function(){r(o);});}},{key:"render",value:function(){var e,n,r,i,a=this.props,l=a.withTitle,u=a.element,s=c(a,["withTitle","element"]),m=this.state.content,f=(e=s,n=t.propTypes,r=Object.keys(n),i=Object.assign({},e),Object.keys(i).filter(function(e){return -1!==r.indexOf(e)}).forEach(function(e){return delete i[e]}),i);return l&&(f.title=this.getTitle()),o.a.createElement(u||t.globalElement,function(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{},r=Object.keys(n);"function"==typeof Object.getOwnPropertySymbols&&(r=r.concat(Object.getOwnPropertySymbols(n).filter(function(e){return Object.getOwnPropertyDescriptor(n,e).enumerable}))),r.forEach(function(t){h(e,t,n[t]);});}return e}({dateTime:t.getDatetime(this.props)},f),m)}}],[{key:"getDerivedStateFromProps",value:function(e){return {content:t.getContent(e)}}}]),t}();h(S,"propTypes",{element:a.a.any,date:a.a.oneOfType(d),parse:a.a.oneOfType(v),format:a.a.string,add:a.a.object,subtract:a.a.object,ago:a.a.bool,fromNow:a.a.bool,fromNowDuring:a.a.number,from:a.a.oneOfType(d),toNow:a.a.bool,to:a.a.oneOfType(d),calendar:a.a.oneOfType(b),unix:a.a.bool,utc:a.a.bool,local:a.a.bool,tz:a.a.string,withTitle:a.a.bool,titleFormat:a.a.string,locale:a.a.string,interval:a.a.number,diff:a.a.oneOfType(d),duration:a.a.oneOfType(d),durationFromNow:a.a.bool,unit:a.a.string,decimal:a.a.bool,filter:a.a.func,onChange:a.a.func}),h(S,"defaultProps",{element:null,fromNow:!1,toNow:!1,calendar:!1,ago:!1,unix:!1,utc:!1,local:!1,unit:null,withTitle:!1,decimal:!1,titleFormat:"",interval:6e4,filter:function(e){return e},onChange:function(){}}),h(S,"globalMoment",null),h(S,"globalLocale",null),h(S,"globalLocal",null),h(S,"globalFormat",null),h(S,"globalParse",null),h(S,"globalFilter",null),h(S,"globalElement","time"),h(S,"globalTimezone",null),h(S,"pooledElements",[]),h(S,"pooledTimer",null);}])});
});

var Moment = unwrapExports$1(dist);

var es = createCommonjsModule$1(function (module, exports) {
(function (global, factory) {
    typeof commonjsRequire === 'function' ? factory(moment) :
   
   factory(global.moment);
}(commonjsGlobal, (function (moment) {
    //! moment.js locale configuration

    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
            '_'
        ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    return es;

})));
});

var css$3 = "\n\n@media only screen and (max-width: 768px) {\n    .styles_messagesContainer__3BTwe {\n        padding-bottom: 90px;\n    }\n}\n\n.styles_pdfBox__3P8kr {\n    background-image: url(data:image/png;base64,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);\n    width: 70px;\n    height: 80px;\n    margin: 5px 0 5px 0;\n    background-size: cover;\n    cursor: pointer;\n}\n\n.styles_clickWrapper__17pOK {\n  min-height: 100px;\n}\n\n.styles_clickWrapper__17pOK:hover {\n    cursor: pointer;\n}\n\n.styles_messagesContainer__3BTwe img {\n    width: 100%;\n    border-radius: 8px;\n    cursor: pointer;\n}\n\n.styles_messagesContainer__3BTwe img:hover {\n    box-shadow: azure 2px 3px 2px;\n}\n\n.styles_upButton__3Wn4S {\n    height: 40px;\n    width: 30px;\n    z-index: 999999999999999;\n    background: #4eaa38;\n    background-image:  url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAANCAYAAABGkiVgAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAADgSURBVDiNndExSkNBFIXhMdFOosaIKLo6wU24AU0hWAjBiIiVVdaQFCkixqiICKKNC/kskgHzmMl78cBp7r3nv8zcgFDiDbTxhQsclGWqAEfm9Y3D/0I38SCtT+wvC93CYwYY9YHdqtAmxiXAqDfslEGbeMoA3jP1l1kuCd3GJBO8Qx3nmf7Y9AZz0BaeM4Fb1P4sv8zMjdCI0BZeM4M3BWDACrqZ+SHWw4InXc8AqWPWTL8kpdOAn0TjagEwuo77RHYS0CkUOxWA0avoFfLtgD2coY+jJYDRazjGACdo/AIUdaej/xEeHAAAAABJRU5ErkJggg==');\n    background-position: center center;\n    background-repeat: no-repeat;\n    opacity: 1;\n    cursor: pointer;\n    display: inline-block;\n    box-shadow: 5px 5px 15px 5px rgba(0,0,0,0.14);\n    border-radius: 4px;\n}\n\n.styles_showLastOptions__2EyN2 {\n  font-family: 'Montserrat Light', arial;\n  font-size: 14px;\n  background-color: grey;\n  width: auto;\n  display: inline-block;\n  padding: 0.5em;\n  cursor: pointer;\n  border-radius: 4px;\n  box-shadow: 0 2px 1px rgba(0, 0, 0, 0.08);\n  display: inline-flex;\n  text-align: center;\n  flex: initial;\n  height: 30px;\n  color: white;\n}\n\n.styles_arrowOpen__2IlJ9 {\n  height: 20px;\n  width: 20px;\n  color: white;\n  background-image: url(data:image/png;base64,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);\n  background-size: contain;\n  display: flex;\n  margin-right: 10px;\n}\n";
var styles$5 = {"messagesContainer":"styles_messagesContainer__3BTwe","pdfBox":"styles_pdfBox__3P8kr","clickWrapper":"styles_clickWrapper__17pOK","upButton":"styles_upButton__3Wn4S","showLastOptions":"styles_showLastOptions__2EyN2","arrowOpen":"styles_arrowOpen__2IlJ9"};
styleInject(css$3);

function generateKey() {
    return Math.round(Math.random() * 1090390904345);
}

var Buttons = /** @class */ (function (_super) {
    __extends(Buttons, _super);
    function Buttons() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Buttons.prototype.render = function () {
        var btnList = [];
        var _a = this.props, handleClickOnCard = _a.handleClickOnCard, numberOfValuesPerItem = _a.numberOfValuesPerItem, orderedValues = _a.orderedValues, showNoneAbove = _a.showNoneAbove, noneAbove = _a.noneAbove, isH1Buttons = _a.isH1Buttons, theme = _a.theme;
        var _loop_1 = function (index) {
            var labelValues = "" + orderedValues[index].value;
            btnList.push(createElement("button", { className: isH1Buttons ? theme.rtButtonEmoji : theme.rtButton, key: generateKey(), onClick: function () { return handleClickOnCard(orderedValues[index].value, false); } }, labelValues));
        };
        for (var index = 0; index < numberOfValuesPerItem; index++) {
            _loop_1(index);
        }
        var existSiorNot = false;
        var existsShowAgain = false;
        var existsNoInfo = false;
        for (var index = 0; index < numberOfValuesPerItem; index++) {
            var lowerCased = orderedValues[index].value.toLocaleLowerCase();
            if (lowerCased === "si")
                existSiorNot = true;
            if (lowerCased === 'no')
                existSiorNot = true;
            if (lowerCased === 'si, quiero volver a ver el contenido')
                existsShowAgain = true;
            if (lowerCased === 'he leído el contenido, pero no encuentro la información que busco')
                existsNoInfo = true;
        }
        if (!existSiorNot && !existsShowAgain && !existsNoInfo && showNoneAbove && noneAbove) {
            btnList.push(createElement("button", { className: theme.rtButton, key: Date.now() + Math.floor(Math.random() * 1000), onClick: function () { return handleClickOnCard('Ninguna de las anteriores', true); } }, "Ninguna de las anteriores"));
        }
        if (existsShowAgain && existsNoInfo) {
            btnList = [];
            btnList.push(createElement("button", { className: theme.rtButton, key: Date.now() + Math.floor(Math.random() * 1000), onClick: function () { return handleClickOnCard('Si, quiero volver a ver el contenido', false); } }, "Si, quiero volver a ver el contenido"));
            btnList.push(createElement("button", { className: theme.rtButton, key: Date.now() + Math.floor(Math.random() * 1000), onClick: function () { return handleClickOnCard('He leído el contenido, pero no encuentro la información que busco', false); } }, "He le\u00EDdo el contenido, pero no encuentro la informaci\u00F3n que busco"));
        }
        return btnList;
    };
    return Buttons;
}(Component));

var SmallTemplate = /** @class */ (function (_super) {
    __extends(SmallTemplate, _super);
    function SmallTemplate() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SmallTemplate.prototype.createProperties = function (numberOfValuesPerItem, orderedValues) {
        var propList = [];
        for (var index = 0; index < numberOfValuesPerItem; index++) {
            if (index > orderedValues.length - 1)
                break;
            if (orderedValues[index].label !== 'displayName' && orderedValues[index].label !== 'displayOrder') {
                propList.push(createElement("p", { key: index + Date.now() },
                    createElement("strong", null,
                        orderedValues[index].label,
                        ":"),
                    " ",
                    orderedValues[index].value));
            }
        }
        return propList;
    };
    SmallTemplate.prototype.render = function () {
        var _a = this.props, isWithPicture = _a.isWithPicture, cardDisplayName = _a.cardDisplayName, numberOfValuesPerItem = _a.numberOfValuesPerItem, orderedValues = _a.orderedValues, handleClickOnCard = _a.handleClickOnCard, cardPicture = _a.cardPicture, theme = _a.theme;
        return (createElement("div", { className: theme.smallCard, onClick: function () { return handleClickOnCard(cardDisplayName); } },
            isWithPicture ? (createElement("img", { src: cardPicture, alt: "avatar", className: theme.smallImageCard })) : (createElement(Fragment, null)),
            createElement("div", { className: theme.container },
                createElement("div", { className: theme.displayName }, cardDisplayName),
                this.createProperties(numberOfValuesPerItem, orderedValues))));
    };
    return SmallTemplate;
}(Component));

var BigTemplate = /** @class */ (function (_super) {
    __extends(BigTemplate, _super);
    function BigTemplate() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BigTemplate.prototype.createProperties = function (numberOfValuesPerItem, orderedValues) {
        var propList = [];
        for (var index = 0; index < numberOfValuesPerItem; index++) {
            propList.push(createElement("p", { key: index + Date.now() },
                createElement("strong", null,
                    orderedValues[index].label,
                    ":"),
                " ",
                orderedValues[index].value));
        }
        return propList;
    };
    BigTemplate.prototype.render = function () {
        var _a = this.props, isWithPicture = _a.isWithPicture, cardDisplayName = _a.cardDisplayName, numberOfValuesPerItem = _a.numberOfValuesPerItem, orderedValues = _a.orderedValues, handleClickOnCard = _a.handleClickOnCard, cardPicture = _a.cardPicture, theme = _a.theme;
        return (createElement("div", { className: theme.card },
            (isWithPicture) ? (createElement("img", { src: cardPicture, alt: "avatar", className: theme.imageCard, onClick: function () { return handleClickOnCard(cardDisplayName); } })) : (createElement(Fragment, null)),
            createElement("div", { className: theme.container },
                createElement("span", { className: theme.displayName },
                    createElement("b", null, cardDisplayName)),
                this.createProperties(numberOfValuesPerItem, orderedValues))));
    };
    return BigTemplate;
}(Component));

var sortBy = require('lodash.sortby');
var Cards = /** @class */ (function (_super) {
    __extends(Cards, _super);
    function Cards() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Cards.prototype.render = function () {
        var _a = this.props, template = _a.template, values = _a.values, handleClickOnCard = _a.handleClickOnCard, showNoneAbove = _a.showNoneAbove, noneAbove = _a.noneAbove, isH1Buttons = _a.isH1Buttons, theme = _a.theme;
        var templateName = template.split('-')[0];
        var numberOfValuesPerItem;
        var orderedValues = sortBy(values, ['displayRelevance']);
        var cardToRender;
        var listOfCardsToRender = [];
        var cardPicture;
        var cardDisplayName;
        if (templateName.indexOf('buttons:') !== -1 || templateName === 'defaultTemplate')
            numberOfValuesPerItem = values.length;
        else
            numberOfValuesPerItem = template.split('-')[1];
        if (templateName.indexOf('buttons') !== -1 || templateName === 'defaultTemplate') {
            cardToRender = (createElement("div", { key: generateKey(), className: theme.buttonsContainer },
                createElement(Buttons, { numberOfValuesPerItem: numberOfValuesPerItem, orderedValues: orderedValues, handleClickOnCard: this.props.handleClickOnCard, showNoneAbove: showNoneAbove, noneAbove: noneAbove, isH1Buttons: isH1Buttons, theme: theme })));
        }
        else {
            // Entrypoint for cards:
            // ---------------------
            values.forEach(function (card) {
                orderedValues = (typeof card === 'object') ? card : sortBy(card, ['displayRelevance']);
                console.log('orderedValues: ', orderedValues);
                orderedValues.forEach(function (_value, index) {
                    if (_value.label === 'displayName') {
                        cardDisplayName = _value.value;
                    }
                    if (_value.label === 'picture') {
                        cardPicture = _value.value;
                    }
                });
                if (templateName.indexOf('small') !== -1) {
                    listOfCardsToRender.push(createElement(SmallTemplate, { key: generateKey(), cardDisplayName: cardDisplayName, cardPicture: cardPicture, handleClickOnCard: handleClickOnCard, numberOfValuesPerItem: numberOfValuesPerItem, orderedValues: orderedValues, isWithPicture: (templateName === 'smallPicture'), theme: theme }));
                }
                if (templateName.indexOf('big') !== -1) {
                    listOfCardsToRender.push(createElement(BigTemplate, { key: generateKey(), cardDisplayName: cardDisplayName, cardPicture: cardPicture, handleClickOnCard: handleClickOnCard, numberOfValuesPerItem: numberOfValuesPerItem, orderedValues: orderedValues, isWithPicture: (templateName === 'bigPicture'), theme: theme }));
                }
            });
        }
        var toReturn;
        if (cardToRender)
            toReturn = cardToRender;
        else if (!cardToRender && listOfCardsToRender.length)
            toReturn = listOfCardsToRender;
        else
            toReturn = (createElement(Fragment, null));
        return (toReturn);
    };
    return Cards;
}(Component));

var css$4 = ".styles_App-logo__yTypz {\n  animation: styles_App-logo-spin__xSyl9 infinite 20s linear;\n  height: 40vmin;\n  pointer-events: none;\n}\n\n.styles_image__1eNbx{\n  width: 100%;\n  height: 100%;\n  background: no-repeat center;\n  background-size: cover;\n  overflow: hidden;\n  padding-bottom: 100%;\n}\n\n.styles_wrapperLarge__parSo{\n  flex-direction: column;\n  width: 100%;\n  font-weight: 400;\n  hyphens: auto;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  min-height: 200px;\n  background: #fff;\n  border: 0.5px solid rgba(0, 0, 0, 0.02);\n  box-shadow: 0 2px 1px rgba(0, 0, 0, 0.08);\n  max-width: 70%;\n  display: inline-block;\n  text-align: left;\n  margin-top: 5px;\n  margin-bottom: 5px;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.styles_imgWrapperLarge__3DdEc{\n  height: 80%;\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n}\n\n.styles_textWrapperLarge__9Hhlh{\n  padding: 10px 10px;\n  color: #000;\n  font-size: 13px;\n}\n\n.styles_textWrapperLarge__9Hhlh p {\n  margin-top: 2em;\n}\n\n.styles_siteNameLinkWrapper__2K3Tj{\n  max-height: 2.8em;\n  color: #000;\n  font-weight: 700;\n}\n\n\n\n@media (min-width: 360px){\n  .styles_siteNameLinkWrapper__2K3Tj{\n    font-size: 14px;\n  }\n  .styles_responsiveVideo__3tsvy{\n    min-height: 202px;\n  }\n}\n\n@media (min-width: 460px){\n  .styles_textWrapperLarge__9Hhlh {\n    font-size: 14px;\n  }\n  .styles_textWrapperSmall__1FE6v {\n    font-size: 12px;\n  }\n  .styles_siteNameLinkWrapper__2K3Tj{\n    font-size: 15px;\n  }\n  .styles_wrapperLarge__parSo{\n    max-width: 400px;\n  }\n  .styles_outerWrapperSmall__VTmVK{\n    min-width: 360px;\n    width: 360px;\n  }\n  .styles_responsiveVideo__3tsvy{\n    min-height: 258px;\n  }\n}\n\n@media (min-width: 600px){\n  .styles_textWrapperLarge__9Hhlh {\n    font-size: 15px;\n  }\n  .styles_textWrapperSmall__1FE6v {\n    font-size: 13px;\n  }\n  .styles_siteNameLinkWrapper__2K3Tj{\n    font-size: 17px;\n  }\n  .styles_wrapperLarge__parSo{\n    max-width: 600px;\n  }\n  .styles_outerWrapperSmall__VTmVK{\n    min-width: 600px;\n    width: 600px;\n  }\n  .styles_responsiveVideo__3tsvy{\n    min-height: 337px;\n  }\n}\n\n\n\n.styles_responsiveImage__2wSso{\n  width: 100%;\n  height: auto;\n  border-radius: 8px 8px 0 0 !important;\n}\n\n";
var styles$6 = {"App-logo":"styles_App-logo__yTypz","App-logo-spin":"styles_App-logo-spin__xSyl9","image":"styles_image__1eNbx","wrapperLarge":"styles_wrapperLarge__parSo","imgWrapperLarge":"styles_imgWrapperLarge__3DdEc","textWrapperLarge":"styles_textWrapperLarge__9Hhlh","siteNameLinkWrapper":"styles_siteNameLinkWrapper__2K3Tj","responsiveVideo":"styles_responsiveVideo__3tsvy","textWrapperSmall":"styles_textWrapperSmall__1FE6v","outerWrapperSmall":"styles_outerWrapperSmall__VTmVK","responsiveImage":"styles_responsiveImage__2wSso"};
styleInject(css$4);

var Snippets = /** @class */ (function (_super) {
    __extends(Snippets, _super);
    function Snippets(props) {
        var _this = _super.call(this, props) || this;
        _this.renderLarge = function (resultsToUse) {
            var feature = null;
            if (resultsToUse.image !== '') {
                feature = (createElement("div", { className: styles$6.imgWrapperLarge },
                    createElement("img", { className: styles$6.responsiveImage, src: resultsToUse.image, alt: 'alt' })));
            }
            else
                feature = (createElement(Fragment, null));
            return (createElement("div", { className: styles$6.wrapperLarge, onClick: function () {
                    _this.props.onClick();
                } },
                feature,
                createElement("div", { className: styles$6.textWrapperLarge },
                    createElement("div", { className: styles$6.siteNameLinkWrapper },
                        createElement("a", null, resultsToUse.title)),
                    createElement("div", { className: styles$6.titleWrapper }),
                    createElement("p", null, resultsToUse.title !== resultsToUse.description ? resultsToUse.description : ''))));
        };
        _this.state = {
            error: false,
            result: {
                openGraph: {
                    site_name: '',
                    title: '',
                    url: '',
                    description: '',
                    image: {
                        url: ''
                    }
                },
                htmlInferred: {
                    site_name: '',
                    title: '',
                    url: '',
                    favicon: '',
                    description: '',
                    products: '',
                    image: {
                        url: ''
                    }
                },
                hybridGraph: {
                    site_name: '',
                    title: '',
                    url: '',
                    favicon: '',
                    description: '',
                    products: '',
                    image: {
                        url: ''
                    }
                }
            }
        };
        return _this;
    }
    Snippets.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this.props, cachedSnippetsResults = _a.cachedSnippetsResults, site = _a.site, updateCachedResults = _a.updateCachedResults;
        var acceptLang = 'auto';
        var appId = '1c9fcd26-3169-4554-9e7c-6c9f9d1831bc';
        var _site = encodeURIComponent(site);
        var url = "https://opengraph.io/api/1.1/site/" + _site + "?accept_lang" + acceptLang + "&app_id=" + appId + "&cache_ok=true&max_cache_age=7200000";
        if (cachedSnippetsResults[url]) {
            this.setState({ result: cachedSnippetsResults[url] });
        }
        else {
            fetch(url)
                .then(function (res) { return res.json(); })
                .then(function (result) {
                if (!result.error) {
                    _this.setState({ result: result });
                    updateCachedResults(url, result);
                }
                else {
                    console.error(result);
                }
            });
        }
    };
    Snippets.prototype.getResultsToUse = function () {
        var _a = this.state.result, openGraph = _a.openGraph, htmlInferred = _a.htmlInferred, hybridGraph = _a.hybridGraph;
        // protect against null values
        openGraph = openGraph || {};
        htmlInferred = htmlInferred || {};
        hybridGraph = hybridGraph || {};
        var site_name = openGraph.site_name || htmlInferred.site_name || hybridGraph.site_name;
        var title = openGraph.title || htmlInferred.title || hybridGraph.title;
        var url = openGraph.url || htmlInferred.url || hybridGraph.url;
        var favicon = htmlInferred.favicon || hybridGraph.favicon;
        var description = openGraph.description || htmlInferred.description || hybridGraph.description;
        var image;
        if (openGraph.image) {
            image = openGraph.image.url;
        }
        else {
            image = htmlInferred.image || hybridGraph.image;
        }
        return {
            site_name: site_name,
            title: title,
            url: url,
            favicon: favicon,
            image: image,
            description: description
        };
    };
    Snippets.prototype.render = function () {
        var resultsToUse = this.getResultsToUse();
        if (!resultsToUse.image)
            console.log('imagen no cargada todavia!!!');
        return this.renderLarge(resultsToUse);
    };
    return Snippets;
}(Component));

var Collapsable = /** @class */ (function (_super) {
    __extends(Collapsable, _super);
    function Collapsable(props) {
        var _this = _super.call(this, props) || this;
        var state = _this.readStateFromLS(props.id, {
            isOpen: false,
            show: false,
            allChildrens: props.children,
            elemToShow: [],
            groups: props.children.length / 2,
            nextGroupToShow: 1,
            lastGroup: false,
            firstIndex: 0,
            secondIndex: 1,
            elementRemaining: props.children.length / 2,
        });
        var elemToShow = [];
        if (state.nextGroupToShow > 1) {
            for (var index = 0; index < state.nextGroupToShow * 2; index++) {
                elemToShow.push(props.children[index]);
            }
        }
        _this.state = {
            nextGroupToShow: state.nextGroupToShow,
            isOpen: state.isOpen,
            show: state.show,
            groups: state.groups,
            lastGroup: state.lastGroup,
            firstIndex: state.firstIndex,
            secondIndex: state.secondIndex,
            elementRemaining: state.elementRemaining,
            allChildrens: props.children,
            elemToShow: elemToShow,
        };
        return _this;
    }
    Collapsable.prototype.saveStateLocalStorage = function (id, state) {
        window.localStorage.setItem(id + "_collapseItem_", JSON.stringify(state));
    };
    Collapsable.prototype.readStateFromLS = function (id, defaultState) {
        var state = window.localStorage.getItem(id + "_collapseItem_");
        return state ? JSON.parse(state) : defaultState;
    };
    Collapsable.prototype.viewMore = function () {
        var _a = this.state, groups = _a.groups, nextGroupToShow = _a.nextGroupToShow, elemToShow = _a.elemToShow, allChildrens = _a.allChildrens, firstIndex = _a.firstIndex, secondIndex = _a.secondIndex, elementRemaining = _a.elementRemaining;
        this.setState({
            isOpen: true,
        });
        if (nextGroupToShow <= groups) {
            var objToSave = {
                elemToShow: elemToShow.concat([allChildrens[firstIndex], allChildrens[secondIndex]]),
                nextGroupToShow: nextGroupToShow + 1,
                firstIndex: firstIndex + 2,
                secondIndex: secondIndex + 2,
                lastGroup: (nextGroupToShow + 1 > groups) ? true : false,
                elementRemaining: elementRemaining - 1,
                isOpen: true,
                show: true,
            };
            this.setState(__assign({}, objToSave));
            this.saveStateLocalStorage(this.props.id, __assign({}, objToSave));
        }
        else {
            this.setState({
                lastGroup: true,
            });
        }
    };
    Collapsable.prototype.componentDidMount = function () {
        this.setState({
            show: true
        });
    };
    Collapsable.prototype.render = function () {
        var _this = this;
        var theme = this.props.theme;
        var _a = this.state, show = _a.show, elemToShow = _a.elemToShow, lastGroup = _a.lastGroup, isOpen = _a.isOpen, elementRemaining = _a.elementRemaining;
        var moreButton;
        var contentToShow;
        if (lastGroup)
            moreButton = (createElement(Fragment, null));
        else {
            moreButton = (createElement("div", { onClick: function () { _this.viewMore(); }, className: theme.buttonCloseColl },
                createElement("div", { className: theme.arrowClose }),
                createElement("div", { className: theme.textMoreInfo },
                    elementRemaining,
                    " m\u00E1s...")));
        }
        if (isOpen)
            contentToShow = elemToShow;
        else
            contentToShow = (createElement(Fragment, null));
        if (show) {
            return (createElement("div", { className: theme.wrapper },
                createElement("div", { className: theme.open }, contentToShow),
                moreButton));
        }
        else {
            return (createElement(Fragment, null));
        }
    };
    return Collapsable;
}(Component));

var css$5 = ".styles_cardPdf__36gNt {\n  background: #fff;\n  padding: 12px 18px;\n  border: 0.5px solid rgba(0, 0, 0, 0.02);\n  box-shadow: 0 2px 1px rgba(0, 0, 0, 0.08);\n  max-width: 70%;\n  display: inline-block;\n  text-align: left;\n  font-size: 14px;\n  margin-top: 5px;\n  margin-bottom: 5px;\n  border-radius: 8px;\n}\n\n.styles_cardPdf__36gNt > a > img {\n  width: 16px;\n}\n\n.styles_cardPdf__36gNt > a {\n  text-decoration: none;\n  cursor: pointer;\n}\n";
var styles$7 = {"cardPdf":"styles_cardPdf__36gNt"};
styleInject(css$5);

var PdfRenderer = function (_a) {
    var pdfUrl = _a.pdfUrl;
    var parts = pdfUrl.split('/');
    var filename = parts[parts.length - 1].replace(/_/g, ' ');
    var fileExtension = pdfUrl.toLocaleLowerCase().indexOf('.pdf') !== -1;
    return (createElement("div", { className: styles$7.cardPdf },
        fileExtension ? createElement("embed", { src: pdfUrl + "#page=1&toolbar=0&navpanes=0&scrollbar=0&view=fitH,100", type: "application/pdf", width: "100%" }) : createElement(Fragment, null),
        createElement("br", null),
        createElement("a", { href: pdfUrl, target: "_blank" },
            createElement("img", { src: "https://img.icons8.com/small/16/000000/download.png" }),
            " ",
            fileExtension ? filename : 'Descargar pdf')));
};

var Messages = /** @class */ (function (_super) {
    __extends(Messages, _super);
    function Messages(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            userSaysRef: createRef(),
            cachedSnippetsResults: {},
        };
        return _this;
    }
    Messages.prototype.onClickInMsg = function (url) {
        window.open(url, '_blank');
    };
    Messages.prototype.onClickUp = function () {
        this.state.userSaysRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });
    };
    Messages.prototype.updateCachedResults = function (url, result) {
        var updatedCacheObj = __assign({}, this.state.cachedSnippetsResults);
        updatedCacheObj[url] = result;
        this.setState({ cachedSnippetsResults: updatedCacheObj });
    };
    Messages.prototype.componentDidMount = function () {
        for (var index = 0; index < 150; index++) {
            var key = index + "_collapseItem_";
            window.localStorage.removeItem(key);
        }
    };
    Messages.prototype.onUpdateMessages = function () {
        var _this = this;
        var msgToRender = [];
        var messagesToCollapse = [];
        var collapsableIndexes = [];
        var _a = this.props, messages = _a.messages, theme = _a.theme, lang = _a.lang, toScrollBottom = _a.toScrollBottom, lastCards = _a.lastCards, noneAbove = _a.noneAbove;
        var cachedSnippetsResults = this.state.cachedSnippetsResults;
        // Find collapsable items
        for (var index = 0; index < messages.length; index++) {
            var msg = messages[index];
            if (msg.type === 'snippet' || msg.type === 'image' || msg.type === 'pdf') {
                if (messages[index - 2]) {
                    if (messages[index - 2].type === 'snippet' || messages[index - 2].type === 'image' || messages[index - 2].type === 'pdf') {
                        collapsableIndexes.push(index - 1);
                        collapsableIndexes.push(index);
                    }
                }
            }
        }
        var _loop_1 = function (i) {
            var msg = messages[i];
            var triggerTextOne = '012_survey._start_012_survey.text.cards';
            var triggerTextTwo = '012_router.012_agent.followUp.cards';
            if (messagesToCollapse.length && (msg.key === triggerTextOne || msg.key === triggerTextTwo)) {
                msgToRender.push(createElement(Collapsable, { theme: theme, key: generateKey(), id: i }, messagesToCollapse));
                messagesToCollapse = [];
            }
            var placeToRender = collapsableIndexes.indexOf(i) !== -1 ? messagesToCollapse : msgToRender;
            // messages only text
            if (!msg.timestamp && msg.cardValues.length === 0 && msg.text !== "" && (msg.type == 'received' || msg.type === 'sent')) {
                placeToRender.push(createElement("div", { className: (msg.type === 'sent') ? theme.messageSent : theme.messageReceived, key: generateKey() },
                    createElement("div", { key: generateKey(), ref: (msg.type === 'sent') ? this_1.state.userSaysRef : null, className: theme.bubble, dangerouslySetInnerHTML: { __html: msg.text } })));
            }
            // messages with text and endOfTurn
            if (msg.timestamp && msg.cardValues.length === 0 && msg.text !== "" && (msg.type == 'received' || msg.type === 'sent')) {
                placeToRender.push(createElement("div", { className: (msg.type === 'sent') ? theme.messageSent : theme.messageReceived, key: generateKey() },
                    createElement("div", { className: theme.timestamp },
                        createElement("div", { className: theme.time },
                            createElement(Moment, { locale: "es", date: msg.timestamp, fromNow: true })))));
            }
            // cards messages with only one option, generated by rt-system-appointments (msg.cardValues.length === 1)
            if ((msg.cardValues.length > 1 || (msg.cardValues.length === 1 && msg.text !== "")) && msg.type === 'card') {
                placeToRender.push(createElement(Cards, { key: generateKey(), template: msg.template, values: msg.cardValues, lang: lang, handleClickOnCard: this_1.props.handleClickOnCard, showNoneAbove: msg.showNoneAbove, noneAbove: noneAbove, isH1Buttons: msg.isH1Buttons, theme: theme }));
            }
            if (msg.type === 'snippet') {
                placeToRender.push(createElement(Snippets, { site: msg.url, cachedSnippetsResults: cachedSnippetsResults, updateCachedResults: this_1.updateCachedResults.bind(this_1), onClick: function () { return _this.onClickInMsg(msg.url); }, key: generateKey() }));
            }
            if (msg.type === 'pdf') {
                placeToRender.push(createElement(PdfRenderer, { pdfUrl: msg.url, key: generateKey() }));
            }
            if (msg.type === 'image') {
                placeToRender.push(createElement("img", { src: msg.url, alt: "recurso no encontrado", onClick: function () { return _this.onClickInMsg(msg.url); }, key: generateKey() }));
            }
            if (i === messages.length - 1 && messages[i - 1]) {
                if (messages[i - 1].type === 'received' && messages[i - 1].key === triggerTextTwo && lastCards.length) {
                    placeToRender.push(createElement("div", { className: theme.messageSent, key: generateKey() },
                        createElement("div", { className: styles$5.showLastOptions, onClick: function () { return _this.props.showLastOptions(); } },
                            createElement("div", { className: styles$5.arrowOpen }),
                            " ",
                            createElement("div", null, "Ver opciones anteriores"))));
                }
            }
        };
        var this_1 = this;
        for (var i = 0; i < messages.length; i++) {
            _loop_1(i);
        }
        setTimeout(function () { return toScrollBottom(); }, 1000);
        return msgToRender;
    };
    Messages.prototype.render = function () {
        return (createElement("div", { className: styles$5.messagesContainer }, this.onUpdateMessages()));
    };
    return Messages;
}(Component));

var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { hasError: false };
        return _this;
    }
    ErrorBoundary.getDerivedStateFromError = function () {
        return { hasError: true };
    };
    ErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        //logErrorToMyService(error, errorInfo);
        console.error(error);
        console.error(errorInfo);
    };
    ErrorBoundary.prototype.render = function () {
        if (this.state.hasError) { // You can render any custom fallback UI     
            return createElement("h1", null, "Something went wrong.");
        }
        return this.props.children;
    };
    return ErrorBoundary;
}(Component));

var _userMessage = function (props) {
    var response = props.response, currentMessages = props.currentMessages, addMessageToList = props.addMessageToList, state = props.state, getUrlFromText = props.getUrlFromText, renderAllMessages = props.renderAllMessages, channel = props.channel;
    if (response.template !== "webSnippet") {
        var expression = /<a[^>]* href=([^"]*)/g;
        var regex = new RegExp(expression);
        var result = response.text.match(regex);
        if (result) {
            currentMessages.push({
                type: "received",
                text: response.text,
                cardValues: [],
                key: response.key
            });
            addMessageToList(currentMessages, state.forceButtons);
        }
        else {
            var url = getUrlFromText(response.text);
            if (url && url.length > 0) {
                var transfomedUrlWithText = response.text.replace(url, "");
                transfomedUrlWithText =
                    transfomedUrlWithText +
                        (" <a href=\"" + url[0] + "\" target=\"_blank\">" + url[0] + "</a>");
                currentMessages.push({
                    type: "received",
                    text: transfomedUrlWithText,
                    cardValues: [],
                    key: response.key
                });
                addMessageToList(currentMessages, state.forceButtons);
            }
            else {
                currentMessages.push({
                    type: "received",
                    text: response.text,
                    cardValues: [],
                    key: response.key,
                });
                addMessageToList(currentMessages, state.forceButtons);
            }
        }
    }
    else {
        var result = getUrlFromText(response.text);
        result.forEach(function (url) {
            var cleanedText = response.text.replace(url, "");
            if (url.toLocaleLowerCase().indexOf(".pdf") !== -1) {
                currentMessages.push({
                    type: "received",
                    text: cleanedText,
                    cardValues: [],
                    key: response.key,
                });
                currentMessages.push({ type: "pdf", url: url, cardValues: [] });
            }
            else if (cleanedText.indexOf("(pdf)") !== -1) {
                var cleanedPdfUrlTag = cleanedText.replace("(pdf)", "");
                currentMessages.push({
                    type: "received",
                    text: cleanedPdfUrlTag,
                    cardValues: [],
                    key: response.key
                });
                currentMessages.push({ type: "pdf", url: url, cardValues: [] });
            }
            else if (url.indexOf(".jpg") !== -1) {
                currentMessages.push({
                    type: "received",
                    text: cleanedText,
                    cardValues: [],
                    key: response.key
                });
                currentMessages.push({ type: "image", url: url, cardValues: [] });
            }
            else {
                currentMessages.push({
                    type: "received",
                    text: cleanedText,
                    cardValues: [],
                    key: response.key
                });
                currentMessages.push({ type: "snippet", url: url, cardValues: [] });
            }
            addMessageToList(currentMessages, state.forceButtons);
        });
    }
    // render messages if courtesy msg is received
    if (response.courtesy)
        renderAllMessages();
    var allow = ['slack', 'desktop', 'voice'];
    if (allow.indexOf(channel) !== -1)
        renderAllMessages();
};
var _buttonsMessage = function (props) {
    var response = props.response, currentMessages = props.currentMessages, addMessageToList = props.addMessageToList, state = props.state;
    if (response.cards.length) {
        // cards messages with only one option, generated by rt-system-appointments (last condition)
        if (Array.isArray(response.cards[0]) && (response.cards.length > 1 || (response.cards.length === 1 && response.text !== ""))) {
            var groupedCards_1 = [];
            var showNoneAbove_1 = false;
            var isH1Buttons_1 = false;
            response.cards.forEach(function (cardArray) {
                cardArray.forEach(function (element) {
                    if (element.label === "displayName")
                        groupedCards_1.push(element);
                    if (response.template.indexOf("buttons:noneabove") != -1)
                        showNoneAbove_1 = true;
                    if (response.template.indexOf("buttons:h1") !== -1)
                        isH1Buttons_1 = true;
                });
            });
            currentMessages.push({
                type: "card",
                cardValues: groupedCards_1,
                template: response.template,
                showNoneAbove: showNoneAbove_1,
                isH1Buttons: isH1Buttons_1,
                key: response.key,
                text: response.text,
            });
        }
        else {
            currentMessages.push({
                type: "card",
                cardValues: response.cards,
                template: response.template,
                key: response.key,
                text: response.text,
            });
        }
        addMessageToList(currentMessages, state.forceButtons);
    }
};
var _cardsMessage = function (props) {
    var response = props.response, currentMessages = props.currentMessages, addMessageToList = props.addMessageToList, state = props.state;
    if (response.cards.length) {
        var showNoneAbove = false;
        var isH1Buttons = false;
        currentMessages.push({
            type: "card",
            cardValues: response.cards,
            template: response.template,
            showNoneAbove: showNoneAbove,
            isH1Buttons: isH1Buttons,
            key: response.key
        });
        addMessageToList(currentMessages, state.forceButtons);
    }
};
var _endOfTurn = function (props) {
    var currentMessages = props.currentMessages, addMessageToList = props.addMessageToList, state = props.state, renderAllMessages = props.renderAllMessages;
    currentMessages.push({
        type: "received",
        timestamp: Date.now(),
        cardValues: [],
    });
    addMessageToList(currentMessages, state.forceButtons);
    renderAllMessages();
};
var ReceivedMessage = function (props) {
    var response = props.response, setState = props.setState;
    if (response.type === "user")
        _userMessage(props);
    if (response.cards && response.template.indexOf('buttons') !== -1)
        _buttonsMessage(props);
    if (response.cards && response.template.indexOf('defaultTemplate') !== -1)
        _buttonsMessage(props);
    if (response.cards && response.template.indexOf('small') !== -1)
        _cardsMessage(props);
    if (!response.content)
        return void 0;
    if (response.content.code === "endOfTurn")
        return _endOfTurn(props);
    if (response.content.code === "Hangup")
        return setState({ forceButtons: true });
    if (response.content.code === "webChatTextInput")
        return setState({ forceButtons: !response.content.data });
};

/**
 * @class ChatBox
 */
var styles$8 = StyleSheet$1.create({
    fadeinquick: {
        animationName: lib_56,
        animationDuration: '3s'
    }
});
var ChatBox = /** @class */ (function (_super) {
    __extends(ChatBox, _super);
    function ChatBox(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        _this.scrollToBottom = function () {
            var node = _this.messageListRef.current;
            var scrollHeight = node.scrollHeight;
            var height = node.clientHeight;
            var maxScrollTop = scrollHeight - height;
            node.scrollTop = maxScrollTop > 0 ? maxScrollTop : 0;
        };
        _this.state = {
            messages: [],
            temporalMessages: [],
            currentText: '',
            openSettings: props.testMode,
            connected: false,
            entryPoint: props.entryPoint,
            title: props.title,
            forceButtons: false,
            userScroll: false,
            userScrollTime: null,
            lastCards: [],
            clickOnStartSurvey: false,
        };
        _this.messageListRef = createRef();
        _this.handleUserAddMessage.bind(_this);
        return _this;
    }
    ChatBox.prototype.componentDidMount = function () {
        if (!this.state.openSettings)
            this.handleConnect();
    };
    ChatBox.prototype.componentWillUnmount = function () {
        if (this.woiceDriver)
            this.woiceDriver.disconnect();
        clearInterval(this.scrollInterval);
    };
    ChatBox.prototype.getUrlFromText = function (text) {
        var expression = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/gi;
        var regex = new RegExp(expression);
        var result = text.match(regex) || [];
        return result;
    };
    ChatBox.prototype.receivedText = function (response) {
        return __awaiter(this, void 0, void 0, function () {
            var currentMessages;
            return __generator(this, function (_a) {
                currentMessages = this.state.temporalMessages.slice();
                if (response.type === 'Websockets' && response.content.event === 'connected') {
                    this.setState({
                        connected: true,
                    });
                }
                if (response.type === 'RemoteConfig') {
                    this.props.onRemoteConfig(response);
                }
                ReceivedMessage({
                    response: response,
                    setState: this.setState.bind(this),
                    currentMessages: currentMessages,
                    addMessageToList: this._addMessageToList.bind(this),
                    state: this.state,
                    getUrlFromText: this.getUrlFromText.bind(this),
                    renderAllMessages: this._renderAllMessages.bind(this),
                    channel: this.props.channel,
                });
                return [2 /*return*/];
            });
        });
    };
    ChatBox.prototype._addMessageToList = function (currentMessages, forceButtons) {
        this.setState({
            temporalMessages: currentMessages,
            forceButtons: forceButtons
        });
    };
    ChatBox.prototype._renderAllMessages = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, temporalMessages, messages;
            return __generator(this, function (_b) {
                try {
                    _a = this.state, temporalMessages = _a.temporalMessages, messages = _a.messages;
                    this.setState({
                        messages: messages.concat(temporalMessages),
                        temporalMessages: [],
                    });
                }
                catch (e) {
                    console.error(e);
                }
                return [2 /*return*/];
            });
        });
    };
    ChatBox.prototype.handleUserAddMessage = function (event) {
        if (event.key === "Enter" && event.target.value !== "") {
            var currentMessages = this.state.messages.slice();
            currentMessages.push({ text: event.target.value, type: 'sent', cardValues: [] });
            currentMessages.push({ type: 'sent', timestamp: Date.now(), cardValues: [] });
            this.woiceDriver.sendUserUtterance(event.target.value);
            this.setState({
                messages: currentMessages,
                currentText: "",
                lastCards: []
            });
            event.target.value = "";
        }
    };
    ChatBox.prototype.handleClickOnCard = function (textToSend, showNoneAbove) {
        this.woiceDriver.sendUserUtterance(textToSend);
        var messages = this.state.messages;
        var cleanedMessages = [];
        var templastCards = [];
        messages.forEach(function (msg) {
            if (msg.type !== "card")
                cleanedMessages.push(msg);
            else {
                var firstValue = msg.cardValues[0].value;
                if (firstValue !== 'No' && firstValue !== 'Sí' && msg.cardValues.length > 1) {
                    templastCards.push(msg);
                }
            }
        });
        cleanedMessages.push({ type: 'sent', text: textToSend, cardValues: [] });
        cleanedMessages.push({ type: 'sent', timestamp: Date.now(), cardValues: [] });
        this.setState({
            messages: cleanedMessages.slice(),
        });
        if (templastCards.length) {
            this.setState({
                lastCards: (showNoneAbove) ? [] : templastCards.slice(),
            });
        }
    };
    ChatBox.prototype.showLastOptions = function () {
        var _a = this.state, lastCards = _a.lastCards, messages = _a.messages;
        this.setState({
            messages: messages.concat(lastCards),
        });
    };
    ChatBox.prototype.onChangeInput = function (event) {
        this.setState({
            currentText: event.target.value,
        });
    };
    ChatBox.prototype.handleStartSurvey = function () {
        this.woiceDriver.sendUserUtterance('start_012_survey');
        this.setState({ clickOnStartSurvey: true });
    };
    ChatBox.prototype.handleConnect = function () {
        var _this = this;
        var _a = this.props, apiKey = _a.apiKey, channel = _a.channel, entryPoint = _a.entryPoint, lang = _a.lang, sourceValue = _a.sourceValue;
        if (apiKey === '' || channel === '') {
            return alert('No apiKey or channel or sourceValue');
        }
        var onReceiveEvent = {
            canHandle: function (handlerInput) {
                handlerInput.allow();
            },
            handle: function (handlerInput) {
                _this.receivedText(handlerInput);
            },
        };
        this.woiceDriver = DriverBuilders.config()
            .setStage(this.props.stage)
            .lang(lang)
            .addActionHandlers(onReceiveEvent)
            .connect(apiKey, channel, entryPoint, sourceValue)
            .noSpeechSynthesis()
            .start();
        this.setState({
            openSettings: false,
        });
    };
    ChatBox.prototype.handleBotSelection = function (e) {
        var _a = this.props, setChatSettings = _a.setChatSettings, botList = _a.botList;
        var botName;
        botList.forEach(function (bot) {
            if (bot.apiKey === e.target.value)
                botName = bot.name;
        });
        setChatSettings({
            sourceValue: false,
            apiKey: e.target.value,
            channel: false,
            botName: botName,
            lang: false,
        });
    };
    ChatBox.prototype.handleSourceValue = function (e) {
        var setChatSettings = this.props.setChatSettings;
        setChatSettings({
            sourceValue: e.target.value,
            apiKey: false,
            channel: false,
            lang: false,
        });
    };
    ChatBox.prototype.handleChannelSelection = function (e) {
        var setChatSettings = this.props.setChatSettings;
        setChatSettings({
            sourceValue: false,
            apiKey: false,
            channel: e.target.value,
            lang: false,
        });
    };
    ChatBox.prototype.handleGoToSettings = function () {
        var setChatSettings = this.props.setChatSettings;
        this.woiceDriver.disconnect();
        this.setState({
            connected: false,
            openSettings: true,
        });
        setChatSettings({
            sourceValue: false,
            apiKey: false,
            channel: false,
            lang: false
        });
    };
    ChatBox.prototype.handleLangSelection = function (e) {
        var setChatSettings = this.props.setChatSettings;
        setChatSettings({
            sourceValue: false,
            apiKey: false,
            channel: false,
            lang: e.target.value
        });
    };
    ChatBox.prototype.inputTextRenderer = function () {
        var _this = this;
        var forceButtons = this.state.forceButtons;
        var theme = this.props.theme;
        if (!forceButtons) {
            return (createElement("div", { className: theme.messagingArea },
                createElement("input", { placeholder: forceButtons ? "Elija una de las opciones" : "Escriba su mensaje aquí...", onKeyPress: function (e) { return _this.handleUserAddMessage(e); }, disabled: forceButtons })));
        }
        else
            return (createElement(Fragment, null));
    };
    ChatBox.prototype.mainRenderer = function () {
        var _a = this.state, openSettings = _a.openSettings, connected = _a.connected;
        var _b = this.props, botList = _b.botList, sourceValue = _b.sourceValue, lang = _b.lang, noneAbove = _b.noneAbove, theme = _b.theme;
        if (openSettings) {
            return (createElement(SettingsPanel, { theme: theme, handleBotSelection: this.handleBotSelection.bind(this), handleChannelSelection: this.handleChannelSelection.bind(this), handleLangSelection: this.handleLangSelection.bind(this), botList: botList, sourceValue: sourceValue, handleSourceValue: this.handleSourceValue.bind(this), handleConnect: this.handleConnect.bind(this), apiKey: this.props.apiKey }));
        }
        if (connected) {
            return (createElement("div", null,
                createElement("div", { className: theme.conversationWrapper, ref: this.messageListRef },
                    createElement(Messages, { messages: this.state.messages, theme: theme, lang: lang, handleClickOnCard: this.handleClickOnCard.bind(this), toScrollBottom: this.scrollToBottom.bind(this), showLastOptions: this.showLastOptions.bind(this), lastCards: this.state.lastCards, noneAbove: noneAbove })),
                this.inputTextRenderer()));
        }
        else {
            return (createElement("div", { ref: this.messageListRef, className: theme.spinnerContainer },
                createElement("svg", { className: theme.spinner, width: "65px", height: "65px", viewBox: "0 0 66 66", xmlns: "http://www.w3.org/2000/svg" },
                    createElement("circle", { className: theme.path, fill: "none", strokeWidth: "6", strokeLinecap: "round", cx: "33", cy: "33", r: "30" }))));
        }
    };
    ChatBox.prototype.titleRender = function () {
        var _this = this;
        var _a = this.state, openSettings = _a.openSettings, title = _a.title;
        var _b = this.props, theme = _b.theme, logo = _b.logo;
        if (openSettings) {
            return (createElement("div", null));
        }
        return (createElement("div", { className: theme.conversationTitle },
            (title) ? (createElement("h1", null, title)) : (createElement(Fragment, null)),
            (logo) ? (createElement("img", { src: logo })) : (createElement(Fragment, null)),
            createElement("div", { className: theme.closeMobile, onClick: function () { return _this.props.switchChat(); } })));
    };
    ChatBox.prototype.render = function () {
        var _this = this;
        var theme = this.props.theme;
        return (createElement(ErrorBoundary, null,
            createElement("div", { className: css$1(styles$8.fadeinquick) },
                createElement("div", { className: theme.content },
                    this.titleRender(),
                    this.mainRenderer())),
            (this.props.activeSurvey && !this.state.clickOnStartSurvey) ? (createElement("div", { className: theme.likeButton, onClick: function () { return _this.handleStartSurvey(); } },
                createElement(FontAwesomeIcon, { icon: faThumbsUp, size: "1x" }),
                " Ay\u00FAdanos a mejorar")) : (createElement(Fragment, null))));
    };
    return ChatBox;
}(Component));

var css$6 = ".cmadrid_content__1ulWc {\n  background: #fff;\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);\n  margin: 3.2em auto;\n  border-radius: 8px 8px 0 0;\n  position: fixed;\n  width: 30vw;\n  right: 30px;\n  bottom: 45px;\n  font-family: 'Montserrat Light', arial;\n  z-index: 999;\n  min-width: 400px;\n}\n\n\n.cmadrid_conversationTitle__1x1DY {\n  text-align: center;\n  padding: 8px;\n  background:#d12000;\n  /*background-image: url('data:image/png;base64,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');*/\n  background-repeat: no-repeat;\n  background-position: center;\n  color: #fff;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n  height: 1em;\n}\n\n.cmadrid_conversationTitle__1x1DY h1 {\n  font: 700 18px 'Noto Sans', sans-serif;\n  margin: 0;\n}\n.cmadrid_conversationTitle__1x1DY .cmadrid_status__2_cOQ {\n  font-size: 12px;\n  width: 50px;\n}\n\n.cmadrid_status__2_cOQ:hover {\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.cmadrid_conversationWrapper__fhYry {\n  background:#E6E6E6;\n  padding: 25px;\n  height: 60vh;\n  overflow-y: auto;\n  border: 1px solid lightgrey;\n  --scrollbarBG: lightgrey;\n  --thumbBG: #E6E6E6;\n  scrollbar-width: thin;\n  scrollbar-color: var(--thumbBG) var(--scrollbarBG);\n}\n\n.cmadrid_conversationWrapper__fhYry::-webkit-scrollbar {\n  width: 11px;\n}\n\n.cmadrid_conversationWrapper__fhYry::-webkit-scrollbar-track {\n  background: var(--scrollbarBG);\n}\n\n.cmadrid_conversationWrapper__fhYry::-webkit-scrollbar-thumb {\n  background-color: var(--thumbBG) ;\n  border-radius: 6px;\n  border: 3px solid var(--scrollbarBG);\n}\n\n /* Hide scrollbar for Chrome, Safari and Opera */\n /* .conversationWrapper::-webkit-scrollbar {\n  display: none;\n} */\n\n/* Hide scrollbar for IE and Edge */\n/* .conversationWrapper {\n  -ms-overflow-style: none;\n}  */\n\n.cmadrid_settingsContainer__2vRsL {\n  background: white;\n  border: 1px solid lightgrey;\n  padding: 25px;\n  height: 500px;\n  overflow-y: auto;\n  font-size: medium;\n}\n\n.cmadrid_settingsContainer__2vRsL select {\n  width: 100%;\n  height: 25px;\n  border: 1px solid lightgrey;\n  margin: 15px 0 15px 0;\n}\n\n.cmadrid_settingsContainer__2vRsL input {\n  width: 100%;\n  height: 25px;\n  border: 1px solid lightgrey;\n  margin: 5px 0 5px 0;\n  padding-left: 10px;\n}\n\n.cmadrid_messageSent__3aUfF, .cmadrid_messageReceived__2u_d0 {\n  padding: 0;\n}\n.cmadrid_messageReceived__2u_d0 {\n  text-align: left;\n  margin-bottom: 10px;\n}\n.cmadrid_messageSent__3aUfF {\n  text-align: right;\n}\n\n.cmadrid_messageSent__3aUfF > .cmadrid_bubble__3PuLi {\n  border-radius: 12px 12px 0px 12px;\n}\n\n.cmadrid_messageReceived__2u_d0 > .cmadrid_bubble__3PuLi {\n  border-radius: 12px 12px 12px 0px;\n}\n\n.cmadrid_bubble__3PuLi {\n  background: #fff;\n  padding: 12px 18px;\n  border: 0.5px solid rgba(0, 0, 0, 0.02);\n  box-shadow: 0 2px 1px rgba(0, 0, 0, 0.08);\n  max-width: 70%;\n  display: inline-block;\n  text-align: left;\n  font-size: 14px;\n  margin-top: 5px;\n  margin-bottom: 5px;\n}\n.cmadrid_timestamp__3YRAy {\n  margin: 0 0;\n}\n.cmadrid_timestamp__3YRAy .cmadrid_avatar__2SVVm {\n  border-radius: 50%;\n  background: linear-gradient(to top right, #e9e7e8, #898b8f);\n  display: inline-block;\n  width: 25px;\n  height: 20px;\n  vertical-align: top;\n  color: #fff;\n  font-size: 10px;\n  text-align: center;\n  padding-top: 5px;\n}\n.cmadrid_timestamp__3YRAy .cmadrid_time__28PLe {\n  font-size: 12px;\n  color: #999;\n  margin: 0 5px;\n}\n.cmadrid_messagingArea__1lM5Z {\n  position: relative;\n  box-shadow: 0 -2px 1px rgba(0, 0, 0, 0.03);\n  border-bottom: 1px solid lightgrey;\n  border-left: 1px solid lightgrey;\n  border-right: 1px solid lightgrey;\n  overflow: hidden;\n}\n.cmadrid_messagingArea__1lM5Z input {\n  font-size: 14px;\n  border: none;\n  padding: 20px 30px;\n  width: 100%;\n  border-bottom-left-radius: 0px;\n  border-bottom-right-radius: 0px;\n  line-height: normal;\n}\n.cmadrid_messagingArea__1lM5Z input:focus {\n  outline: 0;\n}\n\n.cmadrid_send__LuZXI {\n  background: linear-gradient(to top right, #e9e7e8, #898b8f);\n  color: #fff;\n  border-radius: 50%;\n  width: 25px;\n  height: 25px;\n  padding: 8px 10px 12px;\n  position: absolute;\n  font-size: 0.7em;\n  text-align: center;\n  right: 8px;\n  bottom: 8px;\n}\n\n.cmadrid_button__p1NCC {\n\t/* box-shadow:inset 0px -3px 7px 0px #898b8f; */\n\tcolor: gray;\n\tbackground-color:white;\n\tborder-radius:3px;\n\tborder: 1px solid lightgray;\n\tdisplay:inline-block;\n\tcursor:pointer;\n\tfont-size:15px;\n\tpadding:9px 23px;\n\ttext-decoration:none;\n  /* text-shadow:0px 1px 0px #263666; */\n  margin-top: 25px;\n}\n.cmadrid_button__p1NCC:hover {\n  background-color:#898b8f;\n  color: white;\n}\n.cmadrid_button__p1NCC:active {\n\tposition:relative;\n\ttop:1px;\n}\n\n.cmadrid_spinnerContainer__3E6Ym {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 500px;\n  border: 1px solid lightgrey;\n}\n\n.cmadrid_spinner__26rN- {\n  animation: cmadrid_rotator__2vFbL 1.4s linear infinite;\n}\n\n@keyframes cmadrid_rotator__2vFbL {\n  0% {\n    transform: rotate(0deg);\n }\n  100% {\n    transform: rotate(270deg);\n }\n}\n.cmadrid_path__3c7Wo {\n  stroke-dasharray: 187;\n  stroke-dashoffset: 0;\n  transform-origin: center;\n  animation: cmadrid_dash__3KL1d 1.4s ease-in-out infinite, cmadrid_colors__2H4-9 5.6s ease-in-out infinite;\n}\n@keyframes cmadrid_colors__2H4-9 {\n  0% {\n    stroke: #4285f4;\n }\n  25% {\n    stroke: #de3e35;\n }\n  50% {\n    stroke: #f7c223;\n }\n  75% {\n    stroke: #1b9a59;\n }\n  100% {\n    stroke: #4285f4;\n }\n}\n@keyframes cmadrid_dash__3KL1d {\n  0% {\n    stroke-dashoffset: 187;\n }\n  50% {\n    stroke-dashoffset: 46.75;\n    transform: rotate(135deg);\n }\n  100% {\n    stroke-dashoffset: 187;\n    transform: rotate(450deg);\n }\n}\n\n.cmadrid_closeMobile__ySUf7 {\n  display: none;\n}\n\n@media only screen and (max-width: 768px) {\n  /* For mobile phones: */\n  .cmadrid_content__1ulWc {\n    bottom: 0 !important;\n    width: 100vw !important;\n    height: 100%;\n    right: 0;\n    bottom: 0;\n    position: unset;\n    margin: 0;\n    min-width: 0;\n  }\n\n  .cmadrid_conversationTitle__1x1DY {\n    border-top-left-radius: 0px;\n    border-top-right-radius: 0px;\n  }\n\n  .cmadrid_conversationWrapper__fhYry {\n    height: 93vh;\n    padding: 20px;\n  }\n\n  .cmadrid_messagingArea__1lM5Z {\n    position: fixed;\n    bottom: 0;\n    width: 100vw;\n    background-color: lightgrey;\n  }\n\n\n\n  .cmadrid_messagingAreaHide__1teex {\n    display: none;\n  }\n\n  .cmadrid_closeMobile__ySUf7 {\n    height: 30px;\n    width: 30px;\n    display: block;\n    position: fixed;\n    right: 20px;\n    top: 0.6rem;\n    color: white;\n    background-image:url('data:image/png;base64,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');\n    background-size: contain;\n  }\n}\n\n/* IPHONE X */\n@media only screen\nand (min-device-width : 375px)\nand (max-device-width : 812px)\nand (-webkit-device-pixel-ratio : 3)\nand (orientation : portrait) {\n\n  .cmadrid_messagingArea__1lM5Z > input {\n    /* enlarge by 16/12 = 133.33% */\n    border-radius: 6.666666667px;\n    font-size: 20px;\n    line-height: 26.666666667px;\n    padding: 6.666666667px;\n    width: 133.333333333%;\n\n    /* scale down by 12/16 = 75% */\n    transform: scale(0.75);\n    transform-origin: left top;\n  }\n\n  .cmadrid_messagingArea__1lM5Z {\n    position: fixed;\n    bottom: 0px;\n    width: 100vw;\n    background-color: white;\n    height: 1em;\n    padding: 4px;\n  }\n\n}\n\n@media only screen\nand (min-device-width : 375px)\nand (max-device-width : 667px)\nand (orientation : portrait) {\n  /* iPhone 6, 7, & 8 in portrait */\n  .cmadrid_messagingArea__1lM5Z > input {\n    /* enlarge by 16/12 = 133.33% */\n    border-radius: 6.666666667px;\n    font-size: 20px;\n    line-height: 26.666666667px;\n    padding: 6.666666667px;\n    width: 133.333333333%;\n\n    /* scale down by 12/16 = 75% */\n    transform: scale(0.75);\n    transform-origin: left top;\n  }\n\n  .cmadrid_messagingArea__1lM5Z {\n    position: fixed;\n    bottom: 0px;\n    width: 100vw;\n    background-color: white;\n    height: 1em;\n    padding: 4px;\n  }\n}\n\n@media only screen\nand (min-device-width : 320px)\nand (max-device-width : 568px) {\n  /* Iphone 5 */\n  /* iPhone 6, 7, & 8 in portrait */\n  .cmadrid_messagingArea__1lM5Z > input {\n    /* enlarge by 16/12 = 133.33% */\n    border-radius: 6.666666667px;\n    font-size: 20px;\n    line-height: 26.666666667px;\n    padding: 6.666666667px;\n    width: 133.333333333%;\n\n    /* scale down by 12/16 = 75% */\n    transform: scale(0.75);\n    transform-origin: left top;\n  }\n\n  .cmadrid_messagingArea__1lM5Z {\n    position: fixed;\n    bottom: 0px;\n    width: 100vw;\n    background-color: white;\n    height: 1em;\n    padding: 4px;\n  }\n}\n\n/* add css styles here (optional) */\n.cmadrid_chatboxContainer__jPlYh {\n  font-size: 2em;\n  position: fixed;\n  right: 0px;\n  z-index: 100000;\n}\n\n@media only screen and (max-width: 600px) {\n  .cmadrid_chatboxContainer__jPlYh {\n    top: 0px;\n    width: 100%;\n  }\n}\n\n.cmadrid_actionButton__1odk5 {\n  background-color:#d12000!important;\n  color: white!important;\n  border: 1px solid#d12000!important;\n  display: inline-block;\n  text-align: center;\n  padding: 15px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-family: 'Montserrat-light';\n  font-size: 1.8rem;\n}\n\n.cmadrid_actionButton__1odk5:hover {\n  text-decoration: underline;\n}\n\n/* Collapsable */\n.cmadrid_wrapper__3jSeR {\n  overflow: hidden;\n  transition: height 200ms;\n}\n\n.cmadrid_closed__2o5eP {\n  display: none;\n}\n\n.cmadrid_buttonOpenColl__35fI2 {\n  background-color:#d12000;\n  border-radius: 6px;\n  border: 1px solid lightgray;\n  display: flex;\n  cursor: pointer;\n  padding: 10px 10px;\n  text-decoration: none;\n  margin-right: 10px;\n  margin-bottom: 0.2em;\n  width: 90px;\n  font-size: 14px;\n}\n\n.cmadrid_buttonCloseColl__3iD0d {\n  background-color:#d12000;\n  border-radius: 6px;\n  border: 1px solid lightgray;\n  display: flex;\n  cursor: pointer;\n  padding: 5px 5px 10px 5px;\n  text-decoration: none;\n  margin-right: 10px;\n  margin-bottom: 0.2em;\n  width: 6em;\n  font-size: 14px;\n  flex: initial;\n  height: 10px;\n}\n\n.cmadrid_arrowOpen__1uE-e {\n  height: 20px;\n  width: 20px;\n  color: white;\n  background-image: url('data:image/png;base64,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');\n  background-size: contain;\n  display: flex;\n  margin-right: 10px;\n  transform: rotate(180deg);\n}\n\n.cmadrid_arrowClose__6qos1 {\n\n  height: 20px;\n  width: 20px;\n  color: white;\n  background-image: url('data:image/png;base64,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');\n  background-size: contain;\n  display: flex;\n  margin-right: 10px;\n\n}\n\n.cmadrid_textMoreInfo__2Z1K7 {\n  display: flex;\n  font-size: 1em;\n  color: #FFF;\n}\n\n.cmadrid_mainColor__1oO1c {\n  color:#d12000 !important;\n}\n\n.cmadrid_card__1QxaK {\n  /* Add shadows to create the \"card\" effect */\n  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);\n  transition: 0.3s;\n  border-radius: 5px; /* 5px rounded corners */\n  margin: 20px 0px 20px 0px;\n  background-color: #f6f6f6;\n  cursor: pointer;\n}\n\n.cmadrid_smallCard__1HAmS {\n  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);\n  transition: 0.3s;\n  border-radius: 5px; /* 5px rounded corners */\n  margin: 20px 0px 20px 0px;\n  background-color: #f6f6f6;\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: stretch;\n  cursor: pointer;\n}\n\n/* On mouse-over, add a deeper shadow */\n.cmadrid_smallCard__1HAmS:hover {\n  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);\n}\n\n.cmadrid_smallImageCard__N55rl {\n  width: 45%;\n  border-radius: 5px 0 0 5px;\n}\n\n/* On mouse-over, add a deeper shadow */\n.cmadrid_card__1QxaK:hover {\n  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);\n}\n\n.cmadrid_imageCard__OjAvv {\n  width: 100%;\n  border-radius: 5px 5px 0 0;\n}\n\n/* Add some padding inside the card container */\n.cmadrid_container__5k-qO {\n  padding: 16px;\n}\n\n.cmadrid_container__5k-qO p {\n  font-size: small;\n}\n\n.cmadrid_displayName__EBx1X {\n  font-size: 0.5em;\n}\n/*===================================\n  Buttons\n===================================*/\n.cmadrid_buttonsContainer__R9pfS {\n\tpadding-bottom: 15px;\n}\n\n.cmadrid_rtButton__18HSq {\n\tbackground-color: lightgray;\n\tborder-radius: 6px;\n\tborder: 1px solid lightgray;\n\tdisplay: inline-block;\n\tcursor: pointer;\n\tpadding: 10px 10px;\n\ttext-decoration: none;\n\tmargin-right: 10px;\n\tmargin-bottom: 0.2em;\n  font-size: 14px;\n  min-width: 50px;\n}\n.cmadrid_rtButton__18HSq:hover {\n\tborder:1px solid #d12000;\n\tcolor: #d12000;\n}\n.cmadrid_rtButton__18HSq:active {\n\tposition:relative;\n\ttop:1px;\n}\n\n.cmadrid_rtButtonEmoji__2l75E {\n\tbackground-color: lightgray;\n\tborder-radius: 6px;\n\tborder: 1px solid lightgray;\n\tdisplay: inline-block;\n\tcursor: pointer;\n\tpadding: 10px 10px;\n\ttext-decoration: none;\n\tmargin-right: 10px;\n\tmargin-bottom: 0.2em;\n\tfont-size: 1.7em;\n}\n.cmadrid_rtButtonEmoji__2l75E:hover {\n\tborder:1px solid #d12000;\n\tcolor: #d12000;\n}\n.cmadrid_rtButtonEmoji__2l75E:active {\n\tposition:relative;\n\ttop:1px;\n}\n\n.cmadrid_rtButtonCard__74asp {\n\tbox-shadow:inset 0px 1px 0px 0px #999999;\n\tbackground:linear-gradient(to bottom, #999999 5%, #f6f6f6 100%);\n\tbackground-color:#999999;\n\tborder-radius:6px;\n\tborder:1px solid #dcdcdc;\n\tdisplay:inline-block;\n\tcursor:pointer;\n\tcolor:#666666;\n\tfont-family:Arial;\n\tfont-size:15px;\n\tfont-weight:bold;\n\tpadding:10px 25px;\n\ttext-decoration:none;\n  text-shadow:0px 1px 0px #999999;\n  margin-right: 10px;\n}\n.cmadrid_rtButtonCard__74asp:hover {\n\tbackground:linear-gradient(to bottom, #f6f6f6 5%, #999999 100%);\n\tbackground-color:#f6f6f6;\n}\n.cmadrid_rtButtonCard__74asp:active {\n\tposition:relative;\n\ttop:1px;\n}\n\n@media only screen and (max-width: 768px) {\n\n\t.cmadrid_rtButton__18HSq {\n\t\tmin-width: 90%;\n\t}\n}\n\n";
var cmadrid = {"content":"cmadrid_content__1ulWc","conversationTitle":"cmadrid_conversationTitle__1x1DY","status":"cmadrid_status__2_cOQ","conversationWrapper":"cmadrid_conversationWrapper__fhYry","settingsContainer":"cmadrid_settingsContainer__2vRsL","messageSent":"cmadrid_messageSent__3aUfF","messageReceived":"cmadrid_messageReceived__2u_d0","bubble":"cmadrid_bubble__3PuLi","timestamp":"cmadrid_timestamp__3YRAy","avatar":"cmadrid_avatar__2SVVm","time":"cmadrid_time__28PLe","messagingArea":"cmadrid_messagingArea__1lM5Z","send":"cmadrid_send__LuZXI","button":"cmadrid_button__p1NCC","spinnerContainer":"cmadrid_spinnerContainer__3E6Ym","spinner":"cmadrid_spinner__26rN-","rotator":"cmadrid_rotator__2vFbL","path":"cmadrid_path__3c7Wo","dash":"cmadrid_dash__3KL1d","colors":"cmadrid_colors__2H4-9","closeMobile":"cmadrid_closeMobile__ySUf7","messagingAreaHide":"cmadrid_messagingAreaHide__1teex","chatboxContainer":"cmadrid_chatboxContainer__jPlYh","actionButton":"cmadrid_actionButton__1odk5","wrapper":"cmadrid_wrapper__3jSeR","closed":"cmadrid_closed__2o5eP","buttonOpenColl":"cmadrid_buttonOpenColl__35fI2","buttonCloseColl":"cmadrid_buttonCloseColl__3iD0d","arrowOpen":"cmadrid_arrowOpen__1uE-e","arrowClose":"cmadrid_arrowClose__6qos1","textMoreInfo":"cmadrid_textMoreInfo__2Z1K7","mainColor":"cmadrid_mainColor__1oO1c","card":"cmadrid_card__1QxaK","smallCard":"cmadrid_smallCard__1HAmS","smallImageCard":"cmadrid_smallImageCard__N55rl","imageCard":"cmadrid_imageCard__OjAvv","container":"cmadrid_container__5k-qO","displayName":"cmadrid_displayName__EBx1X","buttonsContainer":"cmadrid_buttonsContainer__R9pfS","rtButton":"cmadrid_rtButton__18HSq","rtButtonEmoji":"cmadrid_rtButtonEmoji__2l75E","rtButtonCard":"cmadrid_rtButtonCard__74asp"};
styleInject(css$6);

var css$7 = "\n.dev_content__1pCT0 {\n  background: #fff;\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);\n  margin: 3.2em auto;\n  border-radius: 8px 8px 0 0;\n  position: fixed;\n  width: 30vw;\n  right: 30px;\n  bottom: 45px;\n  font-family: 'Montserrat Light', arial;\n  z-index: 999;\n  min-width: 400px;\n}\n\n\n.dev_conversationTitle__1XFQ4 {\n  text-align: center;\n  padding: 8px;\n  background: #2ECC40;\n  /*background-image: url('data:image/png;base64,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');*/\n  background-repeat: no-repeat;\n  background-position: center;\n  color: #fff;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n  height: 1em;\n}\n.dev_conversationTitle__1XFQ4 h1 {\n  font: 700 18px 'Noto Sans', sans-serif;\n  margin: 0;\n}\n.dev_conversationTitle__1XFQ4 .dev_status__3RTRU {\n  font-size: 12px;\n  width: 50px;\n}\n\n.dev_status__3RTRU:hover {\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.dev_conversationWrapper__2-WcO {\n  background:#E6E6E6;\n  padding: 25px;\n  height: 60vh;\n  overflow-y: auto;\n  border: 1px solid lightgrey;\n  --scrollbarBG: lightgrey;\n  --thumbBG: #E6E6E6;\n  scrollbar-width: thin;\n  scrollbar-color: var(--thumbBG) var(--scrollbarBG);\n}\n\n.dev_conversationWrapper__2-WcO::-webkit-scrollbar {\n  width: 11px;\n}\n\n.dev_conversationWrapper__2-WcO::-webkit-scrollbar-track {\n  background: var(--scrollbarBG);\n}\n\n.dev_conversationWrapper__2-WcO::-webkit-scrollbar-thumb {\n  background-color: var(--thumbBG) ;\n  border-radius: 6px;\n  border: 3px solid var(--scrollbarBG);\n}\n\n /* Hide scrollbar for Chrome, Safari and Opera */\n /* .conversationWrapper::-webkit-scrollbar {\n  display: none;\n} */\n\n/* Hide scrollbar for IE and Edge */\n/* .conversationWrapper {\n  -ms-overflow-style: none;\n}  */\n\n.dev_settingsContainer__1PSjF {\n  background: white;\n  border: 1px solid lightgrey;\n  padding: 25px;\n  height: 500px;\n  overflow-y: auto;\n  font-size: medium;\n}\n\n.dev_settingsContainer__1PSjF select {\n  width: 100%;\n  height: 25px;\n  border: 1px solid lightgrey;\n  margin: 15px 0 15px 0;\n}\n\n.dev_settingsContainer__1PSjF input {\n  width: 100%;\n  height: 25px;\n  border: 1px solid lightgrey;\n  margin: 5px 0 5px 0;\n  padding-left: 10px;\n}\n\n.dev_messageSent__2mDun, .dev_messageReceived__267Vs {\n  padding: 0;\n}\n.dev_messageReceived__267Vs {\n  text-align: left;\n  margin-bottom: 10px;\n}\n.dev_messageSent__2mDun {\n  text-align: right;\n}\n\n.dev_messageSent__2mDun > .dev_bubble__3XjRJ {\n  border-radius: 12px 12px 0px 12px;\n}\n\n.dev_messageReceived__267Vs > .dev_bubble__3XjRJ {\n  border-radius: 12px 12px 12px 0px;\n}\n\n.dev_bubble__3XjRJ {\n  background: #fff;\n  padding: 12px 18px;\n  border: 0.5px solid rgba(0, 0, 0, 0.02);\n  box-shadow: 0 2px 1px rgba(0, 0, 0, 0.08);\n  max-width: 70%;\n  display: inline-block;\n  text-align: left;\n  font-size: 14px;\n  margin-top: 5px;\n  margin-bottom: 5px;\n}\n.dev_timestamp__3ZdSc {\n  margin: 0 0;\n}\n.dev_timestamp__3ZdSc .dev_avatar__3ufxE {\n  border-radius: 50%;\n  background: linear-gradient(to top right, #e9e7e8, #898b8f);\n  display: inline-block;\n  width: 25px;\n  height: 20px;\n  vertical-align: top;\n  color: #fff;\n  font-size: 10px;\n  text-align: center;\n  padding-top: 5px;\n}\n.dev_timestamp__3ZdSc .dev_time__2cSB9 {\n  font-size: 12px;\n  color: #999;\n  margin: 0 5px;\n}\n.dev_messagingArea__3HumR {\n  position: relative;\n  box-shadow: 0 -2px 1px rgba(0, 0, 0, 0.03);\n  border-bottom: 1px solid lightgrey;\n  border-left: 1px solid lightgrey;\n  border-right: 1px solid lightgrey;\n  overflow: hidden;\n}\n.dev_messagingArea__3HumR input {\n  font-size: 14px;\n  border: none;\n  padding: 20px 30px;\n  width: 100%;\n  border-bottom-left-radius: 0px;\n  border-bottom-right-radius: 0px;\n  line-height: normal;\n}\n.dev_messagingArea__3HumR input:focus {\n  outline: 0;\n}\n\n.dev_send__15Gst {\n  background: linear-gradient(to top right, #e9e7e8, #898b8f);\n  color: #fff;\n  border-radius: 50%;\n  width: 25px;\n  height: 25px;\n  padding: 8px 10px 12px;\n  position: absolute;\n  font-size: 0.7em;\n  text-align: center;\n  right: 8px;\n  bottom: 8px;\n}\n\n.dev_button__17sgh {\n\t/* box-shadow:inset 0px -3px 7px 0px #898b8f; */\n\tcolor: gray;\n\tbackground-color:white;\n\tborder-radius:3px;\n\tborder: 1px solid lightgray;\n\tdisplay:inline-block;\n\tcursor:pointer;\n\tfont-size:15px;\n\tpadding:9px 23px;\n\ttext-decoration:none;\n  /* text-shadow:0px 1px 0px #263666; */\n  margin-top: 25px;\n}\n.dev_button__17sgh:hover {\n  background-color:#898b8f;\n  color: white;\n}\n.dev_button__17sgh:active {\n\tposition:relative;\n\ttop:1px;\n}\n\n.dev_spinnerContainer__1_b32 {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 500px;\n  border: 1px solid lightgrey;\n}\n\n.dev_spinner__ZSKyF {\n  animation: dev_rotator__N6JaM 1.4s linear infinite;\n}\n\n@keyframes dev_rotator__N6JaM {\n  0% {\n    transform: rotate(0deg);\n }\n  100% {\n    transform: rotate(270deg);\n }\n}\n.dev_path__2InTA {\n  stroke-dasharray: 187;\n  stroke-dashoffset: 0;\n  transform-origin: center;\n  animation: dev_dash__26mgj 1.4s ease-in-out infinite, dev_colors__2xZBM 5.6s ease-in-out infinite;\n}\n@keyframes dev_colors__2xZBM {\n  0% {\n    stroke: #4285f4;\n }\n  25% {\n    stroke: #de3e35;\n }\n  50% {\n    stroke: #f7c223;\n }\n  75% {\n    stroke: #1b9a59;\n }\n  100% {\n    stroke: #4285f4;\n }\n}\n@keyframes dev_dash__26mgj {\n  0% {\n    stroke-dashoffset: 187;\n }\n  50% {\n    stroke-dashoffset: 46.75;\n    transform: rotate(135deg);\n }\n  100% {\n    stroke-dashoffset: 187;\n    transform: rotate(450deg);\n }\n}\n\n.dev_closeMobile__1sX-6 {\n  display: none;\n}\n\n@media only screen and (max-width: 768px) {\n  /* For mobile phones: */\n  .dev_content__1pCT0 {\n    bottom: 0 !important;\n    width: 100vw !important;\n    height: 100%;\n    right: 0;\n    bottom: 0;\n    position: unset;\n    margin: 0;\n    min-width: 0;\n  }\n\n  .dev_conversationTitle__1XFQ4 {\n    border-top-left-radius: 0px;\n    border-top-right-radius: 0px;\n  }\n\n  .dev_conversationWrapper__2-WcO {\n    height: 85vh;\n    padding: 20px;\n  }\n\n  .dev_messagingArea__3HumR {\n    position: fixed;\n    bottom: 0px;\n    width: 100vw;\n    background-color: lightgrey;\n    height: 2em;\n  }\n\n\n\n  .dev_messagingAreaHide__yb2Rn {\n    display: none;\n  }\n\n  .dev_closeMobile__1sX-6 {\n    height: 30px;\n    width: 30px;\n    display: block;\n    position: fixed;\n    right: 20px;\n    top: 0.6rem;\n    color: white;\n    background-image:url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAQAAAAAYLlVAAAF6npUWHRSYXcgcHJvZmlsZSB0eXBlIGV4aWYAAHja7VhZsqM4EPyvU/QRtC/H0RoxN5jjd5YkvNtg3vtsE0ZYEqUiMysBU/v/v05/8NEhOjLWBxedE/iYaKJKOAhifuLYS2HGfnzMGsLvu366DCh0abR6/vRpzU/ot9cTtjVkvu+nsEZUWIHWwBZQ88oKB/U2SfSr2S9XJhTbPHAx+NtUs5pt2VIO12/zwo9gdg7xb7rtMB4oVYuFtFJNSy3G3swM9PwmfM3Ye56H8YTfhtBIrVYmAOTu8rZWiFuA7kDejugR/cvRA/gqrX79gKVbGOHg5YC0r8EfEN8srC8ZqfsBtO3pcta39xp6b/PqknFA1C1FCdrQ4XMwMQNyPU5z2Dy+Fsd+bBFbEEkUUF5FERlbkVEqsNJJGlllkl220RZZkKJRTYETpVQBLdwXwFFUBVxJ5kgb2ZXXUVcdwFxRjbRGt7rkIse6caxXZMDKVWKqkggGdt9v9Gnwm416LwyRFOGCFfJSrCykwczxHrNAiOyLDjsA3rZFv7jRD6QKBu2AOeACk8gzRLbyqi09eNaYZ9HOEpLk6woAiLC2RTJSgwHhpLbSSeGV8lICxwCCEjJX2qgMBqS1qiJJZbR2irwKitfGOV6Oucoqp7gb3gQirHbag5uoE8gyxkI/3gRoKFltjbXWWW8D2WiT084465zzjk0uee2Nt95574OPPgUdTLDBBR9CiCFFFTU80EYXfQwxxpQUJSyUECthfkJPVllnk2122eeQY04F8imm2OKKL6HEkqqqusImqqu+hhprapIanKKZZptrvoUWW+rQWtfddNtd9z302NOFtcXq0/YFa3KxpgZTPM9fWEMveb+FkGwnljkDY8pIMO6ZAQhaMWciSGMUM8eciahQFFYhScvcUJXMGCg0TSrb5YW7K3OHeCMbDvGm9pgjpu43mCNQ98zbC9Yq3+fKYGxWIWMqNKoP4y0kUiHxTS39tP0X6AeBemYuwEkYvwwOYu6ioFva0sGWs7wvpvaejaZWe3MoqJx9tFk7NyfVrCNGalW5IKIQaSzyvqW9CUdazpcCMpwJo6A6xN1nsrq3Ipv1M9ecu2995opirLH16oLQnO1EgW6Rye0JCgZiRIaVGL1wADK3SAwcaAHRcudMdeNkc8WBcr3wnTNYr3uNvneJlFsVPfuOxRBOtdqsKzUif6rZleY9Rk1ChZ3WAH2eMHKT0a/cQkXxxpUbLioLXODMjSqKvtc+Uq0ZPqGdz93yo9slAh5OLjFgpysKUJtx+AodrSi3MeAa7Y5jPUgA7iPGJGHQm3RfFFhifkufDPAq3cmrFpkClvblCid/E/+VnwqDAWIKOL2uFwH8WHbFH5FXfm/0sZUKbbWyXyrvFcI50iaSBeJVJrciOaAROiGaO01sjNInSl8wKt7pih6F9U5XT5oQqceFE8NMW2oLJybzklmebM7IQCpc414jrNOJi3Gdvc5FXm/Ovse536mUlhYehXqvU56xo1PqV5luIl0anZltKgViH3VKZ43sUaV01sgeNUrnjOzZp+idUX3rU/SFqj9qkq6S+kZRVz1eau1LRb+9P9ALkb600j0npaNWuuekdNRK95yUjlrpnpPSUSvdUyUdufkdccqvlf1OlfQorLNOSWd0/QrGD9X/rNJPTkpHrXTPSemole45KR210j0npaNWuqdJ2nukO+qUdELVLzVJ4unme84pz977n2D77jXrg5PSUSvdc1I6aqV7CqWjVrqnUTpqpR9UOoLRN68Jn5zytLIfVUmPD5VnnZJ+outbVdLPX/qnSumole45KR210j0npZ++XW/J0SbTVY4v/gJAqJd/AnA9Xv8EoKX4l6//E70RdZURozejjjICeiPqqjV5/W/hxfkPZ/Pl3Zx/OZmqO/gvyk5L7wb0FzdHZpSeKWVCM3vEV0+W9OyHzOEk4P1r3nNF0rnXvOeKpO8eXt639Dslazv9vGRHuEzM0EshHxTi0uFv+NGvGdu/QCcC4RYaodC/O31MYktOhjIAAAEkaUNDUElDQyBwcm9maWxlAAB4nJ2Qv0rDUBTGf6nFiuhUcRCFDG5ScDGTi38wdCjUtoLRKU1SLCYxJCnFN/BN9GE6CIJP4BMoOPvd6OBgFi8cvh+Hc77v3gsNOw6SorkPSVrm7uDIu/Su7NYbTVq02WPHD4qsNzwbUXs+X7GMvnSMV/3cn2c5jIpAulClQZaXYB2KnXmZGVaxcTsanIgfxHaYpKH4SbwbJqFhsztI4lnw42lusxalF0PTV23j0qVHH5sxM6bElHSkqTqnOBxIXXJ87ikIpDGRenPNlNyICjm5HItGIt2mJm+ryusrZSyPqbxMwh2JPE0e5n+/1z7Oq01rc5H5uV+1llSNyQTeH2Hdg/YzrF7XZK38flvNjFPN/PONXwwfUHdeCSRsAAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAADukAAA7pAQ4zQhwAAAAHdElNRQfkBAcTLBVj2v8hAAAA+ElEQVRo3u2Y2w7DIAxDMf//z93DLuoYFOKYTNrip6qQ+LSFELWUVCqVSqX+XTiOxwVijZ++tb0Ra38CiEQ4O9XRQIx9AxCB0DrU2YS99qWgexNh9nerGIS+C64G99u/AHYjjLNjZdI++zeAXQjXWWGZrLf/AFAjzLOBCdLZdwFUCGtZ4An22w8BvAjr0VAk8URClYiNgjIZEwHt89iBpa+U+WTQLSpuxcjWNbtnoNnZ/JaVFBdP0TIV2L6Rr2a6K3wnpSmn+ZSbIVgPLckx6zm2qVZjhMB0DbJeh+2b6H6vRWDbNlHDyTeurqb7W793UqlUKpX6Ld0AolWAFIxyajgAAAAASUVORK5CYII=');\n    background-size: contain;\n  }\n}\n\n/* IPHONE X */\n@media only screen\nand (min-device-width : 375px)\nand (max-device-width : 812px)\nand (-webkit-device-pixel-ratio : 3)\nand (orientation : portrait) {\n\n  .dev_messagingArea__3HumR > input {\n    /* enlarge by 16/12 = 133.33% */\n    border-radius: 6.666666667px;\n    font-size: 20px;\n    line-height: 26.666666667px;\n    padding: 6.666666667px;\n    width: 133.333333333%;\n\n    /* scale down by 12/16 = 75% */\n    transform: scale(0.75);\n    transform-origin: left top;\n  }\n\n  .dev_messagingArea__3HumR {\n    position: fixed;\n    bottom: 0px;\n    width: 100vw;\n    background-color: white;\n    height: 1em;\n    padding: 4px;\n  }\n\n}\n\n@media only screen\nand (min-device-width : 375px)\nand (max-device-width : 667px)\nand (orientation : portrait) {\n  /* iPhone 6, 7, & 8 in portrait */\n  .dev_messagingArea__3HumR > input {\n    /* enlarge by 16/12 = 133.33% */\n    border-radius: 6.666666667px;\n    font-size: 20px;\n    line-height: 26.666666667px;\n    padding: 6.666666667px;\n    width: 133.333333333%;\n\n    /* scale down by 12/16 = 75% */\n    transform: scale(0.75);\n    transform-origin: left top;\n  }\n\n  .dev_messagingArea__3HumR {\n    position: fixed;\n    bottom: 0px;\n    width: 100vw;\n    background-color: white;\n    height: 1em;\n    padding: 4px;\n  }\n}\n\n@media only screen\nand (min-device-width : 320px)\nand (max-device-width : 568px) {\n  /* Iphone 5 */\n  /* iPhone 6, 7, & 8 in portrait */\n  .dev_messagingArea__3HumR > input {\n    /* enlarge by 16/12 = 133.33% */\n    border-radius: 6.666666667px;\n    font-size: 20px;\n    line-height: 26.666666667px;\n    padding: 6.666666667px;\n    width: 133.333333333%;\n\n    /* scale down by 12/16 = 75% */\n    transform: scale(0.75);\n    transform-origin: left top;\n  }\n\n  .dev_messagingArea__3HumR {\n    position: fixed;\n    bottom: 0px;\n    width: 100vw;\n    background-color: white;\n    height: 1em;\n    padding: 4px;\n  }\n}\n\n/* add css styles here (optional) */\n.dev_chatboxContainer__14UTL {\n  font-size: 2em;\n  position: fixed;\n  right: 0px;\n  z-index: 100000;\n}\n\n@media only screen and (max-width: 600px) {\n  .dev_chatboxContainer__14UTL {\n    top: 0px;\n    width: 100%;\n  }\n}\n\n.dev_actionButton__3kKO6 {\n  background-color: #2ECC40!important;\n  color: white!important;\n  border: 1px solid #2ECC40!important;\n  display: inline-block;\n  text-align: center;\n  padding: 15px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-family: 'Montserrat-light';\n  font-size: 1.8rem;\n}\n\n.dev_actionButton__3kKO6:hover {\n  text-decoration: underline;\n}\n\n/* Collapsable */\n.dev_wrapper__36Bz- {\n  overflow: hidden;\n  transition: height 200ms;\n}\n\n.dev_closed__WI_eJ {\n  display: none;\n}\n\n.dev_buttonOpenColl__3n3xp {\n  background-color: #2ECC40;\n  border-radius: 6px;\n  border: 1px solid lightgray;\n  display: flex;\n  cursor: pointer;\n  padding: 10px 10px;\n  text-decoration: none;\n  margin-right: 10px;\n  margin-bottom: 0.2em;\n  width: 90px;\n  font-size: 14px;\n}\n\n.dev_buttonCloseColl__pyWHS {\n  background-color: #2ECC40;\n  border-radius: 6px;\n  border: 1px solid lightgray;\n  display: flex;\n  cursor: pointer;\n  padding: 5px 5px 10px 5px;\n  text-decoration: none;\n  margin-right: 10px;\n  margin-bottom: 0.2em;\n  width: 6em;\n  font-size: 14px;\n  flex: initial;\n  height: 10px;\n}\n\n.dev_arrowOpen__3HAhI {\n  height: 20px;\n  width: 20px;\n  color: white;\n  background-image: url('data:image/png;base64,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');\n  background-size: contain;\n  display: flex;\n  margin-right: 10px;\n  transform: rotate(180deg);\n}\n\n.dev_arrowClose__3EQ-n {\n\n  height: 20px;\n  width: 20px;\n  color: white;\n  background-image: url('data:image/png;base64,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');\n  background-size: contain;\n  display: flex;\n  margin-right: 10px;\n\n}\n\n.dev_textMoreInfo__3IuYZ {\n  display: flex;\n  font-size: 1em;\n  color: #FFF;\n}\n\n.dev_mainColor__1eAox {\n  color: #2ECC40 !important;\n}\n\n.dev_card__1jSOX {\n  /* Add shadows to create the \"card\" effect */\n  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);\n  transition: 0.3s;\n  border-radius: 5px; /* 5px rounded corners */\n  margin: 20px 0px 20px 0px;\n  background-color: #f6f6f6;\n  cursor: pointer;\n}\n\n.dev_smallCard__1ZSEH {\n  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);\n  transition: 0.3s;\n  border-radius: 5px; /* 5px rounded corners */\n  margin: 20px 0px 20px 0px;\n  background-color: #f6f6f6;\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: stretch;\n  cursor: pointer;\n}\n\n/* On mouse-over, add a deeper shadow */\n.dev_smallCard__1ZSEH:hover {\n  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);\n}\n\n.dev_smallImageCard__3HnVD {\n  width: 45%;\n  border-radius: 5px 0 0 5px;\n}\n\n/* On mouse-over, add a deeper shadow */\n.dev_card__1jSOX:hover {\n  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);\n}\n\n.dev_imageCard__3euEM {\n  width: 100%;\n  border-radius: 5px 5px 0 0;\n}\n\n/* Add some padding inside the card container */\n.dev_container__226Ui {\n  padding: 16px;\n}\n\n.dev_container__226Ui p {\n  font-size: small;\n}\n\n.dev_displayName__3JYzD {\n  font-size: 0.5em;\n}\n/*===================================\n  Buttons\n===================================*/\n.dev_buttonsContainer__cp_6x {\n\tpadding-bottom: 15px;\n}\n\n.dev_rtButton__3yXgy {\n\tbackground-color: lightgray;\n\tborder-radius: 6px;\n\tborder: 1px solid lightgray;\n\tdisplay: inline-block;\n\tcursor: pointer;\n\tpadding: 10px 10px;\n\ttext-decoration: none;\n\tmargin-right: 10px;\n\tmargin-bottom: 0.2em;\n  font-size: 14px;\n  min-width: 50px;\n}\n.dev_rtButton__3yXgy:hover {\n\tborder:1px solid #4eaa38;\n\tcolor: #4eaa38;\n}\n.dev_rtButton__3yXgy:active {\n\tposition:relative;\n\ttop:1px;\n}\n\n.dev_rtButtonEmoji__2d6ey {\n\tbackground-color: lightgray;\n\tborder-radius: 6px;\n\tborder: 1px solid lightgray;\n\tdisplay: inline-block;\n\tcursor: pointer;\n\tpadding: 10px 10px;\n\ttext-decoration: none;\n\tmargin-right: 10px;\n\tmargin-bottom: 0.2em;\n\tfont-size: 1.7em;\n}\n.dev_rtButtonEmoji__2d6ey:hover {\n\tborder:1px solid #4eaa38;\n\tcolor: #4eaa38;\n}\n.dev_rtButtonEmoji__2d6ey:active {\n\tposition:relative;\n\ttop:1px;\n}\n\n.dev_rtButtonCard__2nKnP {\n\tbox-shadow:inset 0px 1px 0px 0px #999999;\n\tbackground:linear-gradient(to bottom, #999999 5%, #f6f6f6 100%);\n\tbackground-color:#999999;\n\tborder-radius:6px;\n\tborder:1px solid #dcdcdc;\n\tdisplay:inline-block;\n\tcursor:pointer;\n\tcolor:#666666;\n\tfont-family:Arial;\n\tfont-size:15px;\n\tfont-weight:bold;\n\tpadding:10px 25px;\n\ttext-decoration:none;\n  text-shadow:0px 1px 0px #999999;\n  margin-right: 10px;\n}\n.dev_rtButtonCard__2nKnP:hover {\n\tbackground:linear-gradient(to bottom, #f6f6f6 5%, #999999 100%);\n\tbackground-color:#f6f6f6;\n}\n.dev_rtButtonCard__2nKnP:active {\n\tposition:relative;\n\ttop:1px;\n}\n\n@media only screen and (max-width: 768px) {\n\n\t.dev_rtButton__3yXgy {\n\t\tmin-width: 90%;\n\t}\n}\n\n";
var dev = {"content":"dev_content__1pCT0","conversationTitle":"dev_conversationTitle__1XFQ4","status":"dev_status__3RTRU","conversationWrapper":"dev_conversationWrapper__2-WcO","settingsContainer":"dev_settingsContainer__1PSjF","messageSent":"dev_messageSent__2mDun","messageReceived":"dev_messageReceived__267Vs","bubble":"dev_bubble__3XjRJ","timestamp":"dev_timestamp__3ZdSc","avatar":"dev_avatar__3ufxE","time":"dev_time__2cSB9","messagingArea":"dev_messagingArea__3HumR","send":"dev_send__15Gst","button":"dev_button__17sgh","spinnerContainer":"dev_spinnerContainer__1_b32","spinner":"dev_spinner__ZSKyF","rotator":"dev_rotator__N6JaM","path":"dev_path__2InTA","dash":"dev_dash__26mgj","colors":"dev_colors__2xZBM","closeMobile":"dev_closeMobile__1sX-6","messagingAreaHide":"dev_messagingAreaHide__yb2Rn","chatboxContainer":"dev_chatboxContainer__14UTL","actionButton":"dev_actionButton__3kKO6","wrapper":"dev_wrapper__36Bz-","closed":"dev_closed__WI_eJ","buttonOpenColl":"dev_buttonOpenColl__3n3xp","buttonCloseColl":"dev_buttonCloseColl__pyWHS","arrowOpen":"dev_arrowOpen__3HAhI","arrowClose":"dev_arrowClose__3EQ-n","textMoreInfo":"dev_textMoreInfo__3IuYZ","mainColor":"dev_mainColor__1eAox","card":"dev_card__1jSOX","smallCard":"dev_smallCard__1ZSEH","smallImageCard":"dev_smallImageCard__3HnVD","imageCard":"dev_imageCard__3euEM","container":"dev_container__226Ui","displayName":"dev_displayName__3JYzD","buttonsContainer":"dev_buttonsContainer__cp_6x","rtButton":"dev_rtButton__3yXgy","rtButtonEmoji":"dev_rtButtonEmoji__2d6ey","rtButtonCard":"dev_rtButtonCard__2nKnP"};
styleInject(css$7);

var css$8 = ".qa_content__gm3Lm {\n  background: #fff;\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);\n  margin: 3.2em auto;\n  border-radius: 8px 8px 0 0;\n  position: fixed;\n  width: 30vw;\n  right: 30px;\n  bottom: 45px;\n  font-family: 'Montserrat Light', arial;\n  z-index: 999;\n  min-width: 400px;\n}\n\n\n.qa_conversationTitle__1nVrU {\n  text-align: center;\n  padding: 8px;\n  background: #0074D9;\n  background-repeat: no-repeat;\n  background-position: center;\n  color: #FFF;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n  height: 1em;\n}\n.qa_conversationTitle__1nVrU h1 {\n  font: 700 18px 'Noto Sans', sans-serif;\n  margin: 0;\n}\n.qa_conversationTitle__1nVrU .qa_status__2WcHX {\n  font-size: 12px;\n  width: 50px;\n}\n\n.qa_status__2WcHX:hover {\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.qa_conversationWrapper__1CqFS {\n  background:#E6E6E6;\n  padding: 25px;\n  height: 60vh;\n  overflow-y: auto;\n  border: 1px solid lightgrey;\n  --scrollbarBG: lightgrey;\n  --thumbBG: #E6E6E6;\n  scrollbar-width: thin;\n  scrollbar-color: var(--thumbBG) var(--scrollbarBG);\n}\n\n.qa_conversationWrapper__1CqFS::-webkit-scrollbar {\n  width: 11px;\n}\n\n.qa_conversationWrapper__1CqFS::-webkit-scrollbar-track {\n  background: var(--scrollbarBG);\n}\n\n.qa_conversationWrapper__1CqFS::-webkit-scrollbar-thumb {\n  background-color: var(--thumbBG) ;\n  border-radius: 6px;\n  border: 3px solid var(--scrollbarBG);\n}\n\n /* Hide scrollbar for Chrome, Safari and Opera */\n /* .conversationWrapper::-webkit-scrollbar {\n  display: none;\n} */\n\n/* Hide scrollbar for IE and Edge */\n/* .conversationWrapper {\n  -ms-overflow-style: none;\n}  */\n\n.qa_settingsContainer__hIOJm {\n  background: white;\n  border: 1px solid lightgrey;\n  padding: 25px;\n  height: 500px;\n  overflow-y: auto;\n  font-size: medium;\n}\n\n.qa_settingsContainer__hIOJm select {\n  width: 100%;\n  height: 25px;\n  border: 1px solid lightgrey;\n  margin: 15px 0 15px 0;\n}\n\n.qa_settingsContainer__hIOJm input {\n  width: 100%;\n  height: 25px;\n  border: 1px solid lightgrey;\n  margin: 5px 0 5px 0;\n  padding-left: 10px;\n}\n\n.qa_messageSent__Myv2I, .qa_messageReceived__2WPAd {\n  padding: 0;\n}\n.qa_messageReceived__2WPAd {\n  text-align: left;\n  margin-bottom: 10px;\n}\n.qa_messageSent__Myv2I {\n  text-align: right;\n}\n\n.qa_messageSent__Myv2I > .qa_bubble__3draw {\n  border-radius: 12px 12px 0px 12px;\n}\n\n.qa_messageReceived__2WPAd > .qa_bubble__3draw {\n  border-radius: 12px 12px 12px 0px;\n}\n\n.qa_bubble__3draw {\n  background: #fff;\n  padding: 12px 18px;\n  border: 0.5px solid rgba(0, 0, 0, 0.02);\n  box-shadow: 0 2px 1px rgba(0, 0, 0, 0.08);\n  max-width: 70%;\n  display: inline-block;\n  text-align: left;\n  font-size: 14px;\n  margin-top: 5px;\n  margin-bottom: 5px;\n}\n.qa_timestamp__2Uxf9 {\n  margin: 0 0;\n}\n.qa_timestamp__2Uxf9 .qa_avatar__3Fa6f {\n  border-radius: 50%;\n  background: linear-gradient(to top right, #e9e7e8, #898b8f);\n  display: inline-block;\n  width: 25px;\n  height: 20px;\n  vertical-align: top;\n  color: #fff;\n  font-size: 10px;\n  text-align: center;\n  padding-top: 5px;\n}\n.qa_timestamp__2Uxf9 .qa_time__rkbNQ {\n  font-size: 12px;\n  color: #999;\n  margin: 0 5px;\n}\n.qa_messagingArea__1A_7e {\n  position: relative;\n  box-shadow: 0 -2px 1px rgba(0, 0, 0, 0.03);\n  border-bottom: 1px solid lightgrey;\n  border-left: 1px solid lightgrey;\n  border-right: 1px solid lightgrey;\n  overflow: hidden;\n}\n.qa_messagingArea__1A_7e input {\n  font-size: 14px;\n  border: none;\n  padding: 20px 30px;\n  width: 100%;\n  border-bottom-left-radius: 0px;\n  border-bottom-right-radius: 0px;\n  line-height: normal;\n}\n.qa_messagingArea__1A_7e input:focus {\n  outline: 0;\n}\n\n.qa_send__2slkB {\n  background: linear-gradient(to top right, #e9e7e8, #898b8f);\n  color: #fff;\n  border-radius: 50%;\n  width: 25px;\n  height: 25px;\n  padding: 8px 10px 12px;\n  position: absolute;\n  font-size: 0.7em;\n  text-align: center;\n  right: 8px;\n  bottom: 8px;\n}\n\n.qa_button__3npq_ {\n\t/* box-shadow:inset 0px -3px 7px 0px #898b8f; */\n\tcolor: gray;\n\tbackground-color:white;\n\tborder-radius:3px;\n\tborder: 1px solid lightgray;\n\tdisplay:inline-block;\n\tcursor:pointer;\n\tfont-size:15px;\n\tpadding:9px 23px;\n\ttext-decoration:none;\n  /* text-shadow:0px 1px 0px #263666; */\n  margin-top: 25px;\n}\n.qa_button__3npq_:hover {\n  background-color:#898b8f;\n  color: white;\n}\n.qa_button__3npq_:active {\n\tposition:relative;\n\ttop:1px;\n}\n\n.qa_spinnerContainer__8mswA {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 500px;\n  border: 1px solid lightgrey;\n}\n\n.qa_spinner__1BpN6 {\n  animation: qa_rotator__CJPiN 1.4s linear infinite;\n}\n\n@keyframes qa_rotator__CJPiN {\n  0% {\n    transform: rotate(0deg);\n }\n  100% {\n    transform: rotate(270deg);\n }\n}\n.qa_path__wBQsT {\n  stroke-dasharray: 187;\n  stroke-dashoffset: 0;\n  transform-origin: center;\n  animation: qa_dash__2XkQe 1.4s ease-in-out infinite, qa_colors__1rq4O 5.6s ease-in-out infinite;\n}\n@keyframes qa_colors__1rq4O {\n  0% {\n    stroke: #4285f4;\n }\n  25% {\n    stroke: #de3e35;\n }\n  50% {\n    stroke: #f7c223;\n }\n  75% {\n    stroke: #1b9a59;\n }\n  100% {\n    stroke: #4285f4;\n }\n}\n@keyframes qa_dash__2XkQe {\n  0% {\n    stroke-dashoffset: 187;\n }\n  50% {\n    stroke-dashoffset: 46.75;\n    transform: rotate(135deg);\n }\n  100% {\n    stroke-dashoffset: 187;\n    transform: rotate(450deg);\n }\n}\n\n.qa_closeMobile__167YA {\n  display: none;\n}\n\n@media only screen and (max-width: 768px) {\n  /* For mobile phones: */\n  .qa_content__gm3Lm {\n    bottom: 0 !important;\n    width: 100vw !important;\n    height: 100%;\n    right: 0;\n    bottom: 0;\n    position: unset;\n    margin: 0;\n    min-width: 0;\n  }\n\n  .qa_conversationTitle__1nVrU {\n    border-top-left-radius: 0px;\n    border-top-right-radius: 0px;\n  }\n\n  .qa_conversationWrapper__1CqFS {\n    height: 100vh;\n    padding: 20px;\n  }\n\n  .qa_messagingArea__1A_7e {\n    position: fixed;\n    bottom: 0px;\n    width: 100vw;\n    background-color: lightgrey;\n    height: 2em;\n  }\n\n\n\n  .qa_messagingAreaHide__rRd-Q {\n    display: none;\n  }\n\n  .qa_closeMobile__167YA {\n    height: 30px;\n    width: 30px;\n    display: block;\n    position: fixed;\n    right: 20px;\n    top: 0.6rem;\n    color: white;\n    background-image:url('data:image/png;base64,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');\n    background-size: contain;\n  }\n}\n\n/* IPHONE X */\n@media only screen\nand (min-device-width : 375px)\nand (max-device-width : 812px)\nand (-webkit-device-pixel-ratio : 3)\nand (orientation : portrait) {\n\n  .qa_messagingArea__1A_7e > input {\n    /* enlarge by 16/12 = 133.33% */\n    border-radius: 6.666666667px;\n    font-size: 20px;\n    line-height: 26.666666667px;\n    padding: 6.666666667px;\n    width: 133.333333333%;\n\n    /* scale down by 12/16 = 75% */\n    transform: scale(0.75);\n    transform-origin: left top;\n  }\n\n  .qa_messagingArea__1A_7e {\n    position: fixed;\n    bottom: 0px;\n    width: 100vw;\n    background-color: white;\n    height: 1em;\n    padding: 4px;\n  }\n\n}\n\n@media only screen\nand (min-device-width : 375px)\nand (max-device-width : 667px)\nand (orientation : portrait) {\n  /* iPhone 6, 7, & 8 in portrait */\n  .qa_messagingArea__1A_7e > input {\n    /* enlarge by 16/12 = 133.33% */\n    border-radius: 6.666666667px;\n    font-size: 20px;\n    line-height: 26.666666667px;\n    padding: 6.666666667px;\n    width: 133.333333333%;\n\n    /* scale down by 12/16 = 75% */\n    transform: scale(0.75);\n    transform-origin: left top;\n  }\n\n  .qa_messagingArea__1A_7e {\n    position: fixed;\n    bottom: 0px;\n    width: 100vw;\n    background-color: white;\n    height: 1em;\n    padding: 4px;\n  }\n}\n\n@media only screen\nand (min-device-width : 320px)\nand (max-device-width : 568px) {\n  /* Iphone 5 */\n  /* iPhone 6, 7, & 8 in portrait */\n  .qa_messagingArea__1A_7e > input {\n    /* enlarge by 16/12 = 133.33% */\n    border-radius: 6.666666667px;\n    font-size: 20px;\n    line-height: 26.666666667px;\n    padding: 6.666666667px;\n    width: 133.333333333%;\n\n    /* scale down by 12/16 = 75% */\n    transform: scale(0.75);\n    transform-origin: left top;\n  }\n\n  .qa_messagingArea__1A_7e {\n    position: fixed;\n    bottom: 0px;\n    width: 100vw;\n    background-color: white;\n    height: 1em;\n    padding: 4px;\n  }\n}\n\n.qa_chatboxContainer__3wxPw {\n  font-size: 2em;\n  position: fixed;\n  right: 0px;\n  z-index: 100000;\n}\n\n@media only screen and (max-width: 600px) {\n  .qa_chatboxContainer__3wxPw {\n    top: 0px;\n    width: 100%;\n  }\n}\n\n.qa_actionButton__YGDfl {\n  background-color: #0074D9!important;\n  color: white!important;\n  border: 1px solid #0074D9!important;\n  display: inline-block;\n  text-align: center;\n  padding: 15px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-family: 'Montserrat-light';\n  font-size: 1.8rem;\n}\n\n.qa_actionButton__YGDfl:hover {\n  text-decoration: underline;\n}\n\n/* Collapsable */\n.qa_wrapper__3k-Vh {\n  overflow: hidden;\n  transition: height 200ms;\n}\n\n.qa_closed__2Dg06 {\n  display: none;\n}\n\n.qa_buttonOpenColl__1jGzp {\n  background-color: #0074D9;\n  border-radius: 6px;\n  border: 1px solid lightgray;\n  display: flex;\n  cursor: pointer;\n  padding: 10px 10px;\n  text-decoration: none;\n  margin-right: 10px;\n  margin-bottom: 0.2em;\n  width: 90px;\n  font-size: 14px;\n}\n\n.qa_buttonCloseColl__3PJJd {\n  background-color: #0074D9;\n  border-radius: 6px;\n  border: 1px solid lightgray;\n  display: flex;\n  cursor: pointer;\n  padding: 5px 5px 10px 5px;\n  text-decoration: none;\n  margin-right: 10px;\n  margin-bottom: 0.2em;\n  width: 6em;\n  font-size: 14px;\n  flex: initial;\n  height: 10px;\n}\n\n.qa_arrowOpen__3uOCX {\n  height: 20px;\n  width: 20px;\n  color: white;\n  background-image: url('data:image/png;base64,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');\n  background-size: contain;\n  display: flex;\n  margin-right: 10px;\n  transform: rotate(180deg);\n}\n\n.qa_arrowClose__Px7l4 {\n\n  height: 20px;\n  width: 20px;\n  color: white;\n  background-image: url('data:image/png;base64,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');\n  background-size: contain;\n  display: flex;\n  margin-right: 10px;\n\n}\n\n.qa_textMoreInfo__1E878 {\n  display: flex;\n  font-size: 1em;\n  color: #FFF;\n}\n\n.qa_mainColor__1RopQ {\n  color: #0074D9 !important;\n}\n\n.qa_card__3p7TU {\n  /* Add shadows to create the \"card\" effect */\n  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);\n  transition: 0.3s;\n  border-radius: 5px; /* 5px rounded corners */\n  margin: 20px 0px 20px 0px;\n  background-color: #f6f6f6;\n  cursor: pointer;\n}\n\n.qa_smallCard__4MgrC {\n  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);\n  transition: 0.3s;\n  border-radius: 5px; /* 5px rounded corners */\n  margin: 20px 0px 20px 0px;\n  background-color: #f6f6f6;\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: stretch;\n  cursor: pointer;\n}\n\n/* On mouse-over, add a deeper shadow */\n.qa_smallCard__4MgrC:hover {\n  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);\n}\n\n.qa_smallImageCard__28QUe {\n  width: 45%;\n  border-radius: 5px 0 0 5px;\n}\n\n/* On mouse-over, add a deeper shadow */\n.qa_card__3p7TU:hover {\n  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);\n}\n\n.qa_imageCard__33ZAM {\n  width: 100%;\n  border-radius: 5px 5px 0 0;\n}\n\n/* Add some padding inside the card container */\n.qa_container__1NFbc {\n  padding: 16px;\n}\n\n.qa_container__1NFbc p {\n  font-size: small;\n}\n\n.qa_displayName__24rJ_ {\n  font-size: 0.5em;\n}\n/*===================================\n  Buttons\n===================================*/\n.qa_buttonsContainer__2ujHN {\n\tpadding-bottom: 15px;\n}\n\n.qa_rtButton__Ga_4E {\n\tbackground-color: lightgray;\n\tborder-radius: 6px;\n\tborder: 1px solid lightgray;\n\tdisplay: inline-block;\n\tcursor: pointer;\n\tpadding: 10px 10px;\n\ttext-decoration: none;\n\tmargin-right: 10px;\n\tmargin-bottom: 0.2em;\n  font-size: 14px;\n  min-width: 50px;\n}\n.qa_rtButton__Ga_4E:hover {\n\tborder:1px solid #4eaa38;\n\tcolor: #4eaa38;\n}\n.qa_rtButton__Ga_4E:active {\n\tposition:relative;\n\ttop:1px;\n}\n\n.qa_rtButtonEmoji__1uCXv {\n\tbackground-color: lightgray;\n\tborder-radius: 6px;\n\tborder: 1px solid lightgray;\n\tdisplay: inline-block;\n\tcursor: pointer;\n\tpadding: 10px 10px;\n\ttext-decoration: none;\n\tmargin-right: 10px;\n\tmargin-bottom: 0.2em;\n\tfont-size: 1.7em;\n}\n.qa_rtButtonEmoji__1uCXv:hover {\n\tborder:1px solid #4eaa38;\n\tcolor: #4eaa38;\n}\n.qa_rtButtonEmoji__1uCXv:active {\n\tposition:relative;\n\ttop:1px;\n}\n\n.qa_rtButtonCard__nVpp7 {\n\tbox-shadow:inset 0px 1px 0px 0px #999999;\n\tbackground:linear-gradient(to bottom, #999999 5%, #f6f6f6 100%);\n\tbackground-color:#999999;\n\tborder-radius:6px;\n\tborder:1px solid #dcdcdc;\n\tdisplay:inline-block;\n\tcursor:pointer;\n\tcolor:#666666;\n\tfont-family:Arial;\n\tfont-size:15px;\n\tfont-weight:bold;\n\tpadding:10px 25px;\n\ttext-decoration:none;\n  text-shadow:0px 1px 0px #999999;\n  margin-right: 10px;\n}\n.qa_rtButtonCard__nVpp7:hover {\n\tbackground:linear-gradient(to bottom, #f6f6f6 5%, #999999 100%);\n\tbackground-color:#f6f6f6;\n}\n.qa_rtButtonCard__nVpp7:active {\n\tposition:relative;\n\ttop:1px;\n}\n\n@media only screen and (max-width: 768px) {\n\n\t.qa_rtButton__Ga_4E {\n\t\tmin-width: 90%;\n\t}\n}\n\n";
var qa = {"content":"qa_content__gm3Lm","conversationTitle":"qa_conversationTitle__1nVrU","status":"qa_status__2WcHX","conversationWrapper":"qa_conversationWrapper__1CqFS","settingsContainer":"qa_settingsContainer__hIOJm","messageSent":"qa_messageSent__Myv2I","messageReceived":"qa_messageReceived__2WPAd","bubble":"qa_bubble__3draw","timestamp":"qa_timestamp__2Uxf9","avatar":"qa_avatar__3Fa6f","time":"qa_time__rkbNQ","messagingArea":"qa_messagingArea__1A_7e","send":"qa_send__2slkB","button":"qa_button__3npq_","spinnerContainer":"qa_spinnerContainer__8mswA","spinner":"qa_spinner__1BpN6","rotator":"qa_rotator__CJPiN","path":"qa_path__wBQsT","dash":"qa_dash__2XkQe","colors":"qa_colors__1rq4O","closeMobile":"qa_closeMobile__167YA","messagingAreaHide":"qa_messagingAreaHide__rRd-Q","chatboxContainer":"qa_chatboxContainer__3wxPw","actionButton":"qa_actionButton__YGDfl","wrapper":"qa_wrapper__3k-Vh","closed":"qa_closed__2Dg06","buttonOpenColl":"qa_buttonOpenColl__1jGzp","buttonCloseColl":"qa_buttonCloseColl__3PJJd","arrowOpen":"qa_arrowOpen__3uOCX","arrowClose":"qa_arrowClose__Px7l4","textMoreInfo":"qa_textMoreInfo__1E878","mainColor":"qa_mainColor__1RopQ","card":"qa_card__3p7TU","smallCard":"qa_smallCard__4MgrC","smallImageCard":"qa_smallImageCard__28QUe","imageCard":"qa_imageCard__33ZAM","container":"qa_container__1NFbc","displayName":"qa_displayName__24rJ_","buttonsContainer":"qa_buttonsContainer__2ujHN","rtButton":"qa_rtButton__Ga_4E","rtButtonEmoji":"qa_rtButtonEmoji__1uCXv","rtButtonCard":"qa_rtButtonCard__nVpp7"};
styleInject(css$8);

var css$9 = "\n.pro_content__3U-Yj {\n  background: #fff;\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);\n  margin: 3.2em auto;\n  border-radius: 8px 8px 0 0;\n  position: fixed;\n  width: 30vw;\n  right: 30px;\n  bottom: 45px;\n  font-family: 'Montserrat Light', arial;\n  z-index: 999;\n  min-width: 400px;\n}\n\n\n.pro_conversationTitle__D71ua {\n  text-align: center;\n  padding: 8px;\n  background: #FF4136;\n  /*background-image: url('data:image/png;base64,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');*/\n  background-repeat: no-repeat;\n  background-position: center;\n  color: #FFF;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n  height: 1em;\n}\n\n.pro_conversationTitle__D71ua h1 {\n  font: 700 18px 'Noto Sans', sans-serif;\n  margin: 0;\n}\n\n.pro_conversationTitle__D71ua .pro_status__3Z2ht {\n  font-size: 12px;\n  width: 50px;\n}\n\n.pro_status__3Z2ht:hover {\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.pro_conversationWrapper__2LHAp {\n  background: #E6E6E6;\n  padding: 25px;\n  height: 60vh;\n  overflow-y: auto;\n  border: 1px solid lightgrey;\n  --scrollbarBG: lightgrey;\n  --thumbBG: #E6E6E6;\n  scrollbar-width: thin;\n  scrollbar-color: var(--thumbBG) var(--scrollbarBG);\n}\n\n.pro_conversationWrapper__2LHAp::-webkit-scrollbar {\n  width: 11px;\n}\n\n.pro_conversationWrapper__2LHAp::-webkit-scrollbar-track {\n  background: var(--scrollbarBG);\n}\n\n.pro_conversationWrapper__2LHAp::-webkit-scrollbar-thumb {\n  background-color: var(--thumbBG);\n  border-radius: 6px;\n  border: 3px solid var(--scrollbarBG);\n}\n\n/* Hide scrollbar for Chrome, Safari and Opera */\n/* .conversationWrapper::-webkit-scrollbar {\n  display: none;\n} */\n\n/* Hide scrollbar for IE and Edge */\n/* .conversationWrapper {\n  -ms-overflow-style: none;\n}  */\n\n.pro_settingsContainer__1AW-m {\n  background: white;\n  border: 1px solid lightgrey;\n  padding: 25px;\n  height: 500px;\n  overflow-y: auto;\n  font-size: medium;\n}\n\n.pro_settingsContainer__1AW-m select {\n  width: 100%;\n  height: 25px;\n  border: 1px solid lightgrey;\n  margin: 15px 0 15px 0;\n}\n\n.pro_settingsContainer__1AW-m input {\n  width: 100%;\n  height: 25px;\n  border: 1px solid lightgrey;\n  margin: 5px 0 5px 0;\n  padding-left: 10px;\n}\n\n.pro_messageSent__1zVdy,\n.pro_messageReceived__1FlOw {\n  padding: 0;\n}\n\n.pro_messageReceived__1FlOw {\n  text-align: left;\n  margin-bottom: 10px;\n}\n\n.pro_messageSent__1zVdy {\n  text-align: right;\n}\n\n.pro_messageSent__1zVdy>.pro_bubble__3vL7M {\n  border-radius: 12px 12px 0px 12px;\n}\n\n.pro_messageReceived__1FlOw>.pro_bubble__3vL7M {\n  border-radius: 12px 12px 12px 0px;\n}\n\n.pro_bubble__3vL7M {\n  background: #fff;\n  padding: 12px 18px;\n  border: 0.5px solid rgba(0, 0, 0, 0.02);\n  box-shadow: 0 2px 1px rgba(0, 0, 0, 0.08);\n  max-width: 70%;\n  display: inline-block;\n  text-align: left;\n  font-size: 14px;\n  margin-top: 5px;\n  margin-bottom: 5px;\n}\n\n.pro_timestamp__27_wB {\n  margin: 0 0;\n}\n\n.pro_timestamp__27_wB .pro_avatar__SAyvm {\n  border-radius: 50%;\n  background: linear-gradient(to top right, #e9e7e8, #898b8f);\n  display: inline-block;\n  width: 25px;\n  height: 20px;\n  vertical-align: top;\n  color: #fff;\n  font-size: 10px;\n  text-align: center;\n  padding-top: 5px;\n}\n\n.pro_timestamp__27_wB .pro_time__xKrbs {\n  font-size: 12px;\n  color: #999;\n  margin: 0 5px;\n}\n\n.pro_messagingArea__1agCN {\n  position: relative;\n  box-shadow: 0 -2px 1px rgba(0, 0, 0, 0.03);\n  border-bottom: 1px solid lightgrey;\n  border-left: 1px solid lightgrey;\n  border-right: 1px solid lightgrey;\n  overflow: hidden;\n}\n\n.pro_messagingArea__1agCN input {\n  font-size: 14px;\n  border: none;\n  padding: 20px 30px;\n  width: 100%;\n  border-bottom-left-radius: 0px;\n  border-bottom-right-radius: 0px;\n  line-height: normal;\n}\n\n.pro_messagingArea__1agCN input:focus {\n  outline: 0;\n}\n\n.pro_send__gNVFc {\n  background: linear-gradient(to top right, #e9e7e8, #898b8f);\n  color: #fff;\n  border-radius: 50%;\n  width: 25px;\n  height: 25px;\n  padding: 8px 10px 12px;\n  position: absolute;\n  font-size: 0.7em;\n  text-align: center;\n  right: 8px;\n  bottom: 8px;\n}\n\n.pro_button__-YnLf {\n  /* box-shadow:inset 0px -3px 7px 0px #898b8f; */\n  color: gray;\n  background-color: white;\n  border-radius: 3px;\n  border: 1px solid lightgray;\n  display: inline-block;\n  cursor: pointer;\n  font-size: 15px;\n  padding: 9px 23px;\n  text-decoration: none;\n  /* text-shadow:0px 1px 0px #263666; */\n  margin-top: 25px;\n}\n\n.pro_button__-YnLf:hover {\n  background-color: #898b8f;\n  color: white;\n}\n\n.pro_button__-YnLf:active {\n  position: relative;\n  top: 1px;\n}\n\n.pro_spinnerContainer__1l8ER {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 500px;\n  border: 1px solid lightgrey;\n}\n\n.pro_spinner__2jrC_ {\n  animation: pro_rotator__gQCVW 1.4s linear infinite;\n}\n\n@keyframes pro_rotator__gQCVW {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(270deg);\n  }\n}\n\n.pro_path__2IY-0 {\n  stroke-dasharray: 187;\n  stroke-dashoffset: 0;\n  transform-origin: center;\n  animation: pro_dash__OOTL- 1.4s ease-in-out infinite, pro_colors__1U9_n 5.6s ease-in-out infinite;\n}\n\n@keyframes pro_colors__1U9_n {\n  0% {\n    stroke: #4285f4;\n  }\n\n  25% {\n    stroke: #de3e35;\n  }\n\n  50% {\n    stroke: #f7c223;\n  }\n\n  75% {\n    stroke: #1b9a59;\n  }\n\n  100% {\n    stroke: #4285f4;\n  }\n}\n\n@keyframes pro_dash__OOTL- {\n  0% {\n    stroke-dashoffset: 187;\n  }\n\n  50% {\n    stroke-dashoffset: 46.75;\n    transform: rotate(135deg);\n  }\n\n  100% {\n    stroke-dashoffset: 187;\n    transform: rotate(450deg);\n  }\n}\n\n.pro_closeMobile__1Q2dg {\n  display: none;\n}\n\n@media only screen and (max-width: 768px) {\n\n  /* For mobile phones: */\n  .pro_content__3U-Yj {\n    bottom: 0 !important;\n    width: 100vw !important;\n    height: 100%;\n    right: 0;\n    bottom: 0;\n    position: unset;\n    margin: 0;\n    min-width: 0;\n  }\n\n  .pro_conversationTitle__D71ua {\n    border-top-left-radius: 0px;\n    border-top-right-radius: 0px;\n  }\n\n  .pro_conversationWrapper__2LHAp {\n    height: 100vh;\n    padding: 20px;\n  }\n\n  .pro_messagingArea__1agCN {\n    position: fixed;\n    bottom: 0px;\n    width: 100vw;\n    background-color: lightgrey;\n    height: 2em;\n  }\n\n\n\n  .pro_messagingAreaHide__1HRBx {\n    display: none;\n  }\n\n  .pro_closeMobile__1Q2dg {\n    height: 30px;\n    width: 30px;\n    display: block;\n    position: fixed;\n    right: 20px;\n    top: 0.6rem;\n    color: white;\n    background-image: url('data:image/png;base64,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');\n    background-size: contain;\n  }\n}\n\n/* IPHONE X */\n@media only screen and (min-device-width : 375px) and (max-device-width : 812px) and (-webkit-device-pixel-ratio : 3) and (orientation : portrait) {\n\n  .pro_messagingArea__1agCN>input {\n    /* enlarge by 16/12 = 133.33% */\n    border-radius: 6.666666667px;\n    font-size: 20px;\n    line-height: 26.666666667px;\n    padding: 6.666666667px;\n    width: 133.333333333%;\n\n    /* scale down by 12/16 = 75% */\n    transform: scale(0.75);\n    transform-origin: left top;\n  }\n\n  .pro_messagingArea__1agCN {\n    position: fixed;\n    bottom: 0px;\n    width: 100vw;\n    background-color: white;\n    height: 1em;\n    padding: 4px;\n  }\n\n}\n\n@media only screen and (min-device-width : 375px) and (max-device-width : 667px) and (orientation : portrait) {\n\n  /* iPhone 6, 7, & 8 in portrait */\n  .pro_messagingArea__1agCN>input {\n    /* enlarge by 16/12 = 133.33% */\n    border-radius: 6.666666667px;\n    font-size: 20px;\n    line-height: 26.666666667px;\n    padding: 6.666666667px;\n    width: 133.333333333%;\n\n    /* scale down by 12/16 = 75% */\n    transform: scale(0.75);\n    transform-origin: left top;\n  }\n\n  .pro_messagingArea__1agCN {\n    position: fixed;\n    bottom: 0px;\n    width: 100vw;\n    background-color: white;\n    height: 1em;\n    padding: 4px;\n  }\n}\n\n@media only screen and (min-device-width : 320px) and (max-device-width : 568px) {\n\n  /* Iphone 5 */\n  /* iPhone 6, 7, & 8 in portrait */\n  .pro_messagingArea__1agCN>input {\n    /* enlarge by 16/12 = 133.33% */\n    border-radius: 6.666666667px;\n    font-size: 20px;\n    line-height: 26.666666667px;\n    padding: 6.666666667px;\n    width: 133.333333333%;\n\n    /* scale down by 12/16 = 75% */\n    transform: scale(0.75);\n    transform-origin: left top;\n  }\n\n  .pro_messagingArea__1agCN {\n    position: fixed;\n    bottom: 0px;\n    width: 100vw;\n    background-color: white;\n    height: 1em;\n    padding: 4px;\n  }\n}\n\n/* add css styles here (optional) */\n.pro_chatboxContainer__10Qm2 {\n  font-size: 2em;\n  position: fixed;\n  right: 0px;\n  z-index: 100000;\n}\n\n@media only screen and (max-width: 600px) {\n  .pro_chatboxContainer__10Qm2 {\n    top: 0px;\n    width: 100%;\n  }\n}\n\n.pro_actionButton__kjVr5 {\n  background-color: #FF4136 !important;\n  color: white !important;\n  border: 1px solid #FF4136 !important;\n  display: inline-block;\n  text-align: center;\n  padding: 15px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-family: 'Montserrat-light';\n  font-size: 1.8rem;\n}\n\n.pro_actionButton__kjVr5:hover {\n  text-decoration: underline;\n}\n\n/* Collapsable */\n.pro_wrapper__1hNM6 {\n  overflow: hidden;\n  transition: height 200ms;\n}\n\n.pro_closed__1OQ5s {\n  display: none;\n}\n\n.pro_buttonOpenColl__1G1Kl {\n  background-color: #FF4136;\n  border-radius: 6px;\n  border: 1px solid lightgray;\n  display: flex;\n  cursor: pointer;\n  padding: 10px 10px;\n  text-decoration: none;\n  margin-right: 10px;\n  margin-bottom: 0.2em;\n  width: 90px;\n  font-size: 14px;\n}\n\n.pro_buttonCloseColl__3y-EO {\n  background-color: #FF4136;\n  border-radius: 6px;\n  border: 1px solid lightgray;\n  display: flex;\n  cursor: pointer;\n  padding: 5px 5px 10px 5px;\n  text-decoration: none;\n  margin-right: 10px;\n  margin-bottom: 0.2em;\n  width: 6em;\n  font-size: 14px;\n  flex: initial;\n  height: 10px;\n}\n\n.pro_arrowOpen__Pbq-g {\n  height: 20px;\n  width: 20px;\n  color: white;\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAQAAAAAYLlVAAAF6npUWHRSYXcgcHJvZmlsZSB0eXBlIGV4aWYAAHja7VhZsqM4EPyvU/QRtC/H0RoxN5jjd5YkvNtg3vtsE0ZYEqUiMysBU/v/v05/8NEhOjLWBxedE/iYaKJKOAhifuLYS2HGfnzMGsLvu366DCh0abR6/vRpzU/ot9cTtjVkvu+nsEZUWIHWwBZQ88oKB/U2SfSr2S9XJhTbPHAx+NtUs5pt2VIO12/zwo9gdg7xb7rtMB4oVYuFtFJNSy3G3swM9PwmfM3Ye56H8YTfhtBIrVYmAOTu8rZWiFuA7kDejugR/cvRA/gqrX79gKVbGOHg5YC0r8EfEN8srC8ZqfsBtO3pcta39xp6b/PqknFA1C1FCdrQ4XMwMQNyPU5z2Dy+Fsd+bBFbEEkUUF5FERlbkVEqsNJJGlllkl220RZZkKJRTYETpVQBLdwXwFFUBVxJ5kgb2ZXXUVcdwFxRjbRGt7rkIse6caxXZMDKVWKqkggGdt9v9Gnwm416LwyRFOGCFfJSrCykwczxHrNAiOyLDjsA3rZFv7jRD6QKBu2AOeACk8gzRLbyqi09eNaYZ9HOEpLk6woAiLC2RTJSgwHhpLbSSeGV8lICxwCCEjJX2qgMBqS1qiJJZbR2irwKitfGOV6Oucoqp7gb3gQirHbag5uoE8gyxkI/3gRoKFltjbXWWW8D2WiT084465zzjk0uee2Nt95574OPPgUdTLDBBR9CiCFFFTU80EYXfQwxxpQUJSyUECthfkJPVllnk2122eeQY04F8imm2OKKL6HEkqqqusImqqu+hhprapIanKKZZptrvoUWW+rQWtfddNtd9z302NOFtcXq0/YFa3KxpgZTPM9fWEMveb+FkGwnljkDY8pIMO6ZAQhaMWciSGMUM8eciahQFFYhScvcUJXMGCg0TSrb5YW7K3OHeCMbDvGm9pgjpu43mCNQ98zbC9Yq3+fKYGxWIWMqNKoP4y0kUiHxTS39tP0X6AeBemYuwEkYvwwOYu6ioFva0sGWs7wvpvaejaZWe3MoqJx9tFk7NyfVrCNGalW5IKIQaSzyvqW9CUdazpcCMpwJo6A6xN1nsrq3Ipv1M9ecu2995opirLH16oLQnO1EgW6Rye0JCgZiRIaVGL1wADK3SAwcaAHRcudMdeNkc8WBcr3wnTNYr3uNvneJlFsVPfuOxRBOtdqsKzUif6rZleY9Rk1ChZ3WAH2eMHKT0a/cQkXxxpUbLioLXODMjSqKvtc+Uq0ZPqGdz93yo9slAh5OLjFgpysKUJtx+AodrSi3MeAa7Y5jPUgA7iPGJGHQm3RfFFhifkufDPAq3cmrFpkClvblCid/E/+VnwqDAWIKOL2uFwH8WHbFH5FXfm/0sZUKbbWyXyrvFcI50iaSBeJVJrciOaAROiGaO01sjNInSl8wKt7pih6F9U5XT5oQqceFE8NMW2oLJybzklmebM7IQCpc414jrNOJi3Gdvc5FXm/Ovse536mUlhYehXqvU56xo1PqV5luIl0anZltKgViH3VKZ43sUaV01sgeNUrnjOzZp+idUX3rU/SFqj9qkq6S+kZRVz1eau1LRb+9P9ALkb600j0npaNWuuekdNRK95yUjlrpnpPSUSvdUyUdufkdccqvlf1OlfQorLNOSWd0/QrGD9X/rNJPTkpHrXTPSemole45KR210j0npaNWuqdJ2nukO+qUdELVLzVJ4unme84pz977n2D77jXrg5PSUSvdc1I6aqV7CqWjVrqnUTpqpR9UOoLRN68Jn5zytLIfVUmPD5VnnZJ+outbVdLPX/qnSumole45KR210j0npZ++XW/J0SbTVY4v/gJAqJd/AnA9Xv8EoKX4l6//E70RdZURozejjjICeiPqqjV5/W/hxfkPZ/Pl3Zx/OZmqO/gvyk5L7wb0FzdHZpSeKWVCM3vEV0+W9OyHzOEk4P1r3nNF0rnXvOeKpO8eXt639Dslazv9vGRHuEzM0EshHxTi0uFv+NGvGdu/QCcC4RYaodC/O31MYktOhjIAAAEkaUNDUElDQyBwcm9maWxlAAB4nJ2Qv0rDUBTGf6nFiuhUcRCFDG5ScDGTi38wdCjUtoLRKU1SLCYxJCnFN/BN9GE6CIJP4BMoOPvd6OBgFi8cvh+Hc77v3gsNOw6SorkPSVrm7uDIu/Su7NYbTVq02WPHD4qsNzwbUXs+X7GMvnSMV/3cn2c5jIpAulClQZaXYB2KnXmZGVaxcTsanIgfxHaYpKH4SbwbJqFhsztI4lnw42lusxalF0PTV23j0qVHH5sxM6bElHSkqTqnOBxIXXJ87ikIpDGRenPNlNyICjm5HItGIt2mJm+ryusrZSyPqbxMwh2JPE0e5n+/1z7Oq01rc5H5uV+1llSNyQTeH2Hdg/YzrF7XZK38flvNjFPN/PONXwwfUHdeCSRsAAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAADukAAA7pAQ4zQhwAAAAHdElNRQfkBAcTLBVj2v8hAAAA+ElEQVRo3u2Y2w7DIAxDMf//z93DLuoYFOKYTNrip6qQ+LSFELWUVCqVSqX+XTiOxwVijZ++tb0Ra38CiEQ4O9XRQIx9AxCB0DrU2YS99qWgexNh9nerGIS+C64G99u/AHYjjLNjZdI++zeAXQjXWWGZrLf/AFAjzLOBCdLZdwFUCGtZ4An22w8BvAjr0VAk8URClYiNgjIZEwHt89iBpa+U+WTQLSpuxcjWNbtnoNnZ/JaVFBdP0TIV2L6Rr2a6K3wnpSmn+ZSbIVgPLckx6zm2qVZjhMB0DbJeh+2b6H6vRWDbNlHDyTeurqb7W793UqlUKpX6Ld0AolWAFIxyajgAAAAASUVORK5CYII=');\n  background-size: contain;\n  display: flex;\n  margin-right: 10px;\n  transform: rotate(180deg);\n}\n\n.pro_arrowClose__1brBE {\n\n  height: 20px;\n  width: 20px;\n  color: white;\n  background-image: url('data:image/png;base64,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');\n  background-size: contain;\n  display: flex;\n  margin-right: 10px;\n\n}\n\n.pro_textMoreInfo__3fjWv {\n  display: flex;\n  font-size: 1em;\n  color: #FFF;\n}\n\n.pro_mainColor__BjDND {\n  color: #FF4136 !important;\n}\n\n.pro_card__1D9Aq {\n  /* Add shadows to create the \"card\" effect */\n  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);\n  transition: 0.3s;\n  border-radius: 5px; /* 5px rounded corners */\n  margin: 20px 0px 20px 0px;\n  background-color: #f6f6f6;\n  cursor: pointer;\n}\n\n.pro_smallCard__1nBDH {\n  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);\n  transition: 0.3s;\n  border-radius: 5px; /* 5px rounded corners */\n  margin: 20px 0px 20px 0px;\n  background-color: #f6f6f6;\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: stretch;\n  cursor: pointer;\n}\n\n/* On mouse-over, add a deeper shadow */\n.pro_smallCard__1nBDH:hover {\n  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);\n}\n\n.pro_smallImageCard__26056 {\n  width: 45%;\n  border-radius: 5px 0 0 5px;\n}\n\n/* On mouse-over, add a deeper shadow */\n.pro_card__1D9Aq:hover {\n  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);\n}\n\n.pro_imageCard__2k8yD {\n  width: 100%;\n  border-radius: 5px 5px 0 0;\n}\n\n/* Add some padding inside the card container */\n.pro_container__X8hMe {\n  padding: 16px;\n}\n\n.pro_container__X8hMe p {\n  font-size: small;\n}\n\n.pro_displayName__3cOCk {\n  font-size: 0.5em;\n}\n/*===================================\n  Buttons\n===================================*/\n.pro_buttonsContainer__27yFa {\n\tpadding-bottom: 15px;\n}\n\n.pro_rtButton__1IY3- {\n\tbackground-color: lightgray;\n\tborder-radius: 6px;\n\tborder: 1px solid lightgray;\n\tdisplay: inline-block;\n\tcursor: pointer;\n\tpadding: 10px 10px;\n\ttext-decoration: none;\n\tmargin-right: 10px;\n\tmargin-bottom: 0.2em;\n  font-size: 14px;\n  min-width: 50px;\n}\n.pro_rtButton__1IY3-:hover {\n\tborder:1px solid #4eaa38;\n\tcolor: #4eaa38;\n}\n.pro_rtButton__1IY3-:active {\n\tposition:relative;\n\ttop:1px;\n}\n\n.pro_rtButtonEmoji__1LIoN {\n\tbackground-color: lightgray;\n\tborder-radius: 6px;\n\tborder: 1px solid lightgray;\n\tdisplay: inline-block;\n\tcursor: pointer;\n\tpadding: 10px 10px;\n\ttext-decoration: none;\n\tmargin-right: 10px;\n\tmargin-bottom: 0.2em;\n\tfont-size: 1.7em;\n}\n.pro_rtButtonEmoji__1LIoN:hover {\n\tborder:1px solid #4eaa38;\n\tcolor: #4eaa38;\n}\n.pro_rtButtonEmoji__1LIoN:active {\n\tposition:relative;\n\ttop:1px;\n}\n\n.pro_rtButtonCard__1yHEh {\n\tbox-shadow:inset 0px 1px 0px 0px #999999;\n\tbackground:linear-gradient(to bottom, #999999 5%, #f6f6f6 100%);\n\tbackground-color:#999999;\n\tborder-radius:6px;\n\tborder:1px solid #dcdcdc;\n\tdisplay:inline-block;\n\tcursor:pointer;\n\tcolor:#666666;\n\tfont-family:Arial;\n\tfont-size:15px;\n\tfont-weight:bold;\n\tpadding:10px 25px;\n\ttext-decoration:none;\n  text-shadow:0px 1px 0px #999999;\n  margin-right: 10px;\n}\n.pro_rtButtonCard__1yHEh:hover {\n\tbackground:linear-gradient(to bottom, #f6f6f6 5%, #999999 100%);\n\tbackground-color:#f6f6f6;\n}\n.pro_rtButtonCard__1yHEh:active {\n\tposition:relative;\n\ttop:1px;\n}\n\n@media only screen and (max-width: 768px) {\n\n\t.pro_rtButton__1IY3- {\n\t\tmin-width: 90%;\n\t}\n}\n";
var pro = {"content":"pro_content__3U-Yj","conversationTitle":"pro_conversationTitle__D71ua","status":"pro_status__3Z2ht","conversationWrapper":"pro_conversationWrapper__2LHAp","settingsContainer":"pro_settingsContainer__1AW-m","messageSent":"pro_messageSent__1zVdy","messageReceived":"pro_messageReceived__1FlOw","bubble":"pro_bubble__3vL7M","timestamp":"pro_timestamp__27_wB","avatar":"pro_avatar__SAyvm","time":"pro_time__xKrbs","messagingArea":"pro_messagingArea__1agCN","send":"pro_send__gNVFc","button":"pro_button__-YnLf","spinnerContainer":"pro_spinnerContainer__1l8ER","spinner":"pro_spinner__2jrC_","rotator":"pro_rotator__gQCVW","path":"pro_path__2IY-0","dash":"pro_dash__OOTL-","colors":"pro_colors__1U9_n","closeMobile":"pro_closeMobile__1Q2dg","messagingAreaHide":"pro_messagingAreaHide__1HRBx","chatboxContainer":"pro_chatboxContainer__10Qm2","actionButton":"pro_actionButton__kjVr5","wrapper":"pro_wrapper__1hNM6","closed":"pro_closed__1OQ5s","buttonOpenColl":"pro_buttonOpenColl__1G1Kl","buttonCloseColl":"pro_buttonCloseColl__3y-EO","arrowOpen":"pro_arrowOpen__Pbq-g","arrowClose":"pro_arrowClose__1brBE","textMoreInfo":"pro_textMoreInfo__3fjWv","mainColor":"pro_mainColor__BjDND","card":"pro_card__1D9Aq","smallCard":"pro_smallCard__1nBDH","smallImageCard":"pro_smallImageCard__26056","imageCard":"pro_imageCard__2k8yD","container":"pro_container__X8hMe","displayName":"pro_displayName__3cOCk","buttonsContainer":"pro_buttonsContainer__27yFa","rtButton":"pro_rtButton__1IY3-","rtButtonEmoji":"pro_rtButtonEmoji__1LIoN","rtButtonCard":"pro_rtButtonCard__1yHEh"};
styleInject(css$9);

var css$a = "\n.motor_pacifico_content__21UUq {\n  background: #fff;\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);\n  margin: 3.2em auto;\n  border-radius: 8px 8px 0 0;\n  position: fixed;\n  width: 30vw;\n  right: 30px;\n  bottom: 45px;\n  font-family: 'Montserrat Light', arial;\n  z-index: 999;\n  min-width: 400px;\n}\n\n\n.motor_pacifico_conversationTitle__3hA_W {\n  text-align: center;\n  padding: 8px;\n  background-repeat: no-repeat;\n  background-position: center;\n  color: #4eaa38;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n  background-size: contain;\n  border: 1px solid lightgrey;\n}\n.motor_pacifico_conversationTitle__3hA_W h1 {\n  font: 700 18px 'Noto Sans', sans-serif;\n  margin: 0;\n}\n.motor_pacifico_conversationTitle__3hA_W .motor_pacifico_status__ELHIG {\n  font-size: 12px;\n  width: 50px;\n}\n\n.motor_pacifico_conversationTitle__3hA_W > img {\n  width: 3em;\n}\n\n.motor_pacifico_status__ELHIG:hover {\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.motor_pacifico_conversationWrapper__32fHO {\n  background:#E6E6E6;\n  padding: 25px;\n  height: 60vh;\n  overflow-y: auto;\n  border: 1px solid lightgrey;\n  --scrollbarBG: lightgrey;\n  --thumbBG: #E6E6E6;\n  scrollbar-width: thin;\n  scrollbar-color: var(--thumbBG) var(--scrollbarBG);\n  line-height: initial;\n}\n\n.motor_pacifico_conversationWrapper__32fHO::-webkit-scrollbar {\n  width: 11px;\n}\n\n.motor_pacifico_conversationWrapper__32fHO::-webkit-scrollbar-track {\n  background: var(--scrollbarBG);\n}\n\n.motor_pacifico_conversationWrapper__32fHO::-webkit-scrollbar-thumb {\n  background-color: var(--thumbBG) ;\n  border-radius: 6px;\n  border: 3px solid var(--scrollbarBG);\n}\n\n /* Hide scrollbar for Chrome, Safari and Opera */\n /* .conversationWrapper::-webkit-scrollbar {\n  display: none;\n} */\n\n/* Hide scrollbar for IE and Edge */\n/* .conversationWrapper {\n  -ms-overflow-style: none;\n}  */\n\n.motor_pacifico_settingsContainer__y3zWc {\n  background: white;\n  border: 1px solid lightgrey;\n  padding: 25px;\n  height: 500px;\n  overflow-y: auto;\n  font-size: medium;\n}\n\n.motor_pacifico_settingsContainer__y3zWc select {\n  width: 100%;\n  height: 25px;\n  border: 1px solid lightgrey;\n  margin: 15px 0 15px 0;\n}\n\n.motor_pacifico_settingsContainer__y3zWc input {\n  width: 100%;\n  height: 25px;\n  border: 1px solid lightgrey;\n  margin: 5px 0 5px 0;\n  padding-left: 10px;\n}\n\n.motor_pacifico_messageSent__nADKl, .motor_pacifico_messageReceived__3GHPM {\n  padding: 0;\n}\n.motor_pacifico_messageReceived__3GHPM {\n  text-align: left;\n  margin-bottom: 10px;\n}\n.motor_pacifico_messageSent__nADKl {\n  text-align: right;\n}\n\n.motor_pacifico_messageSent__nADKl > .motor_pacifico_bubble__IbvPK {\n  border-radius: 12px 12px 0px 12px;\n}\n\n.motor_pacifico_messageReceived__3GHPM > .motor_pacifico_bubble__IbvPK {\n  border-radius: 12px 12px 12px 0px;\n}\n\n.motor_pacifico_bubble__IbvPK {\n  background: #fff;\n  padding: 12px 18px;\n  border: 0.5px solid rgba(0, 0, 0, 0.02);\n  box-shadow: 0 2px 1px rgba(0, 0, 0, 0.08);\n  max-width: 70%;\n  display: inline-block;\n  text-align: left;\n  font-size: 14px;\n  margin-top: 5px;\n  margin-bottom: 5px;\n}\n.motor_pacifico_timestamp__2up-9 {\n  margin: 0 0;\n}\n.motor_pacifico_timestamp__2up-9 .motor_pacifico_avatar__nXM-r {\n  border-radius: 50%;\n  background: linear-gradient(to top right, #e9e7e8, #898b8f);\n  display: inline-block;\n  width: 25px;\n  height: 20px;\n  vertical-align: top;\n  color: #fff;\n  font-size: 10px;\n  text-align: center;\n  padding-top: 5px;\n}\n.motor_pacifico_timestamp__2up-9 .motor_pacifico_time__1Gpn9 {\n  font-size: 12px;\n  color: #999;\n  margin: 0 5px;\n}\n.motor_pacifico_messagingArea__2c2Kb {\n  position: relative;\n  box-shadow: 0 -2px 1px rgba(0, 0, 0, 0.03);\n  border-bottom: 1px solid lightgrey;\n  border-left: 1px solid lightgrey;\n  border-right: 1px solid lightgrey;\n  overflow: hidden;\n}\n.motor_pacifico_messagingArea__2c2Kb input {\n  font-size: 14px;\n  border: none;\n  padding: 20px 30px;\n  width: 100%;\n  border-bottom-left-radius: 0px;\n  border-bottom-right-radius: 0px;\n  line-height: normal;\n}\n.motor_pacifico_messagingArea__2c2Kb input:focus {\n  outline: 0;\n}\n\n.motor_pacifico_send__v0V62 {\n  background: linear-gradient(to top right, #e9e7e8, #898b8f);\n  color: #fff;\n  border-radius: 50%;\n  width: 25px;\n  height: 25px;\n  padding: 8px 10px 12px;\n  position: absolute;\n  font-size: 0.7em;\n  text-align: center;\n  right: 8px;\n  bottom: 8px;\n}\n\n.motor_pacifico_button__3kDmM {\n\t/* box-shadow:inset 0px -3px 7px 0px #898b8f; */\n\tcolor: gray;\n\tbackground-color:white;\n\tborder-radius:3px;\n\tborder: 1px solid lightgray;\n\tdisplay:inline-block;\n\tcursor:pointer;\n\tfont-size:15px;\n\tpadding:9px 23px;\n\ttext-decoration:none;\n  /* text-shadow:0px 1px 0px #263666; */\n  margin-top: 25px;\n}\n.motor_pacifico_button__3kDmM:hover {\n  background-color:#898b8f;\n  color: white;\n}\n.motor_pacifico_button__3kDmM:active {\n\tposition:relative;\n\ttop:1px;\n}\n\n.motor_pacifico_spinnerContainer__Gfo0c {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 500px;\n  border: 1px solid lightgrey;\n}\n\n.motor_pacifico_spinner__2M3NU {\n  animation: motor_pacifico_rotator__1VD2X 1.4s linear infinite;\n}\n\n@keyframes motor_pacifico_rotator__1VD2X {\n  0% {\n    transform: rotate(0deg);\n }\n  100% {\n    transform: rotate(270deg);\n }\n}\n.motor_pacifico_path__QM0qy {\n  stroke-dasharray: 187;\n  stroke-dashoffset: 0;\n  transform-origin: center;\n  animation: motor_pacifico_dash__1sCcD 1.4s ease-in-out infinite, motor_pacifico_colors__2D0T7 5.6s ease-in-out infinite;\n}\n@keyframes motor_pacifico_colors__2D0T7 {\n  0% {\n    stroke: #4285f4;\n }\n  25% {\n    stroke: #de3e35;\n }\n  50% {\n    stroke: #f7c223;\n }\n  75% {\n    stroke: #1b9a59;\n }\n  100% {\n    stroke: #4285f4;\n }\n}\n@keyframes motor_pacifico_dash__1sCcD {\n  0% {\n    stroke-dashoffset: 187;\n }\n  50% {\n    stroke-dashoffset: 46.75;\n    transform: rotate(135deg);\n }\n  100% {\n    stroke-dashoffset: 187;\n    transform: rotate(450deg);\n }\n}\n\n.motor_pacifico_closeMobile__35Mda {\n  display: none;\n}\n\n@media only screen and (max-width: 768px) {\n  /* For mobile phones: */\n  .motor_pacifico_content__21UUq {\n    bottom: 0 !important;\n    width: 100vw !important;\n    height: 100%;\n    right: 0;\n    bottom: 0;\n    position: unset;\n    margin: 0;\n    min-width: 0;\n  }\n\n  .motor_pacifico_conversationTitle__3hA_W {\n    border-top-left-radius: 0px;\n    border-top-right-radius: 0px;\n  }\n\n  .motor_pacifico_conversationWrapper__32fHO {\n    height: 100vh;\n    padding: 20px;\n  }\n\n  .motor_pacifico_messagingArea__2c2Kb {\n    position: fixed;\n    bottom: 0px;\n    width: 100vw;\n    background-color: lightgrey;\n    height: 2em;\n  }\n\n\n\n  .motor_pacifico_messagingAreaHide__16qFY {\n    display: none;\n  }\n\n  .motor_pacifico_closeMobile__35Mda {\n    height: 30px;\n    width: 30px;\n    display: block;\n    position: fixed;\n    right: 20px;\n    top: 0.6rem;\n    color: white;\n    background-image:url('data:image/png;base64,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');\n    background-size: contain;\n  }\n}\n\n/* IPHONE X */\n@media only screen\nand (min-device-width : 375px)\nand (max-device-width : 812px)\nand (-webkit-device-pixel-ratio : 3)\nand (orientation : portrait) {\n\n  .motor_pacifico_messagingArea__2c2Kb > input {\n    /* enlarge by 16/12 = 133.33% */\n    border-radius: 6.666666667px;\n    font-size: 20px;\n    line-height: 26.666666667px;\n    padding: 6.666666667px;\n    width: 133.333333333%;\n\n    /* scale down by 12/16 = 75% */\n    transform: scale(0.75);\n    transform-origin: left top;\n  }\n\n  .motor_pacifico_messagingArea__2c2Kb {\n    position: fixed;\n    bottom: 0px;\n    width: 100vw;\n    background-color: white;\n    height: 1em;\n    padding: 4px;\n  }\n\n}\n\n@media only screen\nand (min-device-width : 375px)\nand (max-device-width : 667px)\nand (orientation : portrait) {\n  /* iPhone 6, 7, & 8 in portrait */\n  .motor_pacifico_messagingArea__2c2Kb > input {\n    /* enlarge by 16/12 = 133.33% */\n    border-radius: 6.666666667px;\n    font-size: 20px;\n    line-height: 26.666666667px;\n    padding: 6.666666667px;\n    width: 133.333333333%;\n\n    /* scale down by 12/16 = 75% */\n    transform: scale(0.75);\n    transform-origin: left top;\n  }\n\n  .motor_pacifico_messagingArea__2c2Kb {\n    position: fixed;\n    bottom: 0px;\n    width: 100vw;\n    background-color: white;\n    height: 1em;\n    padding: 4px;\n  }\n}\n\n@media only screen\nand (min-device-width : 320px)\nand (max-device-width : 568px) {\n  /* Iphone 5 */\n  /* iPhone 6, 7, & 8 in portrait */\n  .motor_pacifico_messagingArea__2c2Kb > input {\n    /* enlarge by 16/12 = 133.33% */\n    border-radius: 6.666666667px;\n    font-size: 20px;\n    line-height: 26.666666667px;\n    padding: 6.666666667px;\n    width: 133.333333333%;\n\n    /* scale down by 12/16 = 75% */\n    transform: scale(0.75);\n    transform-origin: left top;\n  }\n\n  .motor_pacifico_messagingArea__2c2Kb {\n    position: fixed;\n    bottom: 0px;\n    width: 100vw;\n    background-color: white;\n    height: 1em;\n    padding: 4px;\n  }\n}\n\n/* add css styles here (optional) */\n.motor_pacifico_chatboxContainer__2Z9YN {\n  font-size: 2em;\n  position: fixed;\n  right: 0px;\n  z-index: 100000;\n}\n\n@media only screen and (max-width: 600px) {\n  .motor_pacifico_chatboxContainer__2Z9YN {\n    top: 0px;\n    width: 100%;\n  }\n}\n\n.motor_pacifico_actionButton__MwCqf {\n  background-color: #4eaa38!important;\n  color: white!important;\n  border: 1px solid #4eaa38!important;\n  display: inline-block;\n  text-align: center;\n  padding: 15px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-family: 'Montserrat-light';\n  font-size: 1.8rem;\n}\n\n.motor_pacifico_actionButton__MwCqf:hover {\n  text-decoration: underline;\n}\n\n/* Collapsable */\n.motor_pacifico_wrapper__2NMR6 {\n  overflow: hidden;\n  transition: height 200ms;\n}\n\n.motor_pacifico_closed__8bZp6 {\n  display: none;\n}\n\n.motor_pacifico_buttonOpenColl__2ZYKa {\n  background-color: #4eaa38;\n  border-radius: 6px;\n  border: 1px solid lightgray;\n  display: flex;\n  cursor: pointer;\n  padding: 10px 10px;\n  text-decoration: none;\n  margin-right: 10px;\n  margin-bottom: 0.2em;\n  width: 8em;\n  font-size: 14px;\n}\n\n.motor_pacifico_buttonCloseColl__Pi8R7 {\n  background-color: #4eaa38;\n  border-radius: 6px;\n  border: 1px solid lightgray;\n  display: flex;\n  cursor: pointer;\n  padding: 5px;\n  text-decoration: none;\n  margin-right: 10px;\n  margin-bottom: 0.2em;\n  width: 8em;\n  font-size: 14px;\n  flex: initial;\n  color: white;\n\n}\n\n.motor_pacifico_arrowOpen__1j3a0 {\n  height: 20px;\n  width: 20px;\n  color: white;\n  background-image: url('data:image/png;base64,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');\n  background-size: contain;\n  display: flex;\n  margin-right: 10px;\n  transform: rotate(180deg);\n}\n\n.motor_pacifico_arrowClose__1g7Ko {\n\n  height: 20px;\n  width: 20px;\n  color: white;\n  background-image: url('data:image/png;base64,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');\n  background-size: contain;\n  display: flex;\n  margin-right: 10px;\n\n}\n\n.motor_pacifico_likeButton__3jhkl {\n  width: auto;\n  height: 1em;\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 3px 16px 0px, rgba(0, 0, 0, 0.2) 0px 3px 1px -2px, rgba(0, 0, 0, 0.12) 0px 1px 5px 0px !important;\n  font-size: 14px;\n  position: fixed;\n  bottom: 7em;\n  right: 8em;\n  border-radius: 20px 0px 20px 20px;\n  padding: 0.4em;\n  text-align: center;\n  background: white;\n  font-family: 'Montserrat Light', arial;\n  cursor: pointer;\n  color: #333333;\n}\n\n.motor_pacifico_mainColor__2l_pN {\n  color: #4eaa38 !important;\n}\n\n.motor_pacifico_card__zlbPN {\n  /* Add shadows to create the \"card\" effect */\n  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);\n  transition: 0.3s;\n  border-radius: 5px; /* 5px rounded corners */\n  margin: 20px 0px 20px 0px;\n  background-color: #f6f6f6;\n  cursor: pointer;\n}\n\n.motor_pacifico_smallCard__3z7Zv {\n  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);\n  transition: 0.3s;\n  border-radius: 5px; /* 5px rounded corners */\n  margin: 20px 0px 20px 0px;\n  background-color: #f6f6f6;\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: stretch;\n  cursor: pointer;\n}\n\n/* On mouse-over, add a deeper shadow */\n.motor_pacifico_smallCard__3z7Zv:hover {\n  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);\n}\n\n.motor_pacifico_smallImageCard__3BLaa {\n  width: 45%;\n  border-radius: 5px 0 0 5px;\n}\n\n/* On mouse-over, add a deeper shadow */\n.motor_pacifico_card__zlbPN:hover {\n  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);\n}\n\n.motor_pacifico_imageCard__1_9Ue {\n  width: 100%;\n  border-radius: 5px 5px 0 0;\n}\n\n/* Add some padding inside the card container */\n.motor_pacifico_container__IlYj6 {\n  padding: 16px;\n}\n\n.motor_pacifico_container__IlYj6 p {\n  font-size: small;\n}\n\n.motor_pacifico_displayName__1m-FR {\n  font-size: 0.5em;\n}\n/*===================================\n  Buttons\n===================================*/\n.motor_pacifico_buttonsContainer__b5Qnq {\n\tpadding-bottom: 15px;\n}\n\n.motor_pacifico_rtButton__3xlZ_ {\n\tbackground-color: lightgray;\n\tborder-radius: 6px;\n\tborder: 1px solid lightgray;\n\tdisplay: inline-block;\n\tcursor: pointer;\n\tpadding: 10px 10px;\n\ttext-decoration: none;\n\tmargin-right: 10px;\n\tmargin-bottom: 0.2em;\n  font-size: 14px;\n  min-width: 50px;\n}\n.motor_pacifico_rtButton__3xlZ_:hover {\n\tborder:1px solid #4eaa38;\n\tcolor: #4eaa38;\n}\n.motor_pacifico_rtButton__3xlZ_:active {\n\tposition:relative;\n\ttop:1px;\n}\n\n.motor_pacifico_rtButtonEmoji__Xupl2 {\n\tbackground-color: lightgray;\n\tborder-radius: 6px;\n\tborder: 1px solid lightgray;\n\tdisplay: inline-block;\n\tcursor: pointer;\n\tpadding: 10px 10px;\n\ttext-decoration: none;\n\tmargin-right: 10px;\n\tmargin-bottom: 0.2em;\n\tfont-size: 1.7em;\n}\n.motor_pacifico_rtButtonEmoji__Xupl2:hover {\n\tborder:1px solid #4eaa38;\n\tcolor: #4eaa38;\n}\n.motor_pacifico_rtButtonEmoji__Xupl2:active {\n\tposition:relative;\n\ttop:1px;\n}\n\n.motor_pacifico_rtButtonCard__3J15v {\n\tbox-shadow:inset 0px 1px 0px 0px #999999;\n\tbackground:linear-gradient(to bottom, #999999 5%, #f6f6f6 100%);\n\tbackground-color:#999999;\n\tborder-radius:6px;\n\tborder:1px solid #dcdcdc;\n\tdisplay:inline-block;\n\tcursor:pointer;\n\tcolor:#666666;\n\tfont-family:Arial;\n\tfont-size:15px;\n\tfont-weight:bold;\n\tpadding:10px 25px;\n\ttext-decoration:none;\n  text-shadow:0px 1px 0px #999999;\n  margin-right: 10px;\n}\n.motor_pacifico_rtButtonCard__3J15v:hover {\n\tbackground:linear-gradient(to bottom, #f6f6f6 5%, #999999 100%);\n\tbackground-color:#f6f6f6;\n}\n.motor_pacifico_rtButtonCard__3J15v:active {\n\tposition:relative;\n\ttop:1px;\n}\n\n@media only screen and (max-width: 768px) {\n\n\t.motor_pacifico_rtButton__3xlZ_ {\n\t\tmin-width: 90%;\n\t}\n}\n\n";
var motor_pacifico = {"content":"motor_pacifico_content__21UUq","conversationTitle":"motor_pacifico_conversationTitle__3hA_W","status":"motor_pacifico_status__ELHIG","conversationWrapper":"motor_pacifico_conversationWrapper__32fHO","settingsContainer":"motor_pacifico_settingsContainer__y3zWc","messageSent":"motor_pacifico_messageSent__nADKl","messageReceived":"motor_pacifico_messageReceived__3GHPM","bubble":"motor_pacifico_bubble__IbvPK","timestamp":"motor_pacifico_timestamp__2up-9","avatar":"motor_pacifico_avatar__nXM-r","time":"motor_pacifico_time__1Gpn9","messagingArea":"motor_pacifico_messagingArea__2c2Kb","send":"motor_pacifico_send__v0V62","button":"motor_pacifico_button__3kDmM","spinnerContainer":"motor_pacifico_spinnerContainer__Gfo0c","spinner":"motor_pacifico_spinner__2M3NU","rotator":"motor_pacifico_rotator__1VD2X","path":"motor_pacifico_path__QM0qy","dash":"motor_pacifico_dash__1sCcD","colors":"motor_pacifico_colors__2D0T7","closeMobile":"motor_pacifico_closeMobile__35Mda","messagingAreaHide":"motor_pacifico_messagingAreaHide__16qFY","chatboxContainer":"motor_pacifico_chatboxContainer__2Z9YN","actionButton":"motor_pacifico_actionButton__MwCqf","wrapper":"motor_pacifico_wrapper__2NMR6","closed":"motor_pacifico_closed__8bZp6","buttonOpenColl":"motor_pacifico_buttonOpenColl__2ZYKa","buttonCloseColl":"motor_pacifico_buttonCloseColl__Pi8R7","arrowOpen":"motor_pacifico_arrowOpen__1j3a0","arrowClose":"motor_pacifico_arrowClose__1g7Ko","likeButton":"motor_pacifico_likeButton__3jhkl","mainColor":"motor_pacifico_mainColor__2l_pN","card":"motor_pacifico_card__zlbPN","smallCard":"motor_pacifico_smallCard__3z7Zv","smallImageCard":"motor_pacifico_smallImageCard__3BLaa","imageCard":"motor_pacifico_imageCard__1_9Ue","container":"motor_pacifico_container__IlYj6","displayName":"motor_pacifico_displayName__1m-FR","buttonsContainer":"motor_pacifico_buttonsContainer__b5Qnq","rtButton":"motor_pacifico_rtButton__3xlZ_","rtButtonEmoji":"motor_pacifico_rtButtonEmoji__Xupl2","rtButtonCard":"motor_pacifico_rtButtonCard__3J15v"};
styleInject(css$a);

var loadTheme = function (name) {
    switch (name) {
        case 'cmadrid':
            return cmadrid;
        case 'dev':
            return dev;
        case 'qa':
            return qa;
        case 'pro':
            return pro;
        case 'motor_pacifico':
            return motor_pacifico;
        default:
            return dev;
    }
};

var TriggerSystem = /** @class */ (function () {
    function TriggerSystem(triggers, callback) {
        this.triggers = triggers;
        this.callback = callback;
        this.claimCounter = 0;
        // is first load fire event of load
        this.fireEvent('on_load');
    }
    TriggerSystem.prototype.fireEvent = function (event) {
        switch (event) {
            case 'on_load':
                return this._onLoadTrigger();
        }
    };
    TriggerSystem.prototype._getCurrentUrl = function () {
        return window.location.href;
    };
    TriggerSystem.prototype._onLoadTrigger = function () {
        var _this = this;
        this.triggers.forEach(function (trigger) {
            if (trigger.type === 'on_load' && trigger.url === document.location.pathname) {
                var behavior_1;
                if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    behavior_1 = trigger.devices[0].behaviour; // temporal only support desktop
                }
                else {
                    behavior_1 = trigger.devices[0].behaviour; // temporal only support desktop
                }
                _this.callback(null, 'initial', { entryPoint: behavior_1.entryPoint.firstBotMessage });
                if (behavior_1.proactivity.visualClaim.active) {
                    var claimTimer_1 = setInterval(function () {
                        if (_this.claimCounter < behavior_1.proactivity.visualClaim.frequency) {
                            _this.claimCounter += 1;
                            // event to active animation
                            _this.callback(null, 'visual_claim', {
                                gesture: behavior_1.proactivity.visualClaim.gesture,
                                frequency: behavior_1.proactivity.visualClaim.frequency,
                                entryPoint: behavior_1.entryPoint.firstBotMessage,
                            });
                            // event to change to default state.
                            setTimeout(function () {
                                _this.callback(null, 'visual_claim_off', {
                                    gesture: behavior_1.proactivity.visualClaim.gesture,
                                    frequency: behavior_1.proactivity.visualClaim.frequency,
                                    entryPoint: behavior_1.entryPoint.firstBotMessage,
                                });
                            }, 2500);
                        }
                        else
                            clearInterval(claimTimer_1);
                    }, 15000);
                }
                if (behavior_1.proactivity.popUpClaim.active) {
                    setTimeout(function () {
                        _this.callback(null, 'popup_claim', {
                            message: behavior_1.proactivity.popUpClaim.message,
                            entryPoint: behavior_1.entryPoint.firstBotMessage,
                        });
                    }, behavior_1.proactivity.popUpClaim.timeout * 500);
                    setTimeout(function () {
                        _this.callback(null, 'popup_claim_off', {
                            message: behavior_1.proactivity.popUpClaim.message,
                            entryPoint: behavior_1.entryPoint.firstBotMessage,
                        });
                    }, (behavior_1.proactivity.popUpClaim.timeout + 30) * 500);
                    setTimeout(function () {
                        _this.callback(null, 'close_all', {
                            entryPoint: behavior_1.entryPoint,
                        });
                    }, (behavior_1.proactivity.popUpClaim.timeout + 33) * 500);
                }
            }
        });
    };
    return TriggerSystem;
}());

/**
 * @class ChatBoxRT
 */
var ChatBoxRT = /** @class */ (function (_super) {
    __extends(ChatBoxRT, _super);
    function ChatBoxRT(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            channel: props.config.channel || '',
            lang: document.documentElement.lang,
            testMode: props.config.testMode,
            // stage: props.config.stage,// via static config
            openedChat: false,
            showCircleBtn: false,
            apiKey: '',
            title: false,
            botList: [],
            sourceValue: props.config.sourceValue,
            botName: props.config.botName,
            theme: undefined,
            currentEvent: {},
            currentEventType: '',
            entryPoint: '',
            showSettingsBtn: props.config.testMode,
            popoverActive: false,
            popoverText: '',
            logo: false,
            activeSurvey: false,
            noneAbove: false,
            actionButton: false,
            trackingConfig: false,
            trackingBeacon: false,
            maximizeOnLoad: props.config.maximizeOnLoad,
        };
        return _this;
    }
    ChatBoxRT.prototype.componentDidMount = function () {
        if (this.state.testMode) {
            this.requestBotList();
        }
        else {
            this.requestBotConfig();
        }
    };
    ChatBoxRT.prototype.onTriggerEvent = function (error, event, eventPayload) {
        if (error)
            console.log(error);
        if (eventPayload.entryPoint && event === 'initial') {
            this.setState({ entryPoint: eventPayload.entryPoint });
        }
        this.setState(function (prevState) {
            var currentEvent = __assign({}, prevState.currentEvent, eventPayload);
            return { currentEvent: currentEvent, currentEventType: event };
        });
    };
    ChatBoxRT.prototype.switchChat = function () {
        this.setState(function (prevState) { return ({
            openedChat: !prevState.openedChat
        }); });
    };
    ChatBoxRT.prototype.setChatSettings = function (_a) {
        var apiKey = _a.apiKey, channel = _a.channel, sourceValue = _a.sourceValue, botName = _a.botName, lang = _a.lang;
        if (apiKey)
            this.setState({ apiKey: apiKey });
        if (channel)
            this.setState({ channel: channel });
        if (sourceValue)
            this.setState({ sourceValue: sourceValue });
        if (botName)
            this.setState({ botName: botName });
        if (lang)
            this.setState({ lang: lang });
    };
    ChatBoxRT.prototype.onRemoteConfig = function () {
        // Todo when we´ll want config from websockets
    };
    ChatBoxRT.prototype.applyLocalConfig = function () {
        this.setState({ theme: loadTheme(this.props.config.configStage) });
        this.setState({ openedChat: this.props.config.maximizeOnLoad });
        this.setState({ title: this.props.config.configStage });
        this.setState({ actionButton: false });
        this.setState({ showCircleBtn: true });
    };
    ChatBoxRT.prototype.requestBotConfig = function () {
        return __awaiter(this, void 0, void 0, function () {
            var configStage, location_1, botConfig, _a, channelConfig, triggers, botName, triggerSystem_1, tracking, trakingServiceUrl, actionName, idSite, url, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        configStage = this.props.config.configStage;
                        location_1 = this.props.config.location || document.location.hostname;
                        return [4 /*yield*/, getConfig(configStage, location_1)];
                    case 1:
                        botConfig = _b.sent();
                        _a = botConfig.data, channelConfig = _a.channelConfig, triggers = _a.triggers, botName = _a.botName;
                        triggerSystem_1 = new TriggerSystem(triggers, this.onTriggerEvent.bind(this));
                        this.setState({ apiKey: location_1 });
                        this.setState({ theme: loadTheme(channelConfig.theme) });
                        this.setState({ title: channelConfig.title });
                        this.setState({ noneAbove: channelConfig.noneAbove });
                        this.setState({ actionButton: channelConfig.actionButton });
                        this.setState({ activeSurvey: channelConfig.activeSurvey });
                        this.setState({ popoverActive: channelConfig.popoverActive });
                        this.setState({ popoverText: channelConfig.popoverText });
                        this.setState({ logo: channelConfig.logo });
                        this.setState({ botName: botName });
                        this.setState({ trackingConfig: channelConfig.tracking || false });
                        if (channelConfig.tracking) {
                            tracking = channelConfig.tracking;
                            trakingServiceUrl = tracking.trakingServiceUrl, actionName = tracking.actionName, idSite = tracking.idSite;
                            url = trakingServiceUrl + "?action_name=" + actionName + "&idsite=" + idSite + "&rec=1&url=" + location_1;
                            this.setState({ trackingBeacon: url });
                        }
                        this.setState({ openedChat: this.state.maximizeOnLoad });
                        this.setState({ showCircleBtn: !this.state.maximizeOnLoad });
                        setTimeout(function () { return triggerSystem_1.fireEvent('on_load'); }, 1500);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _b.sent();
                        console.error(error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ChatBoxRT.prototype.requestBotList = function () {
        var _this = this;
        var configStage = this.props.config.configStage;
        getBotList(configStage).then(function (response) {
            var botList = response.data.filter(function (bot) {
                return bot.name.split('-')[0] !== 'shopify' && bot.name.split('-')[0] !== 'woice';
            });
            _this.setState({ botList: botList });
            _this.applyLocalConfig();
        })
            .catch(function (error) {
            console.log(error);
        });
    };
    ChatBoxRT.prototype.render = function () {
        var _this = this;
        var _a = this.state, apiKey = _a.apiKey, channel = _a.channel, botList = _a.botList, sourceValue = _a.sourceValue, botName = _a.botName, openedChat = _a.openedChat, currentEvent = _a.currentEvent, currentEventType = _a.currentEventType, lang = _a.lang, entryPoint = _a.entryPoint, showSettingsBtn = _a.showSettingsBtn, theme = _a.theme, popoverActive = _a.popoverActive, popoverText = _a.popoverText, testMode = _a.testMode, title = _a.title, actionButton = _a.actionButton, noneAbove = _a.noneAbove, activeSurvey = _a.activeSurvey, logo = _a.logo, trackingBeacon = _a.trackingBeacon, showCircleBtn = _a.showCircleBtn;
        var wsStage = this.props.config.wsStage;
        if (theme && openedChat) {
            console.log('entraaaaaa');
            return (createElement(Fragment, null,
                (trackingBeacon) ? (createElement("img", { src: trackingBeacon })) : (createElement(Fragment, null)),
                (actionButton) ? (createElement("button", { className: theme.actionButton, onClick: function () { return _this.switchChat(); } }, "Preguntar al Chatbot")) : (createElement(Fragment, null)),
                createElement("div", { className: theme.chatboxContainer },
                    createElement(ChatBox, { apiKey: apiKey, channel: channel, setChatSettings: this.setChatSettings.bind(this), botList: botList, sourceValue: sourceValue, botName: botName, theme: theme, entryPoint: entryPoint, title: title, showSettingsBtn: showSettingsBtn, lang: lang, testMode: testMode, switchChat: this.switchChat.bind(this), stage: wsStage, noneAbove: noneAbove, activeSurvey: activeSurvey, onRemoteConfig: this.onRemoteConfig, logo: logo }),
                    (showCircleBtn) ? (createElement(CircleBtn, { switchChat: function () { return _this.switchChat(); }, openedChat: openedChat, theme: theme, currentEvent: currentEvent, currentEventType: currentEventType, lang: lang, popoverActive: popoverActive, popoverText: popoverText })) : (createElement(Fragment, null)))));
        }
        else {
            if (!theme)
                return (createElement(Fragment, null));
            return (createElement(Fragment, null,
                (actionButton) ? (createElement("button", { className: theme.actionButton, onClick: function () { return _this.switchChat(); } }, "Preguntar al Chatbot")) : (createElement(Fragment, null)),
                createElement("div", { className: theme.chatboxContainer },
                    createElement(CircleBtn, { switchChat: function () { return _this.switchChat(); }, openedChat: openedChat, theme: theme, currentEvent: currentEvent, currentEventType: currentEventType, lang: lang, popoverActive: popoverActive, popoverText: popoverText }))));
        }
    };
    return ChatBoxRT;
}(Component));

export default ChatBoxRT;
//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ../dist/index.es.js
// module id = 28
// module chunks = 0